/* with love from shopstory */
var index = require('./index-0b475274.js');
var React = require('react');
var TextareaAutosize = require('react-textarea-autosize');
var styled = require('styled-components');
var ReactDOM = require('react-dom');
var cryptoJs = require('crypto-js');
var reactBeautifulDnd = require('react-beautiful-dnd');
var tslib = require('tslib');
var tooltip = require('@react-aria/tooltip');
var reactPopper = require('react-popper');
var debounce$1 = require('lodash.debounce');
var ThumbnailButton = require('./ThumbnailButton-653e256d.js');
var slate = require('slate');
var slateReact = require('slate-react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var TextareaAutosize__default = /*#__PURE__*/_interopDefaultLegacy(TextareaAutosize);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var debounce__default = /*#__PURE__*/_interopDefaultLegacy(debounce$1);

function generateDefaultTraceId(config) {
  return "".concat(config._template, "-").concat(index.uniqueId().slice(0, 8));
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var dist$2 = {};

var utils = {};

var splitConfigs = {};

var getFallbackForLocale$2 = {};

var getFallbackLocaleForLocale$2 = {};

var getDefaultLocale$2 = {};

Object.defineProperty(getDefaultLocale$2, "__esModule", {
  value: true
});
getDefaultLocale$2.getDefaultLocale = void 0;

function getDefaultLocale$1(locales) {
  return locales.find(function (locale) {
    return locale.isDefault;
  });
}

getDefaultLocale$2.getDefaultLocale = getDefaultLocale$1;

Object.defineProperty(getFallbackLocaleForLocale$2, "__esModule", {
  value: true
});
getFallbackLocaleForLocale$2.getFallbackLocaleForLocale = void 0;

var getDefaultLocale_1 = getDefaultLocale$2;

function getFallbackLocaleForLocale$1(locale, locales) {
  var _a, _b;

  do {
    var fallbackId = (_b = (_a = locales.find(function (l) {
      return l.code === locale;
    })) === null || _a === void 0 ? void 0 : _a.fallback) !== null && _b !== void 0 ? _b : (0, getDefaultLocale_1.getDefaultLocale)(locales).code; // Default locale, no fallback

    if (fallbackId === locale) {
      return;
    }

    return fallbackId;
  } while (true);
}

getFallbackLocaleForLocale$2.getFallbackLocaleForLocale = getFallbackLocaleForLocale$1;

Object.defineProperty(getFallbackForLocale$2, "__esModule", {
  value: true
});
getFallbackForLocale$2.getFallbackForLocale = void 0;

var getFallbackLocaleForLocale_1 = getFallbackLocaleForLocale$2;

function getFallbackForLocale$1(translatedValues, locale, locales) {
  while (true) {
    var fallbackLocale = (0, getFallbackLocaleForLocale_1.getFallbackLocaleForLocale)(locale, locales);

    if (!fallbackLocale) {
      return;
    }

    var fallbackValue = translatedValues[fallbackLocale];

    if (fallbackValue !== undefined && fallbackValue !== null) {
      return fallbackValue;
    }

    locale = fallbackLocale;
  }
}

getFallbackForLocale$2.getFallbackForLocale = getFallbackForLocale$1;

Object.defineProperty(splitConfigs, "__esModule", {
  value: true
});
splitConfigs.splitConfigIntoSingleLocaleConfigs = void 0;

var getFallbackForLocale_1 = getFallbackForLocale$2;

function isLocalizedText(configComponent) {
  var _a;

  var LOCAL_PREFIX = "local.";
  return ((_a = configComponent === null || configComponent === void 0 ? void 0 : configComponent.id) !== null && _a !== void 0 ? _a : "").startsWith(LOCAL_PREFIX);
}

function extractSingleLocaleConfigs(configComponent, localeCode, locales) {
  var _a, _b, _c, _d;

  var _e;

  if (configComponent === null) {
    return;
  }

  if (typeof configComponent !== "object") {
    return configComponent;
  }

  if (Array.isArray(configComponent)) {
    return configComponent.map(function (value) {
      return extractSingleLocaleConfigs(value, localeCode, locales);
    });
  }

  if (configComponent.__localized !== true) {
    return Object.fromEntries(Object.entries(configComponent).map(function (_a) {
      var key = _a[0],
          value = _a[1];
      return [key, extractSingleLocaleConfigs(value, localeCode, locales)];
    }));
  }

  if (isLocalizedText(configComponent)) {
    var stringValue = (_e = configComponent === null || configComponent === void 0 ? void 0 : configComponent.value) === null || _e === void 0 ? void 0 : _e[localeCode];

    if (stringValue === null || stringValue === undefined) {
      return {
        id: configComponent.id,
        value: (_a = {}, _a[localeCode] = (0, getFallbackForLocale_1.getFallbackForLocale)(configComponent.value, localeCode, locales), _a.__fallback = true, _a)
      };
    } else {
      return {
        id: configComponent.id,
        value: (_b = {}, _b[localeCode] = stringValue, _b)
      };
    }
  }

  var localeCollection = configComponent[localeCode];

  if (localeCollection) {
    return _c = {}, _c[localeCode] = extractSingleLocaleConfigs(localeCollection, localeCode, locales), _c;
  } else {
    return _d = {}, _d[localeCode] = (0, getFallbackForLocale_1.getFallbackForLocale)(configComponent, localeCode, locales), _d.__fallback = true, _d;
  }
}
/**
 * Our Editor always works with one Config where each text is represented by localized object like:
 *
 * {
 *  en: "Hello",
 *  pl: "Dzień dobry",
 *  de: "Halo"
 * }
 *
 * This is easy for us to manage, however this is not a good format for API output, because you never really render all the langauges at once so providing all the langauges is hugely redundant.
 *
 * That's why when we save to the CMS, we save separate configs for each language with ONLY THIS LANGUAGE in texts.
 *
 * So English will have texts like { en: "Hello" } and Polish will have { de: "Dzień dobry" }, etc.
 *
 * Those single-locale configs saved in CMS have a name: SingleLocaleConfig.
 *
 */


function splitConfigIntoSingleLocaleConfigs(config, locales) {
  var localisedConfigs = {};
  locales.forEach(function (locale) {
    localisedConfigs[locale.code] = extractSingleLocaleConfigs(config, locale.code, locales);
  });
  return localisedConfigs;
}

splitConfigs.splitConfigIntoSingleLocaleConfigs = splitConfigIntoSingleLocaleConfigs;

(function (exports) {

var __createBinding = index.commonjsGlobal && index.commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = index.commonjsGlobal && index.commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(splitConfigs, exports);
}(utils));

var types = {};

var ConfigComponent = {};

Object.defineProperty(ConfigComponent, "__esModule", {
  value: true
});

var ConfigComponentIdentifier = {};

Object.defineProperty(ConfigComponentIdentifier, "__esModule", {
  value: true
});
ConfigComponentIdentifier.isComponentConfigIdentifier = void 0;

function isComponentConfigIdentifier(value) {
  var isNotNull = typeof value !== null;
  var isObject = typeof value === "object";
  var idIsAString = typeof (value === null || value === void 0 ? void 0 : value.id) === "string";
  return isNotNull && isObject && idIsAString;
}

ConfigComponentIdentifier.isComponentConfigIdentifier = isComponentConfigIdentifier;

var ConfigModel = {};

Object.defineProperty(ConfigModel, "__esModule", {
  value: true
});

var ConfigOrConfigArray = {};

Object.defineProperty(ConfigOrConfigArray, "__esModule", {
  value: true
});

var ContentPiece = {};

Object.defineProperty(ContentPiece, "__esModule", {
  value: true
});
ContentPiece.isContentPieceFull = ContentPiece.isContentPieceLocal = ContentPiece.isContentPieceRemote = ContentPiece.isContentPiece = void 0;
/**
 * @deprecated
 */

var isContentPieceRemote = function isContentPieceRemote(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 2 && "id" in value && "hash" in value;
};

ContentPiece.isContentPieceRemote = isContentPieceRemote;
/**
 * @deprecated
 */

var isContentPieceLocal = function isContentPieceLocal(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 1 && "config" in value;
};

ContentPiece.isContentPieceLocal = isContentPieceLocal;
/**
 * @deprecated
 */

var isContentPieceFull = function isContentPieceFull(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 3 && "id" in value && "hash" in value && "config" in value;
};

ContentPiece.isContentPieceFull = isContentPieceFull;
/**
 * @deprecated
 */

var isContentPiece = function isContentPiece(value) {
  return isContentPieceRemote(value) || isContentPieceLocal(value) || isContentPieceFull(value);
};

ContentPiece.isContentPiece = isContentPiece;

var Locale = {};

Object.defineProperty(Locale, "__esModule", {
  value: true
});

var RawContent = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRawContent = exports.isRawContentFull = exports.isRawContentLocal = exports.isRawContentRemote = void 0;

var isRawContentRemote = function isRawContentRemote(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 2 && "id" in value && "hash" in value;
};

exports.isRawContentRemote = isRawContentRemote;

var isRawContentLocal = function isRawContentLocal(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 1 && "content" in value;
};

exports.isRawContentLocal = isRawContentLocal;

var isRawContentFull = function isRawContentFull(value) {
  return value !== null && typeof value === "object" && Object.keys(value).length === 3 && "id" in value && "hash" in value && "content" in value;
};

exports.isRawContentFull = isRawContentFull;

var isRawContent = function isRawContent(value) {
  return (0, exports.isRawContentRemote)(value) || (0, exports.isRawContentLocal)(value) || (0, exports.isRawContentFull)(value);
};

exports.isRawContent = isRawContent;
}(RawContent));

(function (exports) {

var __createBinding = index.commonjsGlobal && index.commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = index.commonjsGlobal && index.commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(ConfigComponent, exports);

__exportStar(ConfigComponentIdentifier, exports);

__exportStar(ConfigModel, exports);

__exportStar(ConfigOrConfigArray, exports);

__exportStar(ContentPiece, exports);

__exportStar(Locale, exports);

__exportStar(RawContent, exports);
}(types));

var objects = {};

var objectMap$1 = {};

Object.defineProperty(objectMap$1, "__esModule", {
  value: true
});
objectMap$1.objectMap = void 0;

function objectMap(o, callback) {
  return Object.fromEntries(objectMapInternal(o, callback));
}

objectMap$1.objectMap = objectMap;

function objectMapInternal(o, callback) {
  return Object.entries(o).map(function (entry) {
    if (typeof entry[1] === "object") {
      if (entry[1] === null) {
        return callback(entry);
      }

      if (Array.isArray(entry[1])) {
        return callback([entry[0], entry[1].map(function (value) {
          return typeof value === "object" ? Object.fromEntries(objectMapInternal(value, callback)) : value;
        })]);
      }

      return callback([entry[0], Object.fromEntries(objectMapInternal(entry[1], callback))]);
    }

    return callback(entry);
  });
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectMap = void 0;

var objectMap_1 = objectMap$1;

Object.defineProperty(exports, "objectMap", {
  enumerable: true,
  get: function get() {
    return objectMap_1.objectMap;
  }
});
}(objects));

(function (exports) {

var __createBinding = index.commonjsGlobal && index.commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = index.commonjsGlobal && index.commonjsGlobal.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(utils, exports);

__exportStar(types, exports);

__exportStar(objects, exports);
}(dist$2));

function getDefaultConfig(mode) {
  if (mode === "grid") {
    var rootGridConfig = {
      _id: index.uniqueId(),
      _template: "$RootGrid",
      data: [{
        _template: "$Grid",
        containerMargin: {
          ref: "grid.containerMargin"
        },
        Component: [{
          _template: "$GridCard",
          numberOfItems: {
            ref: "grid"
          },
          columnGap: {
            ref: "grid.horizontalGap"
          },
          rowGap: {
            ref: "grid.verticalGap"
          },
          Cards: []
        }]
      }]
    };
    return rootGridConfig;
  }

  return {
    _id: index.uniqueId(),
    _template: "$RootSections",
    data: []
  };
}

function getMappedToken(tokenId, themeValues) {
  if (!tokenId.startsWith("$")) {
    return undefined;
  }

  var mappedValue = undefined;
  Object.entries(themeValues).forEach(function (_ref) {
    var _ref2 = index._slicedToArray(_ref, 2),
        themeTokenId = _ref2[0],
        themeValue = _ref2[1];

    if (!themeValue.mapTo) {
      return;
    }

    var mapToArray = typeof themeValue.mapTo === "string" ? [themeValue.mapTo] : themeValue.mapTo;

    if (mapToArray.includes(tokenId)) {
      mappedValue = {
        ref: themeTokenId,
        value: themeValue.value
      };
    }
  });
  return mappedValue;
}

function responsiveValueGetHighestDefinedDevice(input, devices) {
  var highestDefinedDevice;

  for (var i = devices.length - 1; i >= 0; i--) {
    var device = devices[i];

    if (input[device.id] !== undefined) {
      highestDefinedDevice = device;
      break;
    }
  }

  if (highestDefinedDevice === undefined) {
    throw new Error("highest defined value doesn't exist");
  }

  return highestDefinedDevice;
}

function responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  var componentWidths = widths ? index.getDeviceWidthPairs(widths, devices) : index.getDeviceWidthPairsFromDevices(devices);
  var componentWidthIndex = componentWidths.findIndex(function (x) {
    return x.deviceId === breakpoint;
  });
  var componentWidth = devices[componentWidthIndex];

  if (!componentWidth) {
    throw new Error("undefined breakpoint");
  } //
  // if (device.breakpoint === null) {
  //   return;
  // }


  var _loop = function _loop(i) {
    var deviceId = componentWidths[i].deviceId;

    if (value[deviceId] !== undefined) {
      return {
        v: devices.find(function (d) {
          return d.id === deviceId;
        })
      };
    }
  };

  for (var i = componentWidthIndex + 1; i <= componentWidths.length - 1; i++) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return undefined;
}
function responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  var componentWidths = widths ? index.getDeviceWidthPairs(widths, devices) : index.getDeviceWidthPairsFromDevices(devices);
  var componentWidthIndex = componentWidths.findIndex(function (x) {
    return x.deviceId === breakpoint;
  });
  var componentWidth = devices[componentWidthIndex];

  if (!componentWidth) {
    throw new Error("undefined breakpoint");
  }

  var _loop2 = function _loop2(i) {
    var deviceId = componentWidths[i].deviceId;

    if (value[deviceId] !== undefined) {
      return {
        v: devices.find(function (d) {
          return d.id === deviceId;
        })
      };
    }
  };

  for (var i = componentWidthIndex - 1; i >= 0; i--) {
    var _ret2 = _loop2(i);

    if (typeof _ret2 === "object") return _ret2.v;
  }

  return undefined;
}
function responsiveValueFindDeviceWithDefinedValue(value, breakpoint, devices, widths) {
  if (value[breakpoint] !== undefined) {
    return devices.find(function (x) {
      return x.id === breakpoint;
    });
  }

  var higherDevice = responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (higherDevice !== undefined) {
    return higherDevice;
  }

  var lowerDevice = responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (lowerDevice !== undefined) {
    return lowerDevice;
  }

  return undefined;
}

function responsiveValueGetFirstHigherValue(value, breakpoint, devices, widths) {
  var higherDefinedDevice = responsiveValueFindHigherDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!higherDefinedDevice) {
    return;
  }

  return value[higherDefinedDevice.id];
}
function responsiveValueGetFirstLowerValue(value, breakpoint, devices, widths) {
  var lowerDefinedDevice = responsiveValueFindLowerDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!lowerDefinedDevice) {
    return;
  }

  return value[lowerDefinedDevice.id];
}
function responsiveValueGetDefinedValue(value, breakpoint, devices, widths) {
  if (!index.isTrulyResponsiveValue(value)) {
    return value;
  }

  var definedDevice = responsiveValueFindDeviceWithDefinedValue(value, breakpoint, devices, widths);

  if (!definedDevice) {
    return;
  }

  return value[definedDevice.id];
}

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$n(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function responsiveValueFlatten(resVal, devices) {
  if (!index.isTrulyResponsiveValue(resVal)) {
    return resVal;
  }

  var result = {
    $res: true
  };
  var activeNestedValue = undefined; // resValCopy has maximum breakpoint always set correctly, otherwise if we have b1, ..., b5 and responsive value is set to b4, then values ABOVE b4 won't be set.

  var resValCopy = _objectSpread$o({}, resVal);

  var maxDeviceInValue = responsiveValueGetHighestDefinedDevice(resValCopy, devices);
  var maxBreakpoint = devices[devices.length - 1].id; // Important condition. Sometimes if b5 is missing, b3 can be responsive and have b5 inside. Then b5 is defined.

  if (!resValCopy[maxBreakpoint] && index.isTrulyResponsiveValue(resValCopy[maxDeviceInValue.id])) {
    activeNestedValue = resValCopy[maxDeviceInValue.id];
  }

  for (var i = devices.length - 1; i >= 0; i--) {
    var breakpoint = devices[i].id;
    var value = resValCopy[breakpoint];

    if (value === undefined) {
      // If active nested value, we take from nested value;
      if (activeNestedValue !== undefined && activeNestedValue[breakpoint] !== undefined) {
        result[breakpoint] = responsiveValueGetDefinedValue(activeNestedValue, breakpoint, devices, index.getDevicesWidths(devices)
        /** FOR NOW TOKENS ARE ALWAYS RELATIVE TO SCREEN WIDTH */
        );
      }

      continue;
    } else if (!index.isTrulyResponsiveValue(value)) {
      activeNestedValue = undefined;
      result[breakpoint] = value;
    } else {
      activeNestedValue = value;
      result[breakpoint] = responsiveValueGetDefinedValue(activeNestedValue, breakpoint, devices, index.getDevicesWidths(devices)
      /** FOR NOW TOKENS ARE ALWAYS RELATIVE TO SCREEN WIDTH */
      );
    }
  }

  return result;
}

/**
 * Because of how `TrulyResponsiveValue` is typed, if we try to access value at the current breakpoint it would return `true | T | undefined`.
 * The literal type `true` in this type shouldn't be included, because it makes no sense.
 * This comes from definition of `$res` property which is a special property that marks given object as responsive value instead of normal object.
 */
function responsiveValueAt(responsiveValue, breakpointIndex) {
  if (breakpointIndex === "$res") {
    throw new Error("This situation isn't possible! Value of responsive value must be accessed by valid breakpoint name");
  }

  var breakpointValue = responsiveValue[breakpointIndex];
  return breakpointValue;
}

function getDefaultLocale(locales) {
  return locales.find(function (locale) {
    return locale.isDefault;
  });
}

function getFallbackLocaleForLocale(locale, locales) {
  do {
    var _locales$find$fallbac, _locales$find;

    var fallbackId = (_locales$find$fallbac = (_locales$find = locales.find(function (l) {
      return l.code === locale;
    })) === null || _locales$find === void 0 ? void 0 : _locales$find.fallback) !== null && _locales$find$fallbac !== void 0 ? _locales$find$fallbac : getDefaultLocale(locales).code; // Default locale, no fallback

    if (fallbackId === locale) {
      return;
    }

    return fallbackId;
  } while (true);
}

function getFallbackForLocale(translatedValues, locale, locales) {
  while (true) {
    var fallbackLocale = getFallbackLocaleForLocale(locale, locales);

    if (!fallbackLocale) {
      return;
    }

    var fallbackValue = translatedValues[fallbackLocale];

    if (fallbackValue !== undefined && fallbackValue !== null) {
      return fallbackValue;
    }

    locale = fallbackLocale;
  }
}

var textProvider = function textProvider(schemaProp, compilationContext) {
  var checkIfValid = function checkIfValid(x) {
    if (typeof x !== "object" || x === null) {
      return false;
    }

    if (typeof x.id !== "string") {
      return false;
    }

    if (x.id.startsWith("local.")) {
      // for local values "value" must be object
      if (typeof x.value !== "object" || x.value === null) {
        return false;
      }
    }

    return true;
  };

  return {
    normalize: function normalize(x) {
      if (x === undefined || x === null) {
        var _schemaProp$defaultVa;

        return {
          id: "local." + index.uniqueId(),
          value: index._defineProperty({}, compilationContext.contextParams.locale, (_schemaProp$defaultVa = schemaProp.defaultValue) !== null && _schemaProp$defaultVa !== void 0 ? _schemaProp$defaultVa : "Lorem ipsum")
        };
      }

      if (checkIfValid(x)) {
        return x;
      }

      throw new Error("incorrect text type: ".concat(x));
    },
    compile: function compile(x) {
      if (x.id === null) {
        throw new Error("text cant be null");
      }

      if (!x.value) {
        throw new Error("text value cant be empty");
      }

      var value = x.value[compilationContext.contextParams.locale]; // Let's apply fallback when we're editing

      var editorContext = compilationContext;

      if (editorContext.locales && typeof value !== "string") {
        var _getFallbackForLocale;

        value = (_getFallbackForLocale = getFallbackForLocale(x.value, compilationContext.contextParams.locale, editorContext.locales)) !== null && _getFallbackForLocale !== void 0 ? _getFallbackForLocale : "";
      }

      return {
        id: x.id,
        value: value
      };
    },
    getHash: function getHash(value) {
      var _value$id;

      // TODO: those conditions will be removed after we merge external-local texts update
      if (typeof value === "string") {
        return value;
      }

      if (value === null) {
        return undefined;
      }

      return (_value$id = value.id) !== null && _value$id !== void 0 ? _value$id : undefined;
    }
  };
}; // const normalize = getNormalize(
//   compilationContext,
//   { value: schemaProp.defaultValue } as ExternalValue<string>,
//   { value: globalTextDefault } as ExternalValue<string>,
//   (x: any) => {
//     if (typeof x === "string") {
//       return {
//         id: "local." + uniqueId(), // temporary id
//         value: x,
//       };
//     }
//
//     if (typeof x === "object" && x !== null) {
//       if (typeof x.id === "string") {
//         return {
//           id: x.id,
//           value: x.value, // doesn't hurt
//           fallback: x.fallback,
//         };
//       }
//
//       if (typeof x.value === "string") {
//         return {
//           id: "local." + uniqueId(), // temporary id
//           value: x.value,
//           fallback: x.fallback,
//         };
//       }
//     }
//   }
// );

function bubbleDown(matcher, items) {
  var originalOrder = [];
  var bubbledDown = [];
  items.forEach(function (item) {
    if (matcher(item)) {
      bubbledDown.push(item);
    } else {
      originalOrder.push(item);
    }
  });
  return [].concat(originalOrder, bubbledDown);
}

function last(collection) {
  return collection[collection.length - 1];
}

function toArray(scalarOrCollection) {
  if (Array.isArray(scalarOrCollection)) {
    return scalarOrCollection;
  }

  return [scalarOrCollection];
}

function range(start, end) {
  var itemsCount = start === end ? 1 : end - start + 1;
  return Array.from({
    length: itemsCount
  }, function (_, index) {
    return start + index;
  });
}

/**
 * Returns a new function that filters nullable elements to be used as callback of `.filter` method.
 * It's useful because it has already defined guard which otherwise would be repeated in many places
 * and also it automatically changes the return value of filter function by extracting `null` and `undefined` types.
 *
 * Usage:
 * ```
 * const onlyNonNullable = nullableElements.filter<TypeOfCollectionItem>(nonNullable())
 * ```
 */
function nonNullable() {
  return function (value) {
    return value != null;
  };
}

/**
 * Traverses given `config` by invoking given `callback` for each schema prop defined within components from `context`
 */
function configTraverse(config, context, callback) {
  configTraverseInternal(config, context, callback, "");
}

function configTraverseArray(array, context, callback, path) {
  array.forEach(function (config, index) {
    configTraverseInternal(config, context, callback, "".concat(path, ".").concat(index));
  });
}

function configTraverseInternal(config, context, callback, path) {
  var componentDefinition = index.findComponentDefinition(config, context);

  if (!componentDefinition) {
    console.warn("[configTraverse] Unknown component definition for: ".concat(config._template));
    return;
  }

  var pathPrefix = path === "" ? "" : path + ".";
  componentDefinition.schema.forEach(function (schemaProp) {
    if (index.isSchemaPropComponent(schemaProp) || schemaProp.type === "component-collection") {
      callback({
        value: config[schemaProp.prop],
        path: "".concat(pathPrefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });
      configTraverseArray(config[schemaProp.prop], context, callback, "".concat(pathPrefix).concat(schemaProp.prop));
    } else if (schemaProp.type === "component-collection-localised") {
      callback({
        value: config[schemaProp.prop],
        path: "".concat(pathPrefix).concat(schemaProp.prop),
        schemaProp: schemaProp
      });

      for (var locale in config[schemaProp.prop]) {
        configTraverseArray(config[schemaProp.prop][locale], context, callback, "".concat(pathPrefix).concat(schemaProp.prop, ".").concat(locale));
      }
    } else {
      var currentPath = "".concat(pathPrefix).concat(schemaProp.prop);
      callback({
        path: currentPath,
        value: config[schemaProp.prop],
        schemaProp: schemaProp
      });
    }
  });
}

/**
 * Traverses given `config` by invoking given `callback` for each schema prop defined within components from `context`
 */
function traverseComponents(config, context, callback) {
  traverseComponentsInternal(config, context, callback, "");
}

function traverseComponentsArray(array, context, callback, path) {
  array.forEach(function (config, index) {
    traverseComponentsInternal(config, context, callback, "".concat(path, ".").concat(index));
  });
}

function traverseComponentsInternal(componentConfig, context, callback, path) {
  var componentDefinition = index.findComponentDefinition(componentConfig, context);

  if (!componentDefinition) {
    console.warn("[traverseComponents] Unknown component definition", componentConfig);
    return;
  }

  var pathPrefix = path === "" ? "" : path + ".";
  callback({
    componentConfig: componentConfig,
    path: path
  });
  componentDefinition.schema.forEach(function (schemaProp) {
    if (index.isSchemaPropComponent(schemaProp) || schemaProp.type === "component-collection") {
      traverseComponentsArray(componentConfig[schemaProp.prop], context, callback, "".concat(pathPrefix).concat(schemaProp.prop));
    } else if (schemaProp.type === "component-collection-localised") {
      for (var locale in componentConfig[schemaProp.prop]) {
        traverseComponentsArray(componentConfig[schemaProp.prop][locale], context, callback, "".concat(pathPrefix).concat(schemaProp.prop, ".").concat(locale));
      }
    }
  });
}

function configFindAllPaths(config, editorContext, predicate) {
  var matchedConfigPaths = [];
  traverseComponents(config, editorContext, function (_ref) {
    var path = _ref.path,
        componentConfig = _ref.componentConfig;

    if (predicate(componentConfig, editorContext)) {
      matchedConfigPaths.push(path);
    }
  });
  return matchedConfigPaths;
}

function dotNotationGet(obj, path) {
  if (path === "") {
    return obj;
  }

  return path.split(".").reduce(function (acc, curVal) {
    return acc && acc[curVal];
  }, obj);
}

var pxKeys = {
  margin: true,
  marginTop: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
  m: true,
  mt: true,
  mb: true,
  ml: true,
  mr: true,
  mx: true,
  my: true,
  padding: true,
  paddingTop: true,
  paddingBottom: true,
  paddingLeft: true,
  paddingRight: true,
  p: true,
  pt: true,
  pb: true,
  pl: true,
  pr: true,
  px: true,
  py: true,
  top: true,
  bottom: true,
  left: true,
  right: true,
  flexBasis: true,
  gridColumnGap: true,
  gridRowGap: true
};

function numericToPx(input) {
  var ret = {};

  for (var _key in input) {
    if (pxKeys[_key] && typeof input[_key] === "number") {
      ret[_key] = input[_key] + "px";
    } else {
      ret[_key] = input[_key];
    }
  }

  return ret;
}

var box = function box(styles, tag) {
  var ret = numericToPx(styles);
  ret.__isBox = true;

  if (tag) {
    ret.__as = tag;
  }

  return ret;
};

function styles$4(values) {
  return {
    Root: box({
      display: "flex",
      justifyContent: mapAlignmentToFlexAlignment(values.align),
      textAlign: values.align
    }),
    elements: {
      // We store values within $richText to allow for changing them from sidebar, but we use them inside of $richTextBlockElement.
      itemProps: values.elements.map(function () {
        return {
          accessibilityRole: values.accessibilityRole,
          mainColor: values.mainColor,
          mainFont: values.mainFont,
          mainFontSize: values.mainFontSize,
          align: values.align
        };
      })
    },
    __props: {
      align: values.align
    }
  };
}
function mapAlignmentToFlexAlignment(align) {
  if (align === "center") {
    return "center";
  }

  if (align === "right") {
    return "flex-end";
  }

  return "flex-start";
}

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$m(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var buttonActionSchemaProp = {
  prop: "action",
  label: "Action",
  type: "component",
  // for now actions are components
  componentTypes: ["action"],
  visible: true,
  group: "Action",
  defaultValue: [],
  isLabelHidden: true
};
var buttonLabelSchemaProp = {
  prop: "label",
  type: "text",
  label: "Label",
  group: "Properties",
  normalize: function normalize(x) {
    if (x.trim() === "") {
      return null;
    }

    return x;
  }
};
var buttonOptionalIconSchemaProp = {
  prop: "symbol",
  label: "Symbol",
  type: "component",
  componentTypes: ["symbol"],
  visible: true,
  group: "Properties"
};
var buttonRequiredIconSchemaProp = _objectSpread$n(_objectSpread$n({}, buttonOptionalIconSchemaProp), {}, {
  required: true
});

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var richTextInlineWrapperActionSchemaProp = _objectSpread$m(_objectSpread$m({}, buttonActionSchemaProp), {}, {
  componentTypes: ["action"],
  label: "Link"
});

/**
 * This is a copy of validate-color function from validate-color npm package. This package has problem with bundling, so I copied it here. It was modified 100 years ago anyway and had 32 stars, so nothing fancy really.
 */
// Good article on HTML Colors:
// https://dev.to/alvaromontoro/the-ultimate-guide-to-css-colors-2020-edition-1bh1#hsl
// Check if parameter is defined and a string
var isString$1 = function isString(color) {
  return color && typeof color === "string";
}; // All existing HTML color names


var htmlColorNames = ["AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "Goldenrod", "Gray", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenrodYellow", "LightGray", "LightGreen", "LightPink", "LightSalmon", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquamarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "RebeccaPurple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow", "YellowGreen"]; // These 3 values are valid, usable color names, which are special in their own way

var htmlColorNamesSpecial = ["currentColor", "inherit", "transparent"]; // Validate HTML color name (red, yellow, etc)

var validateHTMLColorName = function validateHTMLColorName(color) {
  var status = false;

  if (isString$1(color)) {
    htmlColorNames.map(function (c) {
      if (color.toLowerCase() === c.toLowerCase()) {
        status = true;
      }

      return null;
    });
  }

  return status;
}; // Validate HTML color special name (currentColor, inherit, etc)

var validateHTMLColorSpecialName = function validateHTMLColorSpecialName(color) {
  var status = false;

  if (isString$1(color)) {
    htmlColorNamesSpecial.map(function (c) {
      if (color.toLowerCase() === c.toLowerCase()) {
        status = true;
      }

      return null;
    });
  }

  return status;
}; // Validate HTML color 'hex'

var validateHTMLColorHex = function validateHTMLColorHex(color) {
  if (isString$1(color)) {
    var regex = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'rgb'
// -- legacy notation
// color: rgb(255, 255, 255);
// color: rgba(255, 255, 255, 1);
// -- new notation
// color: rgb(255 255 255);
// color: rgb(255 255 255 / 1);
// Note that 'rgba()' is now merged into 'rgb()'

var validateHTMLColorRgb = function validateHTMLColorRgb(color) {
  if (isString$1(color)) {
    var regex = /(rgb)a?\((\s*\d+%?\s*?,?\s*){2}(\s*\d+%?\s*?,?\s*\)?)(\s*,?\s*\/?\s*(0?\.?\d+%?\s*)?|1|0)?\)$/i;
    return !!color && regex.test(color);
  }

  return false;
};
var optionalCommaOrRequiredSpace = "((\\s*,\\s*)|(\\s+))";
var optionalDecimals = "(\\.\\d+)?";
var anyPercentage = "((\\d*".concat(optionalDecimals, ")%)");
var hundredPercent = "(([0-9]|[1-9][0-9]|100)%)";
var alphaPercentage = "(((".concat(hundredPercent, "))|(0?").concat(optionalDecimals, ")|1))?");
var endingWithAlphaPercentage = "\\s*?\\)?)(\\s*?(\\/?)\\s+".concat(alphaPercentage, "\\s*?\\)$"); // Validate HTML color 'hsl'
// -- These units are valid for the first parameter
// 'deg': degrees | full circle = 360
// 'gra': gradians | full circle = 400
// 'radians': radians | full circle = 2π (approx. 6.28)
// 'turn': turns | full circle = 1

var validateHTMLColorHsl = function validateHTMLColorHsl(color) {
  if (isString$1(color)) {
    // Validate each possible unit value separately, as their values differ
    var degRegex = "(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)";
    var graRegex = "(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)gra)";
    var radRegex = "((([0-5])?\\.\\d+|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)";
    var turnRegex = "((0?".concat(optionalDecimals, "|1)turn)");
    var regexLogic = "(hsl)a?\\((\\s*?(".concat(degRegex, "|").concat(graRegex, "|").concat(radRegex, "|").concat(turnRegex, ")").concat(optionalCommaOrRequiredSpace, ")(\\s*?(0|").concat(hundredPercent, ")").concat(optionalCommaOrRequiredSpace, ")(\\s*?(0|").concat(hundredPercent, ")\\s*?\\)?)(\\s*?(\\/?|,?)\\s*?(((").concat(hundredPercent, "))|(0?").concat(optionalDecimals, ")|1))?\\)$");
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'hwb'
// -- 'hwb' accepts 'deg' as unit in its 1st property, which stands for 'hue'
// 'deg': degrees | full circle = 360

var validateHTMLColorHwb = function validateHTMLColorHwb(color) {
  if (isString$1(color)) {
    var degRegex = "(-?([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9]|360)(deg)?)";
    var regexLogic = "(hwb\\(\\s*?".concat(degRegex, "\\s+)((0|").concat(hundredPercent, ")\\s+)((0|").concat(hundredPercent, ")").concat(endingWithAlphaPercentage);
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate HTML color 'lab'
// -- 'lab' 2nd & 3rd parameters are any number between -160 & 160

var validateHTMLColorLab = function validateHTMLColorLab(color) {
  if (isString$1(color)) {
    var labParam = "(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])".concat(optionalDecimals, "?|160))");
    var regexLogic = "(lab\\(\\s*?".concat(anyPercentage, "\\s+").concat(labParam, "\\s+").concat(labParam).concat(endingWithAlphaPercentage);
    var regex = new RegExp(regexLogic);
    return !!color && regex.test(color);
  }

  return false;
}; // Validate only HTML colors (`hex`, `rgb`, `rgba`, `hsl`, `hsla`, `hwb`, `lab`), without `name` og `special name`**

var validateColor = function validateColor(color) {
  // Former validation - source: https://www.regextester.com/103656
  // if (isString(color)) {
  //   const regex = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$|(rgb|hsl)a?\((\s*-?\d+%?\s*,){2}(\s*-?\d+%?\s*,?\s*\)?)(,\s*(0?\.\d+)?|1|0)?\)$/i;
  //   return color && regex.test(color);
  // }
  // New validation
  if (color && validateHTMLColorHex(color) || validateHTMLColorName(color) || validateHTMLColorSpecialName(color) || validateHTMLColorRgb(color) || validateHTMLColorHsl(color) || validateHTMLColorHwb(color) || validateHTMLColorLab(color)) {
    return true;
  }

  return false;
};

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getCommonFieldProps(schemaProp) {
  var label = schemaProp.label || schemaProp.prop;
  var group = schemaProp.group || "Properties";
  return {
    label: label,
    name: schemaProp.prop,
    group: group,
    schemaProp: schemaProp,
    description: schemaProp.description,
    isLabelHidden: schemaProp.isLabelHidden
  };
}

function buildThemeDefinition$1(themeValues, schemaProp, allowCustom) {
  var normalizeCustomValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };

  var outputThemeValues = _objectSpread$l({}, themeValues);

  if (schemaProp.prefix) {
    for (var _key in outputThemeValues) {
      if (!_key.startsWith(schemaProp.prefix + ".")) {
        delete outputThemeValues[_key];
      } else {
        outputThemeValues[_key] = _objectSpread$l(_objectSpread$l({}, outputThemeValues[_key]), {}, {
          label: _key.split("".concat(schemaProp.prefix, "."))[1]
        });
      }
    }
  }

  for (var _key2 in outputThemeValues) {
    if (getMappedToken(_key2, themeValues)) {
      delete outputThemeValues[_key2];
    }
  }

  return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
    component: "responsive2",
    subComponent: "token",

    /**
     * For now we force "hasAuto: false", because auto logic is not yet decided.
     * 1. We must decide if we set 100px on desktop and go to mobile if we should show "auto" or "100px". Or "(auto) 100px".
     * 2. To show sth like "(auto) 100px" we must have access to compiled field (right now we have only access to compiled).
     * 3. This causes a bug, that when linearity is on, show value from higher breakpoint which is bascially not true (the value is different).
     */
    hasAuto: false,
    tokens: outputThemeValues,
    extraValues: schemaProp.extraValues,
    // other fields might ignore it
    normalizeCustomValue: normalizeCustomValue,
    allowCustom: allowCustom,
    format: function format(x) {
      return x;
    },
    parse: function parse(x) {
      return x;
    }
  });
}

var tinaFieldProviders = {
  text: function text(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "text",
      name: schemaProp.prop,
      normalize: schemaProp.normalize
    });
  },
  number: function number(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "number",
      step: 1,
      min: schemaProp.min,
      max: schemaProp.max
    });
  },
  string: function string(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "text",
      normalize: schemaProp.normalize
    });
  },
  string$: function string$(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "text",
      normalize: schemaProp.normalize
    });
  },
  "boolean": function boolean(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "toggle"
    });
  },
  boolean$: function boolean$(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "toggle"
    });
  },
  select: function select(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "select",
      options: schemaProp.options
    });
  },
  "radio-group": function radioGroup(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "radio-group",
      options: schemaProp.options
    });
  },
  select$: function select$(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "select",
      options: schemaProp.options
    });
  },
  "radio-group$": function radioGroup$(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "radio-group",
      options: schemaProp.options
    });
  },
  color: function color(schemaProp, editorContext) {
    return buildThemeDefinition$1(editorContext.theme.colors, schemaProp, true, function (x) {
      if (validateColor(x)) {
        return x;
      } // "fafafa" should be a correct color!


      if (validateColor("#" + x)) {
        return "#" + x;
      }

      return "#999999";
    });
  },
  stringToken: function stringToken(schemaProp, editorContext) {
    var allowCustom;
    var normalizeFunction;

    if (schemaProp.tokenId === "aspectRatios") {
      allowCustom = true;

      normalizeFunction = function normalizeFunction(x) {
        var defaultValue = "3:2";

        if (typeof x !== "string") {
          return defaultValue;
        }

        if (!x.match(/[0-9]+:[0-9]+/)) {
          return defaultValue;
        }

        return x;
      };
    } else if (schemaProp.tokenId === "containerWidths") {
      allowCustom = true;

      normalizeFunction = function normalizeFunction(x) {
        if (x === "none") {
          return x;
        }

        var defaultValue = "1600";

        if (typeof x !== "string") {
          return defaultValue;
        }

        var parsed = parseInt(x);

        if (isNaN(parsed)) {
          return defaultValue;
        }

        parsed = Math.max(parsed, 500);
        parsed = Math.min(parsed, 3000);
        return parsed.toString();
      };
    }

    return buildThemeDefinition$1(_objectSpread$l({}, editorContext.theme[schemaProp.tokenId]), schemaProp, allowCustom, normalizeFunction);
  },
  font: function font(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, buildThemeDefinition$1(editorContext.theme.fonts, schemaProp)), {}, {
      subComponent: "fontToken"
    });
  },
  space: function space(schemaProp, editorContext) {
    return buildThemeDefinition$1(editorContext.theme.space, schemaProp, true, function (x) {
      var _int = Math.round(parseInt(x));

      if (isNaN(_int) || _int < 0) {
        return "0px";
      }

      return "".concat(_int, "px");
    });
  },
  icon: function icon(schemaProp, editorContext) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "token",

      /**
       * For now we force "hasAuto: false", because auto logic is not yet decided.
       * 1. We must decide if we set 100px on desktop and go to mobile if we should show "auto" or "100px". Or "(auto) 100px".
       * 2. To show sth like "(auto) 100px" we must have access to compiled field (right now we have only access to compiled).
       * 3. This causes a bug, that when linearity is on, show value from higher breakpoint which is bascially not true (the value is different).
       */
      hasAuto: false,
      tokens: editorContext.theme.icons,
      normalizeCustomValue: function normalizeCustomValue(x) {
        return x;
      },
      allowCustom: true
    }); // return {
    //   ...getCommonFieldProps(schemaProp),
    //   component: "icon",
    // };
  },
  image: function image(schemaProp, editorContext) {
    var _editorContext$image = editorContext.image,
        resourceType = _editorContext$image.resourceType,
        _editorContext$image$ = _editorContext$image.params,
        params = _editorContext$image$ === void 0 ? {} : _editorContext$image$; // Looking for type representing image

    var imageType = editorContext.resourceTypes[resourceType];

    if (!imageType) {
      throw new Error("Can't find field named \"".concat(resourceType, "\" for image"));
    }

    var imageWidget = imageType.widget;

    if (!imageWidget) {
      throw new Error("Can't find widget named \"".concat(resourceType, "\" for image"));
    } // Passing custom schemaProp parameters to the field if a function


    var imageField = typeof imageWidget === "function" ? imageWidget(params) : imageWidget;
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "external",
      externalField: imageField
    });
  },
  video: function video(schemaProp, editorContext) {
    var _editorContext$video = editorContext.video,
        resourceType = _editorContext$video.resourceType,
        _editorContext$video$ = _editorContext$video.params,
        params = _editorContext$video$ === void 0 ? {} : _editorContext$video$; // Looking for type representing image

    var videoType = editorContext.resourceTypes[resourceType];

    if (!videoType) {
      throw new Error("Can't find field named \"".concat(resourceType, "\" for image"));
    }

    var videoWidget = videoType.widget;

    if (!videoWidget) {
      throw new Error("Can't find widget named \"".concat(resourceType, "\" for image"));
    } // Passing custom schemaProp parameters to the field if a function


    var videoField = typeof videoWidget === "function" ? videoWidget(params) : videoWidget;
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "responsive2",
      subComponent: "external",
      externalField: videoField
    });
  },
  component: function component(schemaProp) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "ss-block",
      schemaProp: schemaProp
    });
  },
  "component-fixed": function componentFixed(schemaProp) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "ss-block",
      schemaProp: schemaProp
    });
  },
  "component-collection": function componentCollection(schemaProp) {
    throw new Error("component-collection is not yet supported in sidebar");
  },
  "component-collection-localised": function componentCollectionLocalised(schemaProp) {
    throw new Error("component-collection-localised is not yet supported in sidebar");
  },
  component$$$: function component$$$(schemaProp) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "identity",
      schemaProp: schemaProp
    });
  },
  variants$$$: function variants$$$(schemaProp) {
    return _objectSpread$l(_objectSpread$l({}, getCommonFieldProps(schemaProp)), {}, {
      component: "variant",
      schemaProp: schemaProp
    });
  },
  resource: function resource(schemaProp, editorContext) {
    var _schemaProp$params;

    var resourceType = editorContext.resourceTypes[schemaProp.resourceType];

    if (!resourceType) {
      throw new Error("Resource field of type '".concat(schemaProp.resourceType, "' not defined."));
    }

    var fieldWidget = resourceType.widget;

    if (!fieldWidget) {
      throw new Error("Can't find widget named \"".concat(schemaProp.resourceType, "\""));
    }

    var field = typeof fieldWidget === "function" ? fieldWidget((_schemaProp$params = schemaProp.params) !== null && _schemaProp$params !== void 0 ? _schemaProp$params : {}) : fieldWidget;
    return _objectSpread$l({
      component: "external",
      externalField: field
    }, getCommonFieldProps(schemaProp));
  }
};
function getTinaField(schemaProp, editorContext, componentDefinition) {
  var fieldProvider = tinaFieldProviders[schemaProp.type] || tinaFieldProviders.resource;
  return fieldProvider(schemaProp, editorContext, componentDefinition);
}

/**
 * When selecting text within $richText, we keep information about which text parts are selected
 * within focused fields. If the text part is partially selected, we add information about the selection.
 * This selection has format: ".{textPartCharacterSelectionStartIndex,textPartCharacterSelectionEndIndex}".
 * We often want to query related to selection text part component config and to do that correctly we need to
 * strip information about selection.
 */
function stripRichTextPartSelection(value) {
  return value.replace(/\.\{\d+,\d+\}$/g, "");
}

function parsePath(path, form) {
  var values = form.values;
  var pathSplit = path === "" ? [] : stripRichTextPartSelection(path).split(".");
  var pathInfo = undefined; // We're going from current path down the path to find current template and parent template

  for (var i = pathSplit.length; i >= 0; i--) {
    var testedPath = pathSplit.slice(0, i).join(".");
    var value = dotNotationGet(values, testedPath);

    if (typeof value === "object" && typeof value._template === "string") {
      if (pathInfo === undefined) {
        pathInfo = {
          templateId: value._template
        }; // fieldName

        var fieldPath = pathSplit.slice(i);

        if (fieldPath.length > 0) {
          pathInfo.fieldName = fieldPath.join(".");
        }

        var potentialIndex = parseInt(pathSplit[i - 1]);

        if (!isNaN(potentialIndex)) {
          pathInfo.index = potentialIndex;
        }
      } else {
        pathInfo.parent = {
          templateId: value._template,
          fieldName: pathSplit[i],
          path: testedPath
        };
        break;
      }
    }
  }

  if (!pathInfo) {
    throw new Error("incorrect path: ".concat(path));
  }

  return pathInfo;
}
function findPathOfFirstAncestorOfType(path, templateId, form) {
  while (true) {
    var parseResult = parsePath(path, form);

    if (!parseResult.parent) {
      throw new Error("couldn't find ancestor of type ".concat(templateId));
    }

    if (parseResult.parent.templateId === templateId) {
      return parseResult.parent.path;
    }

    path = parseResult.parent.path;
  }
}

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DEFAULT_FONT_VALUES = {
  fontWeight: "initial",
  fontStyle: "initial"
};
function styles$3(_ref, t) {
  var color = _ref.color,
      font = _ref.font,
      value = _ref.value,
      __modifierStyles = _ref.__modifierStyles;

  var fontWithDefaults = _objectSpread$k(_objectSpread$k({}, DEFAULT_FONT_VALUES), font);

  return {
    Text: box(_objectSpread$k(_objectSpread$k(_objectSpread$k({
      color: color
    }, fontWithDefaults), __modifierStyles), {}, {
      "& *": _objectSpread$k({
        fontFamily: "inherit",
        fontStyle: "inherit",
        color: "inherit"
      }, __modifierStyles)
    }), "span"),
    __props: {
      color: color,
      font: font,
      value: value
    }
  };
}

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var richTextPartEditableComponent = {
  id: "$richTextPart",
  schema: [{
    prop: "value",
    type: "string",
    visible: false,
    group: "Text"
  }, {
    prop: "font",
    label: "Style",
    type: "font",
    group: "Text"
  }, {
    prop: "color",
    label: "Color",
    type: "color",
    group: "Text"
  }],
  editing: function editing(_, editingInfo, _ref) {
    var pathPrefix = _ref.pathPrefix,
        editorContext = _ref.editorContext;
    var resultFields = [];
    var richTextPath = findPathOfFirstAncestorOfType(pathPrefix, "$richText", editorContext.form);
    var richTextBlockPath = findPathOfFirstAncestorOfType(pathPrefix, "$richTextBlockElement", editorContext.form);
    resultFields.push.apply(resultFields, [{
      portal: "component",
      source: richTextPath,
      includeHeader: true,
      groups: ["Size", "Margins"]
    }].concat(index._toConsumableArray(editingInfo.fields.slice(1)), [{
      portal: "field",
      source: richTextBlockPath,
      fieldName: "type"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "isListStyleAuto"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "mainFont"
    }, {
      portal: "field",
      source: richTextPath,
      fieldName: "mainColor"
    }, {
      portal: "component",
      source: richTextPath,
      groups: ["Accessibility and SEO"]
    }]));

    try {
      // We add fields from inline-wrapper to show current values of filtered fields and any additional field within
      // sidebar when text is selected.
      var inlineWrapperPath = findPathOfFirstAncestorOfType(pathPrefix, "$richTextInlineWrapperElement", editorContext.form);
      resultFields.push({
        portal: "component",
        source: inlineWrapperPath
      });
    } catch (error) {
      // When $richTextPart is outside of wrapper element, we add field for displaying action schema prop to allow
      // to add action to selected text without putting it into schemas of $richTextPart.
      var actionField = getTinaField(_objectSpread$j(_objectSpread$j({}, richTextInlineWrapperActionSchemaProp), {}, {
        prop: "$action",
        definition: index.findComponentDefinitionById("$richTextInlineWrapperElement", editorContext)
      }), editorContext);
      resultFields.push(_objectSpread$j(_objectSpread$j({}, actionField), {}, {
        name: "".concat(pathPrefix, ".$action")
      })); // if (
      //   "disabled" ===
      //   "enabled"
      // ) {
      //   const textModifierField = getTinaField(
      //     {
      //       ...optionalTextModifierSchemaProp,
      //       prop: "$textModifier",
      //       definition: findComponentDefinitionById(
      //         "$richTextInlineWrapperElement",
      //         editorContext
      //       )!,
      //       defaultValue: [],
      //       visible: true,
      //     },
      //     editorContext
      //   );
      //   resultFields.push({
      //     ...textModifierField,
      //     name: `${pathPrefix}.$textModifier`,
      //   });
      // }
    }

    return {
      fields: resultFields
    };
  },
  tags: ["notrace"],
  styles: styles$3
};

function styles$2(values) {
  return {
    TextLine: box({
      lineHeight: "initial",
      wordBreak: "break-word"
    }, "div"),
    ListItem: box({
      display: "flex",
      justifyContent: mapAlignmentToFlexAlignment(values.align),
      alignItems: "baseline",
      paddingLeft: 0,
      lineHeight: "initial",
      wordBreak: "break-word",
      listStyle: "none",
      counterIncrement: "list-item",
      // Allows flex items to break when text is overflowing
      "& > *": {
        minWidth: 0
      }
    }, "li"),
    __props: {
      blockType: values.blockType
    }
  };
}

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function textModifierSchemaProp(options) {
  return _objectSpread$i({
    type: "component",
    componentTypes: ["textModifier"],
    // Schema props of type "component" are hidden by default
    visible: true
  }, options);
}

function getTextModifierStyles(modifier, compilationContext) {
  var modifierStyles = {};
  var childStyles;

  if (modifier.length === 1) {
    var modifierDefinition = index.findComponentDefinitionById(modifier[0]._template, compilationContext);

    if (modifierDefinition) {
      var _modifierDefinition$c;

      modifierStyles = modifierDefinition.apply(modifier[0]);
      childStyles = (_modifierDefinition$c = modifierDefinition.childApply) === null || _modifierDefinition$c === void 0 ? void 0 : _modifierDefinition$c.call(modifierDefinition, modifier[0]);
    }
  }

  return {
    modifierStyles: modifierStyles,
    childStyles: childStyles
  };
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function styles$1(_ref, t) {
  var action = _ref.action,
      elements = _ref.elements,
      actionTextModifier = _ref.actionTextModifier;
  var actionStyles = action.length > 0 ? {
    __action: "action",
    background: "transparent"
  } : {};

  var _getTextModifierStyle = getTextModifierStyles(actionTextModifier, t.compilationContext),
      modifierStyles = _getTextModifierStyle.modifierStyles,
      childStyles = _getTextModifierStyle.childStyles;

  var contextProps = childStyles !== undefined ? {
    elements: {
      itemProps: elements.map(function () {
        return {
          __modifierStyles: childStyles
        };
      })
    }
  } : {};
  return _objectSpread$h({
    Link: box(_objectSpread$h(_objectSpread$h({}, actionStyles), modifierStyles), t.compilationContext.isEditing ? "span" : "a")
  }, contextProps);
}

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var optionalTextModifierSchemaProp = textModifierSchemaProp({
  prop: "textModifier",
  label: "Text modifier",
  group: "Text",
  visible: function visible(_ref) {
    var actionTextModifier = _ref.actionTextModifier;
    return actionTextModifier.length === 0;
  },
  defaultValue: []
});

var requiredActionTextModifierSchemaProp = _objectSpread$g(_objectSpread$g({}, optionalTextModifierSchemaProp), {}, {
  prop: "actionTextModifier",
  componentTypes: ["actionTextModifier"],
  required: true,
  label: "Link styles",
  group: "Action",
  visible: function visible(_ref2) {
    var action = _ref2.action;
    return action.length === 1;
  }
});

var richTextInlineWrapperElementEditableComponent = {
  id: "$richTextInlineWrapperElement",
  schema: [{
    prop: "elements",
    type: "component-collection",
    componentTypes: ["$richTextPart"]
  }, // optionalTextModifierSchemaProp,
  richTextInlineWrapperActionSchemaProp, requiredActionTextModifierSchemaProp],
  styles: styles$1,
  tags: ["notrace"]
};

var richTextLineElementEditableComponent = {
  id: "$richTextLineElement",
  schema: [{
    prop: "elements",
    type: "component-collection",
    componentTypes: [richTextPartEditableComponent.id, richTextInlineWrapperElementEditableComponent.id]
  }],
  styles: styles$2,
  tags: ["notrace"]
};

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function px(value) {
  if (typeof value === "number") {
    return value === 0 ? "0" : "".concat(value, "px");
  }

  return value;
}

var BULLETED_LIST_MIN_INLINE_SPACING = 8;
var NUMBERED_LIST_MIN_COUNTER_SPACING = 8;
var NUMBERED_LIST_MAX_COUNTER_SPACING = "0.5ch";
/**
 * Numbered list consists of number and dot. We can safely calculate required space for number by
 * counting digits of list length and using `ch` unit. Dot character differentiate between fonts
 * and we reserve at least 0.5ch of space.
 */

var NUMBERED_LIST_DOT_CHARACTER_SAFE_WIDTH = "0.5ch";
var BULLET_CHARACTER = "\u2022";
function styles(_ref) {
  var accessibilityRole = _ref.accessibilityRole,
      align = _ref.align,
      elements = _ref.elements,
      mainColor = _ref.mainColor,
      mainFont = _ref.mainFont,
      mainFontSize = _ref.mainFontSize,
      type = _ref.type;
  var maxDigitsCount = elements.length.toString().length;
  var paddingInline = "clamp(".concat(px(BULLETED_LIST_MIN_INLINE_SPACING), ", calc(").concat(px(mainFontSize), " * 0.5), ").concat(px(mainFontSize), ")");
  var bulletedListMarkerStyles = {
    paddingLeft: paddingInline,
    paddingRight: paddingInline,
    content: BULLET_CHARACTER
  };
  var numberedListMarkerStyles = {
    minWidth: "calc(".concat(maxDigitsCount, " * 1ch + ").concat(NUMBERED_LIST_DOT_CHARACTER_SAFE_WIDTH, ")"),
    paddingRight: "clamp(".concat(px(NUMBERED_LIST_MIN_COUNTER_SPACING), ", 0.5ch, ").concat(NUMBERED_LIST_MAX_COUNTER_SPACING, ")"),
    fontVariantNumeric: "tabular-nums",
    textAlign: "right",
    content: "counter(list-item)\".\""
  };

  var markerStyles = _objectSpread$f({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 0,
    flexShrink: 0,
    fontSize: mainFontSize
  }, type === "bulleted-list" ? bulletedListMarkerStyles : numberedListMarkerStyles);

  var listStyles = _objectSpread$f(_objectSpread$f({
    counterSet: "list-item",
    paddingLeft: 0,
    listStyle: "none",
    color: mainColor
  }, mainFont), {}, {
    "& > li": _objectSpread$f(_objectSpread$f({
      color: mainColor
    }, mainFont), {}, {
      // Instead of using ::marker pseudo-element, we use ::before because it gives us more control over its appearance.
      "&::before": markerStyles
    })
  });

  return {
    Paragraph: box({}, accessibilityRole),
    BulletedList: box(listStyles, "ul"),
    NumberedList: box(listStyles, "ol"),
    elements: {
      itemProps: elements.map(function () {
        return {
          blockType: type,
          align: align
        };
      })
    },
    __props: {
      type: type
    }
  };
}

var RICH_TEXT_BLOCK_ELEMENT_TYPES = ["bulleted-list", "numbered-list", "paragraph"];
var RICH_TEXT_BLOCK_ELEMENT_TYPE_OPTIONS = [{
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[0],
  label: "Bulleted"
}, {
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[1],
  label: "Numbered"
}, {
  value: RICH_TEXT_BLOCK_ELEMENT_TYPES[2],
  label: "No list"
}];
var richTextBlockElementEditableComponent = {
  id: "$richTextBlockElement",
  schema: [{
    prop: "type",
    type: "select",
    options: RICH_TEXT_BLOCK_ELEMENT_TYPE_OPTIONS,
    defaultValue: RICH_TEXT_BLOCK_ELEMENT_TYPES[2],
    label: "Type",
    group: "Text"
  }, {
    prop: "elements",
    type: "component-collection",
    componentTypes: [richTextLineElementEditableComponent.id]
  }],
  styles: styles,
  tags: ["notrace"]
};

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var richTextEditableComponent = {
  id: "$richText",
  schema: [{
    prop: "elements",
    type: "component-collection-localised",
    componentTypes: [richTextBlockElementEditableComponent.id],
    visible: false
  }, {
    prop: "accessibilityRole",
    type: "select",
    label: "Role",
    options: [{
      value: "div",
      label: "Paragraph"
    }].concat(index._toConsumableArray(range(1, 6).map(function (index) {
      return {
        value: "h".concat(index),
        label: "Heading ".concat(index)
      };
    }))),
    group: "Accessibility and SEO"
  }, {
    prop: "isListStyleAuto",
    type: "boolean",
    label: "Auto list styles",
    defaultValue: true,
    visible: false,
    group: "Text"
  }, {
    prop: "mainFont",
    type: "font",
    label: "Main font",
    visible: false,
    group: "Text"
  }, {
    prop: "mainColor",
    type: "color",
    label: "Main color",
    visible: false,
    group: "Text"
  }],
  tags: ["item", "notrace"],
  styles: styles$4,
  editing: function editing(values, _ref, _ref2) {
    var fields = _ref.fields;
    var editorContext = _ref2.editorContext,
        pathPrefix = _ref2.pathPrefix;
    var richTextConfig = dotNotationGet(editorContext.form.values, pathPrefix);
    var richTextBlockPaths = configFindAllPaths(richTextConfig, editorContext, function (config) {
      return config._template === "$richTextBlockElement";
    });
    var richTextBlockPath = "".concat(pathPrefix, ".").concat(richTextBlockPaths[0]);
    var richTextBlockType = dotNotationGet(editorContext.form.values, "".concat(richTextBlockPath, ".type"));
    var accessibilityRoleFieldIndex = fields.findIndex(function (field) {
      return field.schemaProp.prop === "accessibilityRole";
    });
    var fieldsBeforeAccessibilityRole = fields.slice(0, accessibilityRoleFieldIndex);
    var listStyleField = {
      portal: "field",
      fieldName: "type",
      source: richTextBlockPath,
      overrides: {
        label: "List style",
        group: "Text"
      },
      hidden: richTextBlockPaths.length === 0
    };
    var fieldsAfterAccessibilityRole = fields.slice(accessibilityRoleFieldIndex).map(function (field) {
      if (richTextBlockType !== "paragraph") {
        if (field.schemaProp.prop === "accessibilityRole") {
          return _objectSpread$e(_objectSpread$e({}, field), {}, {
            hidden: true
          });
        }

        if (field.schemaProp.prop === "isListStyleAuto" && richTextBlockPaths.length > 0) {
          return _objectSpread$e(_objectSpread$e({}, field), {}, {
            hidden: false
          });
        }

        if (!values.isListStyleAuto && (field.schemaProp.prop === "mainFont" || field.schemaProp.prop === "mainColor")) {
          return _objectSpread$e(_objectSpread$e({}, field), {}, {
            hidden: false
          });
        }
      }

      return field;
    });
    var richTextPartPaths = configFindAllPaths(richTextConfig, editorContext, function (config) {
      return config._template === "$richTextPart";
    });
    var currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(editorContext.contextParams.locale));

    if (currentLocaleRichTextPartPaths.length === 0) {
      var fallbackLocale = getFallbackLocaleForLocale(editorContext.contextParams.locale, editorContext.locales);

      if (fallbackLocale) {
        currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(fallbackLocale));
      }
    }

    var richTextPartSources = currentLocaleRichTextPartPaths.map(function (path) {
      return "".concat(pathPrefix, ".").concat(path);
    });
    return {
      fields: [].concat(index._toConsumableArray(fieldsBeforeAccessibilityRole), [{
        portal: "multi-field",
        fieldName: "font",
        sources: richTextPartSources,
        hidden: richTextPartSources.length === 0
      }, {
        portal: "multi-field",
        fieldName: "color",
        sources: richTextPartSources,
        hidden: richTextPartSources.length === 0
      }, listStyleField], index._toConsumableArray(fieldsAfterAccessibilityRole)).filter(nonNullable())
    };
  }
};

function isRichTextPartPathForLocale(locale) {
  return function innerIsLocalizedRichTextPart(richTextPartConfigPath) {
    return richTextPartConfigPath.startsWith("elements.".concat(locale));
  };
}

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Returns the most common value for given `prop` parameter among all $richTextPart components from `richTextComponentConfig`.
 */

function getMostCommonValueFromRichTextParts(richTextComponentConfig, prop, compilationContext, cache) {
  var richTextBlockElements = richTextComponentConfig.elements[compilationContext.contextParams.locale];

  if (compilationContext.isEditing && !richTextBlockElements) {
    richTextBlockElements = getFallbackForLocale(richTextComponentConfig.elements, compilationContext.contextParams.locale, compilationContext.locales);
  }

  if (!richTextBlockElements) {
    return;
  }

  var richTextParts = richTextBlockElements.flatMap(function (blockElement) {
    return blockElement.elements.flatMap(function (lineElement) {
      return lineElement.elements.flatMap(function (child) {
        if (child._template === richTextInlineWrapperElementEditableComponent.id) {
          return child.elements;
        }

        return child;
      });
    });
  });
  var richTextPartComponentDefinition = index.findComponentDefinitionById(richTextPartEditableComponent.id, compilationContext);
  var deviceIdToRichTextPartValuesGroupedByPropValue = Object.fromEntries(compilationContext.devices.map(function (device) {
    var richTextPartsCompiledPropValues = richTextParts.flatMap(function (richTextPart) {
      return mapRichTextPartToCompiledPropValue(richTextPart, richTextPartComponentDefinition, compilationContext, prop, cache);
    });
    var richTextPartValuesLengthGroupedByPropValue = richTextPartsCompiledPropValues.reduce(function (acc, current) {
      return groupTotalValueLengthByCompiledPropValue(prop, device)(acc, current);
    }, {});
    return [device.id, richTextPartValuesLengthGroupedByPropValue];
  }).filter(function (entry) {
    return Object.keys(entry[1]).length > 0;
  }).map(function (entry) {
    return [entry[0], getCompiledValueFromEntryWithMaxTotalValueLength(entry)];
  }));

  if (Object.keys(deviceIdToRichTextPartValuesGroupedByPropValue).length === 0) {
    return;
  }

  return _objectSpread$d({
    $res: true
  }, deviceIdToRichTextPartValuesGroupedByPropValue);
}

function getCompiledValueFromEntryWithMaxTotalValueLength(entry) {
  var compiledPropValue = index.entries(entry[1]).reduce(function (maxEntry, currentEntry) {
    return currentEntry[1] > maxEntry[1] ? currentEntry : maxEntry;
  })[0];

  try {
    return JSON.parse(compiledPropValue);
  } catch (_unused) {
    return compiledPropValue;
  }
}

function groupTotalValueLengthByCompiledPropValue(prop, device) {
  return function (acc, current) {
    var key = JSON.stringify(current[prop][device.id]);

    if (key === undefined) {
      return acc;
    }

    if (!acc[key]) {
      acc[key] = 0;
    }

    acc[key] += current.value.length;
    return acc;
  };
}

function mapRichTextPartToCompiledPropValue(richTextPart, richTextPartComponentDefinition, compilationContext, prop, cache) {
  var compiledValues = compileComponentValues(richTextPart, richTextPartComponentDefinition, compilationContext, cache);
  return index._defineProperty({
    value: richTextPart.value
  }, prop, compiledValues[prop]);
}

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
} //      


function copyField(oldFields, oldKey, newFields, newKey) {
  newFields[newKey] = _extends$a({}, oldFields[oldKey], {
    name: newKey,
    // prevent functions from being overwritten
    // if the newFields[newKey] does not exist, it will be created
    // when that field gets registered, with its own change/blur/focus callbacks
    change: oldFields[newKey] && oldFields[newKey].change,
    blur: oldFields[newKey] && oldFields[newKey].blur,
    focus: oldFields[newKey] && oldFields[newKey].focus,
    lastFieldState: undefined // clearing lastFieldState forces renotification

  });

  if (!newFields[newKey].change) {
    delete newFields[newKey].change;
  }

  if (!newFields[newKey].blur) {
    delete newFields[newKey].blur;
  }

  if (!newFields[newKey].focus) {
    delete newFields[newKey].focus;
  }
} //      
// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping


var escapeRegexTokens = function escapeRegexTokens(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string
//      


var insert = function insert(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 0, value);
    return copy;
  }); // now we have increment any higher indexes

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex >= index) {
        // Shift all higher indices up
        var incrementedKey = name + "[" + (fieldIndex + 1) + "]" + tokens[2];
        copyField(state.fields, key, newFields, incrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being inserted


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
}; //      


var concat$1 = function concat(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, value) : value;
  });
}; //      


var move = function move(_ref, state, _ref2) {
  var name = _ref[0],
      from = _ref[1],
      to = _ref[2];
  var changeValue = _ref2.changeValue;

  if (from === to) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
  });
  var newFields = {};
  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var lowest;
  var highest;
  var increment;

  if (from > to) {
    lowest = to;
    highest = from;
    increment = 1;
  } else {
    lowest = from;
    highest = to;
    increment = -1;
  }

  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex === from) {
        var newKey = name + "[" + to + "]" + tokens[2];
        copyField(state.fields, key, newFields, newKey);
        return;
      }

      if (lowest <= fieldIndex && fieldIndex <= highest) {
        // Shift all indices
        var _newKey = name + "[" + (fieldIndex + increment) + "]" + tokens[2];

        copyField(state.fields, key, newFields, _newKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller or larger than affected range


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
}; //      


var remove = function remove(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1];
  var changeValue = _ref2.changeValue,
      getIn = _ref2.getIn,
      setIn = _ref2.setIn;
  var returnValue;
  changeValue(state, name, function (array) {
    if (!array) {
      return array;
    }

    var copy = [].concat(array);
    returnValue = copy[index];
    copy.splice(index, 1);
    return copy.length > 0 ? copy : undefined;
  }); // now we have to remove any subfields for our index,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex === index) {
        // delete any submitErrors for this array item
        // if the root key of the delete index
        if (key === name + "[" + index + "]") {
          var path = "formState.submitErrors." + name;
          var submitErrors = getIn(state, path); // if has submitErrors for array

          if (Array.isArray(submitErrors)) {
            submitErrors.splice(index, 1);
            state = setIn(state, path, submitErrors);
          }
        }

        return;
      }

      if (fieldIndex > index) {
        // Shift all higher indices down
        var decrementedKey = name + "[" + (fieldIndex - 1) + "]" + tokens[2];
        copyField(state.fields, key, newFields, decrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being removed


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
  return returnValue;
}; //      


var pop = function pop(_ref, state, tools) {
  var name = _ref[0];
  var getIn = tools.getIn;
  var array = getIn(state.formState.values, name);
  return array && array.length > 0 ? remove([name, array.length - 1], state, tools) : undefined;
}; //      


var push = function push(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, [value]) : [value];
  });
}; //      


var binarySearch = function binarySearch(list, value) {
  // This algorithm assumes the items in list is unique
  var first = 0;
  var last = list.length - 1;
  var middle = 0;

  while (first <= last) {
    middle = Math.floor((first + last) / 2);

    if (list[middle] === value) {
      return middle;
    }

    if (list[middle] > value) {
      last = middle - 1;
    } else {
      first = middle + 1;
    }
  }

  return ~first;
};

var removeBatch = function removeBatch(_ref, state, _ref2) {
  var name = _ref[0],
      indexes = _ref[1];
  var changeValue = _ref2.changeValue;

  if (indexes.length === 0) {
    return [];
  }

  var sortedIndexes = [].concat(indexes);
  sortedIndexes.sort(); // Remove duplicates

  for (var i = sortedIndexes.length - 1; i > 0; i -= 1) {
    if (sortedIndexes[i] === sortedIndexes[i - 1]) {
      sortedIndexes.splice(i, 1);
    }
  }

  var returnValue = [];
  changeValue(state, name, function (array) {
    // use original order of indexes for return value
    returnValue = indexes.map(function (index) {
      return array && array[index];
    });

    if (!array) {
      return array;
    }

    var copy = [].concat(array);

    for (var _i = sortedIndexes.length - 1; _i >= 0; _i -= 1) {
      var index = sortedIndexes[_i];
      copy.splice(index, 1);
    }

    return copy.length > 0 ? copy : undefined;
  }); // now we have to remove any subfields for our indexes,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);
      var indexOfFieldIndex = binarySearch(sortedIndexes, fieldIndex);

      if (indexOfFieldIndex >= 0) {
        // One of the removed indices
        return;
      }

      if (fieldIndex > sortedIndexes[0]) {
        // Shift all higher indices down
        var decrementedKey = name + "[" + (fieldIndex - ~indexOfFieldIndex) + "]" + tokens[2];
        copyField(state.fields, key, newFields, decrementedKey);
        return;
      }
    } // Keep this field that does not match the name,
    // or has index smaller than what is being removed


    newFields[key] = state.fields[key];
  });
  state.fields = newFields;
  return returnValue;
}; //      


var shift = function shift(_ref, state, tools) {
  var name = _ref[0];
  return remove([name, 0], state, tools);
}; //      


var swap = function swap(_ref, state, _ref2) {
  var name = _ref[0],
      indexA = _ref[1],
      indexB = _ref[2];
  var changeValue = _ref2.changeValue;

  if (indexA === indexB) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
  }); // swap all field state that begin with "name[indexA]" with that under "name[indexB]"

  var aPrefix = name + "[" + indexA + "]";
  var bPrefix = name + "[" + indexB + "]";
  var newFields = {};
  Object.keys(state.fields).forEach(function (key) {
    if (key.substring(0, aPrefix.length) === aPrefix) {
      var suffix = key.substring(aPrefix.length);
      var newKey = bPrefix + suffix;
      copyField(state.fields, key, newFields, newKey);
    } else if (key.substring(0, bPrefix.length) === bPrefix) {
      var _suffix = key.substring(bPrefix.length);

      var _newKey = aPrefix + _suffix;

      copyField(state.fields, key, newFields, _newKey);
    } else {
      // Keep this field that does not match the name
      newFields[key] = state.fields[key];
    }
  });
  state.fields = newFields;
}; //      


var unshift = function unshift(_ref, state, tools) {
  var name = _ref[0],
      value = _ref[1];
  return insert([name, 0, value], state, tools);
}; //      


var update = function update(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 1, value);
    return copy;
  });
}; //      


var mutators = {
  insert: insert,
  concat: concat$1,
  move: move,
  pop: pop,
  push: push,
  remove: remove,
  removeBatch: removeBatch,
  shift: shift,
  swap: swap,
  unshift: unshift,
  update: update
};

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar$2 = /\\(\\)?/g;
var rePropName$2 = RegExp( // Match anything that isn't a dot or bracket.
"[^.[\\]]+" + "|" + // Or match property names within brackets.
"\\[(?:" + // Match a non-string expression.
"([^\"'][^[]*)" + "|" + // Or match strings (supports escaping characters).
"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" + // Or match "" as the space between consecutive dots or empty brackets.
"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$4 = function stringToPath(string) {
  var result = [];

  if (string.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }

  string.replace(rePropName$2, function (match, expression, quote, subString) {
    var key = match;

    if (quote) {
      key = subString.replace(reEscapeChar$2, "$1");
    } else if (expression) {
      key = expression.trim();
    }

    result.push(key);
  });
  return result;
};

var keysCache = {};
var keysRegex = /[.[\]]+/;

var toPath = function toPath(key) {
  if (key === null || key === undefined || !key.length) {
    return [];
  }

  if (typeof key !== "string") {
    throw new Error("toPath() expects a string");
  }

  if (keysCache[key] == null) {
    /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */
    if (key.endsWith("[]")) {
      // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
      keysCache[key] = key.split(keysRegex).filter(Boolean);
    } else {
      // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
      keysCache[key] = stringToPath$4(key);
    }
  }

  return keysCache[key];
}; //      


var getIn = function getIn(state, complexKey) {
  // Intentionally using iteration rather than recursion
  var path = toPath(complexKey);
  var current = state;

  for (var i = 0; i < path.length; i++) {
    var key = path[i];

    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
      return undefined;
    }

    current = current[key];
  }

  return current;
};

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
  if (index >= path.length) {
    // end of recursion
    return value;
  }

  var key = path[index]; // determine type of key

  if (isNaN(key)) {
    var _extends2; // object set


    if (current === undefined || current === null) {
      var _ref; // recurse


      var _result2 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // delete or create an object


      return _result2 === undefined ? undefined : (_ref = {}, _ref[key] = _result2, _ref);
    }

    if (Array.isArray(current)) {
      throw new Error("Cannot set a non-numeric property on an array");
    } // current exists, so make a copy of all its values, and add/update the new one


    var _result = setInRecursor(current[key], index + 1, path, value, destroyArrays);

    if (_result === undefined) {
      var numKeys = Object.keys(current).length;

      if (current[key] === undefined && numKeys === 0) {
        // object was already empty
        return undefined;
      }

      if (current[key] !== undefined && numKeys <= 1) {
        // only key we had was the one we are deleting
        if (!isNaN(path[index - 1]) && !destroyArrays) {
          // we are in an array, so return an empty object
          return {};
        } else {
          return undefined;
        }
      }

      current[key];

      var _final = _objectWithoutPropertiesLoose$1(current, [key].map(_toPropertyKey));

      return _final;
    } // set result in key


    return _extends$9({}, current, (_extends2 = {}, _extends2[key] = _result, _extends2));
  } // array set


  var numericKey = Number(key);

  if (current === undefined || current === null) {
    // recurse
    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays); // if nothing returned, delete it


    if (_result3 === undefined) {
      return undefined;
    } // create an array


    var _array = [];
    _array[numericKey] = _result3;
    return _array;
  }

  if (!Array.isArray(current)) {
    throw new Error("Cannot set a numeric property on an object");
  } // recurse


  var existingValue = current[numericKey];
  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays); // current exists, so make a copy of all its values, and add/update the new one

  var array = [].concat(current);

  if (destroyArrays && result === undefined) {
    array.splice(numericKey, 1);

    if (array.length === 0) {
      return undefined;
    }
  } else {
    array[numericKey] = result;
  }

  return array;
};

var setIn = function setIn(state, key, value, destroyArrays) {
  if (destroyArrays === void 0) {
    destroyArrays = false;
  }

  if (state === undefined || state === null) {
    throw new Error("Cannot call setIn() with " + String(state) + " state");
  }

  if (key === undefined || key === null) {
    throw new Error("Cannot call setIn() with " + String(key) + " key");
  } // Recursive function needs to accept and return State, but public API should
  // only deal with Objects


  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
};

var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error"; //      

/**
 * Converts internal field state to published field state
 */

function publishFieldState(formState, field) {
  var errors = formState.errors,
      initialValues = formState.initialValues,
      lastSubmittedValues = formState.lastSubmittedValues,
      submitErrors = formState.submitErrors,
      submitFailed = formState.submitFailed,
      submitSucceeded = formState.submitSucceeded,
      submitting = formState.submitting,
      values = formState.values;
  var active = field.active,
      blur = field.blur,
      change = field.change,
      data = field.data,
      focus = field.focus,
      modified = field.modified,
      modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
      name = field.name,
      touched = field.touched,
      validating = field.validating,
      visited = field.visited;
  var value = getIn(values, name);
  var error = getIn(errors, name);

  if (error && error[ARRAY_ERROR]) {
    error = error[ARRAY_ERROR];
  }

  var submitError = submitErrors && getIn(submitErrors, name);
  var initial = initialValues && getIn(initialValues, name);
  var pristine = field.isEqual(initial, value);
  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
  var valid = !error && !submitError;
  return {
    active: active,
    blur: blur,
    change: change,
    data: data,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    error: error,
    focus: focus,
    initial: initial,
    invalid: !valid,
    length: Array.isArray(value) ? value.length : undefined,
    modified: modified,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    name: name,
    pristine: pristine,
    submitError: submitError,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitting: submitting,
    touched: touched,
    valid: valid,
    value: value,
    visited: visited,
    validating: validating
  };
} //      


var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"]; //      

var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}; //      


function subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
  var different = false;
  keys.forEach(function (key) {
    if (subscription[key]) {
      dest[key] = src[key];

      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) {
        different = true;
      }
    }
  });
  return different;
} //      


var shallowEqualKeys$1 = ["data"];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */

var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
  var result = {
    blur: state.blur,
    change: state.change,
    focus: state.focus,
    name: state.name
  };
  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
  return different || force ? result : undefined;
}; //      


var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"]; //      

var shallowEqualKeys = ["touched", "visited"];
/**
 * Filters items in a FormState based on a FormSubscription
 */

function filterFormState(state, previousState, subscription, force) {
  var result = {};
  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
  return different || force ? result : undefined;
} //      


var memoize$3 = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
      return !shallowEqual(lastArgs[index], arg);
    })) {
      lastArgs = args;
      lastResult = fn.apply(void 0, args);
    }

    return lastResult;
  };
};

var isPromise = function isPromise(obj) {
  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};

var tripleEquals = function tripleEquals(a, b) {
  return a === b;
};

var hasAnyError = function hasAnyError(errors) {
  return Object.keys(errors).some(function (key) {
    var value = errors[key];

    if (value && typeof value === "object" && !(value instanceof Error)) {
      return hasAnyError(value);
    }

    return typeof value !== "undefined";
  });
};

function convertToExternalFormState(_ref) {
  var active = _ref.active,
      dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
      modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
      error = _ref.error,
      errors = _ref.errors,
      initialValues = _ref.initialValues,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      submitFailed = _ref.submitFailed,
      submitSucceeded = _ref.submitSucceeded,
      submitError = _ref.submitError,
      submitErrors = _ref.submitErrors,
      valid = _ref.valid,
      validating = _ref.validating,
      values = _ref.values;
  return {
    active: active,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    error: error,
    errors: errors,
    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
    hasValidationErrors: !!(error || hasAnyError(errors)),
    invalid: !valid,
    initialValues: initialValues,
    pristine: pristine,
    submitting: submitting,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitError: submitError,
    submitErrors: submitErrors,
    valid: valid,
    validating: validating > 0,
    values: values
  };
}

function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
  var notification = filter(state, lastState, subscription, force);

  if (notification) {
    subscriber(notification);
    return true;
  }

  return false;
}

function notify(_ref2, state, lastState, filter, force) {
  var entries = _ref2.entries;
  Object.keys(entries).forEach(function (key) {
    var entry = entries[Number(key)]; // istanbul ignore next

    if (entry) {
      var subscription = entry.subscription,
          subscriber = entry.subscriber,
          notified = entry.notified;

      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
        entry.notified = true;
      }
    }
  });
}

function createForm(config) {
  if (!config) {
    throw new Error("No config specified");
  }

  var debug = config.debug,
      destroyOnUnregister = config.destroyOnUnregister,
      keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
      initialValues = config.initialValues,
      mutators = config.mutators,
      onSubmit = config.onSubmit,
      validate = config.validate,
      validateOnBlur = config.validateOnBlur;

  if (!onSubmit) {
    throw new Error("No onSubmit function specified");
  }

  var state = {
    subscribers: {
      index: 0,
      entries: {}
    },
    fieldSubscribers: {},
    fields: {},
    formState: {
      asyncErrors: {},
      dirtySinceLastSubmit: false,
      modifiedSinceLastSubmit: false,
      errors: {},
      initialValues: initialValues && _extends$9({}, initialValues),
      invalid: false,
      pristine: true,
      submitting: false,
      submitFailed: false,
      submitSucceeded: false,
      resetWhileSubmitting: false,
      valid: true,
      validating: 0,
      values: initialValues ? _extends$9({}, initialValues) : {}
    },
    lastFormState: undefined
  };
  var inBatch = 0;
  var validationPaused = false;
  var validationBlocked = false;
  var preventNotificationWhileValidationPaused = false;
  var nextAsyncValidationKey = 0;
  var asyncValidationPromises = {};

  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
    return function (result) {
      delete asyncValidationPromises[key];
      return result;
    };
  };

  var changeValue = function changeValue(state, name, mutate) {
    var before = getIn(state.formState.values, name);
    var after = mutate(before);
    state.formState.values = setIn(state.formState.values, name, after) || {};
  };

  var renameField = function renameField(state, from, to) {
    if (state.fields[from]) {
      var _extends2, _extends3;

      state.fields = _extends$9({}, state.fields, (_extends2 = {}, _extends2[to] = _extends$9({}, state.fields[from], {
        name: to,
        // rebind event handlers
        blur: function blur() {
          return api.blur(to);
        },
        change: function change(value) {
          return api.change(to, value);
        },
        focus: function focus() {
          return api.focus(to);
        },
        lastFieldState: undefined
      }), _extends2));
      delete state.fields[from];
      state.fieldSubscribers = _extends$9({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
      delete state.fieldSubscribers[from];
      var value = getIn(state.formState.values, from);
      state.formState.values = setIn(state.formState.values, from, undefined) || {};
      state.formState.values = setIn(state.formState.values, to, value);
      delete state.lastFormState;
    }
  }; // bind state to mutators


  var getMutatorApi = function getMutatorApi(key) {
    return function () {
      // istanbul ignore next
      if (mutators) {
        // ^^ causes branch coverage warning, but needed to appease the Flow gods
        var mutatableState = {
          formState: state.formState,
          fields: state.fields,
          fieldSubscribers: state.fieldSubscribers,
          lastFormState: state.lastFormState
        };

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var returnValue = mutators[key](args, mutatableState, {
          changeValue: changeValue,
          getIn: getIn,
          renameField: renameField,
          resetFieldState: api.resetFieldState,
          setIn: setIn,
          shallowEqual: shallowEqual
        });
        state.formState = mutatableState.formState;
        state.fields = mutatableState.fields;
        state.fieldSubscribers = mutatableState.fieldSubscribers;
        state.lastFormState = mutatableState.lastFormState;
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
        return returnValue;
      }
    };
  };

  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
    result[key] = getMutatorApi(key);
    return result;
  }, {}) : {};

  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
    var promises = [];

    if (validate) {
      var errorsOrPromise = validate(_extends$9({}, state.formState.values)); // clone to avoid writing

      if (isPromise(errorsOrPromise)) {
        promises.push(errorsOrPromise.then(function (errors) {
          return setErrors(errors, true);
        }));
      } else {
        setErrors(errorsOrPromise, false);
      }
    }

    return promises;
  };

  var getValidators = function getValidators(field) {
    return Object.keys(field.validators).reduce(function (result, index) {
      var validator = field.validators[Number(index)]();

      if (validator) {
        result.push(validator);
      }

      return result;
    }, []);
  };

  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
    var promises = [];
    var validators = getValidators(field);

    if (validators.length) {
      var error;
      validators.forEach(function (validator) {
        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);

        if (errorOrPromise && isPromise(errorOrPromise)) {
          field.validating = true;
          var promise = errorOrPromise.then(function (error) {
            if (state.fields[field.name]) {
              state.fields[field.name].validating = false;
              setError(error);
            }
          }); // errors must be resolved, not rejected

          promises.push(promise);
        } else if (!error) {
          // first registered validator wins
          error = errorOrPromise;
        }
      });
      setError(error);
    }

    return promises;
  };

  var runValidation = function runValidation(fieldChanged, callback) {
    if (validationPaused) {
      validationBlocked = true;
      callback();
      return;
    }

    var fields = state.fields,
        formState = state.formState;

    var safeFields = _extends$9({}, fields);

    var fieldKeys = Object.keys(safeFields);

    if (!validate && !fieldKeys.some(function (key) {
      return getValidators(safeFields[key]).length;
    })) {
      callback();
      return; // no validation rules
    } // pare down field keys to actually validate


    var limitedFieldLevelValidation = false;

    if (fieldChanged) {
      var changedField = safeFields[fieldChanged];

      if (changedField) {
        var validateFields = changedField.validateFields;

        if (validateFields) {
          limitedFieldLevelValidation = true;
          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
        }
      }
    }

    var recordLevelErrors = {};
    var asyncRecordLevelErrors = {};
    var fieldLevelErrors = {};
    var promises = [].concat(runRecordLevelValidation(function (errors, wasAsync) {
      if (wasAsync) {
        asyncRecordLevelErrors = errors || {};
      } else {
        recordLevelErrors = errors || {};
      }
    }), fieldKeys.reduce(function (result, name) {
      return result.concat(runFieldLevelValidation(fields[name], function (error) {
        fieldLevelErrors[name] = error;
      }));
    }, []));
    var hasAsyncValidations = promises.length > 0;
    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey)); // backwards-compat: add promise to submit-blocking promises iff there are any promises to await

    if (hasAsyncValidations) {
      asyncValidationPromises[asyncValidationPromiseKey] = promise;
    }

    var processErrors = function processErrors(afterAsync) {
      var merged = _extends$9({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
      : formState.asyncErrors);

      var forEachError = function forEachError(fn) {
        fieldKeys.forEach(function (name) {
          if (fields[name]) {
            // make sure field is still registered
            // field-level errors take precedent over record-level errors
            var recordLevelError = getIn(recordLevelErrors, name);
            var errorFromParent = getIn(merged, name);
            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
            var fieldLevelError = fieldLevelErrors[name];
            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
          }
        });
      };

      forEachError(function (name, error) {
        merged = setIn(merged, name, error) || {};
      });
      forEachError(function (name, error) {
        if (error && error[ARRAY_ERROR]) {
          var existing = getIn(merged, name);
          var copy = [].concat(existing);
          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
          merged = setIn(merged, name, copy);
        }
      });

      if (!shallowEqual(formState.errors, merged)) {
        formState.errors = merged;
      }

      if (afterAsync) {
        formState.asyncErrors = asyncRecordLevelErrors;
      }

      formState.error = recordLevelErrors[FORM_ERROR];
    };

    if (hasAsyncValidations) {
      // async validations are running, ensure validating is true before notifying
      state.formState.validating++;
      callback();
    } // process sync errors


    processErrors(false); // sync errors have been set. notify listeners while we wait for others

    callback();

    if (hasAsyncValidations) {
      var afterPromise = function afterPromise() {
        state.formState.validating--;
        callback();
      };

      promise.then(function () {
        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
          // if this async validator has been superseded by another, ignore its results
          return;
        }

        processErrors(true);
      }).then(afterPromise, afterPromise);
    }
  };

  var notifyFieldListeners = function notifyFieldListeners(name) {
    if (inBatch) {
      return;
    }

    var fields = state.fields,
        fieldSubscribers = state.fieldSubscribers,
        formState = state.formState;

    var safeFields = _extends$9({}, fields);

    var notifyField = function notifyField(name) {
      var field = safeFields[name];
      var fieldState = publishFieldState(formState, field);
      var lastFieldState = field.lastFieldState;
      field.lastFieldState = fieldState;
      var fieldSubscriber = fieldSubscribers[name];

      if (fieldSubscriber) {
        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
      }
    };

    if (name) {
      notifyField(name);
    } else {
      Object.keys(safeFields).forEach(notifyField);
    }
  };

  var markAllFieldsTouched = function markAllFieldsTouched() {
    Object.keys(state.fields).forEach(function (key) {
      state.fields[key].touched = true;
    });
  };

  var hasSyncErrors = function hasSyncErrors() {
    return !!(state.formState.error || hasAnyError(state.formState.errors));
  };

  var calculateNextFormState = function calculateNextFormState() {
    var fields = state.fields,
        formState = state.formState,
        lastFormState = state.lastFormState;

    var safeFields = _extends$9({}, fields);

    var safeFieldKeys = Object.keys(safeFields); // calculate dirty/pristine

    var foundDirty = false;
    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));

      if (dirty) {
        foundDirty = true;
        result[key] = true;
      }

      return result;
    }, {});
    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
      // istanbul ignore next
      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint

      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
        result[key] = true;
      }

      return result;
    }, {});
    formState.pristine = !foundDirty;
    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
      return value;
    }));
    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
    Object.keys(safeFields).some(function (value) {
      return safeFields[value].modifiedSinceLastSubmit;
    }));
    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
    var nextFormState = convertToExternalFormState(formState);

    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
      result.modified[key] = safeFields[key].modified;
      result.touched[key] = safeFields[key].touched;
      result.visited[key] = safeFields[key].visited;
      return result;
    }, {
      modified: {},
      touched: {},
      visited: {}
    }),
        modified = _safeFieldKeys$reduce.modified,
        touched = _safeFieldKeys$reduce.touched,
        visited = _safeFieldKeys$reduce.visited;

    nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
    nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
    nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
    nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
    return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
  };

  var callDebug = function callDebug() {
    return debug && "development" !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
      result[key] = state.fields[key];
      return result;
    }, {}));
  };

  var notifying = false;
  var scheduleNotification = false;

  var notifyFormListeners = function notifyFormListeners() {
    if (notifying) {
      scheduleNotification = true;
    } else {
      notifying = true;
      callDebug();

      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
        var lastFormState = state.lastFormState;
        var nextFormState = calculateNextFormState();

        if (nextFormState !== lastFormState) {
          state.lastFormState = nextFormState;
          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
        }
      }

      notifying = false;

      if (scheduleNotification) {
        scheduleNotification = false;
        notifyFormListeners();
      }
    }
  };

  var beforeSubmit = function beforeSubmit() {
    return Object.keys(state.fields).some(function (name) {
      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
    });
  };

  var afterSubmit = function afterSubmit() {
    return Object.keys(state.fields).forEach(function (name) {
      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
    });
  };

  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
    return Object.keys(state.fields).forEach(function (key) {
      return state.fields[key].modifiedSinceLastSubmit = false;
    });
  }; // generate initial errors


  runValidation(undefined, function () {
    notifyFormListeners();
  });
  var api = {
    batch: function batch(fn) {
      inBatch++;
      fn();
      inBatch--;
      notifyFieldListeners();
      notifyFormListeners();
    },
    blur: function blur(name) {
      var fields = state.fields,
          formState = state.formState;
      var previous = fields[name];

      if (previous) {
        // can only blur registered fields
        delete formState.active;
        fields[name] = _extends$9({}, previous, {
          active: false,
          touched: true
        });

        if (validateOnBlur) {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        } else {
          notifyFieldListeners();
          notifyFormListeners();
        }
      }
    },
    change: function change(name, value) {
      var fields = state.fields,
          formState = state.formState;

      if (getIn(formState.values, name) !== value) {
        changeValue(state, name, function () {
          return value;
        });
        var previous = fields[name];

        if (previous) {
          // only track modified for registered fields
          fields[name] = _extends$9({}, previous, {
            modified: true,
            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
          });
        }

        if (validateOnBlur) {
          notifyFieldListeners();
          notifyFormListeners();
        } else {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        }
      }
    },

    get destroyOnUnregister() {
      return !!destroyOnUnregister;
    },

    set destroyOnUnregister(value) {
      destroyOnUnregister = value;
    },

    focus: function focus(name) {
      var field = state.fields[name];

      if (field && !field.active) {
        state.formState.active = name;
        field.active = true;
        field.visited = true;
        notifyFieldListeners();
        notifyFormListeners();
      }
    },
    mutators: mutatorsApi,
    getFieldState: function getFieldState(name) {
      var field = state.fields[name];
      return field && field.lastFieldState;
    },
    getRegisteredFields: function getRegisteredFields() {
      return Object.keys(state.fields);
    },
    getState: function getState() {
      return calculateNextFormState();
    },
    initialize: function initialize(data) {
      var fields = state.fields,
          formState = state.formState;

      var safeFields = _extends$9({}, fields);

      var values = typeof data === "function" ? data(formState.values) : data;

      if (!keepDirtyOnReinitialize) {
        formState.values = values;
      }
      /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */
      // save dirty values


      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
        var field = safeFields[key];
        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));

        if (!pristine) {
          result[key] = getIn(formState.values, key);
        }

        return result;
      }, {}) : {}; // update initalValues and values

      formState.initialValues = values;
      formState.values = values; // restore the dirty values

      Object.keys(savedDirtyValues).forEach(function (key) {
        formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    isValidationPaused: function isValidationPaused() {
      return validationPaused;
    },
    pauseValidation: function pauseValidation(preventNotification) {
      if (preventNotification === void 0) {
        preventNotification = true;
      }

      validationPaused = true;
      preventNotificationWhileValidationPaused = preventNotification;
    },
    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
      if (subscription === void 0) {
        subscription = {};
      }

      if (!state.fieldSubscribers[name]) {
        state.fieldSubscribers[name] = {
          index: 0,
          entries: {}
        };
      }

      var index = state.fieldSubscribers[name].index++; // save field subscriber callback

      state.fieldSubscribers[name].entries[index] = {
        subscriber: memoize$3(subscriber),
        subscription: subscription,
        notified: false
      }; // create initial field state if not exists

      var field = state.fields[name] || {
        active: false,
        afterSubmit: fieldConfig && fieldConfig.afterSubmit,
        beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
        data: fieldConfig && fieldConfig.data || {},
        isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
        lastFieldState: undefined,
        modified: false,
        modifiedSinceLastSubmit: false,
        name: name,
        touched: false,
        valid: true,
        validateFields: fieldConfig && fieldConfig.validateFields,
        validators: {},
        validating: false,
        visited: false
      }; // Mutators can create a field in order to keep the field states
      // We must update this field when registerField is called afterwards

      field.blur = field.blur || function () {
        return api.blur(name);
      };

      field.change = field.change || function (value) {
        return api.change(name, value);
      };

      field.focus = field.focus || function () {
        return api.focus(name);
      };

      state.fields[name] = field;
      var haveValidator = false;
      var silent = fieldConfig && fieldConfig.silent;

      var notify = function notify() {
        if (silent) {
          notifyFieldListeners(name);
        } else {
          notifyFormListeners();
          notifyFieldListeners();
        }
      };

      if (fieldConfig) {
        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());

        if (fieldConfig.getValidator) {
          state.fields[name].validators[index] = fieldConfig.getValidator;
        }

        var noValueInFormState = getIn(state.formState.values, name) === undefined;

        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name)) // only initialize if we don't yet have any value for this field
        ) {
          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
          runValidation(undefined, notify);
        } // only use defaultValue if we don't yet have any value for this field


        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
        }
      }

      if (haveValidator) {
        runValidation(undefined, notify);
      } else {
        notify();
      }

      return function () {
        var validatorRemoved = false; // istanbul ignore next

        if (state.fields[name]) {
          // state.fields[name] may have been removed by a mutator
          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
          delete state.fields[name].validators[index];
        }

        var hasFieldSubscribers = !!state.fieldSubscribers[name];

        if (hasFieldSubscribers) {
          // state.fieldSubscribers[name] may have been removed by a mutator
          delete state.fieldSubscribers[name].entries[index];
        }

        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;

        if (lastOne) {
          delete state.fieldSubscribers[name];
          delete state.fields[name];

          if (validatorRemoved) {
            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
          }

          if (destroyOnUnregister) {
            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
          }
        }

        if (!silent) {
          if (validatorRemoved) {
            runValidation(undefined, function () {
              notifyFormListeners();
              notifyFieldListeners();
            });
          } else if (lastOne) {
            // values or errors may have changed
            notifyFormListeners();
          }
        }
      };
    },
    reset: function reset(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }

      if (state.formState.submitting) {
        state.formState.resetWhileSubmitting = true;
      }

      state.formState.submitFailed = false;
      state.formState.submitSucceeded = false;
      delete state.formState.submitError;
      delete state.formState.submitErrors;
      delete state.formState.lastSubmittedValues;
      api.initialize(initialValues || {});
    },

    /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */
    resetFieldState: function resetFieldState(name) {
      state.fields[name] = _extends$9({}, state.fields[name], {
        active: false,
        lastFieldState: undefined,
        modified: false,
        touched: false,
        valid: true,
        validating: false,
        visited: false
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },

    /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */
    restart: function restart(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }

      api.batch(function () {
        for (var name in state.fields) {
          api.resetFieldState(name);
          state.fields[name] = _extends$9({}, state.fields[name], {
            active: false,
            lastFieldState: undefined,
            modified: false,
            modifiedSinceLastSubmit: false,
            touched: false,
            valid: true,
            validating: false,
            visited: false
          });
        }

        api.reset(initialValues);
      });
    },
    resumeValidation: function resumeValidation() {
      validationPaused = false;
      preventNotificationWhileValidationPaused = false;

      if (validationBlocked) {
        // validation was attempted while it was paused, so run it now
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
      }

      validationBlocked = false;
    },
    setConfig: function setConfig(name, value) {
      switch (name) {
        case "debug":
          debug = value;
          break;

        case "destroyOnUnregister":
          destroyOnUnregister = value;
          break;

        case "initialValues":
          api.initialize(value);
          break;

        case "keepDirtyOnReinitialize":
          keepDirtyOnReinitialize = value;
          break;

        case "mutators":
          mutators = value;

          if (value) {
            Object.keys(mutatorsApi).forEach(function (key) {
              if (!(key in value)) {
                delete mutatorsApi[key];
              }
            });
            Object.keys(value).forEach(function (key) {
              mutatorsApi[key] = getMutatorApi(key);
            });
          } else {
            Object.keys(mutatorsApi).forEach(function (key) {
              delete mutatorsApi[key];
            });
          }

          break;

        case "onSubmit":
          onSubmit = value;
          break;

        case "validate":
          validate = value;
          runValidation(undefined, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
          break;

        case "validateOnBlur":
          validateOnBlur = value;
          break;

        default:
          throw new Error("Unrecognised option " + name);
      }
    },
    submit: function submit() {
      var formState = state.formState;

      if (formState.submitting) {
        return;
      }

      delete formState.submitErrors;
      delete formState.submitError;
      formState.lastSubmittedValues = _extends$9({}, formState.values);

      if (hasSyncErrors()) {
        markAllFieldsTouched();
        resetModifiedAfterSubmit();
        state.formState.submitFailed = true;
        notifyFormListeners();
        notifyFieldListeners();
        return; // no submit for you!!
      }

      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);

      if (asyncValidationPromisesKeys.length) {
        // still waiting on async validation to complete...
        Promise.all(asyncValidationPromisesKeys.map(function (key) {
          return asyncValidationPromises[Number(key)];
        })).then(api.submit, console.error);
        return;
      }

      var submitIsBlocked = beforeSubmit();

      if (submitIsBlocked) {
        return;
      }

      var resolvePromise;
      var completeCalled = false;

      var complete = function complete(errors) {
        formState.submitting = false;
        var resetWhileSubmitting = formState.resetWhileSubmitting;

        if (resetWhileSubmitting) {
          formState.resetWhileSubmitting = false;
        }

        if (errors && hasAnyError(errors)) {
          formState.submitFailed = true;
          formState.submitSucceeded = false;
          formState.submitErrors = errors;
          formState.submitError = errors[FORM_ERROR];
          markAllFieldsTouched();
        } else {
          if (!resetWhileSubmitting) {
            formState.submitFailed = false;
            formState.submitSucceeded = true;
          }

          afterSubmit();
        }

        notifyFormListeners();
        notifyFieldListeners();
        completeCalled = true;

        if (resolvePromise) {
          resolvePromise(errors);
        }

        return errors;
      };

      formState.submitting = true;
      formState.submitFailed = false;
      formState.submitSucceeded = false;
      formState.lastSubmittedValues = _extends$9({}, formState.values);
      resetModifiedAfterSubmit(); // onSubmit is either sync, callback or async with a Promise

      var result = onSubmit(formState.values, api, complete);

      if (!completeCalled) {
        if (result && isPromise(result)) {
          // onSubmit is async with a Promise
          notifyFormListeners(); // let everyone know we are submitting

          notifyFieldListeners(); // notify fields also

          return result.then(complete, function (error) {
            complete();
            throw error;
          });
        } else if (onSubmit.length >= 3) {
          // must be async, so we should return a Promise
          notifyFormListeners(); // let everyone know we are submitting

          notifyFieldListeners(); // notify fields also

          return new Promise(function (resolve) {
            resolvePromise = resolve;
          });
        } else {
          // onSubmit is sync
          complete(result);
        }
      }
    },
    subscribe: function subscribe(subscriber, subscription) {
      if (!subscriber) {
        throw new Error("No callback given.");
      }

      if (!subscription) {
        throw new Error("No subscription provided. What values do you want to listen to?");
      }

      var memoized = memoize$3(subscriber);
      var subscribers = state.subscribers;
      var index = subscribers.index++;
      subscribers.entries[index] = {
        subscriber: memoized,
        subscription: subscription,
        notified: false
      };
      var nextFormState = calculateNextFormState();
      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
      return function () {
        delete subscribers.entries[index];
      };
    }
  };
  return api;
}

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Form = /*#__PURE__*/function () {
  function Form(_ref) {
    var _this = this;

    var id = _ref.id,
        label = _ref.label,
        fields = _ref.fields,
        actions = _ref.actions,
        buttons = _ref.buttons,
        reset = _ref.reset,
        loadInitialValues = _ref.loadInitialValues,
        onChange = _ref.onChange,
        _options = index._objectWithoutProperties(_ref, ["id", "label", "fields", "actions", "buttons", "reset", "loadInitialValues", "onChange"]);

    _classCallCheck$8(this, Form);

    index._defineProperty(this, "__type", void 0);

    index._defineProperty(this, "id", void 0);

    index._defineProperty(this, "label", void 0);

    index._defineProperty(this, "fields", void 0);

    index._defineProperty(this, "finalForm", void 0);

    index._defineProperty(this, "actions", void 0);

    index._defineProperty(this, "buttons", void 0);

    index._defineProperty(this, "loading", false);

    index._defineProperty(this, "subscribe", function (cb, options) {
      return _this.finalForm.subscribe(cb, options);
    });

    index._defineProperty(this, "onSubmit", void 0);

    index._defineProperty(this, "handleSubmit", /*#__PURE__*/function () {
      var _ref2 = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee(values, form, cb) {
        var response;
        return index.regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.onSubmit(values, form, cb);

              case 3:
                response = _context.sent;
                form.initialize(values);
                return _context.abrupt("return", response);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", index._defineProperty({}, FORM_ERROR, _context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    index._defineProperty(this, "submit", function () {
      return _this.finalForm.submit();
    });

    var initialValues = _options.initialValues || {};
    this.__type = _options.__type || "form";
    this.id = id;
    this.label = label;
    this.fields = fields || [];
    this.onSubmit = _options.onSubmit;
    this.finalForm = createForm(_objectSpread$c(_objectSpread$c({}, _options), {}, {
      initialValues: initialValues,
      onSubmit: this.handleSubmit,
      mutators: _objectSpread$c(_objectSpread$c({}, mutators), _options.mutators)
    }));
    this._reset = reset;
    this.actions = actions || [];
    this.buttons = buttons || {
      save: "Save",
      reset: "Reset"
    };
    this.updateFields(this.fields);

    if (loadInitialValues) {
      this.loading = true;
      loadInitialValues().then(function (initialValues) {
        _this.updateInitialValues(initialValues);
      })["finally"](function () {
        _this.loading = false;
      });
    }

    if (onChange) {
      var firstUpdate = true;
      this.subscribe(function (formState) {
        if (firstUpdate) {
          firstUpdate = false;
        } else {
          onChange(formState);
        }
      }, {
        values: true
      });
    }
  }
  /**
   * A unique identifier for Forms.
   *
   * @alias id
   */


  _createClass$8(Form, [{
    key: "reset",

    /**
     * Resets the values back to the initial values the form was initialized with.
     * Or empties all the values if the form was not initialized.
     */
    value: function () {
      var _reset2 = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee2() {
        return index.regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._reset) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this._reset();

              case 3:
                this.finalForm.reset();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reset() {
        return _reset2.apply(this, arguments);
      }

      return reset;
    }()
    /**
     * @deprecated Unnecessary indirection
     */

  }, {
    key: "updateFields",
    value: function updateFields(fields) {
      this.fields = fields;
    }
    /**
     * Subscribes to changes to the form. The subscriber will only be called when
     * values specified in subscription change. A form can have many subscribers.
     */

  }, {
    key: "change",

    /**
     * Changes the value of the given field.
     *
     * @param name
     * @param value
     */
    value: function change(name, value) {

      return this.finalForm.change(name, value);
    }
  }, {
    key: "updateValues",

    /**
     * Updates multiple fields in the form.
     *
     * The updates are batched so that it only triggers one `onChange` event.
     *
     * In order to prevent disruptions to the user's editing experience this
     * function will _not_ update the value of any field that is currently
     * being edited.
     *
     * @param values
     */
    value: function updateValues(values) {
      var _this2 = this;

      this.finalForm.batch(function () {
        var activePath = _this2.finalForm.getState().active;

        if (!activePath) {
          updateEverything(_this2.finalForm, values);
        } else {
          updateSelectively(_this2.finalForm, values);
        }
      });
    }
    /**
     * Replaces the initialValues of the form without deleting the current values.
     *
     * This function is helpful when the initialValues are loaded asynchronously.
     *
     * @param initialValues
     */

  }, {
    key: "updateInitialValues",
    value: function updateInitialValues(initialValues) {
      var _this3 = this;

      this.finalForm.batch(function () {
        var values = _this3.values || {};

        _this3.finalForm.initialize(initialValues);

        var activePath = _this3.finalForm.getState().active;

        if (!activePath) {
          updateEverything(_this3.finalForm, values);
        } else {
          updateSelectively(_this3.finalForm, values);
        }
      });
    }
  }, {
    key: "name",
    get: function get() {
      return this.id;
    }
    /**
     * Returns the current values of the form.
     *
     * if the form is still loading it returns `undefined`.
     */

  }, {
    key: "values",
    get: function get() {
      if (this.loading) {
        return undefined;
      }

      return this.finalForm.getState().values || this.initialValues;
    }
    /**
     * The values the form was initialized with.
     */

  }, {
    key: "initialValues",
    get: function get() {
      return this.finalForm.getState().initialValues;
    }
  }, {
    key: "pristine",
    get: function get() {
      return this.finalForm.getState().pristine;
    }
  }, {
    key: "dirty",
    get: function get() {
      return this.finalForm.getState().dirty;
    }
  }, {
    key: "submitting",
    get: function get() {
      return this.finalForm.getState().submitting;
    }
  }, {
    key: "valid",
    get: function get() {
      return this.finalForm.getState().valid;
    }
  }, {
    key: "mutators",
    get: function get() {
      return this.finalForm.mutators;
    }
  }]);

  return Form;
}();

function updateEverything(form, values) {
  Object.entries(values).forEach(function (_ref4) {
    var _ref5 = index._slicedToArray(_ref4, 2),
        path = _ref5[0],
        value = _ref5[1];

    form.change(path, value);
  });
}

function updateSelectively(form, values, prefix) {
  var activePath = form.getState().active;
  Object.entries(values).forEach(function (_ref6) {
    var _ref7 = index._slicedToArray(_ref6, 2),
        name = _ref7[0],
        value = _ref7[1];

    var path = prefix ? "".concat(prefix, ".").concat(name) : name;

    if (typeof value === "object") {
      if (activePath.startsWith(path)) {
        updateSelectively(form, value, path);
      } else {
        form.change(path, value);
      }
    } else if (path !== activePath) {
      form.change(path, value);
    }
  });
}

function areWidthsFullyDefined(widths, devices) {
  var areWidthsFullyDefined = true;
  devices.forEach(function (device) {
    if (widths[device.id] === -1) {
      areWidthsFullyDefined = false;
    }
  });
  return areWidthsFullyDefined;
}

var dist$1 = {exports: {}};

var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);

var parse$2 = function (input) {
  var tokens = [];
  var value = input;
  var next, quote, prev, token, escape, escapePos, whitespacePos;
  var pos = 0;
  var code = value.charCodeAt(pos);
  var max = value.length;
  var stack = [{
    nodes: tokens
  }];
  var balanced = 0;
  var parent;
  var name = "";
  var before = "";
  var after = "";

  while (pos < max) {
    // Whitespaces
    if (code <= 32) {
      next = pos;

      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);

      token = value.slice(pos, next);
      prev = tokens[tokens.length - 1];

      if (code === closeParentheses && balanced) {
        after = token;
      } else if (prev && prev.type === "div") {
        prev.after = token;
      } else if (code === comma || code === colon || code === slash && value.charCodeAt(next + 1) !== star) {
        before = token;
      } else {
        tokens.push({
          type: "space",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next; // Quotes
    } else if (code === singleQuote || code === doubleQuote) {
      next = pos;
      quote = code === singleQuote ? "'" : '"';
      token = {
        type: "string",
        sourceIndex: pos,
        quote: quote
      };

      do {
        escape = false;
        next = value.indexOf(quote, next + 1);

        if (~next) {
          escapePos = next;

          while (value.charCodeAt(escapePos - 1) === backslash) {
            escapePos -= 1;
            escape = !escape;
          }
        } else {
          value += quote;
          next = value.length - 1;
          token.unclosed = true;
        }
      } while (escape);

      token.value = value.slice(pos + 1, next);
      tokens.push(token);
      pos = next + 1;
      code = value.charCodeAt(pos); // Comments
    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
      token = {
        type: "comment",
        sourceIndex: pos
      };
      next = value.indexOf("*/", pos);

      if (next === -1) {
        token.unclosed = true;
        next = value.length;
      }

      token.value = value.slice(pos + 2, next);
      tokens.push(token);
      pos = next + 2;
      code = value.charCodeAt(pos); // Dividers
    } else if (code === slash || code === comma || code === colon) {
      token = value[pos];
      tokens.push({
        type: "div",
        sourceIndex: pos - before.length,
        value: token,
        before: before,
        after: ""
      });
      before = "";
      pos += 1;
      code = value.charCodeAt(pos); // Open parentheses
    } else if (openParentheses === code) {
      // Whitespaces after open parentheses
      next = pos;

      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);

      token = {
        type: "function",
        sourceIndex: pos - name.length,
        value: name,
        before: value.slice(pos + 1, next)
      };
      pos = next;

      if (name === "url" && code !== singleQuote && code !== doubleQuote) {
        next -= 1;

        do {
          escape = false;
          next = value.indexOf(")", next + 1);

          if (~next) {
            escapePos = next;

            while (value.charCodeAt(escapePos - 1) === backslash) {
              escapePos -= 1;
              escape = !escape;
            }
          } else {
            value += ")";
            next = value.length - 1;
            token.unclosed = true;
          }
        } while (escape); // Whitespaces before closed


        whitespacePos = next;

        do {
          whitespacePos -= 1;
          code = value.charCodeAt(whitespacePos);
        } while (code <= 32);

        if (pos !== whitespacePos + 1) {
          token.nodes = [{
            type: "word",
            sourceIndex: pos,
            value: value.slice(pos, whitespacePos + 1)
          }];
        } else {
          token.nodes = [];
        }

        if (token.unclosed && whitespacePos + 1 !== next) {
          token.after = "";
          token.nodes.push({
            type: "space",
            sourceIndex: whitespacePos + 1,
            value: value.slice(whitespacePos + 1, next)
          });
        } else {
          token.after = value.slice(whitespacePos + 1, next);
        }

        pos = next + 1;
        code = value.charCodeAt(pos);
        tokens.push(token);
      } else {
        balanced += 1;
        token.after = "";
        tokens.push(token);
        stack.push(token);
        tokens = token.nodes = [];
        parent = token;
      }

      name = ""; // Close parentheses
    } else if (closeParentheses === code && balanced) {
      pos += 1;
      code = value.charCodeAt(pos);
      parent.after = after;
      after = "";
      balanced -= 1;
      stack.pop();
      parent = stack[balanced];
      tokens = parent.nodes; // Words
    } else {
      next = pos;

      do {
        if (code === backslash) {
          next += 1;
        }

        next += 1;
        code = value.charCodeAt(next);
      } while (next < max && !(code <= 32 || code === singleQuote || code === doubleQuote || code === comma || code === colon || code === slash || code === openParentheses || code === closeParentheses && balanced));

      token = value.slice(pos, next);

      if (openParentheses === code) {
        name = token;
      } else {
        tokens.push({
          type: "word",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;
    }
  }

  for (pos = stack.length - 1; pos; pos -= 1) {
    stack[pos].unclosed = true;
  }

  return stack[0].nodes;
};

var walk$1 = function walk(nodes, cb, bubble) {
  var i, max, node, result;

  for (i = 0, max = nodes.length; i < max; i += 1) {
    node = nodes[i];

    if (!bubble) {
      result = cb(node, i, nodes);
    }

    if (result !== false && node.type === "function" && Array.isArray(node.nodes)) {
      walk(node.nodes, cb, bubble);
    }

    if (bubble) {
      cb(node, i, nodes);
    }
  }
};

function stringifyNode(node, custom) {
  var type = node.type;
  var value = node.value;
  var buf;
  var customResult;

  if (custom && (customResult = custom(node)) !== undefined) {
    return customResult;
  } else if (type === "word" || type === "space") {
    return value;
  } else if (type === "string") {
    buf = node.quote || "";
    return buf + value + (node.unclosed ? "" : buf);
  } else if (type === "comment") {
    return "/*" + value + (node.unclosed ? "" : "*/");
  } else if (type === "div") {
    return (node.before || "") + value + (node.after || "");
  } else if (Array.isArray(node.nodes)) {
    buf = stringify$1(node.nodes);

    if (type !== "function") {
      return buf;
    }

    return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
  }

  return value;
}

function stringify$1(nodes, custom) {
  var result, i;

  if (Array.isArray(nodes)) {
    result = "";

    for (i = nodes.length - 1; ~i; i -= 1) {
      result = stringifyNode(nodes[i], custom) + result;
    }

    return result;
  }

  return stringifyNode(nodes, custom);
}

var stringify_1 = stringify$1;

var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);

var unit = function (value) {
  var pos = 0;
  var length = value.length;
  var dotted = false;
  var sciPos = -1;
  var containsNumber = false;
  var code;

  while (pos < length) {
    code = value.charCodeAt(pos);

    if (code >= 48 && code <= 57) {
      containsNumber = true;
    } else if (code === exp || code === EXP) {
      if (sciPos > -1) {
        break;
      }

      sciPos = pos;
    } else if (code === dot) {
      if (dotted) {
        break;
      }

      dotted = true;
    } else if (code === plus || code === minus) {
      if (pos !== 0) {
        break;
      }
    } else {
      break;
    }

    pos += 1;
  }

  if (sciPos + 1 === pos) pos--;
  return containsNumber ? {
    number: value.slice(0, pos),
    unit: value.slice(pos)
  } : false;
};

var parse$1 = parse$2;

var walk = walk$1;

var stringify = stringify_1;

function ValueParser(value) {
  if (this instanceof ValueParser) {
    this.nodes = parse$1(value);
    return this;
  }

  return new ValueParser(value);
}

ValueParser.prototype.toString = function () {
  return Array.isArray(this.nodes) ? stringify(this.nodes) : "";
};

ValueParser.prototype.walk = function (cb, bubble) {
  walk(this.nodes, cb, bubble);
  return this;
};

ValueParser.unit = unit;
ValueParser.walk = walk;
ValueParser.stringify = stringify;
var lib$1 = ValueParser;

var parser = {};

/* parser generated by jison 0.6.1-215 */

(function (exports) {
/*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */
var parser = function () {
  // See also:
  // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
  // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
  // with userland code which might access the derived class in a 'classic' way.
  function JisonParserError(msg, hash) {
    Object.defineProperty(this, 'name', {
      enumerable: false,
      writable: false,
      value: 'JisonParserError'
    });
    if (msg == null) msg = '???';
    Object.defineProperty(this, 'message', {
      enumerable: false,
      writable: true,
      value: msg
    });
    this.hash = hash;
    var stacktrace;

    if (hash && hash.exception instanceof Error) {
      var ex2 = hash.exception;
      this.message = ex2.message || msg;
      stacktrace = ex2.stack;
    }

    if (!stacktrace) {
      if (Error.hasOwnProperty('captureStackTrace')) {
        // V8/Chrome engine
        Error.captureStackTrace(this, this.constructor);
      } else {
        stacktrace = new Error(msg).stack;
      }
    }

    if (stacktrace) {
      Object.defineProperty(this, 'stack', {
        enumerable: false,
        writable: false,
        value: stacktrace
      });
    }
  }

  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
  } else {
    JisonParserError.prototype = Object.create(Error.prototype);
  }

  JisonParserError.prototype.constructor = JisonParserError;
  JisonParserError.prototype.name = 'JisonParserError'; // helper: reconstruct the productions[] table

  function bp(s) {
    var rv = [];
    var p = s.pop;
    var r = s.rule;

    for (var i = 0, l = p.length; i < l; i++) {
      rv.push([p[i], r[i]]);
    }

    return rv;
  } // helper: reconstruct the defaultActions[] table


  function bda(s) {
    var rv = {};
    var d = s.idx;
    var g = s["goto"];

    for (var i = 0, l = d.length; i < l; i++) {
      var j = d[i];
      rv[j] = g[i];
    }

    return rv;
  } // helper: reconstruct the 'goto' table


  function bt(s) {
    var rv = [];
    var d = s.len;
    var y = s.symbol;
    var t = s.type;
    var a = s.state;
    var m = s.mode;
    var g = s["goto"];

    for (var i = 0, l = d.length; i < l; i++) {
      var n = d[i];
      var q = {};

      for (var j = 0; j < n; j++) {
        var z = y.shift();

        switch (t.shift()) {
          case 2:
            q[z] = [m.shift(), g.shift()];
            break;

          case 0:
            q[z] = a.shift();
            break;

          default:
            // type === 1: accept
            q[z] = [3];
        }
      }

      rv.push(q);
    }

    return rv;
  } // helper: runlength encoding with increment step: code, length: step (default step = 0)
  // `this` references an array


  function s(c, l, a) {
    a = a || 0;

    for (var i = 0; i < l; i++) {
      this.push(c);
      c += a;
    }
  } // helper: duplicate sequence from *relative* offset and length.
  // `this` references an array


  function c(i, l) {
    i = this.length - i;

    for (l += i; i < l; i++) {
      this.push(this[i]);
    }
  } // helper: unpack an array using helpers and data, all passed in an array argument 'a'.


  function u(a) {
    var rv = [];

    for (var i = 0, l = a.length; i < l; i++) {
      var e = a[i]; // Is this entry a helper function?

      if (typeof e === 'function') {
        i++;
        e.apply(rv, a[i]);
      } else {
        rv.push(e);
      }
    }

    return rv;
  }

  var parser = {
    // Code Generator Information Report
    // ---------------------------------
    //
    // Options:
    //
    //   default action mode: ............. ["classic","merge"]
    //   test-compile action mode: ........ "parser:*,lexer:*"
    //   try..catch: ...................... true
    //   default resolve on conflict: ..... true
    //   on-demand look-ahead: ............ false
    //   error recovery token skip maximum: 3
    //   yyerror in parse actions is: ..... NOT recoverable,
    //   yyerror in lexer actions and other non-fatal lexer are:
    //   .................................. NOT recoverable,
    //   debug grammar/output: ............ false
    //   has partial LR conflict upgrade:   true
    //   rudimentary token-stack support:   false
    //   parser table compression mode: ... 2
    //   export debug tables: ............. false
    //   export *all* tables: ............. false
    //   module type: ..................... commonjs
    //   parser engine type: .............. lalr
    //   output main() in the module: ..... true
    //   has user-specified main(): ....... false
    //   has user-specified require()/import modules for main():
    //   .................................. false
    //   number of expected conflicts: .... 0
    //
    //
    // Parser Analysis flags:
    //
    //   no significant actions (parser is a language matcher only):
    //   .................................. false
    //   uses yyleng: ..................... false
    //   uses yylineno: ................... false
    //   uses yytext: ..................... false
    //   uses yylloc: ..................... false
    //   uses ParseError API: ............. false
    //   uses YYERROR: .................... false
    //   uses YYRECOVERING: ............... false
    //   uses YYERROK: .................... false
    //   uses YYCLEARIN: .................. false
    //   tracks rule values: .............. true
    //   assigns rule values: ............. true
    //   uses location tracking: .......... false
    //   assigns location: ................ false
    //   uses yystack: .................... false
    //   uses yysstack: ................... false
    //   uses yysp: ....................... true
    //   uses yyrulelength: ............... false
    //   uses yyMergeLocationInfo API: .... false
    //   has error recovery: .............. false
    //   has error reporting: ............. false
    //
    // --------- END OF REPORT -----------
    trace: function no_op_trace() {},
    JisonParserError: JisonParserError,
    yy: {},
    options: {
      type: "lalr",
      hasPartialLrUpgradeOnConflict: true,
      errorRecoveryTokenDiscardCount: 3
    },
    symbols_: {
      "$accept": 0,
      "$end": 1,
      "ADD": 3,
      "ANGLE": 18,
      "CHS": 24,
      "COMMA": 11,
      "CSS_CPROP": 16,
      "CSS_VAR": 15,
      "DIV": 6,
      "EMS": 22,
      "EOF": 1,
      "EXS": 23,
      "FREQ": 20,
      "LENGTH": 17,
      "LPAREN": 7,
      "MAX": 10,
      "MIN": 12,
      "MUL": 5,
      "NESTED_CALC": 9,
      "NUMBER": 14,
      "PERCENTAGE": 30,
      "PREFIX": 13,
      "REMS": 25,
      "RES": 21,
      "RPAREN": 8,
      "SUB": 4,
      "TIME": 19,
      "VHS": 26,
      "VMAXS": 29,
      "VMINS": 28,
      "VWS": 27,
      "css_value": 35,
      "css_variable": 34,
      "error": 2,
      "expression": 31,
      "math_expression": 32,
      "value": 33
    },
    terminals_: {
      1: "EOF",
      2: "error",
      3: "ADD",
      4: "SUB",
      5: "MUL",
      6: "DIV",
      7: "LPAREN",
      8: "RPAREN",
      9: "NESTED_CALC",
      10: "MAX",
      11: "COMMA",
      12: "MIN",
      13: "PREFIX",
      14: "NUMBER",
      15: "CSS_VAR",
      16: "CSS_CPROP",
      17: "LENGTH",
      18: "ANGLE",
      19: "TIME",
      20: "FREQ",
      21: "RES",
      22: "EMS",
      23: "EXS",
      24: "CHS",
      25: "REMS",
      26: "VHS",
      27: "VWS",
      28: "VMINS",
      29: "VMAXS",
      30: "PERCENTAGE"
    },
    TERROR: 2,
    EOF: 1,
    // internals: defined here so the object *structure* doesn't get modified by parse() et al,
    // thus helping JIT compilers like Chrome V8.
    originalQuoteName: null,
    originalParseError: null,
    cleanupAfterParse: null,
    constructParseErrorInfo: null,
    yyMergeLocationInfo: null,
    __reentrant_call_depth: 0,
    // INTERNAL USE ONLY
    __error_infos: [],
    // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    __error_recovery_infos: [],
    // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    // APIs which will be set up depending on user action code analysis:
    //yyRecovering: 0,
    //yyErrOk: 0,
    //yyClearIn: 0,
    // Helper APIs
    // -----------
    // Helper function which can be overridden by user code later on: put suitable quotes around
    // literal IDs in a description string.
    quoteName: function parser_quoteName(id_str) {
      return '"' + id_str + '"';
    },
    // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
    //
    // Return NULL when the symbol is unknown to the parser.
    getSymbolName: function parser_getSymbolName(symbol) {
      if (this.terminals_[symbol]) {
        return this.terminals_[symbol];
      } // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
      //
      // An example of this may be where a rule's action code contains a call like this:
      //
      //      parser.getSymbolName(#$)
      //
      // to obtain a human-readable name of the current grammar rule.


      var s = this.symbols_;

      for (var key in s) {
        if (s[key] === symbol) {
          return key;
        }
      }

      return null;
    },
    // Return a more-or-less human-readable description of the given symbol, when available,
    // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
    //
    // Return NULL when the symbol is unknown to the parser.
    describeSymbol: function parser_describeSymbol(symbol) {
      if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) {
        return this.terminal_descriptions_[symbol];
      } else if (symbol === this.EOF) {
        return 'end of input';
      }

      var id = this.getSymbolName(symbol);

      if (id) {
        return this.quoteName(id);
      }

      return null;
    },
    // Produce a (more or less) human-readable list of expected tokens at the point of failure.
    //
    // The produced list may contain token or token set descriptions instead of the tokens
    // themselves to help turning this output into something that easier to read by humans
    // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
    // expected terminals and nonterminals is produced.
    //
    // The returned list (array) will not contain any duplicate entries.
    collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
      var TERROR = this.TERROR;
      var tokenset = [];
      var check = {}; // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
      // If so, use that one instead of the less palatable token set.

      if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) {
        return [this.state_descriptions_[state]];
      }

      for (var p in this.table[state]) {
        p = +p;

        if (p !== TERROR) {
          var d = do_not_describe ? p : this.describeSymbol(p);

          if (d && !check[d]) {
            tokenset.push(d);
            check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
          }
        }
      }

      return tokenset;
    },
    productions_: bp({
      pop: u([31, s, [32, 12], 33, 33, 34, 34, s, [35, 15]]),
      rule: u([2, s, [3, 5], 4, 6, 6, 7, s, [1, 4], 2, 4, 6, s, [1, 14], 2])
    }),
    performAction: function parser__PerformAction(yystate
    /* action[1] */
    , yysp, yyvstack) {
      /* this == yyval */
      // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
      var yy = this.yy;
      yy.parser;
      yy.lexer;

      switch (yystate) {
        case 0:
          /*! Production::    $accept : expression $end */
          // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
          this.$ = yyvstack[yysp - 1]; // END of default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-)

          break;

        case 1:
          /*! Production::    expression : math_expression EOF */
          // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
          this.$ = yyvstack[yysp - 1]; // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)

          return yyvstack[yysp - 1];

        case 2:
        /*! Production::    math_expression : math_expression ADD math_expression */

        case 3:
        /*! Production::    math_expression : math_expression SUB math_expression */

        case 4:
        /*! Production::    math_expression : math_expression MUL math_expression */

        case 5:
          /*! Production::    math_expression : math_expression DIV math_expression */
          this.$ = {
            type: 'MathExpression',
            operator: yyvstack[yysp - 1],
            left: yyvstack[yysp - 2],
            right: yyvstack[yysp]
          };
          break;

        case 6:
          /*! Production::    math_expression : LPAREN math_expression RPAREN */
          this.$ = yyvstack[yysp - 1];
          break;

        case 7:
          /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */
          this.$ = {
            type: 'Calc',
            value: yyvstack[yysp - 1]
          };
          break;

        case 8:
          /*! Production::    math_expression : MAX LPAREN math_expression COMMA math_expression RPAREN */
          this.$ = {
            type: 'MathExpression',
            operator: 'max',
            left: yyvstack[yysp - 3],
            right: yyvstack[yysp - 1]
          };
          break;

        case 9:
          /*! Production::    math_expression : MIN LPAREN math_expression COMMA math_expression RPAREN */
          this.$ = {
            type: 'MathExpression',
            operator: 'min',
            left: yyvstack[yysp - 3],
            right: yyvstack[yysp - 1]
          };
          break;

        case 10:
          /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */
          this.$ = {
            type: 'Calc',
            value: yyvstack[yysp - 1],
            prefix: yyvstack[yysp - 5]
          };
          break;

        case 11:
        /*! Production::    math_expression : css_variable */

        case 12:
        /*! Production::    math_expression : css_value */

        case 13:
          /*! Production::    math_expression : value */
          this.$ = yyvstack[yysp];
          break;

        case 14:
          /*! Production::    value : NUMBER */
          this.$ = {
            type: 'Value',
            value: parseFloat(yyvstack[yysp])
          };
          break;

        case 15:
          /*! Production::    value : SUB NUMBER */
          this.$ = {
            type: 'Value',
            value: parseFloat(yyvstack[yysp]) * -1
          };
          break;

        case 16:
          /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */
          this.$ = {
            type: 'CssVariable',
            value: yyvstack[yysp - 1]
          };
          break;

        case 17:
          /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */
          this.$ = {
            type: 'CssVariable',
            value: yyvstack[yysp - 3],
            fallback: yyvstack[yysp - 1]
          };
          break;

        case 18:
          /*! Production::    css_value : LENGTH */
          this.$ = {
            type: 'LengthValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 19:
          /*! Production::    css_value : ANGLE */
          this.$ = {
            type: 'AngleValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 20:
          /*! Production::    css_value : TIME */
          this.$ = {
            type: 'TimeValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 21:
          /*! Production::    css_value : FREQ */
          this.$ = {
            type: 'FrequencyValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 22:
          /*! Production::    css_value : RES */
          this.$ = {
            type: 'ResolutionValue',
            value: parseFloat(yyvstack[yysp]),
            unit: /[a-z]+/.exec(yyvstack[yysp])[0]
          };
          break;

        case 23:
          /*! Production::    css_value : EMS */
          this.$ = {
            type: 'EmValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'em'
          };
          break;

        case 24:
          /*! Production::    css_value : EXS */
          this.$ = {
            type: 'ExValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'ex'
          };
          break;

        case 25:
          /*! Production::    css_value : CHS */
          this.$ = {
            type: 'ChValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'ch'
          };
          break;

        case 26:
          /*! Production::    css_value : REMS */
          this.$ = {
            type: 'RemValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'rem'
          };
          break;

        case 27:
          /*! Production::    css_value : VHS */
          this.$ = {
            type: 'VhValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vh'
          };
          break;

        case 28:
          /*! Production::    css_value : VWS */
          this.$ = {
            type: 'VwValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vw'
          };
          break;

        case 29:
          /*! Production::    css_value : VMINS */
          this.$ = {
            type: 'VminValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vmin'
          };
          break;

        case 30:
          /*! Production::    css_value : VMAXS */
          this.$ = {
            type: 'VmaxValue',
            value: parseFloat(yyvstack[yysp]),
            unit: 'vmax'
          };
          break;

        case 31:
          /*! Production::    css_value : PERCENTAGE */
          this.$ = {
            type: 'PercentageValue',
            value: parseFloat(yyvstack[yysp]),
            unit: '%'
          };
          break;

        case 32:
          /*! Production::    css_value : SUB css_value */
          var prev = yyvstack[yysp];
          prev.value *= -1;
          this.$ = prev;
          break;
      }
    },
    table: bt({
      len: u([26, 1, 5, 25, s, [1, 3], 18, s, [0, 3], 1, s, [0, 16], s, [25, 4], 5, s, [25, 3], c, [25, 3], 16, 1, 7, 7, s, [0, 3], s, [5, 3], 1, 2, c, [24, 3], 1, 0, 25, 5, 5, 25, 5, c, [17, 3], 0, 0]),
      symbol: u([4, 7, 9, 10, 12, 14, 15, s, [17, 19, 1], 1, 1, s, [3, 4, 1], c, [32, 21], c, [31, 4], s, [7, 3], 4, 13, 14, c, [24, 14], 35, 7, c, [47, 25], c, [25, 75], c, [151, 4], 8, c, [105, 76], 4, c, [198, 15], 16, c, [250, 5], 8, 11, c, [7, 7], c, [6, 5], c, [5, 4], c, [10, 5], 11, 9, 8, 11, c, [100, 50], c, [281, 26], c, [94, 9], c, [211, 26], c, [35, 10]]),
      type: u([s, [2, 21], s, [0, 5], 1, s, [2, 26], s, [0, 4], c, [24, 21], c, [47, 46], c, [25, 76], c, [80, 75], c, [97, 27], s, [2, 28], c, [180, 51], c, [206, 30], c, [35, 19]]),
      state: u([1, 2, 10, 8, 9, 32, c, [4, 3], 37, 41, c, [5, 3], 42, c, [4, 3], 43, c, [4, 3], 44, c, [4, 3], 46, c, [4, 3], 47, c, [4, 3], 48, c, [29, 4], 57, c, [5, 3], 58, c, [4, 3], 60, c, [4, 3], 63, c, [4, 3]]),
      mode: u([s, [1, 237], s, [2, 3], c, [5, 5], c, [7, 6], s, [1, 123]]),
      "goto": u([7, s, [3, 4, 1], 26, s, [11, 15, 1], s, [27, 5, 1], c, [26, 21], 33, 34, 35, 39, 36, 38, c, [20, 14], 40, c, [42, 21], c, [21, 63], c, [130, 4], 45, c, [68, 63], 49, 39, c, [16, 14], 50, s, [2, 3], 30, 31, 2, 2, s, [3, 3], 30, 31, 3, 3, c, [99, 4], 51, c, [5, 4], 52, c, [5, 4], s, [53, 4, 1], c, [91, 42], 59, c, [181, 25], 61, c, [5, 4], 62, c, [31, 25], 64, c, [5, 4], 65])
    }),
    defaultActions: bda({
      idx: u([8, 9, 10, s, [12, 16, 1], 37, 38, 43, 44, 45, 51, 55, 61, 62, 64, 65]),
      "goto": u([11, 12, 13, s, [18, 14, 1], 14, 1, 32, 15, s, [4, 4, 1], 16, 8, 9, 17, 10])
    }),
    parseError: function parseError(str, hash, ExceptionClass) {
      if (hash.recoverable) {
        if (typeof this.trace === 'function') {
          this.trace(str);
        }

        hash.destroy(); // destroy... well, *almost*!
      } else {
        if (typeof this.trace === 'function') {
          this.trace(str);
        }

        if (!ExceptionClass) {
          ExceptionClass = this.JisonParserError;
        }

        throw new ExceptionClass(str, hash);
      }
    },
    parse: function parse(input) {
      var self = this;
      var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)

      var sstack = new Array(128); // state stack: stores states (column storage)

      var vstack = new Array(128); // semantic value stack

      var table = this.table;
      var sp = 0; // 'stack pointer': index into the stacks

      var symbol = 0;
      this.TERROR;
      var EOF = this.EOF;
      this.options.errorRecoveryTokenDiscardCount | 0 || 3;
      var NO_ACTION = [0, 66
      /* === table.length :: ensures that anyone using this new state will fail dramatically! */
      ];
      var lexer;

      if (this.__lexer__) {
        lexer = this.__lexer__;
      } else {
        lexer = this.__lexer__ = Object.create(this.lexer);
      }

      var sharedState_yy = {
        parseError: undefined,
        quoteName: undefined,
        lexer: undefined,
        parser: undefined,
        pre_parse: undefined,
        post_parse: undefined,
        pre_lex: undefined,
        post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!

      };

      if (typeof assert !== 'function') ; else {
        assert;
      }

      this.yyGetSharedState = function yyGetSharedState() {
        return sharedState_yy;
      };

      function shallow_copy_noclobber(dst, src) {
        for (var k in src) {
          if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) {
            dst[k] = src[k];
          }
        }
      } // copy state


      shallow_copy_noclobber(sharedState_yy, this.yy);
      sharedState_yy.lexer = lexer;
      sharedState_yy.parser = this; // Does the shared state override the default `parseError` that already comes with this instance?

      if (typeof sharedState_yy.parseError === 'function') {
        this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
          if (!ExceptionClass) {
            ExceptionClass = this.JisonParserError;
          }

          return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
        };
      } else {
        this.parseError = this.originalParseError;
      } // Does the shared state override the default `quoteName` that already comes with this instance?


      if (typeof sharedState_yy.quoteName === 'function') {
        this.quoteName = function quoteNameAlt(id_str) {
          return sharedState_yy.quoteName.call(this, id_str);
        };
      } else {
        this.quoteName = this.originalQuoteName;
      } // set up the cleanup function; make it an API so that external code can re-use this one in case of
      // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
      // case this parse() API method doesn't come with a `finally { ... }` block any more!
      //
      // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
      //       or else your `sharedState`, etc. references will be *wrong*!


      this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
        var rv;

        if (invoke_post_methods) {
          var hash;

          if (sharedState_yy.post_parse || this.post_parse) {
            // create an error hash info instance: we re-use this API in a **non-error situation**
            // as this one delivers all parser internals ready for access by userland code.
            hash = this.constructParseErrorInfo(null
            /* no error! */
            , null
            /* no exception! */
            , null, false);
          }

          if (sharedState_yy.post_parse) {
            rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
            if (typeof rv !== 'undefined') resultValue = rv;
          }

          if (this.post_parse) {
            rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
            if (typeof rv !== 'undefined') resultValue = rv;
          } // cleanup:


          if (hash && hash.destroy) {
            hash.destroy();
          }
        }

        if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
        // clean up the lingering lexer structures as well:

        if (lexer.cleanupAfterLex) {
          lexer.cleanupAfterLex(do_not_nuke_errorinfos);
        } // prevent lingering circular references from causing memory leaks:


        if (sharedState_yy) {
          sharedState_yy.lexer = undefined;
          sharedState_yy.parser = undefined;

          if (lexer.yy === sharedState_yy) {
            lexer.yy = undefined;
          }
        }

        sharedState_yy = undefined;
        this.parseError = this.originalParseError;
        this.quoteName = this.originalQuoteName; // nuke the vstack[] array at least as that one will still reference obsoleted user values.
        // To be safe, we nuke the other internal stack columns as well...

        stack.length = 0; // fastest way to nuke an array without overly bothering the GC

        sstack.length = 0;
        vstack.length = 0;
        sp = 0; // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.

        if (!do_not_nuke_errorinfos) {
          for (var i = this.__error_infos.length - 1; i >= 0; i--) {
            var el = this.__error_infos[i];

            if (el && typeof el.destroy === 'function') {
              el.destroy();
            }
          }

          this.__error_infos.length = 0;
        }

        return resultValue;
      }; // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
      //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!


      this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
        var pei = {
          errStr: msg,
          exception: ex,
          text: lexer.match,
          value: lexer.yytext,
          token: this.describeSymbol(symbol) || symbol,
          token_id: symbol,
          line: lexer.yylineno,
          expected: expected,
          recoverable: recoverable,
          state: state,
          action: action,
          new_state: newState,
          symbol_stack: stack,
          state_stack: sstack,
          value_stack: vstack,
          stack_pointer: sp,
          yy: sharedState_yy,
          lexer: lexer,
          parser: this,
          // and make sure the error info doesn't stay due to potential
          // ref cycle via userland code manipulations.
          // These would otherwise all be memory leak opportunities!
          //
          // Note that only array and object references are nuked as those
          // constitute the set of elements which can produce a cyclic ref.
          // The rest of the members is kept intact as they are harmless.
          destroy: function destructParseErrorInfo() {
            // remove cyclic references added to error info:
            // info.yy = null;
            // info.lexer = null;
            // info.value = null;
            // info.value_stack = null;
            // ...
            var rec = !!this.recoverable;

            for (var key in this) {
              if (this.hasOwnProperty(key) && typeof key === 'object') {
                this[key] = undefined;
              }
            }

            this.recoverable = rec;
          }
        }; // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!

        this.__error_infos.push(pei);

        return pei;
      };

      function stdLex() {
        var token = lexer.lex(); // if token isn't its numeric value, convert

        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }

        return token || EOF;
      }

      function fastLex() {
        var token = lexer.fastLex(); // if token isn't its numeric value, convert

        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }

        return token || EOF;
      }

      var lex = stdLex;
      var state, action, r, t;
      var yyval = {
        $: true,
        _$: undefined,
        yy: sharedState_yy
      };
      var p;
      var yyrulelen;
      var this_production;
      var newState;
      var retval = false;

      try {
        this.__reentrant_call_depth++;
        lexer.setInput(input, sharedState_yy); // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
        // this initial `setInput()` call: hence we can now check and decide
        // whether we'll go with the standard, slower, lex() API or the
        // `fast_lex()` one:

        if (typeof lexer.canIUse === 'function') {
          var lexerInfo = lexer.canIUse();

          if (lexerInfo.fastLex && typeof fastLex === 'function') {
            lex = fastLex;
          }
        }

        vstack[sp] = null;
        sstack[sp] = 0;
        stack[sp] = 0;
        ++sp;

        if (this.pre_parse) {
          this.pre_parse.call(this, sharedState_yy);
        }

        if (sharedState_yy.pre_parse) {
          sharedState_yy.pre_parse.call(this, sharedState_yy);
        }

        newState = sstack[sp - 1];

        for (;;) {
          // retrieve state number from top of stack
          state = newState; // sstack[sp - 1];
          // use default actions if available

          if (this.defaultActions[state]) {
            action = 2;
            newState = this.defaultActions[state];
          } else {
            // The single `==` condition below covers both these `===` comparisons in a single
            // operation:
            //
            //     if (symbol === null || typeof symbol === 'undefined') ...
            if (!symbol) {
              symbol = lex();
            } // read action for current state and first input


            t = table[state] && table[state][symbol] || NO_ACTION;
            newState = t[1];
            action = t[0]; // handle parse error

            if (!action) {
              var errStr;
              var errSymbolDescr = this.describeSymbol(symbol) || symbol;
              var expected = this.collect_expected_token_set(state); // Report error

              if (typeof lexer.yylineno === 'number') {
                errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
              } else {
                errStr = 'Parse error: ';
              }

              if (typeof lexer.showPosition === 'function') {
                errStr += '\n' + lexer.showPosition(79 - 10, 10) + '\n';
              }

              if (expected.length) {
                errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
              } else {
                errStr += 'Unexpected ' + errSymbolDescr;
              } // we cannot recover from the error!


              p = this.constructParseErrorInfo(errStr, null, expected, false);
              r = this.parseError(p.errStr, p, this.JisonParserError);

              if (typeof r !== 'undefined') {
                retval = r;
              }

              break;
            }
          }

          switch (action) {
            // catch misc. parse failures:
            default:
              // this shouldn't happen, unless resolve defaults are off
              if (action instanceof Array) {
                p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                r = this.parseError(p.errStr, p, this.JisonParserError);

                if (typeof r !== 'undefined') {
                  retval = r;
                }

                break;
              } // Another case of better safe than sorry: in case state transitions come out of another error recovery process
              // or a buggy LUT (LookUp Table):


              p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
              r = this.parseError(p.errStr, p, this.JisonParserError);

              if (typeof r !== 'undefined') {
                retval = r;
              }

              break;
            // shift:

            case 1:
              stack[sp] = symbol;
              vstack[sp] = lexer.yytext;
              sstack[sp] = newState; // push state

              ++sp;
              symbol = 0; // Pick up the lexer details for the current symbol as that one is not 'look-ahead' any more:

              continue;
            // reduce:

            case 2:
              this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...

              yyrulelen = this_production[1];
              r = this.performAction.call(yyval, newState, sp - 1, vstack);

              if (typeof r !== 'undefined') {
                retval = r;
                break;
              } // pop off stack


              sp -= yyrulelen; // don't overwrite the `symbol` variable: use a local var to speed things up:

              var ntsymbol = this_production[0]; // push nonterminal (reduce)

              stack[sp] = ntsymbol;
              vstack[sp] = yyval.$; // goto new state = table[STATE][NONTERMINAL]

              newState = table[sstack[sp - 1]][ntsymbol];
              sstack[sp] = newState;
              ++sp;
              continue;
            // accept:

            case 3:
              if (sp !== -2) {
                retval = true; // Return the `$accept` rule's `$$` result, if available.
                //
                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                // default, action):
                //
                //     $accept: <startSymbol> $end
                //                  %{ $$ = $1; @$ = @1; %}
                //
                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                //
                // In code:
                //
                //                  %{
                //                      @$ = @1;            // if location tracking support is included
                //                      if (typeof $1 !== 'undefined')
                //                          return $1;
                //                      else
                //                          return true;           // the default parse result if the rule actions don't produce anything
                //                  %}

                sp--;

                if (typeof vstack[sp] !== 'undefined') {
                  retval = vstack[sp];
                }
              }

              break;
          } // break out of loop: we accept or fail with error


          break;
        }
      } catch (ex) {
        // report exceptions through the parseError callback too, but keep the exception intact
        // if it is a known parser or lexer error which has been thrown by parseError() already:
        if (ex instanceof this.JisonParserError) {
          throw ex;
        } else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) {
          throw ex;
        }

        p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
        retval = false;
        r = this.parseError(p.errStr, p, this.JisonParserError);

        if (typeof r !== 'undefined') {
          retval = r;
        }
      } finally {
        retval = this.cleanupAfterParse(retval, true, true);
        this.__reentrant_call_depth--;
      } // /finally


      return retval;
    }
  };
  parser.originalParseError = parser.parseError;
  parser.originalQuoteName = parser.quoteName;
  /* lexer generated by jison-lex 0.6.1-215 */

  /*
   * Returns a Lexer object of the following structure:
   *
   *  Lexer: {
   *    yy: {}     The so-called "shared state" or rather the *source* of it;
   *               the real "shared state" `yy` passed around to
   *               the rule actions, etc. is a direct reference!
   *
   *               This "shared context" object was passed to the lexer by way of 
   *               the `lexer.setInput(str, yy)` API before you may use it.
   *
   *               This "shared context" object is passed to the lexer action code in `performAction()`
   *               so userland code in the lexer actions may communicate with the outside world 
   *               and/or other lexer rules' actions in more or less complex ways.
   *
   *  }
   *
   *  Lexer.prototype: {
   *    EOF: 1,
   *    ERROR: 2,
   *
   *    yy:        The overall "shared context" object reference.
   *
   *    JisonLexerError: function(msg, hash),
   *
   *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
   *
   *               The function parameters and `this` have the following value/meaning:
   *               - `this`    : reference to the `lexer` instance. 
   *                               `yy_` is an alias for `this` lexer instance reference used internally.
   *
   *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
   *                             by way of the `lexer.setInput(str, yy)` API before.
   *
   *                             Note:
   *                             The extra arguments you specified in the `%parse-param` statement in your
   *                             **parser** grammar definition file are passed to the lexer via this object
   *                             reference as member variables.
   *
   *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
   *
   *               - `YY_START`: the current lexer "start condition" state.
   *
   *    parseError: function(str, hash, ExceptionClass),
   *
   *    constructLexErrorInfo: function(error_message, is_recoverable),
   *               Helper function.
   *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
   *               See it's use in this lexer kernel in many places; example usage:
   *
   *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
   *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
   *
   *    options: { ... lexer %options ... },
   *
   *    lex: function(),
   *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
   *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
   *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
   *
   *               WARNING:
   *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
   *               any attributes already added to `yy` by the **parser** or the jison run-time; 
   *               when such a collision is detected an exception is thrown to prevent the generated run-time 
   *               from silently accepting this confusing and potentially hazardous situation! 
   *
   *    cleanupAfterLex: function(do_not_nuke_errorinfos),
   *               Helper function.
   *
   *               This helper API is invoked when the **parse process** has completed: it is the responsibility
   *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
   *
   *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
   *
   *    setInput: function(input, [yy]),
   *
   *
   *    input: function(),
   *
   *
   *    unput: function(str),
   *
   *
   *    more: function(),
   *
   *
   *    reject: function(),
   *
   *
   *    less: function(n),
   *
   *
   *    pastInput: function(n),
   *
   *
   *    upcomingInput: function(n),
   *
   *
   *    showPosition: function(),
   *
   *
   *    test_match: function(regex_match_array, rule_index),
   *
   *
   *    next: function(),
   *
   *
   *    begin: function(condition),
   *
   *
   *    pushState: function(condition),
   *
   *
   *    popState: function(),
   *
   *
   *    topState: function(),
   *
   *
   *    _currentRules: function(),
   *
   *
   *    stateStackSize: function(),
   *
   *
   *    performAction: function(yy, yy_, yyrulenumber, YY_START),
   *
   *
   *    rules: [...],
   *
   *
   *    conditions: {associative list: name ==> set},
   *  }
   *
   *
   *  token location info (`yylloc`): {
   *    first_line: n,
   *    last_line: n,
   *    first_column: n,
   *    last_column: n,
   *    range: [start_number, end_number]
   *               (where the numbers are indexes into the input string, zero-based)
   *  }
   *
   * ---
   *
   * The `parseError` function receives a 'hash' object with these members for lexer errors:
   *
   *  {
   *    text:        (matched text)
   *    token:       (the produced terminal token, if any)
   *    token_id:    (the produced terminal token numeric ID, if any)
   *    line:        (yylineno)
   *    loc:         (yylloc)
   *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
   *                  available for this particular error)
   *    yy:          (object: the current parser internal "shared state" `yy`
   *                  as is also available in the rule actions; this can be used,
   *                  for instance, for advanced error analysis and reporting)
   *    lexer:       (reference to the current lexer instance used by the parser)
   *  }
   *
   * while `this` will reference the current lexer instance.
   *
   * When `parseError` is invoked by the lexer, the default implementation will
   * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
   * it will try to invoke `yy.parseError()` instead. When that callback is also not
   * provided, a `JisonLexerError` exception will be thrown containing the error
   * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
   *
   * Note that the lexer's `JisonLexerError` error class is passed via the
   * `ExceptionClass` argument, which is invoked to construct the exception
   * instance to be thrown, so technically `parseError` will throw the object
   * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
   *
   * ---
   *
   * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
   * These options are available:
   *
   * (Options are permanent.)
   *  
   *  yy: {
   *      parseError: function(str, hash, ExceptionClass)
   *                 optional: overrides the default `parseError` function.
   *  }
   *
   *  lexer.options: {
   *      pre_lex:  function()
   *                 optional: is invoked before the lexer is invoked to produce another token.
   *                 `this` refers to the Lexer object.
   *      post_lex: function(token) { return token; }
   *                 optional: is invoked when the lexer has produced a token `token`;
   *                 this function can override the returned token value by returning another.
   *                 When it does not return any (truthy) value, the lexer will return
   *                 the original `token`.
   *                 `this` refers to the Lexer object.
   *
   * WARNING: the next set of options are not meant to be changed. They echo the abilities of
   * the lexer as per when it was compiled!
   *
   *      ranges: boolean
   *                 optional: `true` ==> token location info will include a .range[] member.
   *      flex: boolean
   *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
   *                 exhaustively to find the longest match.
   *      backtrack_lexer: boolean
   *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
   *                 the lexer terminates the scan when a token is returned by the action code.
   *      xregexp: boolean
   *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
   *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
   *                 rule regexes have been written as standard JavaScript RegExp expressions.
   *  }
   */

  var lexer = function () {
    /**
     * See also:
     * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
     * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
     * with userland code which might access the derived class in a 'classic' way.
     *
     * @public
     * @constructor
     * @nocollapse
     */
    function JisonLexerError(msg, hash) {
      Object.defineProperty(this, 'name', {
        enumerable: false,
        writable: false,
        value: 'JisonLexerError'
      });
      if (msg == null) msg = '???';
      Object.defineProperty(this, 'message', {
        enumerable: false,
        writable: true,
        value: msg
      });
      this.hash = hash;
      var stacktrace;

      if (hash && hash.exception instanceof Error) {
        var ex2 = hash.exception;
        this.message = ex2.message || msg;
        stacktrace = ex2.stack;
      }

      if (!stacktrace) {
        if (Error.hasOwnProperty('captureStackTrace')) {
          // V8
          Error.captureStackTrace(this, this.constructor);
        } else {
          stacktrace = new Error(msg).stack;
        }
      }

      if (stacktrace) {
        Object.defineProperty(this, 'stack', {
          enumerable: false,
          writable: false,
          value: stacktrace
        });
      }
    }

    if (typeof Object.setPrototypeOf === 'function') {
      Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
    } else {
      JisonLexerError.prototype = Object.create(Error.prototype);
    }

    JisonLexerError.prototype.constructor = JisonLexerError;
    JisonLexerError.prototype.name = 'JisonLexerError';
    var lexer = {
      // Code Generator Information Report
      // ---------------------------------
      //
      // Options:
      //
      //   backtracking: .................... false
      //   location.ranges: ................. false
      //   location line+column tracking: ... true
      //
      //
      // Forwarded Parser Analysis flags:
      //
      //   uses yyleng: ..................... false
      //   uses yylineno: ................... false
      //   uses yytext: ..................... false
      //   uses yylloc: ..................... false
      //   uses lexer values: ............... true / true
      //   location tracking: ............... false
      //   location assignment: ............. false
      //
      //
      // Lexer Analysis flags:
      //
      //   uses yyleng: ..................... ???
      //   uses yylineno: ................... ???
      //   uses yytext: ..................... ???
      //   uses yylloc: ..................... ???
      //   uses ParseError API: ............. ???
      //   uses yyerror: .................... ???
      //   uses location tracking & editing:  ???
      //   uses more() API: ................. ???
      //   uses unput() API: ................ ???
      //   uses reject() API: ............... ???
      //   uses less() API: ................. ???
      //   uses display APIs pastInput(), upcomingInput(), showPosition():
      //        ............................. ???
      //   uses describeYYLLOC() API: ....... ???
      //
      // --------- END OF REPORT -----------
      EOF: 1,
      ERROR: 2,
      // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
      // options: {},                             /// <-- injected by the code generator
      // yy: ...,                                 /// <-- injected by setInput()
      __currentRuleSet__: null,
      /// INTERNAL USE ONLY: internal rule set cache for the current lexer state  
      __error_infos: [],
      /// INTERNAL USE ONLY: the set of lexErrorInfo objects created since the last cleanup  
      __decompressed: false,
      /// INTERNAL USE ONLY: mark whether the lexer instance has been 'unfolded' completely and is now ready for use  
      done: false,
      /// INTERNAL USE ONLY  
      _backtrack: false,
      /// INTERNAL USE ONLY  
      _input: '',
      /// INTERNAL USE ONLY  
      _more: false,
      /// INTERNAL USE ONLY  
      _signaled_error_token: false,
      /// INTERNAL USE ONLY  
      conditionStack: [],
      /// INTERNAL USE ONLY; managed via `pushState()`, `popState()`, `topState()` and `stateStackSize()`  
      match: '',
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction. `match` is identical to `yytext` except that this one still contains the matched input string after `lexer.performAction()` has been invoked, where userland code MAY have changed/replaced the `yytext` value entirely!  
      matched: '',
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks entire input which has been matched so far  
      matches: false,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks RE match result for last (successful) match attempt  
      yytext: '',
      /// ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction; this value is transferred to the parser as the 'token value' when the parser consumes the lexer token produced through a call to the `lex()` API.  
      offset: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks the 'cursor position' in the input string, i.e. the number of characters matched so far  
      yyleng: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: length of matched input for the token under construction (`yytext`)  
      yylineno: 0,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: 'line number' at which the token under construction is located  
      yylloc: null,
      /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks location info (lines + columns) for the token under construction  

      /**
       * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
       * 
       * @public
       * @this {RegExpLexer}
       */
      constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
        msg = '' + msg; // heuristic to determine if the error message already contains a (partial) source code dump
        // as produced by either `showPosition()` or `prettyPrintRange()`:

        if (show_input_position == undefined) {
          show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
        }

        if (this.yylloc && show_input_position) {
          if (typeof this.prettyPrintRange === 'function') {
            this.prettyPrintRange(this.yylloc);

            if (!/\n\s*$/.test(msg)) {
              msg += '\n';
            }

            msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
          } else if (typeof this.showPosition === 'function') {
            var pos_str = this.showPosition();

            if (pos_str) {
              if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') {
                msg += '\n' + pos_str;
              } else {
                msg += pos_str;
              }
            }
          }
        }
        /** @constructor */


        var pei = {
          errStr: msg,
          recoverable: !!recoverable,
          text: this.match,
          // This one MAY be empty; userland code should use the `upcomingInput` API to obtain more text which follows the 'lexer cursor position'...  
          token: null,
          line: this.yylineno,
          loc: this.yylloc,
          yy: this.yy,
          lexer: this,

          /**
           * and make sure the error info doesn't stay due to potential
           * ref cycle via userland code manipulations.
           * These would otherwise all be memory leak opportunities!
           * 
           * Note that only array and object references are nuked as those
           * constitute the set of elements which can produce a cyclic ref.
           * The rest of the members is kept intact as they are harmless.
           * 
           * @public
           * @this {LexErrorInfo}
           */
          destroy: function destructLexErrorInfo() {
            // remove cyclic references added to error info:
            // info.yy = null;
            // info.lexer = null;
            // ...
            var rec = !!this.recoverable;

            for (var key in this) {
              if (this.hasOwnProperty(key) && typeof key === 'object') {
                this[key] = undefined;
              }
            }

            this.recoverable = rec;
          }
        }; // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!

        this.__error_infos.push(pei);

        return pei;
      },

      /**
       * handler which is invoked when a lexer error occurs.
       * 
       * @public
       * @this {RegExpLexer}
       */
      parseError: function lexer_parseError(str, hash, ExceptionClass) {
        if (!ExceptionClass) {
          ExceptionClass = this.JisonLexerError;
        }

        if (this.yy) {
          if (this.yy.parser && typeof this.yy.parser.parseError === 'function') {
            return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
          } else if (typeof this.yy.parseError === 'function') {
            return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
          }
        }

        throw new ExceptionClass(str, hash);
      },

      /**
       * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
       * 
       * @public
       * @this {RegExpLexer}
       */
      yyerror: function yyError(str
      /*, ...args */
      ) {
        var lineno_msg = '';

        if (this.yylloc) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': ' + str, this.options.lexerErrorsAreRecoverable); // Add any extra args to the hash under the name `extra_error_attributes`:

        var args = Array.prototype.slice.call(arguments, 1);

        if (args.length) {
          p.extra_error_attributes = args;
        }

        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
      },

      /**
       * final cleanup function for when we have completed lexing the input;
       * make it an API so that external code can use this one once userland
       * code has decided it's time to destroy any lingering lexer error
       * hash object instances and the like: this function helps to clean
       * up these constructs, which *may* carry cyclic references which would
       * otherwise prevent the instances from being properly and timely
       * garbage-collected, i.e. this function helps prevent memory leaks!
       * 
       * @public
       * @this {RegExpLexer}
       */
      cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
        // prevent lingering circular references from causing memory leaks:
        this.setInput('', {}); // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.

        if (!do_not_nuke_errorinfos) {
          for (var i = this.__error_infos.length - 1; i >= 0; i--) {
            var el = this.__error_infos[i];

            if (el && typeof el.destroy === 'function') {
              el.destroy();
            }
          }

          this.__error_infos.length = 0;
        }

        return this;
      },

      /**
       * clear the lexer token context; intended for internal use only
       * 
       * @public
       * @this {RegExpLexer}
       */
      clear: function lexer_clear() {
        this.yytext = '';
        this.yyleng = 0;
        this.match = ''; // - DO NOT reset `this.matched`

        this.matches = false;
        this._more = false;
        this._backtrack = false;
        var col = this.yylloc ? this.yylloc.last_column : 0;
        this.yylloc = {
          first_line: this.yylineno + 1,
          first_column: col,
          last_line: this.yylineno + 1,
          last_column: col,
          range: [this.offset, this.offset]
        };
      },

      /**
       * resets the lexer, sets new input
       * 
       * @public
       * @this {RegExpLexer}
       */
      setInput: function lexer_setInput(input, yy) {
        this.yy = yy || this.yy || {}; // also check if we've fully initialized the lexer instance,
        // including expansion work to be done to go from a loaded
        // lexer to a usable lexer:

        if (!this.__decompressed) {
          // step 1: decompress the regex list:
          var rules = this.rules;

          for (var i = 0, len = rules.length; i < len; i++) {
            var rule_re = rules[i]; // compression: is the RE an xref to another RE slot in the rules[] table?

            if (typeof rule_re === 'number') {
              rules[i] = rules[rule_re];
            }
          } // step 2: unfold the conditions[] set to make these ready for use:


          var conditions = this.conditions;

          for (var k in conditions) {
            var spec = conditions[k];
            var rule_ids = spec.rules;
            var len = rule_ids.length;
            var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 

            var rule_new_ids = new Array(len + 1);

            for (var i = 0; i < len; i++) {
              var idx = rule_ids[i];
              var rule_re = rules[idx];
              rule_regexes[i + 1] = rule_re;
              rule_new_ids[i + 1] = idx;
            }

            spec.rules = rule_new_ids;
            spec.__rule_regexes = rule_regexes;
            spec.__rule_count = len;
          }

          this.__decompressed = true;
        }

        this._input = input || '';
        this.clear();
        this._signaled_error_token = false;
        this.done = false;
        this.yylineno = 0;
        this.matched = '';
        this.conditionStack = ['INITIAL'];
        this.__currentRuleSet__ = null;
        this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0,
          range: [0, 0]
        };
        this.offset = 0;
        return this;
      },

      /**
       * edit the remaining input via user-specified callback.
       * This can be used to forward-adjust the input-to-parse, 
       * e.g. inserting macro expansions and alike in the
       * input which has yet to be lexed.
       * The behaviour of this API contrasts the `unput()` et al
       * APIs as those act on the *consumed* input, while this
       * one allows one to manipulate the future, without impacting
       * the current `yyloc` cursor location or any history. 
       * 
       * Use this API to help implement C-preprocessor-like
       * `#include` statements, etc.
       * 
       * The provided callback must be synchronous and is
       * expected to return the edited input (string).
       *
       * The `cpsArg` argument value is passed to the callback
       * as-is.
       *
       * `callback` interface: 
       * `function callback(input, cpsArg)`
       * 
       * - `input` will carry the remaining-input-to-lex string
       *   from the lexer.
       * - `cpsArg` is `cpsArg` passed into this API.
       * 
       * The `this` reference for the callback will be set to
       * reference this lexer instance so that userland code
       * in the callback can easily and quickly access any lexer
       * API. 
       *
       * When the callback returns a non-string-type falsey value,
       * we assume the callback did not edit the input and we
       * will using the input as-is.
       *
       * When the callback returns a non-string-type value, it
       * is converted to a string for lexing via the `"" + retval`
       * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
       * -- that way any returned object's `toValue()` and `toString()`
       * methods will be invoked in a proper/desirable order.)
       * 
       * @public
       * @this {RegExpLexer}
       */
      editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
        var rv = callback.call(this, this._input, cpsArg);

        if (typeof rv !== 'string') {
          if (rv) {
            this._input = '' + rv;
          } // else: keep `this._input` as is.  

        } else {
          this._input = rv;
        }

        return this;
      },

      /**
       * consumes and returns one char from the input
       * 
       * @public
       * @this {RegExpLexer}
       */
      input: function lexer_input() {
        if (!this._input) {
          //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
          return null;
        }

        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch; // Count the linenumber up when we hit the LF (or a stand-alone CR).
        // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
        // and we advance immediately past the LF as well, returning both together as if
        // it was all a single 'character' only.

        var slice_len = 1;
        var lines = false;

        if (ch === '\n') {
          lines = true;
        } else if (ch === '\r') {
          lines = true;
          var ch2 = this._input[1];

          if (ch2 === '\n') {
            slice_len++;
            ch += ch2;
            this.yytext += ch2;
            this.yyleng++;
            this.offset++;
            this.match += ch2;
            this.matched += ch2;
            this.yylloc.range[1]++;
          }
        }

        if (lines) {
          this.yylineno++;
          this.yylloc.last_line++;
          this.yylloc.last_column = 0;
        } else {
          this.yylloc.last_column++;
        }

        this.yylloc.range[1]++;
        this._input = this._input.slice(slice_len);
        return ch;
      },

      /**
       * unshifts one char (or an entire string) into the input
       * 
       * @public
       * @this {RegExpLexer}
       */
      unput: function lexer_unput(ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);
        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        this.yyleng = this.yytext.length;
        this.offset -= len;
        this.match = this.match.substr(0, this.match.length - len);
        this.matched = this.matched.substr(0, this.matched.length - len);

        if (lines.length > 1) {
          this.yylineno -= lines.length - 1;
          this.yylloc.last_line = this.yylineno + 1; // Get last entirely matched line into the `pre_lines[]` array's
          // last index slot; we don't mind when other previously 
          // matched lines end up in the array too. 

          var pre = this.match;
          var pre_lines = pre.split(/(?:\r\n?|\n)/g);

          if (pre_lines.length === 1) {
            pre = this.matched;
            pre_lines = pre.split(/(?:\r\n?|\n)/g);
          }

          this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
        } else {
          this.yylloc.last_column -= len;
        }

        this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
        this.done = false;
        return this;
      },

      /**
       * cache matched text and append it on next action
       * 
       * @public
       * @this {RegExpLexer}
       */
      more: function lexer_more() {
        this._more = true;
        return this;
      },

      /**
       * signal the lexer that this rule fails to match the input, so the
       * next matching rule (regex) should be tested instead.
       * 
       * @public
       * @this {RegExpLexer}
       */
      reject: function lexer_reject() {
        if (this.options.backtrack_lexer) {
          this._backtrack = true;
        } else {
          // when the `parseError()` call returns, we MUST ensure that the error is registered.
          // We accomplish this by signaling an 'error' token to be produced for the current
          // `.lex()` run.
          var lineno_msg = '';

          if (this.yylloc) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).', false);
          this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
        }

        return this;
      },

      /**
       * retain first n characters of the match
       * 
       * @public
       * @this {RegExpLexer}
       */
      less: function lexer_less(n) {
        return this.unput(this.match.slice(n));
      },

      /**
       * return (part of the) already matched input, i.e. for error
       * messages.
       * 
       * Limit the returned string length to `maxSize` (default: 20).
       * 
       * Limit the returned string to the `maxLines` number of lines of
       * input (default: 1).
       * 
       * Negative limit values equal *unlimited*.
       * 
       * @public
       * @this {RegExpLexer}
       */
      pastInput: function lexer_pastInput(maxSize, maxLines) {
        var past = this.matched.substring(0, this.matched.length - this.match.length);
        if (maxSize < 0) maxSize = past.length;else if (!maxSize) maxSize = 20;
        if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
        else if (!maxLines) maxLines = 1; // `substr` anticipation: treat \r\n as a single character and take a little
        // more than necessary so that we can still properly check against maxSize
        // after we've transformed and limited the newLines in here:

        past = past.substr(-maxSize * 2 - 2); // now that we have a significantly reduced string to process, transform the newlines
        // and chop them, then limit them:

        var a = past.replace(/\r\n|\r/g, '\n').split('\n');
        a = a.slice(-maxLines);
        past = a.join('\n'); // When, after limiting to maxLines, we still have too much to return,
        // do add an ellipsis prefix...

        if (past.length > maxSize) {
          past = '...' + past.substr(-maxSize);
        }

        return past;
      },

      /**
       * return (part of the) upcoming input, i.e. for error messages.
       * 
       * Limit the returned string length to `maxSize` (default: 20).
       * 
       * Limit the returned string to the `maxLines` number of lines of input (default: 1).
       * 
       * Negative limit values equal *unlimited*.
       *
       * > ### NOTE ###
       * >
       * > *"upcoming input"* is defined as the whole of the both
       * > the *currently lexed* input, together with any remaining input
       * > following that. *"currently lexed"* input is the input 
       * > already recognized by the lexer but not yet returned with
       * > the lexer token. This happens when you are invoking this API
       * > from inside any lexer rule action code block. 
       * >
       * 
       * @public
       * @this {RegExpLexer}
       */
      upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
        var next = this.match;
        if (maxSize < 0) maxSize = next.length + this._input.length;else if (!maxSize) maxSize = 20;
        if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
        else if (!maxLines) maxLines = 1; // `substring` anticipation: treat \r\n as a single character and take a little
        // more than necessary so that we can still properly check against maxSize
        // after we've transformed and limited the newLines in here:

        if (next.length < maxSize * 2 + 2) {
          next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
        } // now that we have a significantly reduced string to process, transform the newlines
        // and chop them, then limit them:


        var a = next.replace(/\r\n|\r/g, '\n').split('\n');
        a = a.slice(0, maxLines);
        next = a.join('\n'); // When, after limiting to maxLines, we still have too much to return,
        // do add an ellipsis postfix...

        if (next.length > maxSize) {
          next = next.substring(0, maxSize) + '...';
        }

        return next;
      },

      /**
       * return a string which displays the character position where the
       * lexing error occurred, i.e. for error messages
       * 
       * @public
       * @this {RegExpLexer}
       */
      showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
        var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
        var c = new Array(pre.length + 1).join('-');
        return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
      },

      /**
       * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
       * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
       * it MAY be NULL) and you MUST have a valid location info object anyway:
       * then we take the given context of the `preceding` and `following` locations, IFF those are available,
       * and reconstruct the `actual` location info from those.
       * If this fails, the heuristic is to take the `current` location, IFF available.
       * If this fails as well, we assume the sought location is at/around the current lexer position
       * and then produce that one as a response. DO NOTE that these heuristic/derived location info
       * values MAY be inaccurate!
       *
       * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
       * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
       * 
       * @public
       * @this {RegExpLexer}
       */
      deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
        var loc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0,
          range: [0, 0]
        };

        if (actual) {
          loc.first_line = actual.first_line | 0;
          loc.last_line = actual.last_line | 0;
          loc.first_column = actual.first_column | 0;
          loc.last_column = actual.last_column | 0;

          if (actual.range) {
            loc.range[0] = actual.range[0] | 0;
            loc.range[1] = actual.range[1] | 0;
          }
        }

        if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
          // plan B: heuristic using preceding and following:
          if (loc.first_line <= 0 && preceding) {
            loc.first_line = preceding.last_line | 0;
            loc.first_column = preceding.last_column | 0;

            if (preceding.range) {
              loc.range[0] = actual.range[1] | 0;
            }
          }

          if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
            loc.last_line = following.first_line | 0;
            loc.last_column = following.first_column | 0;

            if (following.range) {
              loc.range[1] = actual.range[0] | 0;
            }
          } // plan C?: see if the 'current' location is useful/sane too:


          if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
            loc.first_line = current.first_line | 0;
            loc.first_column = current.first_column | 0;

            if (current.range) {
              loc.range[0] = current.range[0] | 0;
            }
          }

          if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
            loc.last_line = current.last_line | 0;
            loc.last_column = current.last_column | 0;

            if (current.range) {
              loc.range[1] = current.range[1] | 0;
            }
          }
        } // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
        // or plan D heuristics to produce a 'sensible' last_line value:


        if (loc.last_line <= 0) {
          if (loc.first_line <= 0) {
            loc.first_line = this.yylloc.first_line;
            loc.last_line = this.yylloc.last_line;
            loc.first_column = this.yylloc.first_column;
            loc.last_column = this.yylloc.last_column;
            loc.range[0] = this.yylloc.range[0];
            loc.range[1] = this.yylloc.range[1];
          } else {
            loc.last_line = this.yylloc.last_line;
            loc.last_column = this.yylloc.last_column;
            loc.range[1] = this.yylloc.range[1];
          }
        }

        if (loc.first_line <= 0) {
          loc.first_line = loc.last_line;
          loc.first_column = 0; // loc.last_column; 

          loc.range[1] = loc.range[0];
        }

        if (loc.first_column < 0) {
          loc.first_column = 0;
        }

        if (loc.last_column < 0) {
          loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
        }

        return loc;
      },

      /**
       * return a string which displays the lines & columns of input which are referenced 
       * by the given location info range, plus a few lines of context.
       * 
       * This function pretty-prints the indicated section of the input, with line numbers 
       * and everything!
       * 
       * This function is very useful to provide highly readable error reports, while
       * the location range may be specified in various flexible ways:
       * 
       * - `loc` is the location info object which references the area which should be
       *   displayed and 'marked up': these lines & columns of text are marked up by `^`
       *   characters below each character in the entire input range.
       * 
       * - `context_loc` is the *optional* location info object which instructs this
       *   pretty-printer how much *leading* context should be displayed alongside
       *   the area referenced by `loc`. This can help provide context for the displayed
       *   error, etc.
       * 
       *   When this location info is not provided, a default context of 3 lines is
       *   used.
       * 
       * - `context_loc2` is another *optional* location info object, which serves
       *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
       *   context lines to display in the pretty-print output.
       * 
       *   When this location info is not provided, a default context of 1 line only is
       *   used.
       * 
       * Special Notes:
       * 
       * - when the `loc`-indicated range is very large (about 5 lines or more), then
       *   only the first and last few lines of this block are printed while a
       *   `...continued...` message will be printed between them.
       * 
       *   This serves the purpose of not printing a huge amount of text when the `loc`
       *   range happens to be huge: this way a manageable & readable output results
       *   for arbitrary large ranges.
       * 
       * - this function can display lines of input which whave not yet been lexed.
       *   `prettyPrintRange()` can access the entire input!
       * 
       * @public
       * @this {RegExpLexer}
       */
      prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
        loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
        var CONTEXT = 3;
        var CONTEXT_TAIL = 1;
        var MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
        var input = this.matched + this._input;
        var lines = input.split('\n');
        var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
        var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
        var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
        var ws_prefix = new Array(lineno_display_width).join(' ');
        var nonempty_line_indexes = [];
        var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
          var lno = index + l0;
          var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
          var rv = lno_pfx + ': ' + line;
          var errpfx = new Array(lineno_display_width + 1).join('^');
          var offset = 2 + 1;
          var len = 0;

          if (lno === loc.first_line) {
            offset += loc.first_column;
            len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
          } else if (lno === loc.last_line) {
            len = Math.max(2, loc.last_column + 1);
          } else if (lno > loc.first_line && lno < loc.last_line) {
            len = Math.max(2, line.length + 1);
          }

          if (len) {
            var lead = new Array(offset).join('.');
            var mark = new Array(len).join('^');
            rv += '\n' + errpfx + lead + mark;

            if (line.trim().length > 0) {
              nonempty_line_indexes.push(index);
            }
          }

          rv = rv.replace(/\t/g, ' ');
          return rv;
        }); // now make sure we don't print an overly large amount of error area: limit it 
        // to the top and bottom line count:

        if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
          var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
          var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
          var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
          intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
          rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
        }

        return rv.join('\n');
      },

      /**
       * helper function, used to produce a human readable description as a string, given
       * the input `yylloc` location object.
       * 
       * Set `display_range_too` to TRUE to include the string character index position(s)
       * in the description if the `yylloc.range` is available.
       * 
       * @public
       * @this {RegExpLexer}
       */
      describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
        var l1 = yylloc.first_line;
        var l2 = yylloc.last_line;
        var c1 = yylloc.first_column;
        var c2 = yylloc.last_column;
        var dl = l2 - l1;
        var dc = c2 - c1;
        var rv;

        if (dl === 0) {
          rv = 'line ' + l1 + ', ';

          if (dc <= 1) {
            rv += 'column ' + c1;
          } else {
            rv += 'columns ' + c1 + ' .. ' + c2;
          }
        } else {
          rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
        }

        if (yylloc.range && display_range_too) {
          var r1 = yylloc.range[0];
          var r2 = yylloc.range[1] - 1;

          if (r2 <= r1) {
            rv += ' {String Offset: ' + r1 + '}';
          } else {
            rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
          }
        }

        return rv;
      },

      /**
       * test the lexed token: return FALSE when not a match, otherwise return token.
       * 
       * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
       * contains the actually matched text string.
       * 
       * Also move the input cursor forward and update the match collectors:
       * 
       * - `yytext`
       * - `yyleng`
       * - `match`
       * - `matches`
       * - `yylloc`
       * - `offset`
       * 
       * @public
       * @this {RegExpLexer}
       */
      test_match: function lexer_test_match(match, indexed_rule) {
        var token, lines, backup, match_str, match_str_len;

        if (this.options.backtrack_lexer) {
          // save context
          backup = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.yylloc.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column,
              range: this.yylloc.range.slice(0)
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            //_signaled_error_token: this._signaled_error_token,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          };
        }

        match_str = match[0];
        match_str_len = match_str.length; // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {

        lines = match_str.split(/(?:\r\n?|\n)/g);

        if (lines.length > 1) {
          this.yylineno += lines.length - 1;
          this.yylloc.last_line = this.yylineno + 1;
          this.yylloc.last_column = lines[lines.length - 1].length;
        } else {
          this.yylloc.last_column += match_str_len;
        } // }


        this.yytext += match_str;
        this.match += match_str;
        this.matched += match_str;
        this.matches = match;
        this.yyleng = this.yytext.length;
        this.yylloc.range[1] += match_str_len; // previous lex rules MAY have invoked the `more()` API rather than producing a token:
        // those rules will already have moved this `offset` forward matching their match lengths,
        // hence we must only add our own match length now:

        this.offset += match_str_len;
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match_str_len); // calling this method:
        //
        //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}

        token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]
        /* = YY_START */
        ); // otherwise, when the action codes are all simple return token statements:
        //token = this.simpleCaseActionClusters[indexed_rule];

        if (this.done && this._input) {
          this.done = false;
        }

        if (token) {
          return token;
        } else if (this._backtrack) {
          // recover context
          for (var k in backup) {
            this[k] = backup[k];
          }

          this.__currentRuleSet__ = null;
          return false; // rule action called reject() implying the next rule should be tested instead. 
        } else if (this._signaled_error_token) {
          // produce one 'error' token as `.parseError()` in `reject()`
          // did not guarantee a failure signal by throwing an exception!
          token = this._signaled_error_token;
          this._signaled_error_token = false;
          return token;
        }

        return false;
      },

      /**
       * return next match in input
       * 
       * @public
       * @this {RegExpLexer}
       */
      next: function lexer_next() {
        if (this.done) {
          this.clear();
          return this.EOF;
        }

        if (!this._input) {
          this.done = true;
        }

        var token, match, tempMatch, index;

        if (!this._more) {
          this.clear();
        }

        var spec = this.__currentRuleSet__;

        if (!spec) {
          // Update the ruleset cache as we apparently encountered a state change or just started lexing.
          // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
          // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
          // speed up those activities a tiny bit.
          spec = this.__currentRuleSet__ = this._currentRules(); // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
          // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19

          if (!spec || !spec.rules) {
            var lineno_msg = '';

            if (this.options.trackPosition) {
              lineno_msg = ' on line ' + (this.yylineno + 1);
            }

            var p = this.constructLexErrorInfo('Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false); // produce one 'error' token until this situation has been resolved, most probably by parse termination!

            return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
          }
        }

        var rule_ids = spec.rules;
        var regexes = spec.__rule_regexes;
        var len = spec.__rule_count; // Note: the arrays are 1-based, while `len` itself is a valid index,
        // hence the non-standard less-or-equal check in the next loop condition!

        for (var i = 1; i <= len; i++) {
          tempMatch = this._input.match(regexes[i]);

          if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
            match = tempMatch;
            index = i;

            if (this.options.backtrack_lexer) {
              token = this.test_match(tempMatch, rule_ids[i]);

              if (token !== false) {
                return token;
              } else if (this._backtrack) {
                match = undefined;
                continue; // rule action called reject() implying a rule MISmatch. 
              } else {
                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                return false;
              }
            } else if (!this.options.flex) {
              break;
            }
          }
        }

        if (match) {
          token = this.test_match(match, rule_ids[index]);

          if (token !== false) {
            return token;
          } // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)


          return false;
        }

        if (!this._input) {
          this.done = true;
          this.clear();
          return this.EOF;
        } else {
          var lineno_msg = '';

          if (this.options.trackPosition) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo('Lexical error' + lineno_msg + ': Unrecognized text.', this.options.lexerErrorsAreRecoverable);
          var pendingInput = this._input;
          var activeCondition = this.topState();
          var conditionStackDepth = this.conditionStack.length;
          token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;

          if (token === this.ERROR) {
            // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
            // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
            // has not consumed/modified any pending input or changed state in the error handler:
            if (!this.matches && // and make sure the input has been modified/consumed ...
            pendingInput === this._input && // ...or the lexer state has been modified significantly enough
            // to merit a non-consuming error handling action right now.
            activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) {
              this.input();
            }
          }

          return token;
        }
      },

      /**
       * return next match that has a token
       * 
       * @public
       * @this {RegExpLexer}
       */
      lex: function lexer_lex() {
        var r; // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:

        if (typeof this.pre_lex === 'function') {
          r = this.pre_lex.call(this, 0);
        }

        if (typeof this.options.pre_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.options.pre_lex.call(this, r) || r;
        }

        if (this.yy && typeof this.yy.pre_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.yy.pre_lex.call(this, r) || r;
        }

        while (!r) {
          r = this.next();
        }

        if (this.yy && typeof this.yy.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.yy.post_lex.call(this, r) || r;
        }

        if (typeof this.options.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.options.post_lex.call(this, r) || r;
        }

        if (typeof this.post_lex === 'function') {
          // (also account for a userdef function which does not return any value: keep the token as is)
          r = this.post_lex.call(this, r) || r;
        }

        return r;
      },

      /**
       * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
       * `pre_lex()` nor any of the `post_lex()` callbacks.
       * 
       * @public
       * @this {RegExpLexer}
       */
      fastLex: function lexer_fastLex() {
        var r;

        while (!r) {
          r = this.next();
        }

        return r;
      },

      /**
       * return info about the lexer state that can help a parser or other lexer API user to use the
       * most efficient means available. This API is provided to aid run-time performance for larger
       * systems which employ this lexer.
       * 
       * @public
       * @this {RegExpLexer}
       */
      canIUse: function lexer_canIUse() {
        var rv = {
          fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
        };
        return rv;
      },

      /**
       * backwards compatible alias for `pushState()`;
       * the latter is symmetrical with `popState()` and we advise to use
       * those APIs in any modern lexer code, rather than `begin()`.
       * 
       * @public
       * @this {RegExpLexer}
       */
      begin: function lexer_begin(condition) {
        return this.pushState(condition);
      },

      /**
       * activates a new lexer condition state (pushes the new lexer
       * condition state onto the condition stack)
       * 
       * @public
       * @this {RegExpLexer}
       */
      pushState: function lexer_pushState(condition) {
        this.conditionStack.push(condition);
        this.__currentRuleSet__ = null;
        return this;
      },

      /**
       * pop the previously active lexer condition state off the condition
       * stack
       * 
       * @public
       * @this {RegExpLexer}
       */
      popState: function lexer_popState() {
        var n = this.conditionStack.length - 1;

        if (n > 0) {
          this.__currentRuleSet__ = null;
          return this.conditionStack.pop();
        } else {
          return this.conditionStack[0];
        }
      },

      /**
       * return the currently active lexer condition state; when an index
       * argument is provided it produces the N-th previous condition state,
       * if available
       * 
       * @public
       * @this {RegExpLexer}
       */
      topState: function lexer_topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);

        if (n >= 0) {
          return this.conditionStack[n];
        } else {
          return 'INITIAL';
        }
      },

      /**
       * (internal) determine the lexer rule set which is active for the
       * currently active lexer condition state
       * 
       * @public
       * @this {RegExpLexer}
       */
      _currentRules: function lexer__currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
          return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
        } else {
          return this.conditions['INITIAL'];
        }
      },

      /**
       * return the number of states currently on the stack
       * 
       * @public
       * @this {RegExpLexer}
       */
      stateStackSize: function lexer_stateStackSize() {
        return this.conditionStack.length;
      },
      options: {
        trackPosition: true
      },
      JisonLexerError: JisonLexerError,
      performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {

        switch (yyrulenumber) {
          case 1:
            /*! Conditions:: INITIAL */

            /*! Rule::       \s+ */

            /* skip whitespace */
            break;

          default:
            return this.simpleCaseActionClusters[yyrulenumber];
        }
      },
      simpleCaseActionClusters: {
        /*! Conditions:: INITIAL */

        /*! Rule::       (--[0-9a-z-A-Z-]*) */
        0: 16,

        /*! Conditions:: INITIAL */

        /*! Rule::       \* */
        2: 5,

        /*! Conditions:: INITIAL */

        /*! Rule::       \/ */
        3: 6,

        /*! Conditions:: INITIAL */

        /*! Rule::       \+ */
        4: 3,

        /*! Conditions:: INITIAL */

        /*! Rule::       - */
        5: 4,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */
        6: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */
        7: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */
        8: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */
        9: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */
        10: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */
        11: 17,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */
        12: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */
        13: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */
        14: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */
        15: 18,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */
        16: 19,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */
        17: 19,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */
        18: 20,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */
        19: 20,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */
        20: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */
        21: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */
        22: 21,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */
        23: 22,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */
        24: 23,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */
        25: 24,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */
        26: 25,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */
        27: 27,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */
        28: 26,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */
        29: 28,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */
        30: 29,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */
        31: 30,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */
        32: 14,

        /*! Conditions:: INITIAL */

        /*! Rule::       (calc) */
        33: 9,

        /*! Conditions:: INITIAL */

        /*! Rule::       (var) */
        34: 15,

        /*! Conditions:: INITIAL */

        /*! Rule::       (max) */
        35: 10,

        /*! Conditions:: INITIAL */

        /*! Rule::       (min) */
        36: 12,

        /*! Conditions:: INITIAL */

        /*! Rule::       ([a-z]+) */
        37: 13,

        /*! Conditions:: INITIAL */

        /*! Rule::       \( */
        38: 7,

        /*! Conditions:: INITIAL */

        /*! Rule::       \) */
        39: 8,

        /*! Conditions:: INITIAL */

        /*! Rule::       , */
        40: 11,

        /*! Conditions:: INITIAL */

        /*! Rule::       $ */
        41: 1
      },
      rules: [
      /*  0: */
      /^(?:(--[\d\-A-Za-z]*))/,
      /*  1: */
      /^(?:\s+)/,
      /*  2: */
      /^(?:\*)/,
      /*  3: */
      /^(?:\/)/,
      /*  4: */
      /^(?:\+)/,
      /*  5: */
      /^(?:-)/,
      /*  6: */
      /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
      /*  7: */
      /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
      /*  8: */
      /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
      /*  9: */
      /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
      /* 10: */
      /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
      /* 11: */
      /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
      /* 12: */
      /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
      /* 13: */
      /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
      /* 14: */
      /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
      /* 15: */
      /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
      /* 16: */
      /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
      /* 17: */
      /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
      /* 18: */
      /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
      /* 19: */
      /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
      /* 20: */
      /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
      /* 21: */
      /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
      /* 22: */
      /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
      /* 23: */
      /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
      /* 24: */
      /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
      /* 25: */
      /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
      /* 26: */
      /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
      /* 27: */
      /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
      /* 28: */
      /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
      /* 29: */
      /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
      /* 30: */
      /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
      /* 31: */
      /^(?:(\d+(\.\d*)?|\.\d+)%)/,
      /* 32: */
      /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
      /* 33: */
      /^(?:(calc))/,
      /* 34: */
      /^(?:(var))/,
      /* 35: */
      /^(?:(max))/,
      /* 36: */
      /^(?:(min))/,
      /* 37: */
      /^(?:([a-z]+))/,
      /* 38: */
      /^(?:\()/,
      /* 39: */
      /^(?:\))/,
      /* 40: */
      /^(?:,)/,
      /* 41: */
      /^(?:$)/],
      conditions: {
        'INITIAL': {
          rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41],
          inclusive: true
        }
      }
    };
    return lexer;
  }();

  parser.lexer = lexer;

  function Parser() {
    this.yy = {};
  }

  Parser.prototype = parser;
  parser.Parser = Parser;
  return new Parser();
}();

if (typeof index.commonjsRequire !== 'undefined' && 'object' !== 'undefined') {
  exports.parser = parser;
  exports.Parser = parser.Parser;

  exports.parse = function () {
    return parser.parse.apply(parser, arguments);
  };
}
}(parser));

var reducer$1 = {};

var convert = {exports: {}};

var conversions = {
  // length
  'px': {
    'px': 1,
    'cm': 96.0 / 2.54,
    'mm': 96.0 / 25.4,
    'in': 96,
    'pt': 96.0 / 72.0,
    'pc': 16
  },
  'cm': {
    'px': 2.54 / 96.0,
    'cm': 1,
    'mm': 0.1,
    'in': 2.54,
    'pt': 2.54 / 72.0,
    'pc': 2.54 / 6.0
  },
  'mm': {
    'px': 25.4 / 96.0,
    'cm': 10,
    'mm': 1,
    'in': 25.4,
    'pt': 25.4 / 72.0,
    'pc': 25.4 / 6.0
  },
  'in': {
    'px': 1.0 / 96.0,
    'cm': 1.0 / 2.54,
    'mm': 1.0 / 25.4,
    'in': 1,
    'pt': 1.0 / 72.0,
    'pc': 1.0 / 6.0
  },
  'pt': {
    'px': 0.75,
    'cm': 72.0 / 2.54,
    'mm': 72.0 / 25.4,
    'in': 72,
    'pt': 1,
    'pc': 12
  },
  'pc': {
    'px': 6.0 / 96.0,
    'cm': 6.0 / 2.54,
    'mm': 6.0 / 25.4,
    'in': 6,
    'pt': 6.0 / 72.0,
    'pc': 1
  },
  // angle
  'deg': {
    'deg': 1,
    'grad': 0.9,
    'rad': 180 / Math.PI,
    'turn': 360
  },
  'grad': {
    'deg': 400 / 360,
    'grad': 1,
    'rad': 200 / Math.PI,
    'turn': 400
  },
  'rad': {
    'deg': Math.PI / 180,
    'grad': Math.PI / 200,
    'rad': 1,
    'turn': Math.PI * 2
  },
  'turn': {
    'deg': 1 / 360,
    'grad': 1 / 400,
    'rad': 0.5 / Math.PI,
    'turn': 1
  },
  // time
  's': {
    's': 1,
    'ms': 1 / 1000
  },
  'ms': {
    's': 1000,
    'ms': 1
  },
  // frequency
  'Hz': {
    'Hz': 1,
    'kHz': 1000
  },
  'kHz': {
    'Hz': 1 / 1000,
    'kHz': 1
  },
  // resolution
  'dpi': {
    'dpi': 1,
    'dpcm': 1.0 / 2.54,
    'dppx': 1 / 96
  },
  'dpcm': {
    'dpi': 2.54,
    'dpcm': 1,
    'dppx': 2.54 / 96.0
  },
  'dppx': {
    'dpi': 96,
    'dpcm': 96.0 / 2.54,
    'dppx': 1
  }
};

var cssUnitConverter = function (value, sourceUnit, targetUnit, precision) {
  if (!conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
  if (!conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
  var converted = conversions[targetUnit][sourceUnit] * value;

  if (precision !== false) {
    precision = Math.pow(10, parseInt(precision) || 5);
    return Math.round(converted * precision) / precision;
  }

  return converted;
};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssUnitConverter = cssUnitConverter;

var _cssUnitConverter2 = _interopRequireDefault(_cssUnitConverter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function convertNodes(left, right, precision) {
  switch (left.type) {
    case "LengthValue":
    case "AngleValue":
    case "TimeValue":
    case "FrequencyValue":
    case "ResolutionValue":
      return convertAbsoluteLength(left, right, precision);

    default:
      return {
        left: left,
        right: right
      };
  }
}

function convertAbsoluteLength(left, right, precision) {
  if (right.type === left.type) {
    right = {
      type: left.type,
      value: (0, _cssUnitConverter2["default"])(right.value, right.unit, left.unit, precision),
      unit: left.unit
    };
  }

  return {
    left: left,
    right: right
  };
}

exports["default"] = convertNodes;
module.exports = exports["default"];
}(convert, convert.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flip = flip;

var _convert = convert.exports;

var _convert2 = _interopRequireDefault(_convert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function reduce(node, precision) {
  if (node.type === "MathExpression") return reduceMathExpression(node, precision);
  if (node.type === "Calc") return reduce(node.value, precision);
  return node;
}

function isEqual(left, right) {
  return left.type === right.type && left.value === right.value;
}

function isValueType(type) {
  switch (type) {
    case "LengthValue":
    case "AngleValue":
    case "TimeValue":
    case "FrequencyValue":
    case "ResolutionValue":
    case "EmValue":
    case "ExValue":
    case "ChValue":
    case "RemValue":
    case "VhValue":
    case "VwValue":
    case "VminValue":
    case "VmaxValue":
    case "PercentageValue":
    case "Value":
      return true;
  }

  return false;
}

function convertMathExpression(node, precision) {
  var nodes = (0, _convert2["default"])(node.left, node.right, precision);
  var left = reduce(nodes.left, precision);
  var right = reduce(nodes.right, precision);

  if (left.type === "MathExpression" && right.type === "MathExpression") {
    if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
      if (isEqual(left.right, right.right)) nodes = (0, _convert2["default"])(left.left, right.left, precision);else if (isEqual(left.right, right.left)) nodes = (0, _convert2["default"])(left.left, right.right, precision);
      left = reduce(nodes.left, precision);
      right = reduce(nodes.right, precision);
    }
  }

  node.left = left;
  node.right = right;
  return node;
}

function flip(operator) {
  return operator === "+" ? "-" : "+";
}

function flipValue(node) {
  if (isValueType(node.type)) node.value = -node.value;else if (node.type == "MathExpression") {
    node.left = flipValue(node.left);
    node.right = flipValue(node.right);
  }
  return node;
}

function reduceAddSubExpression(node, precision) {
  var _node = node,
      left = _node.left,
      right = _node.right,
      op = _node.operator;
  if (left.type === "CssVariable" || right.type === "CssVariable") return node; // something + 0 => something
  // something - 0 => something

  if (right.value === 0) return left; // 0 + something => something

  if (left.value === 0 && op === "+") return right; // 0 - something => -something

  if (left.value === 0 && op === "-") return flipValue(right); // value + value
  // value - value

  if (left.type === right.type && isValueType(left.type)) {
    node = Object.assign({}, left);
    if (op === "+") node.value = left.value + right.value;else node.value = left.value - right.value;
  } // value <op> (expr)


  if (isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
    // value + (value + something) => (value + value) + something
    // value + (value - something) => (value + value) - something
    // value - (value + something) => (value - value) - something
    // value - (value - something) => (value - value) + something
    if (left.type === right.left.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: "MathExpression",
        operator: op,
        left: left,
        right: right.left
      }, precision);
      node.right = right.right;
      node.operator = op === "-" ? flip(right.operator) : right.operator;
      return reduce(node, precision);
    } // value + (something + value) => (value + value) + something
    // value + (something - value) => (value - value) + something
    // value - (something + value) => (value - value) - something
    // value - (something - value) => (value + value) - something
    else if (left.type === right.right.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: "MathExpression",
        operator: op === "-" ? flip(right.operator) : right.operator,
        left: left,
        right: right.right
      }, precision);
      node.right = right.left;
      return reduce(node, precision);
    }
  } // (expr) <op> value


  if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && isValueType(right.type)) {
    // (value + something) + value => (value + value) + something
    // (value - something) + value => (value + value) - something
    // (value + something) - value => (value - value) + something
    // (value - something) - value => (value - value) - something
    if (right.type === left.left.type) {
      node = Object.assign({}, left);
      node.left = reduce({
        type: "MathExpression",
        operator: op,
        left: left.left,
        right: right
      }, precision);
      return reduce(node, precision);
    } // (something + value) + value => something + (value + value)
    // (something - value1) + value2 => something - (value2 - value1)
    // (something + value) - value => something + (value - value)
    // (something - value) - value => something - (value + value)
    else if (right.type === left.right.type) {
      node = Object.assign({}, left);

      if (left.operator === "-") {
        node.right = reduce({
          type: "MathExpression",
          operator: op === "-" ? "+" : "-",
          left: right,
          right: left.right
        }, precision);
        node.operator = op === "-" ? "-" : "+";
      } else {
        node.right = reduce({
          type: "MathExpression",
          operator: op,
          left: left.right,
          right: right
        }, precision);
      }

      if (node.right.value < 0) {
        node.right.value *= -1;
        node.operator = node.operator === "-" ? "+" : "-";
      }

      return reduce(node, precision);
    }
  }

  return node;
}

function reduceDivisionExpression(node, precision) {
  if (!isValueType(node.right.type)) return node;
  if (node.right.type !== "Value") throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");
  if (node.right.value === 0) throw new Error("Cannot divide by zero"); // (expr) / value

  if (node.left.type === "MathExpression") {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value /= node.right.value;
      node.left.right.value /= node.right.value;
      return reduce(node.left, precision);
    }

    return node;
  } // something / value
  else if (isValueType(node.left.type)) {
    node.left.value /= node.right.value;
    return node.left;
  }

  return node;
}

function reduceMultiplicationExpression(node) {
  // (expr) * value
  if (node.left.type === "MathExpression" && node.right.type === "Value") {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value *= node.right.value;
      node.left.right.value *= node.right.value;
      return node.left;
    }
  } // something * value
  else if (isValueType(node.left.type) && node.right.type === "Value") {
    node.left.value *= node.right.value;
    return node.left;
  } // value * (expr)
  else if (node.left.type === "Value" && node.right.type === "MathExpression") {
    if (isValueType(node.right.left.type) && isValueType(node.right.right.type)) {
      node.right.left.value *= node.left.value;
      node.right.right.value *= node.left.value;
      return node.right;
    }
  } // value * something
  else if (node.left.type === "Value" && isValueType(node.right.type)) {
    node.right.value *= node.left.value;
    return node.right;
  }

  return node;
}

function reduceMaxExpression(node) {
  if (node.left.type !== "LengthValue" || node.right.type !== "LengthValue") {
    throw new Error("Max function can be reduced only if types are LengthValue");
  }

  node.left.value = Math.max(node.left.value, node.right.value);
  return node.left;
}

function reduceMinExpression(node) {
  if (node.left.type !== "LengthValue" || node.right.type !== "LengthValue") {
    throw new Error("Min function can be reduced only if types are LengthValue");
  }

  node.left.value = Math.min(node.left.value, node.right.value);
  return node.left;
}

function reduceMathExpression(node, precision) {
  node = convertMathExpression(node, precision);

  switch (node.operator) {
    case "+":
    case "-":
      return reduceAddSubExpression(node, precision);

    case "/":
      return reduceDivisionExpression(node, precision);

    case "*":
      return reduceMultiplicationExpression(node);

    case "max":
      return reduceMaxExpression(node);

    case "min":
      return reduceMinExpression(node);
  }

  return node;
}

exports["default"] = reduce;
}(reducer$1));

var stringifier = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (calc, node, precision) {
  var str = stringify(node, precision);

  if (node.type === "MathExpression") {
    // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
  }

  return str;
};

var _reducer = reducer$1;

var order = {
  "*": 0,
  "/": 0,
  "+": 1,
  "-": 1
};

function round(value, prec) {
  if (prec !== false) {
    var precision = Math.pow(10, prec);
    return Math.round(value * precision) / precision;
  }

  return value;
}

function stringify(node, prec) {
  switch (node.type) {
    case "MathExpression":
      {
        var left = node.left,
            right = node.right,
            op = node.operator;
        var str = "";
        if (left.type === "MathExpression" && order[op] < order[left.operator]) str += "(" + stringify(left, prec) + ")";else str += stringify(left, prec);
        str += " " + node.operator + " ";

        if (right.type === "MathExpression" && order[op] < order[right.operator]) {
          str += "(" + stringify(right, prec) + ")";
        } else if (right.type === "MathExpression" && op === "-" && ["+", "-"].includes(right.operator)) {
          // fix #52 : a-(b+c) = a-b-c
          right.operator = (0, _reducer.flip)(right.operator);
          str += stringify(right, prec);
        } else {
          str += stringify(right, prec);
        }

        return str;
      }

    case "Value":
      return round(node.value, prec);

    case "CssVariable":
      if (node.fallback) {
        return "var(" + node.value + ", " + stringify(node.fallback, prec) + ")";
      }

      return "var(" + node.value + ")";

    case "Calc":
      if (node.prefix) {
        return "-" + node.prefix + "-calc(" + stringify(node.value, prec) + ")";
      }

      return "calc(" + stringify(node.value, prec) + ")";

    default:
      return round(node.value, prec) + node.unit;
  }
}

module.exports = exports["default"];
}(stringifier, stringifier.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; // eslint-disable-line


var _postcssValueParser = lib$1;

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

var _parser = parser;

var _reducer = reducer$1;

var _reducer2 = _interopRequireDefault(_reducer);

var _stringifier = stringifier.exports;

var _stringifier2 = _interopRequireDefault(_stringifier);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;

function calculateAllViewportValues(ast, map) {
  if ((typeof ast === "undefined" ? "undefined" : _typeof(ast)) === "object" && ast !== null) {
    if (ast.type === "VwValue" && ast.unit === "vw" && typeof map.vw === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.vw
      };
    } else if (ast.type === "PercentageValue" && ast.unit === "%" && typeof map.percent === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.percent
      };
    } else {
      for (var key in ast) {
        if (_typeof(ast[key]) === "object" && ast[key] !== null) {
          ast[key] = calculateAllViewportValues(ast[key], map);
        }
      }
    }
  }

  return ast;
}

exports["default"] = function (value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _postcssValueParser2["default"])(value).walk(function (node) {
    // skip anything which isn't a calc() function
    if (node.type !== "function" || !MATCH_CALC.test(node.value)) return; // stringify calc expression and produce an AST

    var contents = _postcssValueParser2["default"].stringify(node.nodes); // skip constant() and env()


    if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
    var ast = calculateAllViewportValues(_parser.parser.parse(contents), map); // reduce AST to its simplest form, that is, either to a single value
    // or a simplified calc expression

    var reducedAst = (0, _reducer2["default"])(ast, precision, map); // stringify AST and write it back

    node.type = "word";
    node.value = (0, _stringifier2["default"])(node.value, reducedAst, precision);
  }, true).toString();
};

module.exports = exports["default"];
}(dist$1, dist$1.exports));

var reduceCSSCalc = /*@__PURE__*/index.getDefaultExportFromCjs(dist$1.exports);

function parseSpacing(spacing) {
  if (spacing.endsWith("px")) {
    var value = parseFloat(spacing);

    if (isNaN(value)) {
      throw new Error("incorrect spacing: ".concat(spacing));
    }

    return {
      unit: "px",
      value: value
    };
  }

  if (spacing.endsWith("vw")) {
    var _value = parseFloat(spacing);

    if (isNaN(_value)) {
      throw new Error("incorrect spacing: ".concat(spacing));
    }

    return {
      unit: "vw",
      value: _value
    };
  }

  throw new Error("incorrect spacing: ".concat(spacing, "."));
}
function spacingToPx(spacing, width) {
  var reducedSpacing = reduceCSSCalc("calc(".concat(spacing, ")")
  /* wrapping calc is necessary, otherwise max(10px,20px) doesn't work */
  , 5, {
    vw: width,
    percent: width
  });
  var parsed = parseSpacing(reducedSpacing);

  if (parsed.unit === "px") {
    return parsed.value;
  }

  throw new Error("unreachable");
}

function applyAutoUsingResponsiveTokens(input, compilationContext) {
  if (!index.isTrulyResponsiveValue(input)) {
    return input;
  }

  var highestDefinedDevice = responsiveValueGetHighestDefinedDevice(input, compilationContext.devices);
  var highestDefinedValue = index.responsiveValueForceGet(input, highestDefinedDevice.id);
  var inputAfterAuto = {
    $res: true
  };

  for (var i = compilationContext.devices.length - 1; i >= 0; i--) {
    var device = compilationContext.devices[i];
    var value = index.responsiveValueGet(input, device.id);

    if (value === undefined && index.isTrulyResponsiveValue(highestDefinedValue.value)) {
      inputAfterAuto[device.id] = highestDefinedValue;
    }

    if (value !== undefined) {
      inputAfterAuto[device.id] = value;
      highestDefinedValue = input[device.id];
    }
  }

  return inputAfterAuto;
}

function linearizeSpace(input, compilationContext, widths) {
  var constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!index.isTrulyResponsiveValue(input)) {
    return input;
  }
  /**
   *
   * Important!
   *
   * Although linearizeSpace takes widths into account (it's obvious) we must still remember about responsive tokens.
   *
   * Responsive tokens will be quite rare (like a container margin or a font size).
   * But still we must remember that responsive tokens are defined relative to SCREEN WIDTH.
   * It means that even if our component has "width" that is not a screen width and is very irregular, then responsive tokens relative to screen width takes precedence!
   * So if our component has width 500px on XL and is wider on smaller breakpoint LG (800px), then if responsive token is bigger on XL than LG it will still hold.
   * It makes a total sense. If we broke this rule and somehow applied widths to responsive tokens, then user could see a font that she totally doesn't want for a specific breakpoint.
   * It usually won't hurt at all, because fonts and container margins are responsive by nature. Actually maybe other spacings shouldn't be possible to be responsive at all!
   * That's why first thing below is to fill undefined values with responsive tokens if possible and only then linearize the remaining ones (with widths taken into account).
   *
   */
  // If responsive value has some token that is responsive, then this token should be applied to all surrounding breakpoints.
  // Responsive token kind of "overrides auto".
  // If we want in the future auto for responsive tokens it's not the place for it. Linearizing tokens should happen in creating compilation context.


  var inputAfterResponsiveTokenAuto = applyAutoUsingResponsiveTokens(input, compilationContext);
  var inputWithScalarNonRefValues = {
    $res: true
  };
  compilationContext.devices.forEach(function (device) {
    if (inputAfterResponsiveTokenAuto[device.id] === undefined) {
      return;
    }

    var refValue = responsiveValueGetDefinedValue(inputAfterResponsiveTokenAuto, device.id, compilationContext.devices, index.getDevicesWidths(compilationContext.devices));

    if (index.isTrulyResponsiveValue(refValue.value)) {
      inputWithScalarNonRefValues[device.id] = spacingToPx(responsiveValueGetDefinedValue(refValue.value, device.id, compilationContext.devices, index.getDevicesWidths(compilationContext.devices)), device.w);
    } else {
      inputWithScalarNonRefValues[device.id] = spacingToPx(refValue.value, device.w);
    }
  });

  if (!areWidthsFullyDefined(widths, compilationContext.devices)) {
    return index.responsiveValueFill(inputAfterResponsiveTokenAuto, compilationContext.devices, index.getDevicesWidths(compilationContext.devices));
  } // Let's run linearize function


  var linearisedCompiledValues = linearizeSpaceWithoutNesting(inputWithScalarNonRefValues, compilationContext, widths, constant);
  compilationContext.devices.forEach(function (device) {
    if (inputAfterResponsiveTokenAuto[device.id] === undefined) {
      inputAfterResponsiveTokenAuto[device.id] = snapValueToToken(index.responsiveValueForceGet(linearisedCompiledValues, device.id), responsiveValueGetFirstLowerValue(inputWithScalarNonRefValues, device.id, compilationContext.devices, index.getDevicesWidths(compilationContext.devices)), responsiveValueGetFirstHigherValue(inputWithScalarNonRefValues, device.id, compilationContext.devices, index.getDevicesWidths(compilationContext.devices)), compilationContext.theme.space, constant);
    }
  });
  return inputAfterResponsiveTokenAuto;
}

function snapValueToToken(value, lowerDefinedValue, higherDefinedValue, spaces, constant) {
  var currentToken = undefined;
  var minDelta = Number.MAX_VALUE;

  for (var tokenId in spaces) {
    var tokenValue = spaces[tokenId].value;

    if (index.isTrulyResponsiveValue(tokenValue)) {
      // only non-responsive
      continue;
    }

    var parsedValue = parseSpacing(tokenValue);

    if (parsedValue.unit === "vw") {
      continue;
    }

    var tokenPxValue = parsedValue.value; // If value smaller than constant then the only possible token is the token equaling the value

    if (value <= constant && tokenPxValue !== value) {
      continue;
    } // token value must be within higher and lower limits


    if (higherDefinedValue !== undefined) {
      if (tokenPxValue > higherDefinedValue) {
        continue;
      }
    }

    if (lowerDefinedValue !== undefined) {
      if (tokenPxValue < lowerDefinedValue) {
        continue;
      }
    }

    if (tokenId.split(".").length > 1) {
      // only non-prefixed
      continue;
    } // snapped token can never be bigger than our constant


    if (tokenPxValue < constant) {
      continue;
    }

    var delta = Math.abs(value - tokenPxValue);

    if (delta < minDelta ||
    /* in case of equal deltas, let's take bigger token */
    currentToken && delta === minDelta && tokenValue > currentToken.value) {
      minDelta = delta;
      currentToken = {
        ref: tokenId,
        value: tokenValue
      };
    }
  }

  if (!currentToken) {
    return {
      value: "".concat(value, "px")
    };
  }

  return currentToken;
}

function linearizeSpaceWithoutNesting(input, compilationContext, widths) {
  var constant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!index.isTrulyResponsiveValue(input)) {
    return input;
  } // // If only 1 value is defined (2 keys, $res and value), then we return
  // if (Object.keys(input).length === 2) {
  //   return responsiveValueFill(input, compilationContext.devices);
  // }
  // Empty object returns 0


  if (Object.keys(input).length === 0) {
    console.warn("linearize Space - empty object input, that shouldn't happen, fallback to 0");
    return 0;
  } // For now we just use arrays (from previous implementation). Later they're mapped back to object


  var value = [];
  var referencePoints = [];
  var componentWidths = index.getDeviceWidthPairs(widths, compilationContext.devices);
  componentWidths.forEach(function (componentWidth, index) {
    var breakpointValue = input[componentWidth.deviceId];
    value[index] = breakpointValue;

    if (breakpointValue === null || breakpointValue === undefined) {
      value[index] = null; // null padding and normalization

      var leftIndex;
      var rightIndex; // Let's find closest left index

      for (var i = index - 1; i >= 0; i--) {
        var val = input[componentWidths[i].deviceId];

        if (val !== undefined) {
          leftIndex = i;
          break;
        }
      } // Let's find closest right index


      for (var _i = index + 1; _i < componentWidths.length; _i++) {
        var _val = input[componentWidths[_i].deviceId];

        if (_val !== undefined) {
          rightIndex = _i;
          break;
        }
      }

      if (leftIndex === undefined && rightIndex === undefined) {
        throw new Error("unreachable");
      }

      referencePoints[index] = {
        leftIndex: leftIndex,
        rightIndex: rightIndex
      };
      return;
    }
  });
  referencePoints.forEach(function (refPoint, index) {
    if (!refPoint) {
      return;
    }

    var currentX = componentWidths[index].width; // Single point linearity

    if (refPoint.leftIndex !== undefined && refPoint.rightIndex === undefined || refPoint.leftIndex === undefined && refPoint.rightIndex !== undefined) {
      var _refPoint$leftIndex;

      var currentRefPoint = (_refPoint$leftIndex = refPoint.leftIndex) !== null && _refPoint$leftIndex !== void 0 ? _refPoint$leftIndex : refPoint.rightIndex;
      var refY = value[currentRefPoint];
      var refX = componentWidths[currentRefPoint].width;
      var deltaY = refY - constant;

      if (deltaY <= 0) {
        value[index] = refY;
      } else {
        var a = (refY - constant) / refX;
        value[index] = a * currentX + constant;
      }
    } else if (refPoint.leftIndex !== undefined && refPoint.rightIndex !== undefined) {
      var p1_x = componentWidths[refPoint.leftIndex].width;
      var p1_y = value[refPoint.leftIndex]; // default a, b (enabled when only p1 is defined)

      var _a = 0,
          b = p1_y;
      var p2_x = componentWidths[refPoint.rightIndex].width;
      var p2_y = value[refPoint.rightIndex];
      var deltaX = p1_x - p2_x;

      if (deltaX === 0) {
        // if delta 0 then we take lower for left and higher for right
        value[index] = index < refPoint.leftIndex ? p1_y : p2_y;
      } else {
        _a = (p1_y - p2_y) / deltaX;
        b = p2_y - _a * p2_x;

        if (_a >= 0) {
          // take into account 0 values!!!
          if (p1_y === 0 || p2_y === 0) {
            if (index < refPoint.leftIndex) {
              _a = 0;
              b = p1_y;
            } else {
              _a = 0;
              b = p2_y;
            }
          }

          value[index] = currentX * _a + b;
        } else {
          // We don't linearize descending functions!
          value[index] = index < refPoint.leftIndex ? p1_y : p2_y;
        }
      }
    } else {
      throw new Error("unreachable");
    }
  });
  var output = {
    $res: true
  };
  value.forEach(function (scalarVal, index) {
    if (scalarVal === undefined || scalarVal === null) {
      return;
    }

    output[componentWidths[index].deviceId] = scalarVal;
  });
  return output;
}

function dotNotationSet(obj, path, value) {
  if (path === "") {
    throw new Error("Path can't be empty in dotNotationSetter");
  }

  if (typeof obj !== "object" || obj === null) {
    throw new Error("dotNotationSet - you're trying to set value for non-object");
  }

  var splitPath = typeof path === "string" ? path.split(".").map(function (x) {
    if (typeof x === "string" && !isNaN(parseInt(x))) {
      return parseInt(x);
    }

    return x;
  }) : path;

  if (splitPath.length === 1) {
    obj[splitPath[0]] = value;
  } else {
    if (!obj[splitPath[0]]) {
      if (typeof splitPath[1] === "number") {
        obj[splitPath[0]] = [];
      } else {
        obj[splitPath[0]] = {};
      }
    }

    dotNotationSet(obj[splitPath[0]], splitPath.slice(1), value);
  }
}

var arrowLeftIcon = {
  type: "dev",
  // label: "Arrow left",
  value: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"red\" width=\"100px\" height=\"100px\"><path d=\"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\"/></svg>"
};
var arrowRightIcon = {
  type: "dev",
  // label: "Arrow right",
  value: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z\"/></svg>"
}; // export const chevronLeftIcon: Theme["icons"]["key"] = {
//   type: "dev",
//   // label: "Arrow left",
//   value: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="100px" height="100px"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>`,
// };
//
// export const chevronRightIcon: Theme["icons"]["key"] = {
//   type: "dev",
//   // label: "Arrow right",
//   value: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 15" fill="currentColor"><path d="M0.220635 0.208548C0.514814 -0.0695159 0.991773 -0.0695159 1.28595 0.208548L9 7.5L1.28595 14.7915C0.991773 15.0695 0.514814 15.0695 0.220635 14.7915C-0.0735449 14.5134 -0.0735449 14.0626 0.220635 13.7845L6.86937 7.5L0.220635 1.2155C-0.0735449 0.937441 -0.0735449 0.486611 0.220635 0.208548Z" fill="currentColor"/></svg>`,
// };

var playIcon = {
  type: "dev",
  // label: "Play",
  value: "<svg viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M8,5.14V19.14L19,12.14L8,5.14Z\" /></svg>"
};
var pauseIcon = {
  type: "dev",
  // label: "Pause",
  value: "<svg style=\"width:24px;height:24px\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M14,19H18V5H14M6,19H10V5H6V19Z\" /></svg>"
};
var muteIcon = {
  type: "dev",
  // label: "Mute",
  value: "<svg viewBox=\"0 0 24 24\">\n    <path fill=\"currentColor\" d=\"M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z\" />\n</svg>"
};
var unmuteIcon = {
  type: "dev",
  // label: "Unmute",
  value: "<svg viewBox=\"0 0 24 24\">\n    <path fill=\"currentColor\" d=\"M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z\" />\n</svg>"
};

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var MASTER_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, sans-serif";
var defaultTheme = {
  space: {
    0: {
      value: "0px",
      type: "dev"
    },
    1: {
      value: "1px",
      type: "dev"
    },
    2: {
      value: "2px",
      type: "dev"
    },
    4: {
      value: "4px",
      type: "dev"
    },
    6: {
      value: "6px",
      type: "dev"
    },
    8: {
      value: "8px",
      type: "dev"
    },
    12: {
      value: "12px",
      type: "dev"
    },
    16: {
      value: "16px",
      type: "dev"
    },
    24: {
      value: "24px",
      type: "dev"
    },
    32: {
      value: "32px",
      type: "dev"
    },
    48: {
      value: "48px",
      type: "dev"
    },
    64: {
      value: "64px",
      type: "dev"
    },
    96: {
      value: "96px",
      type: "dev"
    },
    128: {
      value: "128px",
      type: "dev"
    },
    160: {
      value: "160px",
      type: "dev"
    },
    "containerMargin.default": {
      value: {
        $res: true,
        xl: "5vw"
      },
      type: "dev"
    }
  },
  colors: {
    $dark: {
      value: "black",
      type: "dev"
    },
    $light: {
      value: "white",
      type: "dev"
    },
    $backgroundDark: {
      value: "#363636",
      type: "dev"
    },
    $backgroundLight: {
      value: "#F2F2F2",
      type: "dev"
    },
    transparent: {
      value: "transparent",
      type: "dev"
    }
  },
  fonts: {
    $body: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 20,
        fontWeight: 400,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 18
        }
      },
      type: "dev"
    },
    "$body.bold": {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 18
        }
      },
      type: "dev"
    },
    $body2: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.2
      },
      type: "dev"
    },
    "$body2.bold": {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 1.2
      },
      type: "dev"
    },
    $heading1: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 64,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 36
        }
      },
      type: "dev"
    },
    $heading2: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 48,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 32
        }
      },
      type: "dev"
    },
    $heading3: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 32,
        fontWeight: 500,
        lineHeight: 1.2,
        "@xs": {
          fontSize: 28
        }
      },
      type: "dev"
    },
    $heading4: {
      value: {
        fontFamily: MASTER_FONT_FAMILY,
        fontSize: 24,
        fontWeight: 500,
        lineHeight: 1.2
      },
      type: "dev"
    }
  },
  icons: {
    $sliderLeft: _objectSpread$b({}, arrowLeftIcon),
    $sliderRight: _objectSpread$b({}, arrowRightIcon),
    $play: _objectSpread$b({}, playIcon),
    $pause: _objectSpread$b({}, pauseIcon),
    $mute: _objectSpread$b({}, muteIcon),
    $unmute: _objectSpread$b({}, unmuteIcon)
  },
  aspectRatios: {
    $panoramic: {
      value: "2:1",
      type: "dev" // label: "Panoramic",

    },
    $landscape: {
      value: "16:9",
      type: "dev" // label: "Landscape",

    },
    $portrait: {
      value: "4:5",
      type: "dev" // label: "Portrait",

    },
    $square: {
      value: "1:1",
      type: "dev" // label: "Square",

    },
    $gridMainObjectDefault: {
      value: "4:5",
      type: "dev" // label: "Grid main object default",

    }
  },
  numberOfItemsInRow: {
    "1": {
      value: "1",
      type: "dev"
    },
    "2": {
      value: "2",
      type: "dev"
    },
    "3": {
      value: "3",
      type: "dev"
    },
    "4": {
      value: "4",
      type: "dev"
    },
    "5": {
      value: "5",
      type: "dev"
    },
    "6": {
      value: "6",
      type: "dev"
    }
  },
  containerWidths: {
    none: {
      value: "none",
      type: "dev"
    }
  }
};
function buildFullTheme(theme) {
  var _theme$space$containe, _theme$space;

  var userFonts = theme.fonts || {};
  var userAspectRatios = theme.aspectRatios || {};
  var userContainerWidths = theme.containerWidths || {}; // We spread values from default theme because we want to prevent overriding master tokens by our users

  return {
    space: _objectSpread$b(_objectSpread$b(_objectSpread$b({}, theme.space), defaultTheme.space), {}, {
      // This token is an exception and need to be handled manually.
      "containerMargin.default": (_theme$space$containe = (_theme$space = theme.space) === null || _theme$space === void 0 ? void 0 : _theme$space["containerMargin.default"]) !== null && _theme$space$containe !== void 0 ? _theme$space$containe : defaultTheme.space["containerMargin.default"]
    }),
    colors: _objectSpread$b(_objectSpread$b({}, theme.colors), defaultTheme.colors),
    fonts: _objectSpread$b(_objectSpread$b({}, userFonts), defaultTheme.fonts),
    icons: _objectSpread$b(_objectSpread$b({}, theme.icons), defaultTheme.icons),
    numberOfItemsInRow: _objectSpread$b(_objectSpread$b({}, theme.numberOfItemsInRow), defaultTheme.numberOfItemsInRow),
    aspectRatios: _objectSpread$b(_objectSpread$b({}, userAspectRatios), defaultTheme.aspectRatios),
    containerWidths: _objectSpread$b(_objectSpread$b({}, userContainerWidths), defaultTheme.containerWidths)
  };
}

function isComponentConfig(value) {
  return typeof value === "object" && typeof (value === null || value === void 0 ? void 0 : value._template) === "string" && typeof (value === null || value === void 0 ? void 0 : value._id) === "string";
}

var CompilationCache = /*#__PURE__*/function () {
  function CompilationCache(initialEntries) {
    _classCallCheck$8(this, CompilationCache);

    index._defineProperty(this, "cache", void 0);

    this.cache = initialEntries ? new Map(initialEntries) : new Map();
  }

  _createClass$8(CompilationCache, [{
    key: "get",
    value: function get(key) {
      return this.cache.get(key);
    }
  }, {
    key: "set",
    value: function set(key, entry) {
      this.cache.set(key, entry);
    }
  }, {
    key: "remove",
    value: function remove(path) {
      this.cache["delete"](path);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
    }
  }, {
    key: "count",
    get: function get() {
      return this.cache.size;
    }
  }]);

  return CompilationCache;
}();

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getNormalize(compilationContext, defaultValue, fallbackDefaultValue) {
  var normalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };
  return function (val) {
    var normalizedVal = normalize(val);

    if (normalizedVal !== undefined) {
      return normalizedVal;
    }

    var normalizedDefaultVal = normalize(defaultValue);

    if (normalizedDefaultVal !== undefined) {
      return normalizedDefaultVal;
    }

    return normalize(fallbackDefaultValue);
  };
}

function getResponsiveNormalize(compilationContext, defaultValue, fallbackDefaultValue) {
  var normalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };

  if (index.isTrulyResponsiveValue(defaultValue)) {
    /**
     * Here we must decide how this behaves. It's not obvious. If default is responsive, we cannot easily use default breakpoints.
     * It's because auto might be different. Changing one breakpoint changes "context" for others.
     */
    throw new Error("default responsive values not yet supported");
  }

  return function (val) {
    var scalarNormalize = getNormalize(compilationContext, defaultValue, fallbackDefaultValue, normalize); // if value is not really responsive

    if (!index.isTrulyResponsiveValue(val)) {
      return index._defineProperty({
        $res: true
      }, compilationContext.mainBreakpointIndex, scalarNormalize(val));
    }

    var responsiveVal = index.responsiveValueMap(val, function (x) {
      return normalize(x);
    }); // main breakpoint always set

    if (responsiveVal[compilationContext.mainBreakpointIndex] === undefined) {
      responsiveVal[compilationContext.mainBreakpointIndex] = scalarNormalize(undefined);
    }

    return responsiveVal;
  };
}

function getSelectValue(arg) {
  if (typeof arg === "string") {
    return arg;
  }

  return arg.value;
}

function isSelectValueCorrect(value, options) {
  if (typeof value !== "string") {
    return false;
  }

  return options.map(getSelectValue).indexOf(value) > -1;
}

function getFirstOptionValue(schemaProp) {
  if (schemaProp.options.length === 0) {
    throw new Error("Select field can't have 0 options");
  }

  var firstOption = schemaProp.options[0];
  var firstOptionValue = typeof firstOption === "object" ? firstOption.value : firstOption;
  return firstOptionValue;
}

function getSelectSchemaPropDefinition() {
  return function (schemaProp, compilationContext) {
    return {
      normalize: getNormalize(compilationContext, schemaProp.defaultValue, getFirstOptionValue(schemaProp), function (x) {
        return isSelectValueCorrect(x, schemaProp.options) ? x : undefined;
      }),
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value;
      }
    };
  };
}

function getResponsiveSelectSchemaPropDefinition() {
  return function (schemaProp, compilationContext) {
    return {
      normalize: getResponsiveNormalize(compilationContext, schemaProp.defaultValue, getFirstOptionValue(schemaProp), function (x) {
        return isSelectValueCorrect(x, schemaProp.options) ? x : undefined;
      }),
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, currentBreakpoint) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, currentBreakpoint);
          return breakpointValue === null || breakpointValue === void 0 ? void 0 : breakpointValue.toString();
        }

        return value;
      }
    };
  };
}

function normalizeTokenValue(x, themeValues, defaultValue) {
  var scalarValueNormalize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return undefined;
  };

  // Mapping of legacy value of string (now not possible)
  if (typeof x === "string" && themeValues[x]) {
    // If string value exist as a theme key
    x = {
      value: themeValues[x].value,
      ref: x
    };
  } // Mapping of legacy value of type object which could be a font (now not possible)
  // The test below is shitty but this code should stay.


  if (!(typeof x === "object" && x !== null && (x.value !== undefined || typeof x.ref === "string")
  /* this is primitive test if this is ThemeRef value (either ref or value defined). It can also be object for Font! */
  )) {
    x = {
      value: x
    };
  }

  if (typeof x.ref === "string") {
    var _getMappedToken;

    // Mapping
    x = (_getMappedToken = getMappedToken(x.ref, themeValues)) !== null && _getMappedToken !== void 0 ? _getMappedToken : x; // If ref is defined

    var val = themeValues[x.ref]; // If ref exists in a theme we just take ref value

    if (val) {
      return {
        value: val.value,
        ref: x.ref
      };
    } // If ref is defined but doesn't exist in a theme it means that it was probably removed
    // In that case we simply pass the non-existent ref name (it can be later brought back).
    // The value is scalar-normalized! We'll never get incorrect value after normalization.


    var normalizedVal = scalarValueNormalize(x.value);

    if (normalizedVal === undefined) {
      return {
        value: defaultValue.value,
        // if value was incorrect, we apply default value
        ref: x.ref
      };
    } else {
      return {
        value: normalizedVal,
        // if value was correct, it stays
        ref: x.ref
      };
    }
  } // If ref is not defined
  else {
    var _normalizedVal = scalarValueNormalize(x.value);

    if (_normalizedVal === undefined) {
      return;
    } else {
      return {
        value: _normalizedVal
      };
    }
  }
}

function buildThemeDefinition(themeValues, defaultKey, // we must make sure that defaultKey is always correct
schemaProp, compilationContext) {
  var scalarValueNormalize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (x) {
    return undefined;
  };
  // Create default value
  var defaultValue = {
    ref: defaultKey,
    value: themeValues[defaultKey].value
  };
  /**
   * TODO:
   * - getResponsiveNormalize and helpers take into account recursion now!
   * - only thing we need to do is to write compile properly
   */

  var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, defaultValue, function (x) {
    return normalizeTokenValue(x, themeValues, defaultValue, scalarValueNormalize);
  });
  return {
    normalize: normalize,
    // FIXME: input of compile should be output of normalize.
    compile: function compile(x) {
      // /**
      //  * We need to run this normalization here. Why?
      //  *
      //  * Although compiled config is promised to be normalized, but in case of theme can change under the hood.
      //  * And this will cause Tina state to be invalid (ref not conformant with value). That's why we normalize here.
      //  *
      //  * That could probably go from here.
      //  */
      //
      // // x = normalize(x);
      var val = index.responsiveValueMap(x, function (y) {
        return y === null || y === void 0 ? void 0 : y.value;
      });
      var flattened = responsiveValueFlatten(val, compilationContext.devices);
      return index.responsiveValueFill(flattened, compilationContext.devices, index.getDevicesWidths(compilationContext.devices));
    }
  };
}

function addStylesHash(styles) {
  if ("__hash" in styles) {
    delete styles["__hash"];
  }

  var hash = cryptoJs.SHA1(JSON.stringify(styles));
  styles.__hash = hash.toString();
  return styles;
}

function compileBoxes(value, compilationContext) {
  if (Array.isArray(value)) {
    return value.map(function (x) {
      return compileBoxes(x, compilationContext);
    });
  } else if (typeof value === "object" && value !== null) {
    if (value.__isBox) {
      return addStylesHash(index.compileBox(value, compilationContext.devices));
    }

    var ret = {};

    for (var _key in value) {
      ret[_key] = compileBoxes(value[_key], compilationContext);
    }

    return ret;
  }

  return value;
}

function tracingType(tags, overwrite) {
  var _types$find;

  if (overwrite) {
    return overwrite;
  }

  var types = ["section", "card", "button", "item"];
  return (_types$find = types.find(function (t) {
    return tags.includes(t);
  })) !== null && _types$find !== void 0 ? _types$find : "item";
}

function isSchemaPropTracing(prop) {
  return index.isTracingSchemaProp(prop);
}
/**
 * This compilation function doesn't take schema. It means that it assumes couple of things:
 * 1. That input is ConfigComponent or 1-item array of. ConfigComponent. Basically it's a single component.
 * 2. It also assumes that component-fixed schema.
 * 3. Return format
 */


function compileComponentValues(inputValues, componentDefinition, compilationContext, cache) {
  var values = {};
  componentDefinition.schema.forEach(function (schemaProp) {
    if (!index.isSchemaPropComponentOrComponentCollection(schemaProp)) {
      values[schemaProp.prop] = compileFromSchema(inputValues[schemaProp.prop], schemaProp, compilationContext, cache);
    }
  });
  return _objectSpread$a({}, values);
}

function compileAction(editableElement, compilationContext, serializedDefinitions, configPrefix, cache) {
  var componentDefinition = index.findComponentDefinitionById(editableElement._template, compilationContext);

  if (!componentDefinition) {
    componentDefinition = index.findComponentDefinitionById("$MissingAction", compilationContext);
    editableElement = {
      _template: componentDefinition.id
    };
  }

  addComponentToSerializedComponentDefinitions(editableElement, componentDefinition.tags.includes("actionLink") ? serializedDefinitions.links : serializedDefinitions.actions, compilationContext);
  var compiledValues = compileComponentValues(editableElement, componentDefinition, compilationContext, cache);
  var compiled = {
    _template: editableElement._template,
    _id: editableElement._id,
    props: compiledValues
  };

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, editorContext, compiledValues, editableElement._template);
    compiled.__editing = {
      fields: editingInfo.fields
    };
  }

  return [compiled];
}

function compileSubcomponents(editableElement, subcomponentsContextProps, compilationContext, refMap, serializedDefinitions, editingInfoComponents, configPrefix, compiledComponentConfig, configAfterAuto, // null means that we don't want auto
cache) {
  var componentDefinition = index.findComponentDefinition(editableElement, compilationContext);
  componentDefinition.schema.forEach(function (schemaProp) {
    if (index.isSchemaPropComponentOrComponentCollection(schemaProp)) {
      // Currently these are processed outside of compileSubcomponents
      if (index.isSchemaPropActionTextModifier(schemaProp) || index.isSchemaPropTextModifier(schemaProp)) {
        return;
      }

      if (index.isSchemaPropAction(schemaProp)) {
        var actionFieldValue = editableElement[schemaProp.prop];

        if (actionFieldValue.length > 0) {
          var actionConfigPrefix = "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".0");
          var compiledAction = compileAction(editableElement[schemaProp.prop][0], compilationContext, serializedDefinitions, actionConfigPrefix, cache);
          compiledComponentConfig.actions[schemaProp.prop] = compiledAction;
        } else {
          compiledComponentConfig.actions[schemaProp.prop] = [];
        }

        return;
      }

      var contextProps = subcomponentsContextProps[schemaProp.prop] || {};
      var compilationOutput = compileFromSchema(editableElement[schemaProp.prop], schemaProp, compilationContext, cache, contextProps, serializedDefinitions, refMap, editingInfoComponents === null || editingInfoComponents === void 0 ? void 0 : editingInfoComponents[schemaProp.prop], "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop));
      compiledComponentConfig.components[schemaProp.prop] = compilationOutput.map(function (compilationOutput) {
        return compilationOutput.compiledComponentConfig;
      }); // Merge config after auto

      if (compilationContext.isEditing && configAfterAuto !== null) {
        if (schemaProp.type === "component" || schemaProp.type === "component-fixed") {
          var _compilationOutput$0$, _compilationOutput$;

          configAfterAuto[schemaProp.prop] = [(_compilationOutput$0$ = (_compilationOutput$ = compilationOutput[0]) === null || _compilationOutput$ === void 0 ? void 0 : _compilationOutput$.configAfterAuto) !== null && _compilationOutput$0$ !== void 0 ? _compilationOutput$0$ : []];
        } else if (schemaProp.type === "component-collection" || schemaProp.type === "component-collection-localised") {
          var configsAfterAuto = compilationOutput.map(function (compilationOutput, index) {
            if (schemaProp.itemFields) {
              var itemPropsCollectionPath = "_itemProps.".concat(editableElement._template, ".").concat(schemaProp.prop);
              var itemProps = Object.fromEntries(schemaProp.itemFields.map(function (itemSchemaProp) {
                // const itemPropPathExpanded = `${itemPropsCollectionPath}.${itemSchemaProp.prop}`;
                // const currentItemPropValue = dotNotationGet(
                //   compilationOutput.configAfterAuto,
                //   itemPropPathExpanded
                // );
                // if (currentItemPropValue) {
                //   return [itemSchemaProp.prop, currentItemPropValue];
                // }
                var itemPropValue = configAfterAuto[schemaProp.prop][index][itemSchemaProp.prop];
                return [itemSchemaProp.prop, itemPropValue];
              }));
              dotNotationSet(compilationOutput.configAfterAuto, itemPropsCollectionPath, itemProps);
            }

            return compilationOutput.configAfterAuto;
          });

          if (schemaProp.type === "component-collection-localised") {
            // We store after auto config within context of current locale only
            configAfterAuto[schemaProp.prop] = index._defineProperty({}, compilationContext.contextParams.locale, configsAfterAuto);
          } else {
            configAfterAuto[schemaProp.prop] = configsAfterAuto;
          }
        }
      }
    }
  });
}

function addComponentToSerializedComponentDefinitions(component, serializedDefinitions, compilationContext) {
  if (serializedDefinitions.find(function (def) {
    return def.id === component._template;
  })) {
    return;
  }

  var internalDefinition = index.findComponentDefinition(component, compilationContext);
  var newDef = {
    id: internalDefinition.id,
    label: internalDefinition.label,
    schema: internalDefinition.schema,
    tags: internalDefinition.tags
  };

  if ("componentCode" in internalDefinition) {
    newDef.componentCode = internalDefinition.componentCode;
  }

  serializedDefinitions.push(newDef);
}

function createFieldName(schemaProp, configPrefix, templateId, editorContext) {
  var _splitTemplateName = index.splitTemplateName(templateId),
      ref = _splitTemplateName.ref,
      isRefLocal = _splitTemplateName.isRefLocal;
  /**
   * This condition is kind of "ancient". It's ref mechanism (shared properties) that is not in use anymore. But it's necessary for backward compatibility.
   */


  if (ref && !index.isResourceSchemaProp(schemaProp)) {
    // local ref
    if (!isRefLocal) {
      throw new Error("global refs not enabled");
    }

    var parent = parsePath(configPrefix + "." + schemaProp.prop, editorContext.form).parent;
    return "".concat(parent.path, ".$$$refs.").concat(ref, ".").concat(schemaProp.prop);
  } else {
    return schemaProp.prop === "$myself" ? configPrefix : "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop);
  }
}

function getDefaultFieldDefinition(schemaProp, configPrefix, definition, editorContext, compiledValues, templateId) {
  var _schemaProp$label, _schemaProp$group;

  var tinaField = getTinaField(_objectSpread$a(_objectSpread$a({}, schemaProp), {}, {
    definition: definition
  }), editorContext, definition);
  var visible = !index.isSchemaPropComponentOrComponentCollection(schemaProp);

  if (typeof schemaProp.visible === "boolean") {
    visible = schemaProp.visible;
  } else if (typeof schemaProp.visible === "function") {
    visible = schemaProp.visible(compiledValues, {
      editorContext: editorContext
    });
  }

  return _objectSpread$a(_objectSpread$a({}, tinaField), {}, {
    prop: schemaProp.prop,
    label: (_schemaProp$label = schemaProp.label) !== null && _schemaProp$label !== void 0 ? _schemaProp$label : schemaProp.prop,
    group: (_schemaProp$group = schemaProp.group) !== null && _schemaProp$group !== void 0 ? _schemaProp$group : "Properties",
    name: createFieldName(schemaProp, configPrefix, templateId, editorContext),
    hidden: !visible
  });
}

function buildDefaultEditingInfo(definition, configPrefix, editorContext, compiledValues, templateId) {
  var scalarizedConfig = index.scalarizeConfig(compiledValues, editorContext.breakpointIndex, editorContext.devices, definition.schema);

  var schema = index._toConsumableArray(definition.schema);

  var defaultFields = schema.filter(function (schemaProp) {
    return !index.isSchemaPropCollection(schemaProp);
  }).filter(function (schemaProp) {
    if (compiledValues.noTrace && schemaProp.prop.startsWith("trace")) {
      return false;
    }

    return true;
  }).map(function (schemaProp) {
    return getDefaultFieldDefinition(schemaProp, configPrefix, definition, editorContext, scalarizedConfig, templateId);
  }); // noAction is a special property

  if (compiledValues.noAction) {
    defaultFields = defaultFields.filter(function (field) {
      return field.prop !== "action";
    });
  }

  var pathInfo = parsePath(configPrefix, editorContext.form);
  var parentInfo = pathInfo.parent;

  if (parentInfo) {
    var parentDefinition = index.findComponentDefinitionById(parentInfo.templateId, editorContext);

    if (!parentDefinition) {
      throw new Error("Can't find parent definition: ".concat(parentInfo.templateId));
    }

    var parentSchemaProp = parentDefinition.schema.find(function (schemaProp) {
      return schemaProp.prop === parentInfo.fieldName;
    });

    if (!parentSchemaProp) {
      throw new Error("Can't find parent schemaProp: ".concat(parentInfo.templateId, " > ").concat(parentInfo.fieldName));
    }

    var required;

    if (parentSchemaProp.type === "component-fixed") {
      required = true;
    } else if (index.isSchemaPropCollection(parentSchemaProp)) {
      required = false;
    } else {
      required = !!parentSchemaProp.required;
    }

    var headerSchemaProp = {
      prop: "$myself",
      label: "Component type",
      type: "component$$$",
      picker: parentSchemaProp.picker,
      definition: parentDefinition,
      required: required,
      group: "Component"
    };
    var headerField = {
      component: "identity",
      hidden: false,
      label: "Component type",
      name: configPrefix,
      prop: "$myself",
      schemaProp: headerSchemaProp
    };

    if (process.env.NEXT_PUBLIC_SHOPSTORY_FEATURE_VARIANTS === "enabled") {
      var variantSchemaProp = {
        prop: "$myself",
        label: "Variants",
        type: "variants$$$",
        group: "Variations",
        definition: parentDefinition
      };
      var variantsField = {
        component: "variant",
        group: "Variations",
        hidden: false,
        label: "Variants",
        name: configPrefix,
        prop: "$myself",
        schemaProp: variantSchemaProp
      };
      defaultFields.unshift(variantsField);
    }

    defaultFields.unshift(headerField);
  }

  var fields = bubbleDown(function (x) {
    return x.prop === "Analytics";
  }, defaultFields);
  var editingInfo = {
    fields: fields,
    components: {}
  };
  definition.schema.forEach(function (schemaProp) {
    if (index.isSchemaPropCollection(schemaProp)) {
      editingInfo.components[schemaProp.prop] = {
        items: scalarizedConfig[schemaProp.prop].map(function (x, index) {
          var _schemaProp$itemField;

          return {
            fields: ((_schemaProp$itemField = schemaProp.itemFields) !== null && _schemaProp$itemField !== void 0 ? _schemaProp$itemField : []).map(function (itemSchemaProp) {
              return getDefaultFieldDefinition(itemSchemaProp, "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".").concat(index, "._itemProps.").concat(definition.id, ".").concat(schemaProp.prop), definition, editorContext, scalarizedConfig, templateId);
            })
          };
        })
      };
    } else if (index.isSchemaPropComponent(schemaProp)) {
      editingInfo.components[schemaProp.prop] = {
        fields: []
      };
    }
  });
  return editingInfo;
}

function applyEditingInfoToCompiledConfig(compiledComponentConfig, editingInfo, parentEditingInfo) {
  var headerFields = editingInfo.fields.filter(function (field) {
    return field.prop === "$myself";
  });
  var nonHeaderFields = editingInfo.fields.filter(function (field) {
    return field.prop !== "$myself";
  });
  var fields = [].concat(index._toConsumableArray(headerFields), index._toConsumableArray(parentEditingInfo && "fields" in parentEditingInfo ? parentEditingInfo.fields : []), index._toConsumableArray(nonHeaderFields));
  compiledComponentConfig.__editing = _objectSpread$a(_objectSpread$a({}, parentEditingInfo), {}, {
    fields: fields,
    components: {}
  });

  for (var fieldName in editingInfo.components) {
    compiledComponentConfig.__editing.components[fieldName] = {}; // Here we copy only noInline. It's the only flag we need in parent component. It's only because we need noInline info even if there is no component in array (to know that we shouldn't render placeholder)

    if (editingInfo.components[fieldName].noInline !== undefined) {
      compiledComponentConfig.__editing.components[fieldName].noInline = editingInfo.components[fieldName].noInline;
    }
  }
}

var deepObjectMergeWithoutArrays = function deepObjectMergeWithoutArrays(target, source) {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
    var _key2 = _Object$keys[_i];
    if (source[_key2] instanceof Object && !Array.isArray(source[_key2])) Object.assign(source[_key2], deepObjectMergeWithoutArrays(target[_key2], source[_key2]));
  } // Join `target` and modified `source`


  Object.assign(target || {}, source);
  return target;
};

function itemFieldsForEach(config, compilationContext, callback) {
  var componentDefinition = index.findComponentDefinition(config, compilationContext);
  componentDefinition.schema.forEach(function (schemaProp) {
    if (index.isSchemaPropCollection(schemaProp)) {
      var _dotNotationGet;

      var itemFields = schemaProp.itemFields;
      var path = schemaProp.prop;

      if (schemaProp.type === "component-collection-localised") {
        var localizedValue = resolveLocalisedValue(config[schemaProp.prop], compilationContext);

        if (localizedValue) {
          path = "".concat(path, ".").concat(localizedValue.locale);
        } else {
          path = "".concat(path, ".").concat(compilationContext.contextParams.locale);
        }
      }

      var value = (_dotNotationGet = dotNotationGet(config, path)) !== null && _dotNotationGet !== void 0 ? _dotNotationGet : [];
      value.forEach(function (itemConfig, index) {
        if (itemFields) {
          itemFields.forEach(function (itemSchemaProp) {
            var itemPath = "".concat(path, ".").concat(index, ".").concat(itemSchemaProp.prop);
            var itemValue = dotNotationGet(config, itemPath);
            callback({
              collectionSchemaProp: schemaProp,
              itemIndex: index,
              itemSchemaProp: itemSchemaProp,
              itemPropPath: itemPath,
              itemPropValue: itemValue
            });
          });
        }
      });
    }
  });
}

function compileComponent(editableElement, compilationContext, // contextProps are already compiled! They're result of compilation function.
contextProps, serializedDefinitions, refMap, cache, parentComponentEditingInfo, configPrefix) {
  var _configPrefix;

  configPrefix = (_configPrefix = configPrefix) !== null && _configPrefix !== void 0 ? _configPrefix : "";

  if (!isComponentConfig(editableElement)) {
    console.error("[compile] wrong input for compileComponent", editableElement);
    throw new Error("[compile] wrong input for compileComponent");
  }

  var cachedResult = cache.get(editableElement._id);

  var _splitTemplateName2 = index.splitTemplateName(editableElement._template),
      name = _splitTemplateName2.name,
      ref = _splitTemplateName2.ref;

  var componentDefinition = index.findComponentDefinitionById(name, compilationContext);

  if (!componentDefinition) {
    componentDefinition = index.findComponentDefinitionById("$MissingComponent", compilationContext);
    editableElement = {
      _template: componentDefinition.id,
      _id: index.uniqueId(),
      error: "Shopstory can\u2019t find definition for component: ".concat(name, " in your project. Please contact your developers to resolve this issue.")
    };
    parentComponentEditingInfo = undefined;
  }

  refMap = _objectSpread$a(_objectSpread$a({}, refMap), editableElement.$$$refs || {});

  if (componentDefinition.tags.length > 0 && componentDefinition.tags[0].startsWith("action")) {
    throw new Error("compileComponent can never be called for action");
  }

  var ownProps = createOwnComponentProps({
    config: editableElement,
    contextProps: contextProps,
    componentDefinition: componentDefinition,
    compilationContext: compilationContext,
    refMap: refMap,
    ref: ref
  });
  var hasComponentConfigChanged = true;
  var ownPropsAfterAuto;
  var compiled = {
    _template: editableElement._template,
    _id: editableElement._id,
    props: {},
    actions: {},
    components: {},
    textModifiers: {}
  };
  var configAfterAuto;
  var editingInfo;
  var compiledValues = {};
  var subcomponentsContextProps = {};
  var editingContextProps;

  if (cachedResult) {
    hasComponentConfigChanged = !index.deepCompare(ownProps, cachedResult.values);

    if (!hasComponentConfigChanged) {
      ownPropsAfterAuto = cachedResult.valuesAfterAuto;
      compiledValues = cachedResult.compiledValues;
      compiled = cachedResult.compiledConfig;
      configAfterAuto = cachedResult.valuesAfterAuto;
      subcomponentsContextProps = cachedResult.contextProps;
      editingContextProps = cachedResult.editingContextProps;
    }
  }

  addComponentToSerializedComponentDefinitions(editableElement, serializedDefinitions.components, compilationContext);
  var isCustomComponent = !editableElement._template.startsWith("$");
  var isButton = componentDefinition.tags.includes("button");

  if (hasComponentConfigChanged) {
    // We are going to mutate this object so let's disconnect it from its source object
    ownPropsAfterAuto = index.deepClone(ownProps); // update refMap
    // refMap = { ...refMap, ...(editableElement.$$$refs || {}) };

    var _calculateWidths = calculateWidths(compilationContext, contextProps, componentDefinition),
        $width = _calculateWidths.$width,
        $widthAuto = _calculateWidths.$widthAuto;
    /**
     * APPLY AUTO
     */


    var DEFAULT_SPACE_AUTO_CONSTANT = 16; // linearize space

    componentDefinition.schema.forEach(function (schemaProp) {
      if (index.isSchemaPropTokenized(schemaProp)) {
        ownPropsAfterAuto[schemaProp.prop] = applyAutoUsingResponsiveTokens(ownPropsAfterAuto[schemaProp.prop], compilationContext);
      }

      if (schemaProp.type === "space") {
        var _schemaProp$autoConst;

        ownPropsAfterAuto[schemaProp.prop] = linearizeSpace(ownPropsAfterAuto[schemaProp.prop], compilationContext, $width, (_schemaProp$autoConst = schemaProp.autoConstant) !== null && _schemaProp$autoConst !== void 0 ? _schemaProp$autoConst : DEFAULT_SPACE_AUTO_CONSTANT);
      }
    });
    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (arg) {
      var value = arg.itemPropValue;

      if (index.isSchemaPropTokenized(arg.itemSchemaProp)) {
        value = applyAutoUsingResponsiveTokens(value, compilationContext);
      }

      if (arg.itemSchemaProp.type === "space") {
        var _arg$itemSchemaProp$a;

        value = linearizeSpace(value, compilationContext, $width, (_arg$itemSchemaProp$a = arg.itemSchemaProp.autoConstant) !== null && _arg$itemSchemaProp$a !== void 0 ? _arg$itemSchemaProp$a : DEFAULT_SPACE_AUTO_CONSTANT);
      }

      dotNotationSet(ownPropsAfterAuto, arg.itemPropPath, value);
    });
    var autoFunction = componentDefinition.auto;

    if (autoFunction) {
      ownPropsAfterAuto = autoFunction(ownPropsAfterAuto, compilationContext, $width);
    } // Fill all responsive values. We can assume that values after auto for each breakpoint MUST be defined!!!
    // IMPORTANT: For now we make it realtive to device widths, so Webflow way


    for (var _prop in ownPropsAfterAuto) {
      ownPropsAfterAuto[_prop] = index.responsiveValueFill(ownPropsAfterAuto[_prop], compilationContext.devices, index.getDevicesWidths(compilationContext.devices));
    }

    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (arg) {
      dotNotationSet(ownPropsAfterAuto, arg.itemPropPath, index.responsiveValueFill(arg.itemPropValue, compilationContext.devices, index.getDevicesWidths(compilationContext.devices)));
    }); // First we compile all the props and store them in compiledValues

    var _compileComponentValu = compileComponentValues(ownPropsAfterAuto, componentDefinition, compilationContext, cache),
        traceId = _compileComponentValu.traceId,
        traceClicks = _compileComponentValu.traceClicks,
        traceImpressions = _compileComponentValu.traceImpressions,
        _compiledValues = index._objectWithoutProperties(_compileComponentValu, ["traceId", "traceClicks", "traceImpressions"]);

    compiledValues = _objectSpread$a(_objectSpread$a({}, index.deepClone(ownPropsAfterAuto)), _compiledValues); // Compile item props

    itemFieldsForEach(ownPropsAfterAuto, compilationContext, function (_ref2) {
      var itemPropValue = _ref2.itemPropValue,
          itemIndex = _ref2.itemIndex,
          itemSchemaProp = _ref2.itemSchemaProp,
          collectionSchemaProp = _ref2.collectionSchemaProp;
      var compiledValue = compileFromSchema(itemPropValue, itemSchemaProp, compilationContext, cache, {}, serializedDefinitions, refMap);
      compiledValues[collectionSchemaProp.prop][itemIndex][itemSchemaProp.prop] = compiledValue;
    }); // Let's compile tracing

    if (componentDefinition.schema.some(function (_ref3) {
      var prop = _ref3.prop;
      return isSchemaPropTracing(prop);
    })) {
      compiled.tracing = {
        traceId: traceId,
        traceClicks: traceClicks,
        traceImpressions: traceImpressions,
        type: tracingType(componentDefinition.tags, contextProps.tracingType)
      };
    }

    componentDefinition.schema.forEach(function (schemaProp) {
      if (index.isSchemaPropActionTextModifier(schemaProp) || index.isSchemaPropTextModifier(schemaProp)) {
        var modifierValue = editableElement[schemaProp.prop][0];

        if (!modifierValue) {
          compiledValues[schemaProp.prop] = [];
          return;
        }

        compiledValues[schemaProp.prop] = [compileTextModifier(modifierValue, editableElement.elements, compilationContext, "".concat(configPrefix).concat(configPrefix === "" ? "" : ".").concat(schemaProp.prop, ".0"), cache)];
        compiled.textModifiers[schemaProp.prop] = compiledValues[schemaProp.prop];
      }
    }); // We want to style block element based on the most common values from all text parts within all lines.
    // Only for this component, we compile nested $richTextPart components values.

    if (editableElement._template === richTextEditableComponent.id) {
      if (compiledValues.isListStyleAuto) {
        var _compileRichTextValue = compileRichTextValuesFromRichTextParts(editableElement, compilationContext, cache),
            _compileRichTextValue2 = _compileRichTextValue.mainColor,
            mainColor = _compileRichTextValue2 === void 0 ? compiledValues.mainColor : _compileRichTextValue2,
            _compileRichTextValue3 = _compileRichTextValue.mainFont,
            mainFont = _compileRichTextValue3 === void 0 ? compiledValues.mainFont : _compileRichTextValue3;

        compiledValues.mainColor = mainColor;
        compiledValues.mainFont = mainFont;
      }

      compiledValues.mainFontSize = mapResponsiveFontToResponsiveFontSize(compiledValues.mainFont);
    } // $SectionWrapper holds the hide prop, but the $RootSections component is responsible for showing/hiding sections
    // We add `hide` value of each section to compiled values of $RootSections component


    if (editableElement._template === "$RootSections") {
      compiledValues.data = compiledValues.data.map(function (data, index$1) {
        return _objectSpread$a(_objectSpread$a({}, data), {}, {
          hide: index.responsiveValueFill(editableElement.data[index$1].hide, compilationContext.devices, index.getDevicesWidths(compilationContext.devices))
        });
      });
    } // User-defined components don't need any more work


    if (isCustomComponent) {
      compiled.props = compiledValues; // for now we're not adding context values to custom components

      var stylesOutput = {};

      if (compilationContext.isEditing) {
        editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, compilationContext, compiledValues, editableElement._template);
      }
      /**
       * This is exception. If we have button we pass special context props to the symbol subcomponent (ignoreColor).
       * Actually maybe custom components should also have compilation phase?
       */


      var _isButton = componentDefinition.tags.includes("button");

      if (_isButton) {
        var _editingInfo;

        stylesOutput.symbol = {
          noInline: true,
          ignoreColor: true
        };

        if ((_editingInfo = editingInfo) === null || _editingInfo === void 0 ? void 0 : _editingInfo.components.symbol) {
          editingInfo.components.symbol.noInline = true;
        }
      }

      if (compilationContext.isEditing && editingInfo) {
        applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
      }

      subcomponentsContextProps = extractContextPropsFromStyles(stylesOutput); // We are going to mutate this object so let's disconnect it from its source object

      configAfterAuto = index.deepClone(ownProps);
    } else {
      compiled = _objectSpread$a(_objectSpread$a({}, compiled), {}, {
        components: {},
        styled: {}
      });
      var renderableComponentDefinition = componentDefinition;

      if (compilationContext.isEditing) {
        /**
         * Let's build default editingOutput (fields and component output)
         */
        var editorContext = compilationContext;
        editingInfo = buildDefaultEditingInfo(renderableComponentDefinition, configPrefix, editorContext, compiledValues, editableElement._template);
        /**
         * Let's run custom editing function
         */

        if (renderableComponentDefinition.editing) {
          var fieldsMap = {};
          editingInfo.fields.forEach(function (field) {
            fieldsMap[field.prop] = field;
          });
          var scalarizedConfig = index.scalarizeConfig(compiledValues, editorContext.breakpointIndex, editorContext.devices, renderableComponentDefinition.schema);
          var editingInfoPartial = renderableComponentDefinition.editing(scalarizedConfig, editingInfo, {
            fields: fieldsMap,
            pathPrefix: configPrefix,
            editorContext: editorContext
          });

          if (editingInfoPartial) {
            deepObjectMergeWithoutArrays(editingInfo, editingInfoPartial);
          }
        }
        /**
         * Save to __editing
         */


        applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
        editingContextProps = editingInfo.components;
      }

      var _resop = index.resop2(compiledValues, function (x, breakpointIndex) {
        if (!renderableComponentDefinition.styles) {
          return {};
        }

        var device = compilationContext.devices.find(function (device) {
          return device.id === breakpointIndex;
        });
        return renderableComponentDefinition.styles(x, {
          breakpointIndex: breakpointIndex,
          device: device,
          compilationContext: compilationContext,
          $width: $width[breakpointIndex],
          $widthAuto: $widthAuto[breakpointIndex]
        });
      }, compilationContext.devices, renderableComponentDefinition),
          __props = _resop.__props,
          _stylesOutput = index._objectWithoutProperties(_resop, ["__props"]);

      subcomponentsContextProps = extractContextPropsFromStyles(_stylesOutput); // Move all the boxes to _compiled

      var _loop = function _loop(_key3) {
        var value = _stylesOutput[_key3];
        var schemaProp = componentDefinition.schema.find(function (x) {
          return x.prop === _key3;
        }); // Context props processed below

        if (schemaProp) {
          return "continue";
        } // If box


        compiled.styled[_key3] = compileBoxes(value, compilationContext);
      };

      for (var _key3 in _stylesOutput) {
        var _ret = _loop(_key3);

        if (_ret === "continue") continue;
      }
      /**
       * 1. We must move resources to props by default.
       * 2. Compiled values at this point are "filled", all breakpoints are defined. It's OK for auto and compilation.
       * 3. However, it's not OK for responsive resources (like image, video).
       */


      componentDefinition.schema.forEach(function (schemaProp) {
        if (index.isResourceSchemaProp(schemaProp)) {
          compiled.props[schemaProp.prop] = index.responsiveValueNormalize(compiledValues[schemaProp.prop], compilationContext.devices);
        }
      }); // we also add __props to props

      compiled.props = _objectSpread$a(_objectSpread$a({}, __props), compiled.props); // We are going to mutate this object so let's disconnect it from its source object

      configAfterAuto = index.deepClone(ownPropsAfterAuto);
    }
  }

  if (compilationContext.isEditing) {
    if (isCustomComponent) {
      editingInfo = buildDefaultEditingInfo(componentDefinition, configPrefix, compilationContext, compiledValues, editableElement._template);
      /**
       * This is exception. If we have button we pass special context props to the symbol subcomponent (ignoreColor).
       * Actually maybe custom components should also have compilation phase?
       */

      if (isButton) {
        var _editingInfo2;

        if ((_editingInfo2 = editingInfo) === null || _editingInfo2 === void 0 ? void 0 : _editingInfo2.components.symbol) {
          editingInfo.components.symbol.noInline = true;
        }
      }
    } else {
      /**
       * Let's build default editingOutput (fields and component output)
       */
      var _editorContext = compilationContext;
      var _renderableComponentDefinition = componentDefinition;
      editingInfo = buildDefaultEditingInfo(_renderableComponentDefinition, configPrefix, _editorContext, compiledValues, editableElement._template);
      /**
       * Let's run custom editing function
       */

      if (_renderableComponentDefinition.editing) {
        var _fieldsMap = {};
        editingInfo.fields.forEach(function (field) {
          _fieldsMap[field.prop] = field;
        });

        var _scalarizedConfig = index.scalarizeConfig(compiledValues, _editorContext.breakpointIndex, _editorContext.devices, _renderableComponentDefinition.schema);

        var _editingInfoPartial = _renderableComponentDefinition.editing(_scalarizedConfig, editingInfo, {
          fields: _fieldsMap,
          pathPrefix: configPrefix,
          editorContext: _editorContext
        });

        if (_editingInfoPartial) {
          deepObjectMergeWithoutArrays(editingInfo, _editingInfoPartial);
        }
      }
    }

    if (editingInfo) // Save to __editing
      applyEditingInfoToCompiledConfig(compiled, editingInfo, parentComponentEditingInfo);
    editingContextProps = editingInfo.components;
  }

  compileSubcomponents(editableElement, subcomponentsContextProps, compilationContext, refMap, serializedDefinitions, editingContextProps, configPrefix, compiled, isCustomComponent ? null : configAfterAuto, cache);
  cache.set(ownProps._id, {
    values: ownProps,
    valuesAfterAuto: ownPropsAfterAuto,
    compiledValues: compiledValues,
    compiledConfig: compiled,
    contextProps: subcomponentsContextProps,
    editingContextProps: editingContextProps
  });

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    logCompilationDebugOutput({
      cachedResult: cachedResult,
      hasComponentConfigChanged: hasComponentConfigChanged,
      configPrefix: configPrefix,
      ownProps: ownProps,
      compiled: compiled
    });
  }

  return {
    compiledComponentConfig: compiled,
    configAfterAuto: configAfterAuto
  };
}

function logCompilationDebugOutput(_ref4) {
  var cachedResult = _ref4.cachedResult,
      hasComponentConfigChanged = _ref4.hasComponentConfigChanged,
      configPrefix = _ref4.configPrefix,
      ownProps = _ref4.ownProps,
      compiled = _ref4.compiled;

  if (cachedResult && !hasComponentConfigChanged) {
    console.groupCollapsed("[cache] ", configPrefix ? configPrefix : "root");
  } else {
    console.groupCollapsed("[compiled] ", configPrefix ? configPrefix : "root");
  }

  console.log(ownProps);
  console.log(compiled);
  console.groupEnd();
}

function calculateWidths(compilationContext, contextProps, componentDefinition) {
  var $width = {
    $res: true
  };
  var $widthAuto = {
    $res: true
  };
  compilationContext.devices.forEach(function (device) {
    var _contextProps$$width$, _contextProps$$width, _contextProps$$widthA, _contextProps$$widthA2;

    $width[device.id] = (_contextProps$$width$ = (_contextProps$$width = contextProps.$width) === null || _contextProps$$width === void 0 ? void 0 : _contextProps$$width[device.id]) !== null && _contextProps$$width$ !== void 0 ? _contextProps$$width$ : (componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.tags.includes("section")) || (componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.tags.includes("root")) ? device.w : -1;
    $widthAuto[device.id] = (_contextProps$$widthA = (_contextProps$$widthA2 = contextProps.$widthAuto) === null || _contextProps$$widthA2 === void 0 ? void 0 : _contextProps$$widthA2[device.id]) !== null && _contextProps$$widthA !== void 0 ? _contextProps$$widthA : false;
  });
  return {
    $width: $width,
    $widthAuto: $widthAuto
  };
}

function mapResponsiveFontToResponsiveFontSize(responsiveFontValue) {
  return Object.fromEntries(index.entries(responsiveFontValue).map(function (_ref5) {
    var _ref6 = index._slicedToArray(_ref5, 2),
        breakpoint = _ref6[0],
        fontValue = _ref6[1];

    if (breakpoint === "$res") {
      return [breakpoint, fontValue];
    }

    return [breakpoint, fontValue.fontSize];
  }));
}

function resourceNormalize(x) {
  if (typeof x === "object" && x !== null) {
    if (typeof x.id === "string") {
      var normalized = {
        id: x.id
      };

      if (typeof x.info === "object") {
        normalized.info = x.info;
      }

      return normalized;
    }

    return {
      id: null
    };
  }

  return;
}

function externalGetHash(value, breakpointIndex) {
  var _value$id;

  if (index.isTrulyResponsiveValue(value)) {
    var breakpointValue = responsiveValueAt(value, breakpointIndex);

    if (breakpointValue) {
      var _breakpointValue$id;

      return (_breakpointValue$id = breakpointValue.id) !== null && _breakpointValue$id !== void 0 ? _breakpointValue$id : undefined;
    }

    return;
  }

  return (_value$id = value.id) !== null && _value$id !== void 0 ? _value$id : undefined;
}

function resolveLocalisedValue(localisedValue, compilationContext) {
  var locale = compilationContext.contextParams.locale;

  if (localisedValue[locale] !== undefined) {
    return {
      value: localisedValue[locale],
      locale: locale
    };
  }

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var fallbackLocale = getFallbackLocaleForLocale(locale, editorContext.locales);

    if (!fallbackLocale) {
      return;
    }

    return {
      value: localisedValue[fallbackLocale],
      locale: fallbackLocale
    };
  } else {
    return;
  }
}
var schemaPropDefinitions = {
  text: textProvider,
  number: function number(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, 0, function (x) {
      return typeof x === "number" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value.toString();
      }
    };
  },
  string: function string(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, "", function (x) {
      return typeof x === "string" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value;
      }
    };
  },
  string$: function string$(schemaProp, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, "", function (x) {
      return typeof x === "string" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          return responsiveValueAt(value, breakpointIndex);
        }

        return value;
      }
    };
  },
  "boolean": function boolean(schemaProp, compilationContext) {
    var normalize = getNormalize(compilationContext, schemaProp.defaultValue, false, function (x) {
      return typeof x === "boolean" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value) {
        return value.toString();
      }
    };
  },
  boolean$: function boolean$(schemaProp, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, schemaProp.defaultValue, false, function (x) {
      return typeof x === "boolean" ? x : undefined;
    });
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue === null || breakpointValue === void 0 ? void 0 : breakpointValue.toString();
        }

        return value.toString();
      }
    };
  },
  select: getSelectSchemaPropDefinition(),
  "radio-group": getSelectSchemaPropDefinition(),
  select$: getResponsiveSelectSchemaPropDefinition(),
  "radio-group$": getResponsiveSelectSchemaPropDefinition(),
  // @ts-ignore TODO: temporary, we need to fix those types
  color: function color(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$a(_objectSpread$a({}, buildThemeDefinition(compilationContext.theme.colors, "$dark", schemaProp, compilationContext, function (x) {
      if (typeof x !== "string") {
        return;
      } // right now we assume that user gives correct CSS color!


      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  stringToken: function stringToken(schemaProp, compilationContext) {
    var themeValues = compilationContext.theme[schemaProp.tokenId];

    if (!themeValues) {
      throw new Error("string token with ID \"".concat(schemaProp.tokenId, "\" doesn't have any values."));
    }

    var defaultKey;

    if (schemaProp.tokenId === "numberOfItemsInRow") {
      defaultKey = "4";
    } else if (schemaProp.tokenId === "aspectRatios") {
      defaultKey = "$landscape";
    } else if (schemaProp.tokenId === "containerWidths") {
      defaultKey = "none";
    } else {
      throw new Error("unknown token Id: " + schemaProp.tokenId);
    } // @ts-ignore


    return _objectSpread$a(_objectSpread$a({}, buildThemeDefinition(themeValues, defaultKey, schemaProp, compilationContext, function (x) {
      if (typeof x !== "string") {
        return;
      } // right now we assume that user gives correct CSS color!


      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);

          if (!breakpointValue) {
            return breakpointValue;
          }

          if (breakpointValue.ref) {
            return breakpointValue.ref;
          }

          if (index.isTrulyResponsiveValue(breakpointValue.value)) {
            var nestedBreakpointValue = responsiveValueAt(breakpointValue.value, breakpointIndex);
            return nestedBreakpointValue;
          }

          return breakpointValue.value;
        }

        if (value.ref) {
          return value.ref;
        }

        if (index.isTrulyResponsiveValue(value.value)) {
          var _breakpointValue = responsiveValueAt(value.value, breakpointIndex);

          return _breakpointValue;
        }

        return value.value;
      }
    });
  },
  // @ts-ignore TODO: temporary, we need to fix those types
  font: function font(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$a(_objectSpread$a({}, buildThemeDefinition(compilationContext.theme.fonts, "$body", schemaProp, compilationContext, function (x) {
      if (typeof x !== "object" || x === null) {
        return;
      }

      return x;
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  // @ts-ignore TODO: temporary, we need to fix those types
  space: function space(schemaProp, compilationContext) {
    // @ts-ignore
    return _objectSpread$a(_objectSpread$a({}, buildThemeDefinition(compilationContext.theme.space, schemaProp.prefix ? schemaProp.prefix + ".default" : "0", schemaProp, compilationContext, function (x) {
      if (typeof x === "number") {
        return "".concat(x, "px");
      }

      if (typeof x !== "string") {
        return;
      }

      try {
        parseSpacing(x);
        return x;
      } catch (error) {
        return;
      }
    })), {}, {
      getHash: function getHash(value, breakpointIndex) {
        if (index.isTrulyResponsiveValue(value)) {
          var breakpointValue = responsiveValueAt(value, breakpointIndex);
          return breakpointValue ? getRef(breakpointValue) : undefined;
        }

        return getRef(value);
      }
    });
  },
  icon: function icon(schemaProp, compilationContext) {
    var ultimateDefaultValue = {
      ref: "$sliderLeft",
      value: compilationContext.theme.icons["$sliderLeft"].value
    };

    var scalarValueNormalize = function scalarValueNormalize(x) {
      if (typeof x === "string" && x.trim().startsWith("<svg")) {
        return x;
      }

      return;
    };

    var defaultValue = normalizeTokenValue(schemaProp.defaultValue, compilationContext.theme.icons, ultimateDefaultValue, scalarValueNormalize) || ultimateDefaultValue;
    return {
      normalize: function normalize(x) {
        var normalized = normalizeTokenValue(x, compilationContext.theme.icons, defaultValue, scalarValueNormalize);

        if (!normalized) {
          return defaultValue;
        }

        return normalized;
      },
      compile: function compile(x) {
        return x.value;
      },
      getHash: function getHash(x) {
        return getRef(x);
      }
    };
  },
  image: function image(_, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, {}, {
      id: null
    }, resourceNormalize);
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  video: function video(_, compilationContext) {
    var normalize = getResponsiveNormalize(compilationContext, {}, {
      id: null
    }, resourceNormalize);
    return {
      normalize: normalize,
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  custom: function custom() {
    return {
      normalize: function normalize(x) {
        var normalized = resourceNormalize(x);

        if (!normalized) {
          return {
            id: null
          };
        }

        return normalized;
      },
      compile: function compile(x) {
        return x;
      },
      getHash: externalGetHash
    };
  },
  component: function component(_, compilationContext) {
    // Here:
    // 1. if non-fixed => ss-block field.
    // 2. if fixed => ss-block field with "fixed" flag (no component picker).
    var normalize = function normalize(x) {
      if (!Array.isArray(x) || x.length === 0) {
        return [];
      }

      return [normalizeComponent(x[0], compilationContext)];
    };

    return {
      normalize: normalize,
      compile: function compile(arg, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache) {
        if (arg.length === 0) {
          return [];
        }

        var _compileComponent = compileComponent(arg[0], compilationContext, contextProps, serializedDefinitions || {}, refMap, cache, editingInfoComponent, "".concat(configPrefix, ".0")),
            configAfterAuto = _compileComponent.configAfterAuto,
            compiledComponentConfig = _compileComponent.compiledComponentConfig;

        return [{
          configAfterAuto: configAfterAuto,
          compiledComponentConfig: compiledComponentConfig
        }];
      },
      getHash: function getHash(value) {
        if (value.length > 0) {

          return value[0]._template;
        }

        return "__BLOCK_EMPTY__";
      }
    };
  },
  "component-fixed": function componentFixed(schemaProp, compilationContext) {
    var normalize = function normalize(x) {
      if (!Array.isArray(x) || x.length === 0) {
        return [normalizeComponent({
          _template: schemaProp.componentType
        }, compilationContext)];
      }

      return [normalizeComponent(x[0], compilationContext)];
    };

    return {
      normalize: normalize,
      compile: function compile(arr, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache) {
        var _compileComponent2 = compileComponent(arr[0], compilationContext, contextProps, serializedDefinitions, refMap, cache, editingInfoComponent, "".concat(configPrefix, ".0")),
            configAfterAuto = _compileComponent2.configAfterAuto,
            compiledComponentConfig = _compileComponent2.compiledComponentConfig;

        return [{
          configAfterAuto: configAfterAuto,
          compiledComponentConfig: compiledComponentConfig
        }];
      },
      getHash: function getHash(value) {
        return value.map(function (v) {
          return v._template;
        }).join(";");
      }
    };
  },
  "component-collection": function componentCollection(_, compilationContext) {
    var normalize = function normalize(x) {
      if (!Array.isArray(x)) {
        return [];
      }

      var ret = (x || []).map(function (item) {
        return normalizeComponent(item, compilationContext);
      });
      return ret;
    };

    return {
      normalize: normalize,
      compile: function compile(arr, contextProps, serializedDefinitions, refMap, editingInfoComponents, configPrefix, cache) {
        // pass index here!!!
        return arr.map(function (componentConfig, index) {
          var _items;

          return compileComponent(componentConfig, compilationContext, _objectSpread$a(_objectSpread$a({}, (contextProps.itemProps || [])[index] || {}), {}, {
            index: index,
            length: arr.length
          }), serializedDefinitions, refMap, cache, editingInfoComponents === null || editingInfoComponents === void 0 ? void 0 : (_items = editingInfoComponents.items) === null || _items === void 0 ? void 0 : _items[index], "".concat(configPrefix, ".").concat(index));
        });
      },
      getHash: function getHash(value) {
        return value.map(function (v) {
          return v._template;
        }).join(";");
      }
    };
  },
  "component-collection-localised": function componentCollectionLocalised(schemaProp, compilationContext) {
    var collectionSchemaPropDefinition = schemaPropDefinitions["component-collection"](_objectSpread$a(_objectSpread$a({}, schemaProp), {}, {
      type: "component-collection"
    }), compilationContext);
    return {
      normalize: function normalize(x) {
        if (x === undefined) {
          return {};
        }

        var normalized = {};

        for (var _locale in x) {
          if (_locale === "__fallback") {
            continue;
          }

          normalized[_locale] = collectionSchemaPropDefinition.normalize(x[_locale]);
        }

        return normalized;
      },
      compile: function compile(value, contextProps, serializedDefinitions, refMap, editingInfoComponents, configPrefix, cache) {
        var _resolvedLocalisedVal, _resolvedLocalisedVal2;

        var resolvedLocalisedValue = resolveLocalisedValue(value, compilationContext);
        return collectionSchemaPropDefinition.compile((_resolvedLocalisedVal = resolvedLocalisedValue === null || resolvedLocalisedValue === void 0 ? void 0 : resolvedLocalisedValue.value) !== null && _resolvedLocalisedVal !== void 0 ? _resolvedLocalisedVal : [], contextProps, serializedDefinitions, refMap, editingInfoComponents, "".concat(configPrefix, ".").concat((_resolvedLocalisedVal2 = resolvedLocalisedValue === null || resolvedLocalisedValue === void 0 ? void 0 : resolvedLocalisedValue.locale) !== null && _resolvedLocalisedVal2 !== void 0 ? _resolvedLocalisedVal2 : compilationContext.contextParams.locale), cache);
      },
      getHash: function getHash(value, breakpoint, devices) {
        var _value$compilationCon;

        return collectionSchemaPropDefinition.getHash((_value$compilationCon = value[compilationContext.contextParams.locale]) !== null && _value$compilationCon !== void 0 ? _value$compilationCon : [], breakpoint, devices);
      }
    };
  },
  component$$$: function component$$$() {
    return {
      normalize: function normalize() {
        throw new Error("unreachable");
      },
      compile: function compile() {
        throw new Error("unreachable");
      },
      getHash: function getHash(value) {
        return value === null || value === void 0 ? void 0 : value._template;
      }
    };
  },
  resource: function resource(schemaProp) {
    return {
      normalize: function normalize(value) {
        var normalized = resourceNormalize(value);

        if (!normalized) {
          return {
            id: null
          };
        }

        return normalized;
      },
      compile: function compile(value) {
        return value;
      },
      getHash: function getHash(value) {
        if (value.id === null) {
          return "".concat(schemaProp.type, ".").concat(schemaProp.resourceType);
        }

        return "".concat(schemaProp.type, ".").concat(schemaProp.resourceType, ".").concat(value.id);
      }
    };
  }
};

function getRef(value) {
  if (value.ref) {
    return value.ref;
  }

  if (typeof value.value === "object") {
    return JSON.stringify(value.value);
  }

  var scalarVal = value.value;

  if (scalarVal.toString) {
    return scalarVal.toString();
  }

  throw new Error("unreachable");
}

function getSchemaDefinition(schemaProp, compilationContext) {
  var provider = schemaPropDefinitions[schemaProp.type] || schemaPropDefinitions.custom;
  return provider(schemaProp, compilationContext);
}
function compileFromSchema(value, schemaProp, compilationContext, cache, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix) {
  return getSchemaDefinition(schemaProp, compilationContext).compile( // @ts-expect-error //FIXME
  value, contextProps, serializedDefinitions, refMap, editingInfoComponent, configPrefix, cache);
}
function compile(configComponent, compilationContext) {
  var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new CompilationCache();

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    console.groupCollapsed("compilation");
  }

  var compilationContextWithFullTheme = _objectSpread$a(_objectSpread$a({}, compilationContext), {}, {
    theme: buildFullTheme(compilationContext.theme)
  });

  var serializedDefinitions = {
    links: [],
    actions: [],
    components: [],
    textModifiers: []
  };
  /**
   * If we're editing, we should set form.values properly (during compilation in editor we need that)
   */

  if (compilationContext.isEditing) {
    var editorContext = compilationContextWithFullTheme;
    editorContext.form = new Form({
      id: editorContext.form.id,
      label: editorContext.form.label,
      onSubmit: editorContext.form.onSubmit,
      initialValues: configComponent
    });
  }

  var compilationArtifacts = compileComponent(configComponent, compilationContextWithFullTheme, {}, serializedDefinitions, {}, cache);
  var compilationOutput = {
    compiled: compilationArtifacts.compiledComponentConfig,
    meta: {
      devices: compilationContextWithFullTheme.devices,
      image: compilationContextWithFullTheme.image,
      video: compilationContextWithFullTheme.video,
      definitions: serializedDefinitions
    }
  };

  if (!compilationContext.isEditing) {
    return compilationOutput;
  }

  if (process.env.NEXT_PUBLIC_SHOPSTORY_INTERNAL_COMPILATION_DEBUG === "true") {
    console.groupEnd();
  }

  return _objectSpread$a(_objectSpread$a({}, compilationOutput), {}, {
    configAfterAuto: compilationArtifacts.configAfterAuto
  });
}
function normalizeComponent(configComponent, compilationContext, isRef) {
  if (configComponent._template === "$ExternalBlock") {
    return configComponent;
  }

  var ret = {
    _id: configComponent._id,
    _template: configComponent._template,
    _variantGroupId: configComponent._variantGroupId,
    _audience: configComponent._audience,
    _variants: configComponent._variants,
    _master: configComponent._master,
    $$$refs: configComponent.$$$refs,
    traceId: configComponent.traceId
  }; // Normalize itemProps (before own props). If component definition is missing, we still normalize item props

  if (configComponent._itemProps) {
    ret._itemProps = {};

    var _loop2 = function _loop2(templateId) {
      ret._itemProps[templateId] = {};

      var _loop3 = function _loop3(fieldName) {
        ret._itemProps[templateId][fieldName] = {};
        var values = configComponent._itemProps[templateId][fieldName];
        var ownerDefinition = index.findComponentDefinitionById(templateId, compilationContext);
        var ownerSchemaProp = ownerDefinition.schema.find(function (x) {
          return x.prop === fieldName;
        });

        if (!ownerSchemaProp) {
          return "continue";
        }

        (ownerSchemaProp.itemFields || []).forEach(function (itemFieldSchemaProp) {
          ret._itemProps[templateId][fieldName][itemFieldSchemaProp.prop] = getSchemaDefinition(itemFieldSchemaProp, compilationContext).normalize(values[itemFieldSchemaProp.prop]);
        });
      };

      for (var fieldName in configComponent._itemProps[templateId]) {
        var _ret2 = _loop3(fieldName);

        if (_ret2 === "continue") continue;
      }
    };

    for (var templateId in configComponent._itemProps) {
      _loop2(templateId);
    }
  }

  var componentDefinition = index.findComponentDefinitionById(index.splitTemplateName(configComponent._template).name, compilationContext);

  if (!componentDefinition) {
    console.warn("[normalize] Unknown _template ".concat(configComponent._template));
    return ret;
  }

  componentDefinition.schema.forEach(function (schemaProp) {
    if (!isRef) {
      var _splitTemplateName3 = index.splitTemplateName(configComponent._template),
          ref = _splitTemplateName3.ref;

      if (ref) {
        if (!index.isResourceSchemaProp(schemaProp)) {
          return;
        }
      }
    } else {
      if (index.isResourceSchemaProp(schemaProp)) {
        return;
      }
    }

    ret[schemaProp.prop] = getSchemaDefinition(schemaProp, compilationContext).normalize(configComponent[schemaProp.prop]);
  }); // Normalize refs

  if (configComponent.$$$refs) {
    ret.$$$refs = {};

    for (var refName in configComponent.$$$refs) {
      ret.$$$refs[refName] = normalizeComponent(configComponent.$$$refs[refName], compilationContext, true);
    }
  }

  if (!ret._id) {
    ret._id = index.uniqueId();
  }

  if (!ret.traceId) {
    ret.traceId = generateDefaultTraceId(ret);
  }

  return ret;
}
function normalize(configComponent, compilationContext) {
  var compilationContextWithFullTheme = _objectSpread$a(_objectSpread$a({}, compilationContext), {}, {
    theme: buildFullTheme(compilationContext.theme)
  });

  return normalizeComponent(configComponent, compilationContextWithFullTheme);
}

function compileTextModifier(modifierValue, textParts, compilationContext, configPrefix, cache) {
  var modifierDefinition = index.findComponentDefinitionById(modifierValue._template, compilationContext);

  if (!modifierDefinition) {
    return {
      _template: "$MissingTextModifier",
      _id: index.uniqueId(),
      elements: []
    };
  }

  var compiledModifierValues = compileComponentValues(modifierValue, modifierDefinition, compilationContext, cache);
  var textPartDefinition = index.findComponentDefinitionById(richTextPartEditableComponent.id, compilationContext);

  if (!textPartDefinition) {
    throw new Error("[compile] Couldn't find a modifier definition for ".concat(richTextPartEditableComponent.id, ". "));
  }

  var compiledTextPartsValues = textParts.map(function (textPartConfig) {
    return compileComponentValues(textPartConfig, textPartDefinition, compilationContext, cache);
  });

  var compiledModifier = _objectSpread$a(_objectSpread$a({
    _template: modifierValue._template,
    _id: modifierValue._id
  }, compiledModifierValues), {}, {
    elements: compiledTextPartsValues
  });

  if (compilationContext.isEditing) {
    var editorContext = compilationContext;
    var editingInfo = buildDefaultEditingInfo(modifierDefinition, configPrefix, editorContext, compiledModifierValues, modifierValue._template);
    compiledModifier.__editing = {
      fields: editingInfo.fields
    };
  }

  return compiledModifier;
}

function createOwnComponentProps(_ref7) {
  var config = _ref7.config,
      contextProps = _ref7.contextProps,
      componentDefinition = _ref7.componentDefinition,
      compilationContext = _ref7.compilationContext,
      refMap = _ref7.refMap,
      ref = _ref7.ref;
  // Copy all values and refs defined in schema, for component fields copy only _id, _template and its _itemProps but flattened
  var values = Object.fromEntries(componentDefinition.schema.map(function (schemaProp) {
    if (index.isSchemaPropComponentOrComponentCollection(schemaProp)) {
      var configValue = config[schemaProp.prop];

      if (configValue.length === 0) {
        return [schemaProp.prop, []];
      }

      if (index.isSchemaPropComponent(schemaProp)) {
        return [schemaProp.prop, [{
          _id: configValue[0]._id,
          _template: configValue[0]._template
        }]];
      }

      if (index.isSchemaPropComponentCollectionLocalised(schemaProp)) {
        var _ref8, _resolveLocalisedValu;

        configValue = (_ref8 = (_resolveLocalisedValu = resolveLocalisedValue(config[schemaProp.prop], compilationContext)) === null || _resolveLocalisedValu === void 0 ? void 0 : _resolveLocalisedValu.value) !== null && _ref8 !== void 0 ? _ref8 : [];
      }

      var configValuesWithFlattenedItemProps = configValue.map(function (config) {
        if (schemaProp.itemFields) {
          var flattenedItemProps = flattenItemProps(config, componentDefinition, schemaProp, schemaProp.itemFields);
          return _objectSpread$a({
            _id: config._id,
            _template: config._template
          }, flattenedItemProps);
        }

        return {
          _id: config._id,
          _template: config._template
        };
      });
      return [schemaProp.prop, configValuesWithFlattenedItemProps];
    }

    return [schemaProp.prop, config[schemaProp.prop]];
  }));

  var ownValues = _objectSpread$a(_objectSpread$a({
    // Copy id and template which uniquely identify component.
    _id: config._id,
    _template: config._template
  }, values), contextProps);

  if (ref) {
    var refs = Object.fromEntries(componentDefinition.schema.filter(function (schemaProp) {
      return !index.isResourceSchemaProp(schemaProp);
    }).map(function (schemaProp) {
      return [schemaProp.prop, refMap[ref][schemaProp.prop]];
    }));
    Object.assign(ownValues, refs);
  }

  return ownValues;
}

function flattenItemProps(config, componentDefinition, collectionSchemaProp, itemsSchemas) {
  var itemProps = Object.fromEntries(itemsSchemas.map(function (itemSchemaProp) {
    return [itemSchemaProp.prop, config._itemProps[componentDefinition.id][collectionSchemaProp.prop][itemSchemaProp.prop]];
  }));
  return itemProps;
}

function extractContextPropsFromStyles(styles) {
  var contextProps = Object.fromEntries(Object.entries(styles).filter(function (_ref9) {
    var _ref10 = index._slicedToArray(_ref9, 2),
        componentStyles = _ref10[1];

    return !componentStyles.__isBox;
  }));
  return contextProps;
}

function compileRichTextValuesFromRichTextParts(richTextConfig, compilationContext, cache) {
  var mainColor = getMostCommonValueFromRichTextParts(richTextConfig, "color", compilationContext, cache);
  var mainFont = getMostCommonValueFromRichTextParts(richTextConfig, "font", compilationContext, cache);
  return {
    mainColor: mainColor,
    mainFont: mainFont
  };
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$8(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function isLocalisedContentPiece(value) {
  if (value === undefined) {
    return false;
  }

  if (Object.values(value).length === 0) {
    return false;
  }

  return Object.values(value).every(dist$2.isContentPiece);
}

function isLocalizedComponentConfig(value) {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value !== "object") {
    return false;
  }

  if (Object.values(value).length === 0) {
    return false;
  }

  return Object.values(value).every(isComponentConfig);
}

function normalizeCmsConfigInput(cmsConfig) {
  if (isLocalizedComponentConfig(cmsConfig) || isLocalisedContentPiece(cmsConfig)) {
    var rawContent = Object.fromEntries(index.entries(cmsConfig).map(function (_ref) {
      var _ref2 = index._slicedToArray(_ref, 2),
          locale = _ref2[0],
          config = _ref2[1];

      return [locale, convertInputConfigIntoRawContent(config)];
    }));
    return rawContent;
  }

  return cmsConfig;
}

function convertInputConfigIntoRawContent(config) {
  if (dist$2.isContentPiece(config)) {
    if (dist$2.isContentPieceFull(config)) {
      var rawContentFull = {
        id: config.id,
        hash: config.hash,
        content: config.config
      };
      return rawContentFull;
    }

    if (dist$2.isContentPieceLocal(config)) {
      var rawContentLocal = {
        content: config.config
      };
      return rawContentLocal;
    }

    return config;
  }

  if (isComponentConfig(config)) {
    return {
      content: config
    };
  } // At this point it's clear that we've received raw content, but overlapping with content piece makes TS stupid


  if (!dist$2.isRawContent(config)) {
    throw new Error("Unreachable");
  }

  return config;
}

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function $textStyles (configProps, t) {
  var align = configProps.align || "left";

  var fontWithDefaults = _objectSpread$9({
    fontWeight: "initial",
    fontStyle: "initial"
  }, configProps.font);

  return {
    Text: box(_objectSpread$9(_objectSpread$9({}, fontWithDefaults), {}, {
      color: configProps.color,
      textAlign: align,
      "& textarea::placeholder": {
        color: "currentColor",
        opacity: 0.5
      },
      "& textarea": _objectSpread$9(_objectSpread$9({}, fontWithDefaults), {}, {
        color: configProps.color
      }),
      border: configProps.value === "" ? "1px dotted grey" : "none"
    }), configProps.accessibilityRole)
  };
}

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var InputCss = styled.css(["box-sizing:border-box;padding:var(--tina-padding-small);border-radius:var(--tina-radius-small);background:var(--tina-color-grey-0);font-size:var(--tina-font-size-2);line-height:1.35;position:relative;color:var(--tina-color-grey-10);background-color:var(--tina-color-grey-0);transition:all 85ms ease-out;border:1px solid var(--tina-color-grey-2);width:100%;margin:0;outline:none;box-shadow:0 0 0 2px ", ";&:hover{box-shadow:0 0 0 2px var(--tina-color-grey-3);}&:focus{box-shadow:0 0 0 2px ", ";}&::placeholder{font-size:var(--tina-font-size-2);color:var(--tina-color-grey-3);}", ";"], function (p) {
  return p.error ? "var(--tina-color-error)" : "transparent";
}, function (p) {
  return p.error ? "var(--tina-color-error)" : "var(--tina-color-primary)";
}, function (p) {
  return p.small && styled.css(["font-size:var(--tina-font-size-1);padding:8px var(--tina-padding-small);"]);
});
styled__default["default"].input.withConfig({
  displayName: "Input",
  componentId: "sc-13t6aza-0"
})(["", ""], InputCss);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled__default["default"].input.withConfig({
  displayName: "TextField__BaseTextField",
  componentId: "sc-1ifgwyb-0"
})(["", ""], InputCss);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var TextArea = styled__default["default"].textarea.withConfig({
  displayName: "TextArea",
  componentId: "sc-e17qk6-0"
})(["", ";resize:vertical;height:160px;"], InputCss);

var build = {exports: {}};

(function (module, exports) {
!function (e, t) {
  t(exports, React__default["default"]) ;
}(index.commonjsGlobal, function (e, d) {

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, n = 1, o = arguments.length; n < o; n++) {
        for (var i in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function u(e) {
    var o = e.onDismiss,
        t = e.escape,
        i = void 0 !== t && t,
        n = e.click,
        r = void 0 !== n && n,
        c = e.disabled,
        a = void 0 !== c && c,
        s = e.allowClickPropagation,
        l = void 0 !== s && s,
        u = e.document,
        f = d.useRef();
    return d.useEffect(function () {
      function t(e) {
        a || f.current.contains(e.target) || (l || function (e) {
          e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault();
        }(e), o(e));
      }

      function n(e) {
        a || 27 === e.keyCode && (e.stopPropagation(), o(e));
      }

      var e = u ? [document, u] : [document];
      return r && e.forEach(function (e) {
        return e.body.addEventListener("click", t);
      }), i && e.forEach(function (e) {
        return e.addEventListener("keydown", n);
      }), function () {
        e.forEach(function (e) {
          e.body.removeEventListener("click", t), e.removeEventListener("keydown", n);
        });
      };
    }, [r, u, i, a, o]), f;
  }

  e.Dismissible = function (e) {
    var t = e.onDismiss,
        n = e.escape,
        o = e.click,
        i = e.disabled,
        r = e.allowClickPropagation,
        c = e.document,
        a = function (e, t) {
      var n = {};

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;

        for (o = Object.getOwnPropertySymbols(e); i < o.length; i++) {
          t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
        }
      }

      return n;
    }(e, ["onDismiss", "escape", "click", "disabled", "allowClickPropagation", "document"]),
        s = u({
      onDismiss: t,
      escape: n,
      click: o,
      disabled: i,
      allowClickPropagation: r,
      document: c
    });

    return d.createElement("div", _l({
      ref: s
    }, a));
  }, e.useDismissible = u, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});
}(build, build.exports));

var lib = {};

var flattenNames = {};

/** Detect free variable `global` from Node.js. */

var freeGlobal$3 = typeof index.commonjsGlobal == 'object' && index.commonjsGlobal && index.commonjsGlobal.Object === Object && index.commonjsGlobal;
var _freeGlobal = freeGlobal$3;

var freeGlobal$2 = _freeGlobal;
/** Detect free variable `self`. */


var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$a = freeGlobal$2 || freeSelf$1 || Function('return this')();
var _root = root$a;

var root$9 = _root;
/** Built-in value references. */


var Symbol$8 = root$9.Symbol;
var _Symbol = Symbol$8;

var Symbol$7 = _Symbol;
/** Used for built-in method references. */


var objectProto$u = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$p = objectProto$u.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$3 = objectProto$u.toString;
/** Built-in value references. */

var symToStringTag$3 = Symbol$7 ? Symbol$7.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag$2(value) {
  var isOwn = hasOwnProperty$p.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }

  return result;
}

var _getRawTag = getRawTag$2;

/** Used for built-in method references. */

var objectProto$t = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$2 = objectProto$t.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$2;

var Symbol$6 = _Symbol,
    getRawTag$1 = _getRawTag,
    objectToString$1 = _objectToString;
/** `Object#toString` result references. */


var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$2 = Symbol$6 ? Symbol$6.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }

  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}

var _baseGetTag = baseGetTag$8;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$d = Array.isArray;
var isArray_1 = isArray$d;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$a(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$7 = _baseGetTag,
    isArray$c = isArray_1,
    isObjectLike$9 = isObjectLike_1;
/** `Object#toString` result references. */


var stringTag$6 = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */

function isString(value) {
  return typeof value == 'string' || !isArray$c(value) && isObjectLike$9(value) && baseGetTag$7(value) == stringTag$6;
}

var isString_1 = isString;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$2(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

var _createBaseFor = createBaseFor$2;

var createBaseFor$1 = _createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */


var baseFor$3 = createBaseFor$1();
var _baseFor = baseFor$3;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes$2;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;
/** `Object#toString` result references. */


var argsTag$6 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments$2(value) {
  return isObjectLike$8(value) && baseGetTag$6(value) == argsTag$6;
}

var _baseIsArguments = baseIsArguments$2;

var baseIsArguments$1 = _baseIsArguments,
    isObjectLike$7 = isObjectLike_1;
/** Used for built-in method references. */


var objectProto$s = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$o = objectProto$s.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$3 = objectProto$s.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments$4 = baseIsArguments$1(function () {
  return arguments;
}()) ? baseIsArguments$1 : function (value) {
  return isObjectLike$7(value) && hasOwnProperty$o.call(value, 'callee') && !propertyIsEnumerable$3.call(value, 'callee');
};
var isArguments_1 = isArguments$4;

var isBuffer$5 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1 = stubFalse$1;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;
}(isBuffer$5, isBuffer$5.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength$4(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$4;

var baseGetTag$5 = _baseGetTag,
    isLength$3 = isLength_1,
    isObjectLike$6 = isObjectLike_1;
/** `Object#toString` result references. */


var argsTag$5 = '[object Arguments]',
    arrayTag$4 = '[object Array]',
    boolTag$5 = '[object Boolean]',
    dateTag$5 = '[object Date]',
    errorTag$4 = '[object Error]',
    funcTag$4 = '[object Function]',
    mapTag$8 = '[object Map]',
    numberTag$5 = '[object Number]',
    objectTag$8 = '[object Object]',
    regexpTag$5 = '[object RegExp]',
    setTag$8 = '[object Set]',
    stringTag$5 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';
var arrayBufferTag$5 = '[object ArrayBuffer]',
    dataViewTag$7 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$4] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$5] = typedArrayTags$1[weakMapTag$4] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray$2(value) {
  return isObjectLike$6(value) && isLength$3(value.length) && !!typedArrayTags$1[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$2;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray$1 = _baseIsTypedArray,
    baseUnary$3 = _baseUnary,
    nodeUtil$4 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsTypedArray$1 = nodeUtil$4 && nodeUtil$4.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray$4 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray_1 = isTypedArray$4;

var baseTimes$1 = _baseTimes,
    isArguments$3 = isArguments_1,
    isArray$b = isArray_1,
    isBuffer$4 = isBuffer$5.exports,
    isIndex$2 = _isIndex,
    isTypedArray$3 = isTypedArray_1;
/** Used for built-in method references. */


var objectProto$r = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$n = objectProto$r.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys$3(value, inherited) {
  var isArr = isArray$b(value),
      isArg = !isArr && isArguments$3(value),
      isBuff = !isArr && !isArg && isBuffer$4(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$1(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$n.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$2(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys$3;

/** Used for built-in method references. */

var objectProto$q = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$q;
  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$3(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$3;

var overArg$2 = _overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys$3 = overArg$2(Object.keys, Object);
var _nativeKeys = nativeKeys$3;

var isPrototype$3 = _isPrototype,
    nativeKeys$2 = _nativeKeys;
/** Used for built-in method references. */


var objectProto$p = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$m = objectProto$p.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys$2(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$m.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys$2;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$7;

var baseGetTag$4 = _baseGetTag,
    isObject$6 = isObject_1;
/** `Object#toString` result references. */


var asyncTag$1 = '[object AsyncFunction]',
    funcTag$3 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$3(value) {
  if (!isObject$6(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag$4(value);
  return tag == funcTag$3 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$3;

var isFunction$2 = isFunction_1,
    isLength$2 = isLength_1;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike$5(value) {
  return value != null && isLength$2(value.length) && !isFunction$2(value);
}

var isArrayLike_1 = isArrayLike$5;

var arrayLikeKeys$2 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$4 = isArrayLike_1;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys$7(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$2(object) : baseKeys$1(object);
}

var keys_1 = keys$7;

var baseFor$2 = _baseFor,
    keys$6 = keys_1;
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */


function baseForOwn$3(object, iteratee) {
  return object && baseFor$2(object, iteratee, keys$6);
}

var _baseForOwn = baseForOwn$3;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$3(value) {
  return value;
}

var identity_1 = identity$3;

var identity$2 = identity_1;
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */


function castFunction$2(value) {
  return typeof value == 'function' ? value : identity$2;
}

var _castFunction = castFunction$2;

var baseForOwn$2 = _baseForOwn,
    castFunction$1 = _castFunction;
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */


function forOwn(object, iteratee) {
  return object && baseForOwn$2(object, castFunction$1(iteratee));
}

var forOwn_1 = forOwn;

var overArg$1 = _overArg;
/** Built-in value references. */


var getPrototype$5 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$5;

var baseGetTag$3 = _baseGetTag,
    getPrototype$4 = _getPrototype,
    isObjectLike$5 = isObjectLike_1;
/** `Object#toString` result references. */


var objectTag$7 = '[object Object]';
/** Used for built-in method references. */

var funcProto$5 = Function.prototype,
    objectProto$o = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$5 = funcProto$5.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$l = objectProto$o.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString$1 = funcToString$5.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject$1(value) {
  if (!isObjectLike$5(value) || baseGetTag$3(value) != objectTag$7) {
    return false;
  }

  var proto = getPrototype$4(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$l.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$5.call(Ctor) == objectCtorString$1;
}

var isPlainObject_1 = isPlainObject$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap$3;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$4(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq$4;

var eq$3 = eq_1;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf$5(array, key) {
  var length = array.length;

  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;
/** Used for built-in method references. */


var arrayProto$1 = Array.prototype;
/** Built-in value references. */

var splice$1 = arrayProto$1.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;
var _ListCache = ListCache$5;

var ListCache$4 = _ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */


function stackClear$2() {
  this.__data__ = new ListCache$4();
  this.size = 0;
}

var _stackClear = stackClear$2;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$2;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$2(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$2;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$2(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$2;

var root$8 = _root;
/** Used to detect overreaching core-js shims. */


var coreJsData$3 = root$8['__core-js_shared__'];
var _coreJsData = coreJsData$3;

var coreJsData$2 = _coreJsData;
/** Used to detect methods masquerading as native. */


var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked$2(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

var _isMasked = isMasked$2;

/** Used for built-in method references. */

var funcProto$4 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$4 = funcProto$4.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource$3;

var isFunction$1 = isFunction_1,
    isMasked$1 = _isMasked,
    isObject$5 = isObject_1,
    toSource$2 = _toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$3 = Function.prototype,
    objectProto$n = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$3 = funcProto$3.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$k = objectProto$n.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative$1 = RegExp('^' + funcToString$3.call(hasOwnProperty$k).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative$2(value) {
  if (!isObject$5(value) || isMasked$1(value)) {
    return false;
  }

  var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}

var _baseIsNative = baseIsNative$2;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$3(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$3;

var baseIsNative$1 = _baseIsNative,
    getValue$2 = _getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative$8(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

var _getNative = getNative$8;

var getNative$7 = _getNative,
    root$7 = _root;
/* Built-in method references that are verified to be native. */


var Map$6 = getNative$7(root$7, 'Map');
var _Map = Map$6;

var getNative$6 = _getNative;
/* Built-in method references that are verified to be native. */


var nativeCreate$6 = getNative$6(Object, 'create');
var _nativeCreate = nativeCreate$6;

var nativeCreate$5 = _nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$2;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$2;

var nativeCreate$4 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$m = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$j = objectProto$m.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet$2(key) {
  var data = this.__data__;

  if (nativeCreate$4) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? undefined : result;
  }

  return hasOwnProperty$j.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$2;

var nativeCreate$3 = _nativeCreate;
/** Used for built-in method references. */


var objectProto$l = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$i = objectProto$l.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$3 ? data[key] !== undefined : hasOwnProperty$i.call(data, key);
}

var _hashHas = hashHas$2;

var nativeCreate$2 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$2 && value === undefined ? HASH_UNDEFINED$4 : value;
  return this;
}

var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;
var _Hash = Hash$2;

var Hash$1 = _Hash,
    ListCache$3 = _ListCache,
    Map$5 = _Map;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1(),
    'map': new (Map$5 || ListCache$3)(),
    'string': new Hash$1()
  };
}

var _mapCacheClear = mapCacheClear$2;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$2(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$4;

var ListCache$2 = _ListCache,
    Map$4 = _Map,
    MapCache$3 = _MapCache;
/** Used as the size to enable large array optimizations. */


var LARGE_ARRAY_SIZE$1 = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet$2(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache$2) {
    var pairs = data.__data__;

    if (!Map$4 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache$3(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$2;

var ListCache$1 = _ListCache,
    stackClear$1 = _stackClear,
    stackDelete$1 = _stackDelete,
    stackGet$1 = _stackGet,
    stackHas$1 = _stackHas,
    stackSet$1 = _stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Stack$4(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack$4.prototype.clear = stackClear$1;
Stack$4.prototype['delete'] = stackDelete$1;
Stack$4.prototype.get = stackGet$1;
Stack$4.prototype.has = stackHas$1;
Stack$4.prototype.set = stackSet$1;
var _Stack = Stack$4;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);

  return this;
}

var _setCacheAdd = setCacheAdd$2;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$2(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$2;

var MapCache$2 = _MapCache,
    setCacheAdd$1 = _setCacheAdd,
    setCacheHas$1 = _setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */


function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$2();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;
var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome$1 = _arraySome,
    cacheHas$1 = _cacheHas;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$b = 1,
    COMPARE_UNORDERED_FLAG$7 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays$3(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$7 ? new SetCache$1() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome$1(other, function (othValue, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$3;

var root$6 = _root;
/** Built-in value references. */


var Uint8Array$4 = root$6.Uint8Array;
var _Uint8Array = Uint8Array$4;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$2(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$2;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$2(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$2;

var Symbol$5 = _Symbol,
    Uint8Array$3 = _Uint8Array,
    eq$2 = eq_1,
    equalArrays$2 = _equalArrays,
    mapToArray$1 = _mapToArray,
    setToArray$1 = _setToArray;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$a = 1,
    COMPARE_UNORDERED_FLAG$6 = 2;
/** `Object#toString` result references. */

var boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$5 = '[object Symbol]';
var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto$4 = Symbol$5 ? Symbol$5.prototype : undefined,
    symbolValueOf$2 = symbolProto$4 ? symbolProto$4.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag$2(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$6:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$4:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$3(object), new Uint8Array$3(other))) {
        return false;
      }

      return true;

    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$2(+object, +other);

    case errorTag$3:
      return object.name == other.name && object.message == other.message;

    case regexpTag$4:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$7:
      var convert = mapToArray$1;

    case setTag$7:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      convert || (convert = setToArray$1);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$6; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays$2(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$5:
      if (symbolValueOf$2) {
        return symbolValueOf$2.call(object) == symbolValueOf$2.call(other);
      }

  }

  return false;
}

var _equalByTag = equalByTag$2;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush$3;

var arrayPush$2 = _arrayPush,
    isArray$a = isArray_1;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */


function baseGetAllKeys$3(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$a(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$3;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$3() {
  return [];
}

var stubArray_1 = stubArray$3;

var arrayFilter$1 = _arrayFilter,
    stubArray$2 = stubArray_1;
/** Used for built-in method references. */


var objectProto$k = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$2 = objectProto$k.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols$5 = !nativeGetSymbols$2 ? stubArray$2 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$2(object), function (symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};
var _getSymbols = getSymbols$5;

var baseGetAllKeys$2 = _baseGetAllKeys,
    getSymbols$4 = _getSymbols,
    keys$5 = keys_1;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeys$3(object) {
  return baseGetAllKeys$2(object, keys$5, getSymbols$4);
}

var _getAllKeys = getAllKeys$3;

var getAllKeys$2 = _getAllKeys;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$9 = 1;
/** Used for built-in method references. */

var objectProto$j = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$h = objectProto$j.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects$2(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9,
      objProps = getAllKeys$2(object),
      objLength = objProps.length,
      othProps = getAllKeys$2(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$h.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$2;

var getNative$5 = _getNative,
    root$5 = _root;
/* Built-in method references that are verified to be native. */


var DataView$3 = getNative$5(root$5, 'DataView');
var _DataView = DataView$3;

var getNative$4 = _getNative,
    root$4 = _root;
/* Built-in method references that are verified to be native. */


var Promise$4 = getNative$4(root$4, 'Promise');
var _Promise = Promise$4;

var getNative$3 = _getNative,
    root$3 = _root;
/* Built-in method references that are verified to be native. */


var Set$4 = getNative$3(root$3, 'Set');
var _Set = Set$4;

var getNative$2 = _getNative,
    root$2 = _root;
/* Built-in method references that are verified to be native. */


var WeakMap$4 = getNative$2(root$2, 'WeakMap');
var _WeakMap = WeakMap$4;

var DataView$2 = _DataView,
    Map$3 = _Map,
    Promise$3 = _Promise,
    Set$3 = _Set,
    WeakMap$3 = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource$1 = _toSource;
/** `Object#toString` result references. */


var mapTag$6 = '[object Map]',
    objectTag$6 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';
var dataViewTag$5 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString$1 = toSource$1(DataView$2),
    mapCtorString$1 = toSource$1(Map$3),
    promiseCtorString$1 = toSource$1(Promise$3),
    setCtorString$1 = toSource$1(Set$3),
    weakMapCtorString$1 = toSource$1(WeakMap$3);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag$6 = baseGetTag$2; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$2 && getTag$6(new DataView$2(new ArrayBuffer(1))) != dataViewTag$5 || Map$3 && getTag$6(new Map$3()) != mapTag$6 || Promise$3 && getTag$6(Promise$3.resolve()) != promiseTag$1 || Set$3 && getTag$6(new Set$3()) != setTag$6 || WeakMap$3 && getTag$6(new WeakMap$3()) != weakMapTag$3) {
  getTag$6 = function getTag(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$6 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$5;

        case mapCtorString$1:
          return mapTag$6;

        case promiseCtorString$1:
          return promiseTag$1;

        case setCtorString$1:
          return setTag$6;

        case weakMapCtorString$1:
          return weakMapTag$3;
      }
    }

    return result;
  };
}

var _getTag = getTag$6;

var Stack$3 = _Stack,
    equalArrays$1 = _equalArrays,
    equalByTag$1 = _equalByTag,
    equalObjects$1 = _equalObjects,
    getTag$5 = _getTag,
    isArray$9 = isArray_1,
    isBuffer$3 = isBuffer$5.exports,
    isTypedArray$2 = isTypedArray_1;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$8 = 1;
/** `Object#toString` result references. */

var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    objectTag$5 = '[object Object]';
/** Used for built-in method references. */

var objectProto$i = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$g = objectProto$i.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep$2(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$9(object),
      othIsArr = isArray$9(other),
      objTag = objIsArr ? arrayTag$3 : getTag$5(object),
      othTag = othIsArr ? arrayTag$3 : getTag$5(other);
  objTag = objTag == argsTag$4 ? objectTag$5 : objTag;
  othTag = othTag == argsTag$4 ? objectTag$5 : othTag;
  var objIsObj = objTag == objectTag$5,
      othIsObj = othTag == objectTag$5,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$3(object)) {
    if (!isBuffer$3(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3());
    return objIsArr || isTypedArray$2(object) ? equalArrays$1(object, other, bitmask, customizer, equalFunc, stack) : equalByTag$1(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$g.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$g.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack$3());
  return equalObjects$1(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$2;

var baseIsEqualDeep$1 = _baseIsEqualDeep,
    isObjectLike$4 = isObjectLike_1;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */


function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike$4(value) && !isObjectLike$4(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack$2 = _Stack,
    baseIsEqual$2 = _baseIsEqual;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$7 = 1,
    COMPARE_UNORDERED_FLAG$5 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch$2(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

var _baseIsMatch = baseIsMatch$2;

var isObject$4 = isObject_1;
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */


function isStrictComparable$3(value) {
  return value === value && !isObject$4(value);
}

var _isStrictComparable = isStrictComparable$3;

var isStrictComparable$2 = _isStrictComparable,
    keys$4 = keys_1;
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */


function getMatchData$2(object) {
  var result = keys$4(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable$2(value)];
  }

  return result;
}

var _getMatchData = getMatchData$2;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$3(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

var _matchesStrictComparable = matchesStrictComparable$3;

var baseIsMatch$1 = _baseIsMatch,
    getMatchData$1 = _getMatchData,
    matchesStrictComparable$2 = _matchesStrictComparable;
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */


function baseMatches$2(source) {
  var matchData = getMatchData$1(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$2(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch$1(object, source, matchData);
  };
}

var _baseMatches = baseMatches$2;

var baseGetTag$1 = _baseGetTag,
    isObjectLike$3 = isObjectLike_1;
/** `Object#toString` result references. */


var symbolTag$4 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$4(value) {
  return typeof value == 'symbol' || isObjectLike$3(value) && baseGetTag$1(value) == symbolTag$4;
}

var isSymbol_1 = isSymbol$4;

var isArray$8 = isArray_1,
    isSymbol$3 = isSymbol_1;
/** Used to match property names within property paths. */


var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey$4(value, object) {
  if (isArray$8(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$3(value)) {
    return true;
  }

  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}

var _isKey = isKey$4;

var MapCache$1 = _MapCache;
/** Error message constants. */


var FUNC_ERROR_TEXT$3 = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize$2(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize$2.Cache || MapCache$1)();
  return memoized;
} // Expose `MapCache`.


memoize$2.Cache = MapCache$1;
var memoize_1 = memoize$2;

var memoize$1 = memoize_1;
/** Used as the maximum memoize cache size. */


var MAX_MEMOIZE_SIZE$1 = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped$2(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$2;

var memoizeCapped$1 = _memoizeCapped;
/** Used to match property names within property paths. */


var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar$1 = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath$3 = memoizeCapped$1(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$3;

var Symbol$4 = _Symbol,
    arrayMap$2 = _arrayMap,
    isArray$7 = isArray_1,
    isSymbol$2 = isSymbol_1;
/** Used as references for various `Number` constants. */


var INFINITY$3 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$3 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$7(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$2) + '';
  }

  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$2;

var isArray$6 = isArray_1,
    isKey$3 = _isKey,
    stringToPath$2 = _stringToPath,
    toString$1 = toString_1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */


function castPath$3(value, object) {
  if (isArray$6(value)) {
    return value;
  }

  return isKey$3(value, object) ? [value] : stringToPath$2(toString$1(value));
}

var _castPath = castPath$3;

var isSymbol$1 = isSymbol_1;
/** Used as references for various `Number` constants. */


var INFINITY$2 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$2 = _castPath,
    toKey$4 = _toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */


function baseGet$3(object, path) {
  path = castPath$2(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */


function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$3;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$2(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$2;

var castPath$1 = _castPath,
    isArguments$2 = isArguments_1,
    isArray$5 = isArray_1,
    isIndex$1 = _isIndex,
    isLength$1 = isLength_1,
    toKey$3 = _toKey;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */


function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) && (isArray$5(object) || isArguments$2(object));
}

var _hasPath = hasPath$2;

var baseHasIn$1 = _baseHasIn,
    hasPath$1 = _hasPath;
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */


function hasIn$2(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

var hasIn_1 = hasIn$2;

var baseIsEqual$1 = _baseIsEqual,
    get$2 = get_1,
    hasIn$1 = hasIn_1,
    isKey$2 = _isKey,
    isStrictComparable$1 = _isStrictComparable,
    matchesStrictComparable$1 = _matchesStrictComparable,
    toKey$2 = _toKey;
/** Used to compose bitmasks for value comparisons. */


var COMPARE_PARTIAL_FLAG$6 = 1,
    COMPARE_UNORDERED_FLAG$4 = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty$2(path, srcValue) {
  if (isKey$2(path) && isStrictComparable$1(srcValue)) {
    return matchesStrictComparable$1(toKey$2(path), srcValue);
  }

  return function (object) {
    var objValue = get$2(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn$1(object, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}

var _baseMatchesProperty = baseMatchesProperty$2;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$2(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$2;

var baseGet$1 = _baseGet;
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyDeep$2(path) {
  return function (object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$2;

var baseProperty$1 = _baseProperty,
    basePropertyDeep$1 = _basePropertyDeep,
    isKey$1 = _isKey,
    toKey$1 = _toKey;
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */


function property$2(path) {
  return isKey$1(path) ? baseProperty$1(toKey$1(path)) : basePropertyDeep$1(path);
}

var property_1 = property$2;

var baseMatches$1 = _baseMatches,
    baseMatchesProperty$1 = _baseMatchesProperty,
    identity$1 = identity_1,
    isArray$4 = isArray_1,
    property$1 = property_1;
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */


function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity$1;
  }

  if (typeof value == 'object') {
    return isArray$4(value) ? baseMatchesProperty$1(value[0], value[1]) : baseMatches$1(value);
  }

  return property$1(value);
}

var _baseIteratee = baseIteratee$2;

var isArrayLike$3 = isArrayLike_1;
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */


function createBaseEach$2(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike$3(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

var _createBaseEach = createBaseEach$2;

var baseForOwn$1 = _baseForOwn,
    createBaseEach$1 = _createBaseEach;
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */


var baseEach$3 = createBaseEach$1(baseForOwn$1);
var _baseEach = baseEach$3;

var baseEach$2 = _baseEach,
    isArrayLike$2 = isArrayLike_1;
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$2(collection) ? Array(collection.length) : [];
  baseEach$2(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

var arrayMap$1 = _arrayMap,
    baseIteratee$1 = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$3 = isArray_1;
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */


function map$1(collection, iteratee) {
  var func = isArray$3(collection) ? arrayMap$1 : baseMap$1;
  return func(collection, baseIteratee$1(iteratee));
}

var map_1 = map$1;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = isString_1;

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = isPlainObject_1;

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = map_1;

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var names = [];
  (0, _map3["default"])(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3["default"])(thing)) {
      (0, _forOwn3["default"])(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3["default"])(thing)) {
      names.push(thing);
    }
  });
  return names;
};

exports["default"] = flattenNames;
}(flattenNames));

var mergeClasses = {};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach$2;

var getNative$1 = _getNative;

var defineProperty$3 = function () {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty$3 = defineProperty$3;

var defineProperty$2 = _defineProperty$3;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */


function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
    eq$1 = eq_1;
/** Used for built-in method references. */


var objectProto$h = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$f = objectProto$h.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue$3(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$f.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    baseAssignValue$1 = _baseAssignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */


function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$2(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
    keys$3 = keys_1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$3(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$2(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn$2;

var isObject$3 = isObject_1,
    isPrototype$2 = _isPrototype,
    nativeKeysIn$1 = _nativeKeysIn;
/** Used for built-in method references. */


var objectProto$g = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$e = objectProto$g.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn$2(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn$1(object);
  }

  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$e.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeysIn$1 = _baseKeysIn,
    isArrayLike$1 = isArrayLike_1;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */


function keysIn$4(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

var keysIn_1 = keysIn$4;

var copyObject$3 = _copyObject,
    keysIn$3 = keysIn_1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$3(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;
/** Detect free variable `exports`. */


var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray$2;

var copyObject$2 = _copyObject,
    getSymbols$3 = _getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */


function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$3(source), object);
}

var _copySymbols = copySymbols$1;

var arrayPush$1 = _arrayPush,
    getPrototype$3 = _getPrototype,
    getSymbols$2 = _getSymbols,
    stubArray$1 = stubArray_1;
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn$2 = !nativeGetSymbols$1 ? stubArray$1 : function (object) {
  var result = [];

  while (object) {
    arrayPush$1(result, getSymbols$2(object));
    object = getPrototype$3(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn$2;

var copyObject$1 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */


function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$2 = keysIn_1;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$2, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */

var objectProto$f = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$d = objectProto$f.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$d.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$2 = _Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */


function cloneArrayBuffer$4(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$4;

var cloneArrayBuffer$3 = _cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */


function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$3(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$3 = _Symbol;
/** Used to convert symbols to primitives and strings. */


var symbolProto$2 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$2 = _cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */


function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;

var cloneArrayBuffer$1 = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray$1 = _cloneTypedArray;
/** `Object#toString` result references. */


var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(object);

    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);

    case dataViewTag$4:
      return cloneDataView(object, isDeep);

    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray$1(object, isDeep);

    case mapTag$5:
      return new Ctor();

    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$3:
      return cloneRegExp(object);

    case setTag$5:
      return new Ctor();

    case symbolTag$3:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$2 = isObject_1;
/** Built-in value references. */


var objectCreate$1 = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate$3 = function () {
  function object() {}

  return function (proto) {
    if (!isObject$2(proto)) {
      return {};
    }

    if (objectCreate$1) {
      return objectCreate$1(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate$3;

var baseCreate$2 = _baseCreate,
    getPrototype$2 = _getPrototype,
    isPrototype$1 = _isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */


function initCloneObject$2(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate$2(getPrototype$2(object)) : {};
}

var _initCloneObject = initCloneObject$2;

var getTag$4 = _getTag,
    isObjectLike$2 = isObjectLike_1;
/** `Object#toString` result references. */


var mapTag$4 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap$1(value) {
  return isObjectLike$2(value) && getTag$4(value) == mapTag$4;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$2 = _baseUnary,
    nodeUtil$3 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsMap = nodeUtil$3 && nodeUtil$3.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;

var getTag$3 = _getTag,
    isObjectLike$1 = isObjectLike_1;
/** `Object#toString` result references. */


var setTag$4 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet$1(value) {
  return isObjectLike$1(value) && getTag$3(value) == setTag$4;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$1 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;
/* Node.js helper references. */


var nodeIsSet = nodeUtil$2 && nodeUtil$2.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;

var Stack$1 = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue$1 = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer$1 = _cloneBuffer.exports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$2 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject$1 = _initCloneObject,
    isArray$2 = isArray_1,
    isBuffer$2 = isBuffer$5.exports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys$2 = keys_1,
    keysIn$1 = keysIn_1;
/** Used to compose bitmasks for cloning. */


var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/** `Object#toString` result references. */

var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$4] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$1(value)) {
    return value;
  }

  var isArr = isArray$2(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$2(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer$2(value)) {
      return cloneBuffer$1(value, isDeep);
    }

    if (tag == objectTag$4 || tag == argsTag$3 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject$1(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack$1());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn$1 : keys$2;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue$1(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;
/** Used to compose bitmasks for cloning. */


var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = cloneDeep_1;

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var styles = classes["default"] && (0, _cloneDeep3["default"])(classes["default"]) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];

    if (toMerge) {
      (0, _forOwn3["default"])(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports["default"] = mergeClasses;
}(mergeClasses));

var autoprefix = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },
  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },
  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },
  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];

    if (otherStyle) {
      return otherStyle;
    }

    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3["default"])(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3["default"])(styles, function (value, key) {
      var transform = transforms[key];

      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports["default"] = autoprefix;
}(autoprefix));

var hover = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = React__default["default"];

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        hover: false
      }, _this.handleMouseOver = function () {
        return _this.setState({
          hover: true
        });
      }, _this.handleMouseOut = function () {
        return _this.setState({
          hover: false
        });
      }, _this.render = function () {
        return _react2["default"].createElement(Span, {
          onMouseOver: _this.handleMouseOver,
          onMouseOut: _this.handleMouseOut
        }, _react2["default"].createElement(Component, _extends({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2["default"].Component);
};

exports["default"] = hover;
}(hover));

var active = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = React__default["default"];

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this.handleMouseDown = function () {
        return _this.setState({
          active: true
        });
      }, _this.handleMouseUp = function () {
        return _this.setState({
          active: false
        });
      }, _this.render = function () {
        return _react2["default"].createElement(Span, {
          onMouseDown: _this.handleMouseDown,
          onMouseUp: _this.handleMouseUp
        }, _react2["default"].createElement(Component, _extends({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2["default"].Component);
};

exports["default"] = active;
}(active));

var loop = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var loopable = function loopable(i, length) {
  var props = {};

  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);
  return props;
};

exports["default"] = loopable;
}(loop));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = flattenNames;

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = mergeClasses;

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = autoprefix;

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = hover;

var _hover3 = _interopRequireDefault(_hover2);

var _active = active;

var _active2 = _interopRequireDefault(_active);

var _loop2 = loop;

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports.hover = _hover3["default"];
exports.handleHover = _hover3["default"];
exports.handleActive = _active2["default"];
exports.loop = _loop3["default"];

var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2["default"])(activations);
  var merged = (0, _mergeClasses2["default"])(classes, activeNames);
  return (0, _autoprefix2["default"])(merged);
};

exports["default"] = ReactCSS;
}(lib));

var reactCSS = /*@__PURE__*/index.getDefaultExportFromCjs(lib);

var calculateChange$2 = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;

    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;

    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }

  return null;
};

var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }

  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');

  if (!ctx) {
    return null;
  } // If no context can be found, return early.


  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};
var get$1 = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;
  var styles = reactCSS({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + get$1(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return /*#__PURE__*/React.isValidElement(children) ? /*#__PURE__*/React__default["default"].cloneElement(children, _extends$8({}, children.props, {
    style: _extends$8({}, children.props.style, styles.grid)
  })) : /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.grid
  });
};
Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$7 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$7(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function (_ref) {
  _inherits$7(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$7(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$7(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$2(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$7(_this, _ret);
  }

  _createClass$7(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = reactCSS({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends$7({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });
      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.alpha
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.checkboard
      }, /*#__PURE__*/React__default["default"].createElement(Checkboard, {
        renderers: this.props.renderers
      })), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.gradient
      }), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.container,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React__default["default"].createElement(this.props.pointer, this.props) : /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.slider
      }))));
    }
  }]);

  return Alpha;
}(React.PureComponent || React.Component);

var _createClass$6 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];

var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};

var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;
var EditableInput = function (_ref) {
  _inherits$6(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck$6(this, EditableInput);

    var _this = _possibleConstructorReturn$6(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({
          value: _this.state.blurValue,
          blurValue: null
        });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);

      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();

        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);

        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();

        _this.handleDrag(e);

        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass$6(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({
            blurValue: String(this.props.value).toUpperCase()
          });
        } else {
          this.setState({
            value: String(this.props.value).toUpperCase(),
            blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$2({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);
      this.setState({
        value: value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = reactCSS({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);
      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.wrap
      }, /*#__PURE__*/React__default["default"].createElement('input', {
        id: this.inputId,
        style: styles.input,
        ref: function ref(input) {
          return _this2.input = input;
        },
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        placeholder: this.props.placeholder,
        spellCheck: 'false'
      }), this.props.label && !this.props.hideLabel ? /*#__PURE__*/React__default["default"].createElement('label', {
        htmlFor: this.inputId,
        style: styles.label,
        onMouseDown: this.handleMouseDown
      }, this.props.label) : null);
    }
  }]);

  return EditableInput;
}(React.PureComponent || React.Component);

var calculateChange$1 = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;

    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;

    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;

      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }

  return null;
};

var _createClass$5 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function (_ref) {
  _inherits$5(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$5(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$5(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$1(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$5(_this, _ret);
  }

  _createClass$5(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
      var styles = reactCSS({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, {
        vertical: direction === 'vertical'
      });
      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.hue
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        className: 'hue-' + direction,
        style: styles.container,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React__default["default"].createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React__default["default"].createElement(this.props.pointer, this.props) : /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.slider
      }))));
    }
  }]);

  return Hue;
}(React.PureComponent || React.Component);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */

var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

/** Used for built-in method references. */

var objectProto$e = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$c = objectProto$e.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$e.toString;
/** Built-in value references. */

var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$d.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */

var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$c = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$b = objectProto$c.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$b).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */

var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;

/* Built-in method references that are verified to be native. */

var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$b.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }

  return hasOwnProperty$a.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$9.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/** Detect free variable `exports`. */

var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/** Built-in value references. */

var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/** Built-in value references. */

var Uint8Array = root$1.Uint8Array;
var Uint8Array$1 = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var baseCreate$1 = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */

var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9;
  return value === proto;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */

var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Built-in value references. */

var Buffer = moduleExports$1 ? root$1.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** `Object#toString` result references. */

var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$7 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = getPrototype$1(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$7.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */

var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal$1.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$6.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$6.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$5.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */

function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$1(srcValue),
        isBuff = !isArr && isBuffer$1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;

      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  baseFor$1(source, function (srcValue, key) {
    stack || (stack = new Stack());

    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$1 = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest(func, start) {
  return setToString$1(overRest(func, start, identity), func + '');
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */

function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }

  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */

function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */

var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
var merge$1 = merge;

var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;
  var styles = reactCSS(merge$1({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },
    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), {
    'zDepth-1': zDepth === 1
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.wrap
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.bg
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.content
  }, children));
};
Raised.propTypes = {
  background: index.PropTypes.string,
  zDepth: index.PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: index.PropTypes.number,
  styles: index.PropTypes.object
};
Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return root$1.Date.now();
};

var now$1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}

/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Error message constants. */

var FUNC_ERROR_TEXT$2 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }

  wait = toNumber(wait) || 0;

  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now$1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/** Error message constants. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */

function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;
  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

var _createClass$4 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$4(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function (_ref) {
  _inherits$4(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck$4(this, Saturation);

    var _this = _possibleConstructorReturn$4(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);

      var renderWindow = _this.getContainerRenderWindow();

      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = throttle(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass$4(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;
      var renderWindow = window;

      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }

      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = reactCSS({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, {
        'custom': !!this.props.style
      });
      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.color,
        ref: function ref(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /*#__PURE__*/React__default["default"].createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.white,
        className: 'saturation-white'
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.black,
        className: 'saturation-black'
      }), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.pointer
      }, this.props.pointer ? /*#__PURE__*/React__default["default"].createElement(this.props.pointer, this.props) : /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.circle
      }))));
    }
  }]);

  return Saturation;
}(React.PureComponent || React.Component);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */

function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$1);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }

    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }

    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }

    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */

var baseEach = createBaseEach(baseForOwn);
var baseEach$1 = baseEach;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */

function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */

function forEach(collection, iteratee) {
  var func = isArray$1(collection) ? arrayEach : baseEach$1;
  return func(collection, castFunction(iteratee));
}

// This file is autogenerated. It's used to publish ESM to npm.
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var trimLeft = /^\s+/;
var trimRight = /\s+$/;

function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {}; // If input is already a tinycolor, return itself

  if (color instanceof tinycolor) {
    return color;
  } // If we are called as a function, call using new instead


  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }

  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType; // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`

  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}

tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex$1(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }

    if (this._a < 1) {
      return false;
    }

    return hexNames[rgbToHex$1(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";

    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }

    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }

      return this.toRgbString();
    }

    if (format === "rgb") {
      formattedString = this.toRgbString();
    }

    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }

    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }

    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }

    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }

    if (format === "hex8") {
      formattedString = this.toHex8String();
    }

    if (format === "name") {
      formattedString = this.toName();
    }

    if (format === "hsl") {
      formattedString = this.toHslString();
    }

    if (format === "hsv") {
      formattedString = this.toHsvString();
    }

    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
}; // If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1

tinycolor.fromRatio = function (color, opts) {
  if (typeof color == "object") {
    var newColor = {};

    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }

    color = newColor;
  }

  return tinycolor(color, opts);
}; // Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//


function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;

  if (typeof color == "string") {
    color = stringInputToObject(color);
  }

  if (typeof color == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }

    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }

  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
} // Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]


function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
} // `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]


function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h,
      s,
      l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    l: l
  };
} // `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]


function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
} // `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]


function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h,
      s,
      v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;

  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h,
    s: s,
    v: v
  };
} // `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]


function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
} // `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex


function rgbToHex$1(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))]; // Return a 3 character hex if possible

  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }

  return hex.join("");
} // `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex


function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))]; // Return a 4 character hex if possible

  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }

  return hex.join("");
} // `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"


function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
} // `equals`
// Can be called with any tinycolor input


tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
}; // Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>


function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}

function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}

function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}

function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}

function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
} // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.


function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
} // Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>


function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}

function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }

  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;

  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }

  return result;
}

function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}

function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];

  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }

  return ret;
}

function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
  var ret = [];
  var modification = 1 / results;

  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }

  return ret;
} // Utility Functions
// ---------------------


tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
}; // Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)


tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
}; // `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false


tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);

  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;

    case "AAlarge":
      out = readability >= 3;
      break;

    case "AAAsmall":
      out = readability >= 7;
      break;
  }

  return out;
}; // `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"


tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;

  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);

    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }

  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
}; // Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>


var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}; // Make it easy to access colors via `hexNames[hex]`

var hexNames = tinycolor.hexNames = flip(names); // Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`

function flip(o) {
  var flipped = {};

  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }

  return flipped;
} // Return a valid alpha value [0,1] with all invalid values being set to 1


function boundAlpha(a) {
  a = parseFloat(a);

  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }

  return a;
} // Take input from [0, n] and return it as [0, 1]


function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n))); // Automatically convert percentage into number

  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  } // Handle floating point rounding errors


  if (Math.abs(n - max) < 0.000001) {
    return 1;
  } // Convert into [0, 1] range if it isn't already


  return n % max / parseFloat(max);
} // Force a number between 0 and 1


function clamp01(val) {
  return Math.min(1, Math.max(0, val));
} // Parse a base-16 hex value into a base-10 integer


function parseIntFromHex(val) {
  return parseInt(val, 16);
} // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>


function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
} // Check to see if string passed in is a percentage


function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
} // Force a hex value to have 2 characters


function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
} // Replace a decimal with it's percentage value


function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }

  return n;
} // Converts a decimal to a hex value


function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
} // Converts a hex value to a decimal


function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}

var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?"; // <http://www.w3.org/TR/css3-values/#number-value>

  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?"; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")"; // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren

  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}(); // `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).


function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
} // `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`


function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;

  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  } // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.


  var match;

  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }

  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }

  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }

  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }

  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }

  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }

  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }

  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }

  return false;
}

function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();

  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }

  if (size !== "small" && size !== "large") {
    size = "small";
  }

  return {
    level: level,
    size: size
  };
}

var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  forEach(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;

      if (!isNaN(data[letter])) {
        passed += 1;
      }

      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;

        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
  var color = data.hex ? tinycolor(data.hex) : tinycolor(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();

  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }

  var transparent = hex === '000000' && rgb.a === 0;
  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};
var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  } // disable hex4 and hex8


  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }

  var col = toState(data);

  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }

  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};
var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return tinycolor(type + ' (' + stringWithoutDegree + ')')._ok;
};

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$3 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits$3(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck$3(this, ColorPicker);

      var _this = _possibleConstructorReturn$3(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);

        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);

          _this.setState(colors);

          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);

        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends$6({}, toState(props.color, 0));
      _this.debounce = debounce(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass$3(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};

        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return /*#__PURE__*/React__default["default"].createElement(Picker, _extends$6({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$6({}, toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(React.PureComponent || React.Component);

  ColorPicker.propTypes = _extends$6({}, Picker.propTypes);
  ColorPicker.defaultProps = _extends$6({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });
  return ColorPicker;
};

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$2 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$2(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits$2(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$2(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        focus: false
      }, _this.handleFocus = function () {
        return _this.setState({
          focus: true
        });
      }, _this.handleBlur = function () {
        return _this.setState({
          focus: false
        });
      }, _temp), _possibleConstructorReturn$2(_this, _ret);
    }

    _createClass$2(Focus, [{
      key: 'render',
      value: function render() {
        return /*#__PURE__*/React__default["default"].createElement(Span, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, /*#__PURE__*/React__default["default"].createElement(Component, _extends$5({}, this.props, this.state)));
      }
    }]);

    return Focus;
  }(React__default["default"].Component);
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var ENTER = 13;
var Swatch$1 = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
  var transparent = color === 'transparent';
  var styles = reactCSS({
    "default": {
      swatch: _extends$4({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };

  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };

  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};

  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return /*#__PURE__*/React__default["default"].createElement('div', _extends$4({
    style: styles.swatch,
    onClick: handleClick,
    title: title,
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, optionalEvents), children, transparent && /*#__PURE__*/React__default["default"].createElement(Checkboard, {
    borderRadius: styles.swatch.borderRadius,
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
  }));
};
var Swatch$2 = handleFocus(Swatch$1);

var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, {
    vertical: direction === 'vertical'
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'alpha-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement(Alpha, _extends$3({}, styles.alpha, {
    rgb: rgb,
    hsl: hsl,
    pointer: pointer,
    renderers: renderers,
    onChange: onChange,
    direction: direction
  })));
};
AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);

  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }

  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */

function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  } // Check that cyclic values are equal.


  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);

  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }

  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array); // Ignore non-index properties.

  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }

    if (compared !== undefined) {
      if (compared) {
        continue;
      }

      result = false;
      break;
    } // Recursively compare arrays (susceptible to call stack limits).


    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }

  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;
/** `Object#toString` result references. */

var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }

      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }

      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      } // Assume cyclic values are equal.


      var stacked = stack.get(object);

      if (stacked) {
        return stacked == other;
      }

      bitmask |= COMPARE_UNORDERED_FLAG$2; // Recursively compare objects (susceptible to call stack limits).

      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }

  }

  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */

var objectProto$2 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return baseGetAllKeys(object, keys$1, getSymbols$1);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$3 = 1;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }

  var index = objLength;

  while (index--) {
    var key = objProps[index];

    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  } // Check that cyclic values are equal.


  var objStacked = stack.get(object);
  var othStacked = stack.get(other);

  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }

  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;

  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    } // Recursively compare objects (susceptible to call stack limits).


    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }

    skipCtor || (skipCtor = key == 'constructor');
  }

  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }

  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */

var DataView = getNative(root$1, 'DataView');
var DataView$1 = DataView;

/* Built-in method references that are verified to be native. */

var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */

var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/* Built-in method references that are verified to be native. */

var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/** `Object#toString` result references. */

var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$2);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2()) != mapTag || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$2 = 1;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */

function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
      othIsArr = isArray$1(other),
      objTag = objIsArr ? arrayTag : getTag$1(object),
      othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }

    objIsArr = true;
    objIsObj = false;
  }

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }

  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }

  if (!isSameTag) {
    return false;
  }

  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */

function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */

function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }

  object = Object(object);

  while (index--) {
    var data = matchData[index];

    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }

  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();

      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }

      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }

  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */

function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */

function getMatchData(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }

  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }

    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatches(source) {
  var matchData = getMatchData(source);

  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }

  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }

  return isKey(value, object) ? [value] : stringToPath$1(toString(value));
}

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */

function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);

    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }

    object = object[key];
  }

  if (result || ++index != length) {
    return result;
  }

  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */

function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */

var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }

  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */

function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */

function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }

  if (value == null) {
    return identity;
  }

  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }

  return property(value);
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */

function map(collection, iteratee) {
  var func = isArray$1(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;
  var styles = reactCSS({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        "float": 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatches
  }, map(colors, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
      key: c,
      color: c,
      style: styles.swatch,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + c
      }
    });
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.clear
  }));
};

var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var transparent = hex === 'transparent';

  var handleChange = function handleChange(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = reactCSS(merge$1({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide'
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.card,
    className: 'block-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.triangle
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.head
  }, transparent && /*#__PURE__*/React__default["default"].createElement(Checkboard, {
    borderRadius: '6px 6px 0 0'
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.label
  }, hex)), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React__default["default"].createElement(BlockSwatches, {
    colors: colors,
    onClick: handleChange,
    onSwatchHover: onSwatchHover
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input
    },
    value: hex,
    onChange: handleChange
  })));
};
Block.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  colors: index.PropTypes.arrayOf(index.PropTypes.string),
  triangle: index.PropTypes.oneOf(['top', 'hide']),
  styles: index.PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};
var BlockPicker = ColorWrap(Block);

var red = {
  "50": "#ffebee",
  "100": "#ffcdd2",
  "200": "#ef9a9a",
  "300": "#e57373",
  "400": "#ef5350",
  "500": "#f44336",
  "600": "#e53935",
  "700": "#d32f2f",
  "800": "#c62828",
  "900": "#b71c1c",
  "a100": "#ff8a80",
  "a200": "#ff5252",
  "a400": "#ff1744",
  "a700": "#d50000"
};
var pink = {
  "50": "#fce4ec",
  "100": "#f8bbd0",
  "200": "#f48fb1",
  "300": "#f06292",
  "400": "#ec407a",
  "500": "#e91e63",
  "600": "#d81b60",
  "700": "#c2185b",
  "800": "#ad1457",
  "900": "#880e4f",
  "a100": "#ff80ab",
  "a200": "#ff4081",
  "a400": "#f50057",
  "a700": "#c51162"
};
var purple = {
  "50": "#f3e5f5",
  "100": "#e1bee7",
  "200": "#ce93d8",
  "300": "#ba68c8",
  "400": "#ab47bc",
  "500": "#9c27b0",
  "600": "#8e24aa",
  "700": "#7b1fa2",
  "800": "#6a1b9a",
  "900": "#4a148c",
  "a100": "#ea80fc",
  "a200": "#e040fb",
  "a400": "#d500f9",
  "a700": "#aa00ff"
};
var deepPurple = {
  "50": "#ede7f6",
  "100": "#d1c4e9",
  "200": "#b39ddb",
  "300": "#9575cd",
  "400": "#7e57c2",
  "500": "#673ab7",
  "600": "#5e35b1",
  "700": "#512da8",
  "800": "#4527a0",
  "900": "#311b92",
  "a100": "#b388ff",
  "a200": "#7c4dff",
  "a400": "#651fff",
  "a700": "#6200ea"
};
var indigo = {
  "50": "#e8eaf6",
  "100": "#c5cae9",
  "200": "#9fa8da",
  "300": "#7986cb",
  "400": "#5c6bc0",
  "500": "#3f51b5",
  "600": "#3949ab",
  "700": "#303f9f",
  "800": "#283593",
  "900": "#1a237e",
  "a100": "#8c9eff",
  "a200": "#536dfe",
  "a400": "#3d5afe",
  "a700": "#304ffe"
};
var blue = {
  "50": "#e3f2fd",
  "100": "#bbdefb",
  "200": "#90caf9",
  "300": "#64b5f6",
  "400": "#42a5f5",
  "500": "#2196f3",
  "600": "#1e88e5",
  "700": "#1976d2",
  "800": "#1565c0",
  "900": "#0d47a1",
  "a100": "#82b1ff",
  "a200": "#448aff",
  "a400": "#2979ff",
  "a700": "#2962ff"
};
var lightBlue = {
  "50": "#e1f5fe",
  "100": "#b3e5fc",
  "200": "#81d4fa",
  "300": "#4fc3f7",
  "400": "#29b6f6",
  "500": "#03a9f4",
  "600": "#039be5",
  "700": "#0288d1",
  "800": "#0277bd",
  "900": "#01579b",
  "a100": "#80d8ff",
  "a200": "#40c4ff",
  "a400": "#00b0ff",
  "a700": "#0091ea"
};
var cyan = {
  "50": "#e0f7fa",
  "100": "#b2ebf2",
  "200": "#80deea",
  "300": "#4dd0e1",
  "400": "#26c6da",
  "500": "#00bcd4",
  "600": "#00acc1",
  "700": "#0097a7",
  "800": "#00838f",
  "900": "#006064",
  "a100": "#84ffff",
  "a200": "#18ffff",
  "a400": "#00e5ff",
  "a700": "#00b8d4"
};
var teal = {
  "50": "#e0f2f1",
  "100": "#b2dfdb",
  "200": "#80cbc4",
  "300": "#4db6ac",
  "400": "#26a69a",
  "500": "#009688",
  "600": "#00897b",
  "700": "#00796b",
  "800": "#00695c",
  "900": "#004d40",
  "a100": "#a7ffeb",
  "a200": "#64ffda",
  "a400": "#1de9b6",
  "a700": "#00bfa5"
};
var green = {
  "50": "#e8f5e9",
  "100": "#c8e6c9",
  "200": "#a5d6a7",
  "300": "#81c784",
  "400": "#66bb6a",
  "500": "#4caf50",
  "600": "#43a047",
  "700": "#388e3c",
  "800": "#2e7d32",
  "900": "#1b5e20",
  "a100": "#b9f6ca",
  "a200": "#69f0ae",
  "a400": "#00e676",
  "a700": "#00c853"
};
var lightGreen = {
  "50": "#f1f8e9",
  "100": "#dcedc8",
  "200": "#c5e1a5",
  "300": "#aed581",
  "400": "#9ccc65",
  "500": "#8bc34a",
  "600": "#7cb342",
  "700": "#689f38",
  "800": "#558b2f",
  "900": "#33691e",
  "a100": "#ccff90",
  "a200": "#b2ff59",
  "a400": "#76ff03",
  "a700": "#64dd17"
};
var lime = {
  "50": "#f9fbe7",
  "100": "#f0f4c3",
  "200": "#e6ee9c",
  "300": "#dce775",
  "400": "#d4e157",
  "500": "#cddc39",
  "600": "#c0ca33",
  "700": "#afb42b",
  "800": "#9e9d24",
  "900": "#827717",
  "a100": "#f4ff81",
  "a200": "#eeff41",
  "a400": "#c6ff00",
  "a700": "#aeea00"
};
var yellow = {
  "50": "#fffde7",
  "100": "#fff9c4",
  "200": "#fff59d",
  "300": "#fff176",
  "400": "#ffee58",
  "500": "#ffeb3b",
  "600": "#fdd835",
  "700": "#fbc02d",
  "800": "#f9a825",
  "900": "#f57f17",
  "a100": "#ffff8d",
  "a200": "#ffff00",
  "a400": "#ffea00",
  "a700": "#ffd600"
};
var amber = {
  "50": "#fff8e1",
  "100": "#ffecb3",
  "200": "#ffe082",
  "300": "#ffd54f",
  "400": "#ffca28",
  "500": "#ffc107",
  "600": "#ffb300",
  "700": "#ffa000",
  "800": "#ff8f00",
  "900": "#ff6f00",
  "a100": "#ffe57f",
  "a200": "#ffd740",
  "a400": "#ffc400",
  "a700": "#ffab00"
};
var orange = {
  "50": "#fff3e0",
  "100": "#ffe0b2",
  "200": "#ffcc80",
  "300": "#ffb74d",
  "400": "#ffa726",
  "500": "#ff9800",
  "600": "#fb8c00",
  "700": "#f57c00",
  "800": "#ef6c00",
  "900": "#e65100",
  "a100": "#ffd180",
  "a200": "#ffab40",
  "a400": "#ff9100",
  "a700": "#ff6d00"
};
var deepOrange = {
  "50": "#fbe9e7",
  "100": "#ffccbc",
  "200": "#ffab91",
  "300": "#ff8a65",
  "400": "#ff7043",
  "500": "#ff5722",
  "600": "#f4511e",
  "700": "#e64a19",
  "800": "#d84315",
  "900": "#bf360c",
  "a100": "#ff9e80",
  "a200": "#ff6e40",
  "a400": "#ff3d00",
  "a700": "#dd2c00"
};
var brown = {
  "50": "#efebe9",
  "100": "#d7ccc8",
  "200": "#bcaaa4",
  "300": "#a1887f",
  "400": "#8d6e63",
  "500": "#795548",
  "600": "#6d4c41",
  "700": "#5d4037",
  "800": "#4e342e",
  "900": "#3e2723"
};
var blueGrey = {
  "50": "#eceff1",
  "100": "#cfd8dc",
  "200": "#b0bec5",
  "300": "#90a4ae",
  "400": "#78909c",
  "500": "#607d8b",
  "600": "#546e7a",
  "700": "#455a64",
  "800": "#37474f",
  "900": "#263238"
};

var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;
  var styles = reactCSS({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, {
    hover: hover,
    active: active
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
    style: styles.Swatch,
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
    }
  }));
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
var CircleSwatch$1 = lib.handleHover(CircleSwatch);

var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.card,
    className: 'circle-picker ' + className
  }, map(colors, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(CircleSwatch$1, {
      key: c,
      color: c,
      onClick: handleChange,
      onSwatchHover: onSwatchHover,
      active: hex === c.toLowerCase(),
      circleSize: circleSize,
      circleSpacing: circleSpacing
    });
  }));
};
Circle.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  circleSize: index.PropTypes.number,
  circleSpacing: index.PropTypes.number,
  styles: index.PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red['500'], pink['500'], purple['500'], deepPurple['500'], indigo['500'], blue['500'], lightBlue['500'], cyan['500'], teal['500'], green['500'], lightGreen['500'], lime['500'], yellow['500'], amber['500'], orange['500'], deepOrange['500'], brown['500'], blueGrey['500']],
  styles: {}
};
ColorWrap(Circle);

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

var UnfoldMoreHorizontalIcon$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = React__default["default"];

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DEFAULT_SIZE = 24;

exports["default"] = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2["default"].createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2["default"].createElement('path', {
    d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
  }));
};
}(UnfoldMoreHorizontalIcon$1));

var UnfoldMoreHorizontalIcon = /*@__PURE__*/index.getDefaultExportFromCjs(UnfoldMoreHorizontalIcon$1);

var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function (_React$Component) {
  _inherits$1(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck$1(this, ChromeFields);

    var _this = _possibleConstructorReturn$1(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({
          view: 'rgb'
        });
      } else if (_this.state.view === 'rgb') {
        _this.setState({
          view: 'hsl'
        });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({
            view: 'hex'
          });
        } else {
          _this.setState({
            view: 'rgb'
          });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }

        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        } // We store HSL as a unit interval so we need to override the 1 input to 0.01


        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!isUndefined(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!isUndefined(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }

    return _this;
  }

  _createClass$1(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = reactCSS({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);
      var fields = void 0;

      if (this.state.view === 'hex') {
        fields = /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'hex',
          value: this.props.hex,
          onChange: this.handleChange
        })));
      } else if (this.state.view === 'rgb') {
        fields = /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'r',
          value: this.props.rgb.r,
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'g',
          value: this.props.rgb.g,
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'b',
          value: this.props.rgb.b,
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.alpha
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'a',
          value: this.props.rgb.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      } else if (this.state.view === 'hsl') {
        fields = /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.fields,
          className: 'flexbox-fix'
        }, /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'h',
          value: Math.round(this.props.hsl.h),
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 's',
          value: Math.round(this.props.hsl.s * 100) + '%',
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.field
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'l',
          value: Math.round(this.props.hsl.l * 100) + '%',
          onChange: this.handleChange
        })), /*#__PURE__*/React__default["default"].createElement('div', {
          style: styles.alpha
        }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
          style: {
            input: styles.input,
            label: styles.label
          },
          label: 'a',
          value: this.props.hsl.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      }

      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
      }, fields, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.toggle
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.icon,
        onClick: this.toggleViews,
        ref: function ref(icon) {
          return _this2.icon = icon;
        }
      }, /*#__PURE__*/React__default["default"].createElement(UnfoldMoreHorizontalIcon, {
        style: styles.svg,
        onMouseOver: this.showHighlight,
        onMouseEnter: this.showHighlight,
        onMouseOut: this.hideHighlight
      }))));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return {
          view: 'rgb'
        };
      }

      return null;
    }
  }]);

  return ChromeFields;
}(React__default["default"].Component);
ChromeFields.defaultProps = {
  view: "hex"
};

var ChromePointer = function ChromePointer() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var ChromePointerCircle = function ChromePointerCircle() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;
  var styles = reactCSS(merge$1({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), {
    disableAlpha: disableAlpha
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'chrome-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React__default["default"].createElement(Saturation, {
    style: styles.Saturation,
    hsl: hsl,
    hsv: hsv,
    pointer: ChromePointerCircle,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.color
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.active
  }), /*#__PURE__*/React__default["default"].createElement(Checkboard, {
    renderers: renderers
  }))), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.toggles
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React__default["default"].createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    pointer: ChromePointer,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React__default["default"].createElement(Alpha, {
    style: styles.Alpha,
    rgb: rgb,
    hsl: hsl,
    pointer: ChromePointer,
    renderers: renderers,
    onChange: onChange
  })))), /*#__PURE__*/React__default["default"].createElement(ChromeFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    view: defaultView,
    onChange: onChange,
    disableAlpha: disableAlpha
  })));
};
Chrome.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  disableAlpha: index.PropTypes.bool,
  styles: index.PropTypes.object,
  defaultView: index.PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};
ColorWrap(Chrome);

var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        "float": 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, {
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });
  return /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
    style: styles.color,
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: '0 0 4px ' + color
    }
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.dot
  }));
};

var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;
  var styles = reactCSS({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.fields,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.active
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  }));
};

var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(Raised, {
    style: styles.Compact,
    styles: passedStyles
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.compact,
    className: 'compact-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', null, map(colors, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(CompactColor, {
      key: c,
      color: c,
      active: c.toLowerCase() === hex,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.clear
  })), /*#__PURE__*/React__default["default"].createElement(CompactFields, {
    hex: hex,
    rgb: rgb,
    onChange: handleChange
  })));
};
Compact.propTypes = {
  colors: index.PropTypes.arrayOf(index.PropTypes.string),
  styles: index.PropTypes.object
};
Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};
ColorWrap(Compact);

var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;
  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };
  var styles = reactCSS({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, {
    hover: hover
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
    color: color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: hoverSwatch
  }));
};
var GithubSwatch$1 = lib.handleHover(GithubSwatch);

var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.card,
    className: 'github-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.triangleShadow
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.triangle
  }), map(colors, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(GithubSwatch$1, {
      color: c,
      key: c,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }));
};
Github.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  colors: index.PropTypes.arrayOf(index.PropTypes.string),
  triangle: index.PropTypes.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: index.PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};
ColorWrap(Github);

var SliderPointer$1 = function SliderPointer(_ref) {
  var direction = _ref.direction;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, {
    vertical: direction === 'vertical'
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles)); // Overwrite to provide pure hue color

  var handleChange = function handleChange(data) {
    return onChange({
      a: 1,
      h: data.h,
      l: 0.5,
      s: 1
    });
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'hue-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement(Hue, _extends$2({}, styles.hue, {
    hsl: hsl,
    pointer: pointer,
    onChange: handleChange,
    direction: direction
  })));
};
HuePicker.propTypes = {
  styles: index.PropTypes.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);

var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(Raised, {
    styles: passedStyles
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.material,
    className: 'material-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.split,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.third
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  })))));
};
ColorWrap(Material);

var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;
  var styles = reactCSS({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.fields
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'h',
    value: Math.round(hsv.h),
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 's',
    value: Math.round(hsv.s * 100),
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'v',
    value: Math.round(hsv.v * 100),
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.divider
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.RGBwrap,
      input: styles.RGBinput,
      label: styles.RGBlabel
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.divider
  }), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      wrap: styles.HEXwrap,
      input: styles.HEXinput,
      label: styles.HEXlabel
    },
    label: '#',
    value: hex.replace('#', ''),
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.fieldSymbols
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.symbol
  }, '\xB0'), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.symbol
  }, '%'), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.symbol
  }, '%')));
};

var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;
  var styles = reactCSS({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, {
    'black-outline': hsl.l > 0.5
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = reactCSS({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },
      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },
      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.pointer
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.left
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.leftInside
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.right
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.rightInside
  })));
};

var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, {
    active: active
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.button,
    onClick: onClick
  }, label || children);
};

var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;
  var styles = reactCSS({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      "new": {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', null, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.label
  }, 'new'), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles["new"]
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.current
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.label
  }, 'current'));
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;
      var styles = reactCSS(merge$1({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));
      return /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.picker,
        className: 'photoshop-picker ' + className
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.head
      }, this.props.header), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.body,
        className: 'flexbox-fix'
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.saturation
      }, /*#__PURE__*/React__default["default"].createElement(Saturation, {
        hsl: this.props.hsl,
        hsv: this.props.hsv,
        pointer: PhotoshopPointerCircle$1,
        onChange: this.props.onChange
      })), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.hue
      }, /*#__PURE__*/React__default["default"].createElement(Hue, {
        direction: 'vertical',
        hsl: this.props.hsl,
        pointer: PhotoshopPointerCircle,
        onChange: this.props.onChange
      })), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.controls
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.top,
        className: 'flexbox-fix'
      }, /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.previews
      }, /*#__PURE__*/React__default["default"].createElement(PhotoshopPreviews, {
        rgb: this.props.rgb,
        currentColor: this.state.currentColor
      })), /*#__PURE__*/React__default["default"].createElement('div', {
        style: styles.actions
      }, /*#__PURE__*/React__default["default"].createElement(PhotoshopButton, {
        label: 'OK',
        onClick: this.props.onAccept,
        active: true
      }), /*#__PURE__*/React__default["default"].createElement(PhotoshopButton, {
        label: 'Cancel',
        onClick: this.props.onCancel
      }), /*#__PURE__*/React__default["default"].createElement(PhotoshopPicker, {
        onChange: this.props.onChange,
        rgb: this.props.rgb,
        hsv: this.props.hsv,
        hex: this.props.hex
      }))))));
    }
  }]);

  return Photoshop;
}(React__default["default"].Component);
Photoshop.propTypes = {
  header: index.PropTypes.string,
  styles: index.PropTypes.object
};
Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};
ColorWrap(Photoshop);

/* eslint-disable no-param-reassign */
var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;
  var styles = reactCSS({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      "double": {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, {
    disableAlpha: disableAlpha
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.fields,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles["double"]
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'hex',
    value: hex.replace('#', ''),
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'r',
    value: rgb.r,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'g',
    value: rgb.g,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'b',
    value: rgb.b,
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '255'
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'a',
    value: Math.round(rgb.a * 100),
    onChange: handleChange,
    dragLabel: 'true',
    dragMax: '100'
  })));
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;
  var styles = reactCSS({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.colors,
    className: 'flexbox-fix'
  }, colors.map(function (colorObjOrString) {
    var c = typeof colorObjOrString === 'string' ? {
      color: colorObjOrString
    } : colorObjOrString;
    var key = '' + c.color + (c.title || '');
    return /*#__PURE__*/React__default["default"].createElement('div', {
      key: key,
      style: styles.swatchWrap
    }, /*#__PURE__*/React__default["default"].createElement(Swatch$2, _extends$1({}, c, {
      style: styles.swatch,
      onClick: handleClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
      }
    })));
  }));
};
SketchPresetColors.propTypes = {
  colors: index.PropTypes.arrayOf(index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.shape({
    color: index.PropTypes.string,
    title: index.PropTypes.string
  })])).isRequired
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), {
    disableAlpha: disableAlpha
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'sketch-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React__default["default"].createElement(Saturation, {
    style: styles.Saturation,
    hsl: hsl,
    hsv: hsv,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.sliders
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React__default["default"].createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.alpha
  }, /*#__PURE__*/React__default["default"].createElement(Alpha, {
    style: styles.Alpha,
    rgb: rgb,
    hsl: hsl,
    renderers: renderers,
    onChange: onChange
  }))), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.color
  }, /*#__PURE__*/React__default["default"].createElement(Checkboard, null), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.activeColor
  }))), /*#__PURE__*/React__default["default"].createElement(SketchFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    onChange: onChange,
    disableAlpha: disableAlpha
  }), /*#__PURE__*/React__default["default"].createElement(SketchPresetColors, {
    colors: presetColors,
    onClick: onChange,
    onSwatchHover: onSwatchHover
  }));
};
Sketch.propTypes = {
  disableAlpha: index.PropTypes.bool,
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  styles: index.PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};
var SketchPicker = ColorWrap(Sketch);

var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;
  var styles = reactCSS({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, {
    active: active,
    first: first,
    last: last
  });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch,
    onClick: handleClick
  });
};

var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;
  var styles = reactCSS({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        "float": 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  }); // Acceptible difference in floating point equality

  var epsilon = 0.1;
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.80',
    active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    first: true
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.65',
    active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.50',
    active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.35',
    active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatch, {
    hsl: hsl,
    offset: '.20',
    active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    last: true
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.clear
  }));
};

var SliderPointer = function SliderPointer() {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};

var Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.wrap || {},
    className: 'slider-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React__default["default"].createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    pointer: pointer,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatches
  }, /*#__PURE__*/React__default["default"].createElement(SliderSwatches, {
    hsl: hsl,
    onClick: onChange
  })));
};
Slider.propTypes = {
  styles: index.PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap(Slider);

var CheckIcon$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = React__default["default"];

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DEFAULT_SIZE = 24;

exports["default"] = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2["default"].createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2["default"].createElement('path', {
    d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
  }));
};
}(CheckIcon$1));

var CheckIcon = /*@__PURE__*/index.getDefaultExportFromCjs(CheckIcon$1);

var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });
  return /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
    color: color,
    style: styles.color,
    onClick: onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: '0 0 4px ' + color
    }
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.check
  }, /*#__PURE__*/React__default["default"].createElement(CheckIcon, null)));
};

var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;
  var styles = reactCSS({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        "float": 'left',
        marginRight: '10px'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.group
  }, map(group, function (color, i) {
    return /*#__PURE__*/React__default["default"].createElement(SwatchesColor, {
      key: color,
      color: color,
      active: color.toLowerCase() === active,
      first: i === 0,
      last: i === group.length - 1,
      onClick: onClick,
      onSwatchHover: onSwatchHover
    });
  }));
};

var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'swatches-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement(Raised, null, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.overflow
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.body
  }, map(colors, function (group) {
    return /*#__PURE__*/React__default["default"].createElement(SwatchesGroup, {
      key: group.toString(),
      group: group,
      active: hex,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    });
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.clear
  })))));
};
Swatches.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  height: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  colors: index.PropTypes.arrayOf(index.PropTypes.arrayOf(index.PropTypes.string)),
  styles: index.PropTypes.object
  /* eslint-disable max-len */

};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red['900'], red['700'], red['500'], red['300'], red['100']], [pink['900'], pink['700'], pink['500'], pink['300'], pink['100']], [purple['900'], purple['700'], purple['500'], purple['300'], purple['100']], [deepPurple['900'], deepPurple['700'], deepPurple['500'], deepPurple['300'], deepPurple['100']], [indigo['900'], indigo['700'], indigo['500'], indigo['300'], indigo['100']], [blue['900'], blue['700'], blue['500'], blue['300'], blue['100']], [lightBlue['900'], lightBlue['700'], lightBlue['500'], lightBlue['300'], lightBlue['100']], [cyan['900'], cyan['700'], cyan['500'], cyan['300'], cyan['100']], [teal['900'], teal['700'], teal['500'], teal['300'], teal['100']], ['#194D33', green['700'], green['500'], green['300'], green['100']], [lightGreen['900'], lightGreen['700'], lightGreen['500'], lightGreen['300'], lightGreen['100']], [lime['900'], lime['700'], lime['500'], lime['300'], lime['100']], [yellow['900'], yellow['700'], yellow['500'], yellow['300'], yellow['100']], [amber['900'], amber['700'], amber['500'], amber['300'], amber['100']], [orange['900'], orange['700'], orange['500'], orange['300'], orange['100']], [deepOrange['900'], deepOrange['700'], deepOrange['500'], deepOrange['300'], deepOrange['100']], [brown['900'], brown['700'], brown['500'], brown['300'], brown['100']], [blueGrey['900'], blueGrey['700'], blueGrey['500'], blueGrey['300'], blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};
ColorWrap(Swatches);

var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        "float": 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        "float": 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        "float": 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.card,
    className: 'twitter-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.triangleShadow
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.triangle
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.body
  }, map(colors, function (c, i) {
    return /*#__PURE__*/React__default["default"].createElement(Swatch$2, {
      key: i,
      color: c,
      hex: c,
      style: styles.swatch,
      onClick: handleChange,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + c
      }
    });
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.hash
  }, '#'), /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    label: null,
    style: {
      input: styles.input
    },
    value: hex.replace('#', ''),
    onChange: handleChange
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.clear
  })));
};
Twitter.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  triangle: index.PropTypes.oneOf(['hide', 'top-left', 'top-right']),
  colors: index.PropTypes.arrayOf(index.PropTypes.string),
  styles: index.PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};
ColorWrap(Twitter);

var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};
GooglePointerCircle.propTypes = {
  hsl: index.PropTypes.shape({
    h: index.PropTypes.number,
    s: index.PropTypes.number,
    l: index.PropTypes.number,
    a: index.PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.50
  }
};

var GooglePointer = function GooglePointer(props) {
  var styles = reactCSS({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker
  });
};
GooglePointer.propTypes = {
  hsl: index.PropTypes.shape({
    h: index.PropTypes.number,
    s: index.PropTypes.number,
    l: index.PropTypes.number,
    a: index.PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.50
  }
};

var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');

      if (isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');

        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }

        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');

      if (isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');

        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }

        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = reactCSS({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      "double": {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });
  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.wrap,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.fields
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles["double"]
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input,
      label: styles.label
    },
    label: 'hex',
    value: hex,
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.column
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'rgb',
    value: rgbValue,
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'hsv',
    value: hsvValue,
    onChange: handleChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.single
  }, /*#__PURE__*/React__default["default"].createElement(EditableInput, {
    style: {
      input: styles.input2,
      label: styles.label2
    },
    label: 'hsl',
    value: hslValue,
    onChange: handleChange
  })))));
};

var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  var styles = reactCSS(merge$1({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.picker,
    className: 'google-picker ' + className
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.head
  }, header), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.swatch
  }), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.saturation
  }, /*#__PURE__*/React__default["default"].createElement(Saturation, {
    hsl: hsl,
    hsv: hsv,
    pointer: GooglePointerCircle,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.body
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.controls,
    className: 'flexbox-fix'
  }, /*#__PURE__*/React__default["default"].createElement('div', {
    style: styles.hue
  }, /*#__PURE__*/React__default["default"].createElement(Hue, {
    style: styles.Hue,
    hsl: hsl,
    radius: '4px',
    pointer: GooglePointer,
    onChange: onChange
  }))), /*#__PURE__*/React__default["default"].createElement(GoogleFields, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    hsv: hsv,
    onChange: onChange
  })));
};
Google.propTypes = {
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number]),
  styles: index.PropTypes.object,
  header: index.PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};
ColorWrap(Google);

var colorString = {exports: {}};

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var simpleSwizzle = {exports: {}};

var isArrayish$1 = function isArrayish(obj) {
  if (!obj || typeof obj === 'string') {
    return false;
  }

  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

var isArrayish = isArrayish$1;

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
  var results = [];

  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];

    if (isArrayish(arg)) {
      // http://jsperf.com/javascript-array-concat-vs-push/98
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }

  return results;
};

swizzle$1.wrap = function (fn) {
  return function () {
    return fn(swizzle$1(arguments));
  };
};

/* MIT license */

var colorNames = colorName;

var swizzle = simpleSwizzle.exports;

var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = Object.create(null); // create a list of reverse color names

for (var name in colorNames) {
  if (hasOwnProperty.call(colorNames, name)) {
    reverseNames[colorNames[name]] = name;
  }
}

var cs = colorString.exports = {
  to: {},
  get: {}
};

cs.get = function (string) {
  var prefix = string.substring(0, 3).toLowerCase();
  var val;
  var model;

  switch (prefix) {
    case 'hsl':
      val = cs.get.hsl(string);
      model = 'hsl';
      break;

    case 'hwb':
      val = cs.get.hwb(string);
      model = 'hwb';
      break;

    default:
      val = cs.get.rgb(string);
      model = 'rgb';
      break;
  }

  if (!val) {
    return null;
  }

  return {
    model: model,
    value: val
  };
};

cs.get.rgb = function (string) {
  if (!string) {
    return null;
  }

  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var keyword = /^(\w+)$/;
  var rgb = [0, 0, 0, 1];
  var match;
  var i;
  var hexAlpha;

  if (match = string.match(hex)) {
    hexAlpha = match[2];
    match = match[1];

    for (i = 0; i < 3; i++) {
      // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
      var i2 = i * 2;
      rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
    }

    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha, 16) / 255;
    }
  } else if (match = string.match(abbr)) {
    match = match[1];
    hexAlpha = match[3];

    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i] + match[i], 16);
    }

    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    }
  } else if (match = string.match(rgba)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i + 1], 0);
    }

    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(per)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
    }

    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(keyword)) {
    if (match[1] === 'transparent') {
      return [0, 0, 0, 0];
    }

    if (!hasOwnProperty.call(colorNames, match[1])) {
      return null;
    }

    rgb = colorNames[match[1]];
    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }

  for (i = 0; i < 3; i++) {
    rgb[i] = clamp(rgb[i], 0, 255);
  }

  rgb[3] = clamp(rgb[3], 0, 1);
  return rgb;
};

cs.get.hsl = function (string) {
  if (!string) {
    return null;
  }

  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hsl);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var s = clamp(parseFloat(match[2]), 0, 100);
    var l = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }

  return null;
};

cs.get.hwb = function (string) {
  if (!string) {
    return null;
  }

  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hwb);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var w = clamp(parseFloat(match[2]), 0, 100);
    var b = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }

  return null;
};

cs.to.hex = function () {
  var rgba = swizzle(arguments);
  return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
};

cs.to.rgb = function () {
  var rgba = swizzle(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
  var rgba = swizzle(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
  var hsla = swizzle(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
}; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)


cs.to.hwb = function () {
  var hwba = swizzle(arguments);
  var a = '';

  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ', ' + hwba[3];
  }

  return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
  return reverseNames[rgb.slice(0, 3)];
}; // helpers


function clamp(num, min, max) {
  return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? '0' + str : str;
}

var _ColorFormatter;
var ColorFormat;

(function (ColorFormat) {
  ColorFormat["Hex"] = "hex";
  ColorFormat["RGB"] = "rgb";
})(ColorFormat || (ColorFormat = {}));

var rgbToHex = function rgbToHex(color) {
  return "#" + ((1 << 24) + (color.r << 16) + (color.g << 8) + color.b).toString(16).slice(1);
};

function ParseColorStr(color) {
  if (!color) {
    return null;
  }

  var colorDescriptor = colorString.exports.get(color);
  if (!colorDescriptor) return null;
  var colorVals = colorDescriptor.value;
  return {
    r: colorVals[0],
    g: colorVals[1],
    b: colorVals[2],
    a: colorVals[3]
  };
}

var ColorFormatter = (_ColorFormatter = {}, index._defineProperty(_ColorFormatter, ColorFormat.RGB, {
  getLabel: function getLabel(color) {
    return "R".concat(color.r, " G").concat(color.g, " B").concat(color.b);
  },
  getValue: function getValue(color) {
    var colorVals = [color.r, color.g, color.b, color.a];
    return colorString.exports.to.rgb(colorVals);
  },
  parse: ParseColorStr
}), index._defineProperty(_ColorFormatter, ColorFormat.Hex, {
  getLabel: function getLabel(color) {
    return rgbToHex(color);
  },
  getValue: function getValue(color) {
    var colorVals = [color.r, color.g, color.b, color.a];
    return colorString.exports.to.hex(colorVals);
  },
  parse: ParseColorStr
}), _ColorFormatter);

var __jsx$k = React__namespace.createElement;
var CloseIcon = function CloseIcon() {
  return __jsx$k("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$k("path", {
    d: "M5 6.2684L24.7316 26L26 24.7316L6.2684 5L5 6.2684Z"
  }), __jsx$k("path", {
    d: "M6.2684 26L26 6.2684L24.7316 5L5 24.7316L6.2684 26Z"
  }));
};

var __jsx$j = React__namespace.createElement;
var EllipsisVerticalIcon = function EllipsisVerticalIcon() {
  return __jsx$j("svg", {
    width: "4",
    height: "14",
    viewBox: "0 0 4 14",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$j("path", {
    d: "M2 5.5C1.5625 5.5 1.21875 5.65625 0.9375 5.9375C0.625 6.25 0.5 6.59375 0.5 7C0.5 7.4375 0.625 7.78125 0.9375 8.0625C1.21875 8.375 1.5625 8.5 2 8.5C2.40625 8.5 2.75 8.375 3.0625 8.0625C3.34375 7.78125 3.5 7.4375 3.5 7C3.5 6.59375 3.34375 6.25 3.0625 5.9375C2.75 5.65625 2.40625 5.5 2 5.5ZM0.5 2.25C0.5 1.84375 0.625 1.5 0.9375 1.1875C1.21875 0.90625 1.5625 0.75 2 0.75C2.40625 0.75 2.75 0.90625 3.0625 1.1875C3.34375 1.5 3.5 1.84375 3.5 2.25C3.5 2.6875 3.34375 3.03125 3.0625 3.3125C2.75 3.625 2.40625 3.75 2 3.75C1.5625 3.75 1.21875 3.625 0.9375 3.3125C0.625 3.03125 0.5 2.6875 0.5 2.25ZM0.5 11.75C0.5 11.3438 0.625 11 0.9375 10.6875C1.21875 10.4062 1.5625 10.25 2 10.25C2.40625 10.25 2.75 10.4062 3.0625 10.6875C3.34375 11 3.5 11.3438 3.5 11.75C3.5 12.1875 3.34375 12.5312 3.0625 12.8125C2.75 13.125 2.40625 13.25 2 13.25C1.5625 13.25 1.21875 13.125 0.9375 12.8125C0.625 12.5312 0.5 12.1875 0.5 11.75Z"
  }));
};

var __jsx$i = React__namespace.createElement;
var TrashIcon = function TrashIcon() {
  return __jsx$i("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx$i("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 4.2V6.9H25V8.7H7V6.9H15.1V4.2H16.9ZM7.77201 10.5H24.2279L22.4102 24.1332C22.2853 25.0698 21.4406 25.8 20.4977 25.8H11.5022C10.5561 25.8 9.71404 25.0653 9.58977 24.1332L7.77201 10.5ZM22.172 12.3H9.82791L11.3739 23.8953C11.3788 23.9318 11.4569 24 11.5022 24H20.4977C20.5432 24 20.6209 23.9328 20.6259 23.8953L22.172 12.3Z"
  }));
};

React__default["default"].createElement;

React__default["default"].createElement;

var __jsx$h = React__namespace.createElement;
styled__default["default"](function (p) {
  return __jsx$h("button", p, __jsx$h(EllipsisVerticalIcon, null));
}).withConfig({
  displayName: "FormActions__MoreActionsButton",
  componentId: "sc-1bbk0ov-0"
})(["height:64px;width:40px;align-self:stretch;background-color:transparent;background-position:center;background-size:auto 18px;background-repeat:no-repeat;border:0;margin:0 -16px 0 8px;outline:none;cursor:pointer;transition:opacity 85ms ease-out;display:flex;justify-content:center;align-items:center;&:hover{background-color:var(--tina-color-grey-1);fill:var(--tina-color-grey-8);}"]);
styled__default["default"].div.withConfig({
  displayName: "FormActions__ActionsOverlay",
  componentId: "sc-1bbk0ov-1"
})(["min-width:192px;border-radius:var(--tina-radius-big);border:1px solid #efefef;display:block;position:absolute;bottom:var(--tina-padding-big);right:var(--tina-padding-big);transform:translate3d(0,0,0) scale3d(0.5,0.5,1);opacity:0;pointer-events:none;transition:all 85ms ease-out;transform-origin:100% 100%;box-shadow:var(--tina-shadow-big);background-color:white;overflow:hidden;z-index:var(--tina-z-index-1);", ";"], function (props) {
  return props.open && styled.css(["opacity:1;pointer-events:all;transform:translate3d(0,-28px,0) scale3d(1,1,1);"]);
});
styled__default["default"].button.withConfig({
  displayName: "FormActions__ActionButton",
  componentId: "sc-1bbk0ov-2"
})(["position:relative;text-align:center;font-size:var(--tina-font-size-1);padding:0 12px;height:40px;font-weight:var(--tina-font-weight-regular);width:100%;background:none;cursor:pointer;outline:none;border:0;transition:all var(--tina-timing-medium) ease-out;&:hover{color:var(--tina-color-primary);background-color:var(--tina-color-grey-1);}&:not(:last-child){border-bottom:1px solid var(--tina-color-grey-2);}"]);

var __jsx$g = React__namespace.createElement;
var FormPortalContext = /*#__PURE__*/React__namespace.createContext(function () {
  return null;
});
function useFormPortal() {
  return React.useContext(FormPortalContext);
}
styled__default["default"](function (_ref) {
  var children = _ref.children,
      styleProps = index._objectWithoutProperties(_ref, ["children"]);

  var wrapperRef = React__namespace.useRef(null);
  var FormPortal = React__namespace.useCallback(function (props) {
    if (!wrapperRef.current) return null;
    return /*#__PURE__*/ReactDOM.createPortal(props.children, wrapperRef.current);
  }, [wrapperRef.current]);
  return __jsx$g(FormPortalContext.Provider, {
    value: FormPortal
  }, __jsx$g("div", index._extends({
    ref: wrapperRef
  }, styleProps), children));
}).withConfig({
  displayName: "FormPortal__FormPortalProvider",
  componentId: "sc-tpxiem-0"
})(["height:100%;scrollbar-width:none;"]);

formSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var ERROR_MISSING_CMS = "useCMS could not find an instance of CMS";
var CMSContext = /*#__PURE__*/React__namespace.createContext(null);
function useCMS() {
  var cms = React__namespace.useContext(CMSContext);

  if (!cms) {
    throw new Error(ERROR_MISSING_CMS);
  }

  var _React$useState = React__namespace.useState(cms.enabled),
      _React$useState2 = index._slicedToArray(_React$useState, 2),
      setEnabled = _React$useState2[1];

  React__namespace.useEffect(function () {
    return cms.events.subscribe("cms", function () {
      setEnabled(cms.enabled);
    });
  }, [cms]);
  return cms;
}

function duplicateConfig(inputConfig, compilationContext) {
  // deep copy first
  var config = index.deepClone(inputConfig); // refresh component ids and traceIds

  traverseComponents(config, compilationContext, function (_ref) {
    var componentConfig = _ref.componentConfig;
    componentConfig._id = index.uniqueId();
    componentConfig.traceId = generateDefaultTraceId(componentConfig);
  }); // every text must get new local id

  configTraverse(config, compilationContext, function (_ref2) {
    var value = _ref2.value,
        schemaProp = _ref2.schemaProp;

    if (schemaProp.type === "text") {
      value.id = "local." + index.uniqueId();
    }
  });
  return config;
}

/**
 *
 * @param collection Array of values
 * @param mapper Optional callback function that will be invoked for each item of given array to map it into comparable string
 */
function getUniqueValues(collection, mapper) {
  if (mapper) {
    var uniqueValues = new Set();
    var uniqueItems = [];
    collection.forEach(function (item, index) {
      var mappedItem = mapper(item, index);

      if (!uniqueValues.has(mappedItem)) {
        uniqueValues.add(mappedItem);
        uniqueItems.push(item);
      }
    });
    return uniqueItems;
  }

  return Array.from(new Set(collection));
}

// It suggests that in onChange you can pass event OR any value. It's a bit confusing and should be cleaned up in the future.

function createFieldController(_ref) {
  var field = _ref.field,
      editorContext = _ref.editorContext,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? function (v) {
    return v;
  } : _ref$format,
      _ref$parse = _ref.parse,
      parse = _ref$parse === void 0 ? function (v) {
    return v;
  } : _ref$parse;
  var actions = editorContext.actions,
      activeEditor = editorContext.activeEditor,
      contextParams = editorContext.contextParams,
      form = editorContext.form,
      locales = editorContext.locales;
  var normalizedFieldName = toArray(field.name);
  return {
    onChange: function onChange(mainNewValue) {
      for (var _len = arguments.length, extraNewValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extraNewValues[_key - 1] = arguments[_key];
      }

      /**
       * There are 2 modes of onChange: single param and multiple params
       *
       * 1. single param mode is when onChange is given ONE value (1 parameter). It means: "apply this value for all selected fields"
       * 2. multiple param mode is when onChange is given more than one value. It means: "apply each value for respective selected field".
       */
      var newValue = extraNewValues.length === 0 ? mainNewValue : [mainNewValue].concat(extraNewValues);

      if (!Array.isArray(mainNewValue) && Array.isArray(newValue) && newValue.length !== normalizedFieldName.length) {
        throw new Error("onChange in multiple param mode was given wrong number of values");
      }

      if (activeEditor === null || activeEditor === void 0 ? void 0 : activeEditor.selection) {
        // For editor selection we can safely pick a first field name because:
        // * we only can select fields that are children of $richTextPart
        // * we only can update only single property
        var _parsePath = parsePath(normalizedFieldName[0], form),
            templateId = _parsePath.templateId;

        invalidateCache(normalizedFieldName[0], editorContext);

        if (templateId === richTextPartEditableComponent.id || templateId === richTextInlineWrapperElementEditableComponent.id) {
          var schemaPropNameToUpdate = last(normalizedFieldName[0].split("."));

          if (schemaPropNameToUpdate.startsWith("$")) {
            schemaPropNameToUpdate = schemaPropNameToUpdate.slice(1);
          }

          if (extraNewValues.length > 0) {
            var parsedValues = newValue.map(function (value) {
              return parse(getValue(value), normalizedFieldName[0], field);
            });
            actions.setActiveEditorSelection.apply(actions, [schemaPropNameToUpdate, field.schemaProp].concat(index._toConsumableArray(parsedValues)));
          } else {
            var parsedValue = parse(getValue(newValue), normalizedFieldName[0], field);
            actions.setActiveEditorSelection(schemaPropNameToUpdate, field.schemaProp, parsedValue);
          }

          return;
        }
      }

      actions.runChange(function () {
        normalizedFieldName.forEach(function (path, fieldIndex) {
          var inputValue = Array.isArray(newValue) ? getValue(newValue[fieldIndex]) : getValue(newValue);
          var parsedValue = parse(inputValue, path, field); // If path has locale token [locale] (component-collection-localised) then we must first replace it with correct token

          if (hasLocaleToken(path)) {
            var currentLocaleFieldName = replaceLocaleToken(path, contextParams.locale);
            var currentLocaleValue = dotNotationGet(form.values, currentLocaleFieldName);
            parsedValue = parse(inputValue, currentLocaleFieldName, field); // If the path doesn't exist it means that there is no config for path for current locale. It means we must create it!

            if (currentLocaleValue === undefined) {
              var fallbackLocale = getFallbackLocaleForLocale(contextParams.locale, locales);
              var fieldNameSegments = path.split(".");
              var localeTokenIndex = fieldNameSegments.indexOf("[locale]");
              var localisedConfigPath = [].concat(index._toConsumableArray(fieldNameSegments.slice(0, localeTokenIndex + 1)), ["0"]).join(".");
              var fallbackLocaleFieldName = replaceLocaleToken(localisedConfigPath, fallbackLocale);
              var localeConfigPath = replaceLocaleToken(localisedConfigPath, contextParams.locale);
              form.change(localeConfigPath, duplicateConfig(dotNotationGet(form.values, fallbackLocaleFieldName), editorContext));
            }

            path = currentLocaleFieldName;
          }

          invalidateCache(path, editorContext); // At this point we have correct fieldName and correct parsedValue after all [locale] issues solved

          /**
           * Below we're trying to see whether there is a custom change function for specific EditableComponent
           */

          var split = path.split(".");
          var propName = last(split); // TODO: here we can have either a component or component field. parsePath should take this into account!

          var componentPath = split.slice(0, split.length - 1).join(".");

          var _parsePath2 = parsePath(componentPath, editorContext.form),
              templateId = _parsePath2.templateId;

          var parentDefinition = index.findComponentDefinitionById(templateId, editorContext);
          var config = dotNotationGet(editorContext.form.values, componentPath);

          if (parentDefinition && parentDefinition.change) {
            var values = {};
            var closestDefinedValues = {};
            parentDefinition.schema.forEach(function (schemaProp) {
              var val = config[schemaProp.prop];
              values[schemaProp.prop] = index.isTrulyResponsiveValue(val) ? val[editorContext.breakpointIndex] : val;
              /**
               * IMPORTANT!!! Using responsiveValueGetClosestDefinedValue here is a total simplification. It can lead to bugs in the future, good thing it's only used in TwoCards, which are used in full screen mode.
               * This should be fixed.
               * Same applies
               */

              closestDefinedValues[schemaProp.prop] = responsiveValueGetDefinedValue(val, editorContext.breakpointIndex, editorContext.devices, index.getDevicesWidths(editorContext.devices));
            });
            var result = parentDefinition.change({
              value: index.isTrulyResponsiveValue(parsedValue) ? parsedValue[editorContext.breakpointIndex] : parsedValue,
              closestDefinedValue: responsiveValueGetDefinedValue(
              /** IMPORTANT!!! See warning above */
              parsedValue, editorContext.breakpointIndex, editorContext.devices, index.getDevicesWidths(editorContext.devices)),
              fieldName: propName,
              values: values,
              closestDefinedValues: closestDefinedValues
            });
            parentDefinition.schema.forEach(function (schemaProp) {
              if (!result.hasOwnProperty(schemaProp.prop)) {
                return;
              }

              var pathPrefix = "".concat(componentPath, ".").concat(schemaProp.prop);

              if (pathPrefix[0] === ".") {
                pathPrefix = pathPrefix.substring(1);
              }

              if (index.isTrulyResponsiveValue(config[schemaProp.prop])) {
                form.change("".concat(pathPrefix, ".").concat(editorContext.breakpointIndex), result[schemaProp.prop]);
              } else {
                form.change("".concat(pathPrefix), result[schemaProp.prop]);
              }
            });
          } else {
            form.change(path, parsedValue);
          }
        });
      });
    },
    getValue: function getValue() {
      var fieldValues = normalizedFieldName.map(function (fieldName) {
        var propName = last(fieldName.split("."));

        if (propName.startsWith("$")) {
          return field.schemaProp.defaultValue;
        }

        if (hasLocaleToken(fieldName)) {
          var resolvedFieldName = replaceLocaleToken(fieldName, editorContext.contextParams.locale);
          var fieldValue = dotNotationGet(form.values, resolvedFieldName);

          if (fieldValue) {
            return fieldValue;
          }

          var fallbackLocale = getFallbackLocaleForLocale(editorContext.contextParams.locale, editorContext.locales);
          var resolvedFieldFallbackName = replaceLocaleToken(fieldName, fallbackLocale);
          var fieldFallbackValue = dotNotationGet(form.values, resolvedFieldFallbackName);
          return fieldFallbackValue;
        }

        return dotNotationGet(form.values, fieldName);
      });
      var uniqueFieldValues = getUniqueValues(fieldValues, function (fieldValue) {
        var _getSchemaDefinition = getSchemaDefinition(field.schemaProp, editorContext),
            getHash = _getSchemaDefinition.getHash;

        return getHash( // @ts-expect-error Discriminated union of all schema prop definitions produces `never`, but we can safely ignore it for now.
        fieldValue, editorContext.breakpointIndex, editorContext.devices);
      });

      if (uniqueFieldValues.length > 1) {
        return {
          __mixed__: true
        };
      }

      return format(uniqueFieldValues[0], normalizedFieldName[0], field);
    }
  };
}

function hasLocaleToken(configPath) {
  return configPath.includes("[locale]");
}

function replaceLocaleToken(configPath, locale) {
  var localisedFieldName = configPath.replace("[locale]", locale);
  return localisedFieldName;
}

function getValue(eventOrValue) {
  // Event of course has more properties or methods, but for this case
  // checking only for `currentTarget` is sufficient
  var isEventObject = typeof eventOrValue === "object" && eventOrValue !== null && "currentTarget" in eventOrValue;

  if (isEventObject) {
    if ("checked" in eventOrValue.currentTarget && eventOrValue.currentTarget.type === "checkbox") {
      return eventOrValue.currentTarget.checked;
    }

    return eventOrValue.currentTarget.value;
  } else {
    return eventOrValue;
  }
}

// $richText and $richTextPart uses a lot of portals to display correct fields within sidebar
// Changing value through portal won't trigger the recompilation of component using that portal.
// When we change any $richText related component we remove cache for that component (if it is $richText)
// and for all of its ancestors.
var richTextCacheInvalidator = function richTextCacheInvalidator(cache, changedPath, context) {
  var cacheKeysToRemove = [];

  var _parsePath3 = parsePath(changedPath, context.form),
      templateId = _parsePath3.templateId,
      fieldName = _parsePath3.fieldName,
      parent = _parsePath3.parent;

  var isRichTextOrRichTextAncestorComponent = templateId.startsWith("$richText") || (parent === null || parent === void 0 ? void 0 : parent.templateId.startsWith("$richText"));

  if (isRichTextOrRichTextAncestorComponent) {
    var richTextPath = templateId === "$richText" && fieldName ? changedPath.replace(".".concat(fieldName), "") : findPathOfFirstAncestorOfType(changedPath, "$richText", context.form);
    var richTextConfig = dotNotationGet(context.form.values, richTextPath);
    traverseComponents(richTextConfig, context, function (_ref2) {
      var componentConfig = _ref2.componentConfig;

      if (componentConfig && componentConfig._template.startsWith("$richText")) {
        cacheKeysToRemove.push(componentConfig._id);
      }
    });
  }

  return cacheKeysToRemove;
}; // $SectionWrapper holds the hide prop, but the $RootSections component is responsible for showing/hiding sections
// This is done during the compilation of $RootSections so we have to make sure that it's compiled when $SectionWrapper changes.


var sectionWrapperCacheInvalidator = function sectionWrapperCacheInvalidator(_, changedPath, context) {
  var cacheKeysToRemove = [];

  var _parsePath4 = parsePath(changedPath, context.form),
      parent = _parsePath4.parent;

  if (parent && parent.templateId === "$RootSections") {
    var rootSectionsConfig = dotNotationGet(context.form.values, parent.path);
    cacheKeysToRemove.push(rootSectionsConfig._id);
  }

  return cacheKeysToRemove;
};

var cacheInvalidators = [richTextCacheInvalidator, sectionWrapperCacheInvalidator];

function invalidateCache(changedPath, context) {
  var cacheKeysToRemove = new Set(cacheInvalidators.flatMap(function (invalidator) {
    return invalidator(context.compilationCache, changedPath, context);
  }));
  cacheKeysToRemove.forEach(function (cacheKey) {
    context.compilationCache.remove(cacheKey);
  });
}

var __jsx$f = React__namespace.createElement;

function shouldFieldBeDisplayed(form, field) {
  if (field.component === null) return false;

  if (Array.isArray(field.name)) {
    return true;
  }

  if (field.hidden) {
    return false;
  }

  return true;
}

function FieldBuilder(_ref) {
  var _field$format, _field$parse;

  var form = _ref.form,
      field = _ref.field,
      noWrap = _ref.noWrap,
      isLabelHidden = _ref.isLabelHidden;
  var cms = useCMS();
  var editorContext = index.useEditorContext();

  if (!shouldFieldBeDisplayed(form, field)) {
    return null;
  }

  var plugin = cms.plugins.findOrCreateMap("field").find(field.component);

  var _createFieldControlle = createFieldController({
    field: field,
    editorContext: editorContext,
    format: (_field$format = field.format) !== null && _field$format !== void 0 ? _field$format : plugin === null || plugin === void 0 ? void 0 : plugin.format,
    parse: (_field$parse = field.parse) !== null && _field$parse !== void 0 ? _field$parse : plugin === null || plugin === void 0 ? void 0 : plugin.parse
  }),
      onChange = _createFieldControlle.onChange,
      getValue = _createFieldControlle.getValue;

  if (plugin) {
    return __jsx$f(plugin.Component, {
      // Let's talk about this code
      // This branch of code is created to display single input and label that handles multiple inputs under the hood
      // To make this work, we had to skip usage of `Field` from `Final Form` because it requires a single field object with single name
      // Moreover, since we don't use `Field` anymore we have to pretend that it still exists to make fields works as it was there.
      // In the future, this code should become a part of new component (ex. FieldWrapper)
      // and new controller should be introduced (ex. fieldWrapperController) to have single source of truth about behaviour of responsive field.
      input: {
        value: getValue(),
        onChange: onChange
      } // MetaFieldWrapper accesses `error` property of this object, it's needed to prevent runtime error
      ,
      meta: {},
      tinaForm: form,
      form: form.finalForm,
      field: field,
      noWrap: noWrap,
      isLabelHidden: isLabelHidden
    });
  }

  if (typeof field.component !== "string" && field.component !== null) {
    return __jsx$f(field.component, {
      input: {
        value: getValue(),
        onChange: onChange
      },
      meta: {},
      tinaForm: form,
      form: form.finalForm,
      field: field,
      noWrap: noWrap,
      isLabelHidden: isLabelHidden
    });
  }

  return __jsx$f("p", null, "Unrecognized field type");
}
function FieldsBuilder(_ref2) {
  var form = _ref2.form,
      fields = _ref2.fields;
  var grouped = {};
  var ungrouped = [];
  fields.forEach(function (field) {
    if (!shouldFieldBeDisplayed(form, field)) {
      return;
    }

    if (field.group) {
      grouped[field.group] = grouped[field.group] || [];
      grouped[field.group].push(field);
    } else {
      if (field.component === "identity") {
        return;
      }

      ungrouped.push(field);
    }
  });

  var horizontalLine = __jsx$f(_StyledDiv$2, {
    $_css: index.SSColors.black10
  });

  var identityField = fields.find(function (field) {
    return field.component === "identity";
  });
  return __jsx$f(FieldsGroup, null, identityField !== undefined && __jsx$f(React__namespace.Fragment, null, __jsx$f(FieldBuilder, {
    field: identityField,
    form: form
  }), horizontalLine), Object.keys(grouped).map(function (groupName) {
    return __jsx$f("div", {
      key: groupName
    }, __jsx$f(FieldsGroupLabel, null, groupName), grouped[groupName].map(function (field, index, fields) {
      return __jsx$f(_StyledDiv2$1, {
        key: toArray(field.name).join("_"),
        $_css2: index === fields.length - 1 ? "8px" : 0
      }, __jsx$f(FieldBuilder, {
        field: field,
        form: form,
        isLabelHidden: field.schemaProp.isLabelHidden
      }));
    }), horizontalLine);
  }), ungrouped.map(function (field, index, fields) {
    return __jsx$f(_StyledDiv3$1, {
      key: toArray(field.name).join("_"),
      $_css3: index === fields.length - 1 ? "8px" : 0
    }, __jsx$f(FieldBuilder, {
      field: field,
      form: form,
      isLabelHidden: field.schemaProp.isLabelHidden
    }));
  }), horizontalLine);
}
var FieldsGroupLabel = styled__default["default"].div.withConfig({
  displayName: "fields-builder__FieldsGroupLabel",
  componentId: "sc-1l83d9z-0"
})(["display:flex;align-items:center;padding:20px 16px 10px 16px;", ";color:#000;"], index.SSFonts.label);
var FieldsGroup = styled__default["default"].div.withConfig({
  displayName: "fields-builder__FieldsGroup",
  componentId: "sc-1l83d9z-1"
})(["position:relative;display:block;width:100%;padding:0;white-space:nowrap;overflow-x:hidden;overflow-y:auto !important;"]);

var _StyledDiv$2 = styled__default["default"]("div").withConfig({
  displayName: "fields-builder___StyledDiv",
  componentId: "sc-1l83d9z-2"
})(["height:1px;margin-top:-1px;background-color:", ";"], function (p) {
  return p.$_css;
});

var _StyledDiv2$1 = styled__default["default"]("div").withConfig({
  displayName: "fields-builder___StyledDiv2",
  componentId: "sc-1l83d9z-3"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css2;
});

var _StyledDiv3$1 = styled__default["default"]("div").withConfig({
  displayName: "fields-builder___StyledDiv3",
  componentId: "sc-1l83d9z-4"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css3;
});

/**

Copyright 2019 Forestry.io Inc


Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
// import * as React from 'react'

/**
 * SHOPSTORY MODIFICATION!
 *
 * This is commented out. It's because we're bundling entire Tina with Rollup and it doesnt' handle well dynamic requires.
 */
function FontLoader() {
  // const [fontLoaded, setFontLoaded] = React.useState(false)
  //
  // const WebFontConfig = {
  //   google: {
  //     families: ['Inter:400,600'],
  //   },
  //   loading: () => {
  //     setFontLoaded(true)
  //   },
  // }
  //
  // React.useEffect(() => {
  //   if (!fontLoaded) {
  //     const WebFont = require('webfontloader')
  //     return WebFont.load(WebFontConfig)
  //   }
  // }, [])
  return null;
}

var __jsx$e = React__namespace.createElement;
function Theme() {
  return __jsx$e(React__namespace.Fragment, null, __jsx$e(FontLoader, null), __jsx$e(GlobalStyles, null));
}
var theme = styled.css([":root{--tina-color-primary-light:#2296fe;--tina-color-primary:#2296fe;--tina-color-primary-dark:#0574e4;--tina-color-error-light:#eb6337;--tina-color-error:#ec4815;--tina-color-error-dark:#dc4419;--tina-color-warning-light:#f5e06e;--tina-color-warning:#e9d050;--tina-color-warning-dark:#d3ba38;--tina-color-success-light:#57c355;--tina-color-success:#3cad3a;--tina-color-success-dark:#249a21;--tina-color-grey-0:#ffffff;--tina-color-grey-1:#f6f6f9;--tina-color-grey-2:#edecf3;--tina-color-grey-3:#e1ddec;--tina-color-grey-4:#b2adbe;--tina-color-grey-5:#918c9e;--tina-color-grey-6:#716c7f;--tina-color-grey-7:#565165;--tina-color-grey-8:#433e52;--tina-color-grey-9:#363145;--tina-color-grey-10:#282828;--tina-radius-small:5px;--tina-radius-big:24px;--tina-padding-small:12px;--tina-padding-big:20px;--tina-font-size-0:12px;--tina-font-size-1:13px;--tina-font-size-2:15px;--tina-font-size-3:16px;--tina-font-size-4:18px;--tina-font-size-5:20px;--tina-font-size-6:22px;--tina-font-size-7:26px;--tina-font-size-8:32px;--tina-font-family:\"Inter\",sans-serif;--tina-font-weight-regular:400;--tina-font-weight-bold:600;--tina-shadow-big:0px 2px 3px rgba(0,0,0,0.05),0 4px 12px rgba(0,0,0,0.1);--tina-shadow-small:0px 2px 3px rgba(0,0,0,0.12);--tina-timing-short:85ms;--tina-timing-medium:150ms;--tina-timing-long:250ms;--tina-z-index-0:500;--tina-z-index-1:1000;--tina-z-index-2:1500;--tina-z-index-3:2000;--tina-z-index-4:2500;--tina-z-index-5:3000;--tina-sidebar-width:340px;--tina-sidebar-header-height:60px;--tina-toolbar-height:62px;}"]);
var GlobalStyles = styled.createGlobalStyle(["", ";"], theme);
var tina_reset_styles = styled.css(["*{font-family:\"Inter\",sans-serif;&::-webkit-scrollbar{width:8px;}::-webkit-scrollbar-track{background:transparent;border-left:1px solid var(--tina-color-grey-2);}&::-webkit-scrollbar-thumb{background-color:var(--tina-color-grey-3);border-radius:0;border:none;}}*,*:before,*:after{box-sizing:border-box;}hr{border-color:var(--tina-color-grey-2);color:var(--tina-color-grey-2);margin-bottom:var(--tina-padding-big);margin-left:calc(var(--tina-padding-big) * -1);margin-right:calc(var(--tina-padding-big) * -1);border-top:1px solid var(--tina-color-grey-2);border-bottom:none;height:0;box-sizing:content-box;}h1,h2,h3,h4,h5,h6,p{:not([class]){font-family:\"Inter\",sans-serif;&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}}}td,th{padding:0;width:auto;height:auto;border:inherit;margin:0;}h1,h2,h3,h4,h5,h6{:not([class]){font-weight:var(--tina-font-weight-bold);}}h1:not([class]){font-size:var(--tina-font-size-8);}h2:not([class]){font-size:var(--tina-font-size-7);}h3:not([class]){font-size:var(--tina-font-size-5);}h4:not([class]){font-size:var(--tina-font-size-4);}h5:not([class]){font-size:var(--tina-font-size-3);}h6:not([class]){font-size:var(--tina-font-size-2);}"]);
var StyleReset = styled__default["default"].div.withConfig({
  displayName: "Styles__StyleReset",
  componentId: "sc-cxr2xf-0"
})(["", ""], tina_reset_styles);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var Button = styled__default["default"].button.withConfig({
  displayName: "Button",
  componentId: "sc-xnba7t-0"
})(["text-align:center;border:0;border-radius:var(--tina-radius-big);box-shadow:var(--tina-shadow-small);background-color:var(--tina-color-grey-0);border:1px solid var(--tina-color-grey-2);color:var(--tina-color-primary);fill:var(--tina-color-primary);font-weight:var(--tina-font-weight-regular);cursor:pointer;font-size:var(--tina-font-size-1);height:40px;padding:0 var(--tina-padding-big);transition:all 85ms ease-out;&:hover{background-color:var(--tina-color-grey-1);}&:active{background-color:var(--tina-color-grey-2);outline:none;}", ";", ";", ";", ";", ";", ";"], function (p) {
  return p.disabled && styled.css(["opacity:0.3;pointer:not-allowed;pointer-events:none;"]);
}, function (p) {
  return p.primary && styled.css(["background-color:var(--tina-color-primary);color:var(--tina-color-grey-0);fill:var(--tina-color-grey-0);border:none;&:hover{background-color:var(--tina-color-primary-light);}&:active{background-color:var(--tina-color-primary-dark);}"]);
}, function (p) {
  return p.small && styled.css(["height:32px;font-size:var(--tina-font-size-0);padding:0 var(--tina-padding-big);"]);
}, function (p) {
  return p.margin && styled.css(["&:not(:first-child){margin-left:8px;}"]);
}, function (p) {
  return p.grow && styled.css(["flex-grow:1;"]);
}, function (p) {
  return p.busy && styled.css(["cursor:wait;"]);
});
var ICON_BUTTON_SIZE = 28;
var IconButton = styled__default["default"](Button).withConfig({
  displayName: "Button__IconButton",
  componentId: "sc-xnba7t-1"
})(["padding:0;width:", "px;height:", "px;margin:0;position:relative;transform-origin:50% 50%;transition:all 150ms ease-out;padding:0;display:flex;flex-shrink:0;justify-content:center;align-items:center;svg{width:26px;height:26px;transition:all 150ms ease-out;}", ";", ";"], ICON_BUTTON_SIZE, ICON_BUTTON_SIZE, function (p) {
  return p.small && styled.css(["width:28px;height:28px;padding:0;svg{width:24px;height:24px;}"]);
}, function (props) {
  return props.open && styled.css(["background-color:var(--tina-color-grey-0);border-color:var(--tina-color-grey-2);outline:none;fill:var(--tina-color-primary);svg{transform:rotate(45deg);}&:hover{background-color:var(--tina-color-grey-1);}&:active{background-color:var(--tina-color-grey-2);}"]);
});

var __jsx$d = React__namespace.createElement;
var LoadingDots = function LoadingDots(_ref) {
  var _ref$dotSize = _ref.dotSize,
      dotSize = _ref$dotSize === void 0 ? 8 : _ref$dotSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "white" : _ref$color;
  return __jsx$d("div", null, __jsx$d(SingleDot, {
    dotSize: dotSize,
    color: color
  }), __jsx$d(SingleDot, {
    dotSize: dotSize,
    color: color
  }), __jsx$d(SingleDot, {
    dotSize: dotSize,
    color: color
  }));
};
var scaleUpAndDown = styled.keyframes(["0%{transform:scale(0.1);}50%{transform:scale(1);}90%{transform:scale(0.1);}100%{transform:scale(0.1);}"]);
var SingleDot = styled__default["default"].span.withConfig({
  displayName: "LoadingDots__SingleDot",
  componentId: "sc-1jdbb21-0"
})(["animation:", " 2s linear infinite;display:inline-block;margin-right:4px;:nth-child(2){animation-delay:0.3s;}:nth-child(3){animation-delay:0.5s;}", ""], scaleUpAndDown, function (_ref2) {
  var color = _ref2.color,
      dotSize = _ref2.dotSize;
  return styled.css(["background:", ";width:", "px;height:", "px;border-radius:", "px;"], color, dotSize, dotSize, dotSize);
});

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled__default["default"].div.withConfig({
  displayName: "ModalOverlay",
  componentId: "sc-16npwil-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;width:100vw;height:100vh;overflow:auto;padding:0;z-index:var(--tina-z-index-5);"]);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
styled__default["default"].div.withConfig({
  displayName: "ModalActions",
  componentId: "sc-1xec7f7-0"
})(["display:flex;justify-content:flex-end;border-radius:0 0 5px 5px;padding:0 var(--tina-padding-big) var(--tina-padding-big) var(--tina-padding-big);", "{flex:0 1 auto;min-width:128px;margin:0 var(--tina-padding-small) 0 0;&:last-child{margin-right:0;}}"], Button);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var ModalBody = styled__default["default"].div.withConfig({
  displayName: "ModalBody",
  componentId: "sc-9zhpzh-0"
})(["padding:", ";margin:0;overflow:hidden;display:flex;flex-direction:column;min-height:160px;&:last-child{border-radius:0 0 5px 5px;}"], function (p) {
  return p.padded ? "var(--tina-padding-big)" : "0";
});

var __jsx$c = React__namespace.createElement;
styled__default["default"](function (_ref) {
  var children = _ref.children,
      close = _ref.close,
      styleProps = index._objectWithoutProperties(_ref, ["children", "close"]);

  return __jsx$c("div", styleProps, __jsx$c(ModalTitle, null, children), close && __jsx$c(CloseButton, {
    onClick: close
  }, __jsx$c(CloseIcon, null)));
}).withConfig({
  displayName: "ModalHeader",
  componentId: "sc-1ql3adl-0"
})(["height:56px;display:flex;align-items:center;justify-content:space-between;padding:0 var(--tina-padding-big) 0 var(--tina-padding-big);border-bottom:1px solid var(--tina-color-grey-3);margin:0;"]);
var ModalTitle = styled__default["default"].h2.withConfig({
  displayName: "ModalHeader__ModalTitle",
  componentId: "sc-1ql3adl-1"
})(["all:unset;color:var(--tina-color-grey-10);font-weight:var(--tina-font-weight-regular);font-family:var(--tina-font-family);font-size:var(--tina-font-size-4);font-weight:var(--tina-font-weight-regular);line-height:1;margin:0;"]);
var CloseButton = styled__default["default"].div.withConfig({
  displayName: "ModalHeader__CloseButton",
  componentId: "sc-1ql3adl-2"
})(["display:flex;align-items:center;fill:var(--tina-color-grey-5);cursor:pointer;transition:fill 85ms ease-out;svg{width:24px;height:auto;}&:hover{fill:var(--tina-color-grey-8);}"]);

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var ModalFullscreenKeyframes = styled.keyframes(["0%{transform:translate3d( -2rem,0,0 );opacity:0;}100%{transform:translate3d( 0,0,0 );opacity:1;}"]);
styled__default["default"].div.withConfig({
  displayName: "FullscreenModal",
  componentId: "sc-16cj00-0"
})(["display:flex;flex-direction:column;z-index:var(--tina-z-index-0);overflow:visible;background-color:#fff;border-radius:0;position:absolute;top:0;left:0;width:100%;max-width:1500px;height:100%;animation:", " 150ms ease-out 1;", "{height:100%;display:flex;flex-direction:column;}@media (min-width:721px){width:calc(100% - 170px);}"], ModalFullscreenKeyframes, ModalBody);

var cjs = {exports: {}};

var Draggable = {};

function r(e) {
  var t,
      f,
      n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
    e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (t in e) {
    e[t] && (n && (n += " "), n += t);
  }
  return n;
}

function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) {
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  }

  return n;
}

var clsx_m = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clsx: clsx,
  'default': clsx
});

var require$$3 = /*@__PURE__*/index.getAugmentedNamespace(clsx_m);

var domFns = {};

var shims = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dontSetMe = dontSetMe;
exports.findInArray = findInArray;
exports["int"] = _int;
exports.isFunction = isFunction;
exports.isNum = isNum; // @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc

function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function _int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
)
/*: ?Error*/
{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
}(shims));

var getPrefix = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports["default"] = void 0;
exports.getPrefix = getPrefix;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var _window$document, _window$document$docu;

  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform'; // Ensure we're running in an environment where there is actually a global
  // `window` obj

  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.

  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style) return '';
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = getPrefix()
/*: string*/
;

exports["default"] = _default;
}(getPrefix));

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;

var _shims$1 = shims;

var _getPrefix = _interopRequireWildcard(getPrefix);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$1.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims$1.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims$1.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread$8({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread$8({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$1["int"])(computedStyle.borderTopWidth);
  height += (0, _shims$1["int"])(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$1["int"])(computedStyle.borderLeftWidth);
  width += (0, _shims$1["int"])(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$1["int"])(computedStyle.paddingTop);
  height -= (0, _shims$1["int"])(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$1["int"])(computedStyle.paddingLeft);
  width -= (0, _shims$1["int"])(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/
// Get from offsetParent


function offsetXYFromParent(evt
/*: EventWithOffset*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty$1({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix["default"]), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims$1.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims$1.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

var positionFns = {};

Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;

var _shims = shims;

var _domFns = domFns;

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var boundNodeEl
    /*: HTMLElement*/
    = boundNode; // for Flow, can't seem to refine correctly

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims["int"])(boundNodeStyle.paddingLeft) + (0, _shims["int"])(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims["int"])(boundNodeStyle.paddingTop) + (0, _shims["int"])(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims["int"])(boundNodeStyle.paddingRight) - (0, _shims["int"])(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims["int"])(boundNodeStyle.paddingBottom) - (0, _shims["int"])(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

var DraggableCore = {};

var log = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = log;
/*eslint no-console:0*/

function log() {
}
}(log));

(function (exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default["default"]);

var _propTypes = _interopRequireDefault(index.propTypes.exports);

var _reactDom = _interopRequireDefault(ReactDOM__default["default"]);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _log = _interopRequireDefault(log);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Simple abstraction for dragging events names.


var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/
//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

var DraggableCore = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log["default"])('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log["default"])('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log["default"])('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = document.createEvent('MouseEvents')
          /*: any*/

          /*: MouseTouchEvent*/
          ; // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX || 0;
        var deltaY = y - _this.state.lastY || 0;

        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);

        deltaX = _snapToGrid4[0];
        deltaY = _snapToGrid4[1];
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log["default"])('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log["default"])('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props, _this$props2, _this$props2$nodeRef;

      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom["default"].findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: React.Element<any>*/
    {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports["default"] = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes["default"].bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes["default"].bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes["default"].bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes["default"].string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes["default"].string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes["default"].object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes["default"].func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes["default"].func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes["default"].func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes["default"].func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes["default"].number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});
}(DraggableCore));

(function (exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore["default"];
  }
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default["default"]);

var _propTypes = _interopRequireDefault(index.propTypes.exports);

var _reactDom = _interopRequireDefault(ReactDOM__default["default"]);

var _clsx2 = _interopRequireDefault(require$$3);

var _domFns = domFns;

var _positionFns = positionFns;

var _shims = shims;

var _DraggableCore = _interopRequireDefault(DraggableCore);

var _log = _interopRequireDefault(log);

var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} //
// Define <Draggable>
//


var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log["default"])('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log["default"])('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log["default"])('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom["default"].findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _clsx;

      var _this$props2 = this.props;
          _this$props2.axis;
          _this$props2.bounds;
          var children = _this$props2.children,
          defaultPosition = _this$props2.defaultPosition,
          defaultClassName = _this$props2.defaultClassName,
          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
          position = _this$props2.position,
          positionOffset = _this$props2.positionOffset;
          _this$props2.scale;
          var draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _clsx2["default"])(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore["default"], _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2)
    /*: ?$Shape<DraggableState>*/
    {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition; // Set x/y if a new position is provided in props that is different than the previous.

      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log["default"])('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports["default"] = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore["default"].propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes["default"].oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    left: _propTypes["default"].number,
    right: _propTypes["default"].number,
    top: _propTypes["default"].number,
    bottom: _propTypes["default"].number
  }), _propTypes["default"].string, _propTypes["default"].oneOf([false])]),
  defaultClassName: _propTypes["default"].string,
  defaultClassNameDragging: _propTypes["default"].string,
  defaultClassNameDragged: _propTypes["default"].string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  positionOffset: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore["default"].defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  scale: 1
}));
}(Draggable));

(function (module) {

var _require = Draggable,
    Draggable$1 = _require["default"],
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable$1;
module.exports["default"] = Draggable$1;
module.exports.DraggableCore = DraggableCore;
}(cjs));

React__default["default"].createElement;
var ModalPopupKeyframes = styled.keyframes(["0%{transform:translate3d( 0,-2rem,0 );opacity:0;}100%{transform:translate3d( 0,0,0 );opacity:1;}"]);
styled__default["default"].div.withConfig({
  displayName: "PopupModal__PopupModalStyled",
  componentId: "sc-1f5amwb-0"
})(["display:block;z-index:var(--tina-z-index-0);overflow:visible;background-color:var(--tina-color-grey-1);border-radius:var(--tina-radius-small);margin:40px auto;width:460px;max-width:90%;animation:", " 150ms ease-out 1;box-shadow:0 14px 28px rgb(0 0 0 / 15%),0 10px 10px rgb(0 0 0 / 12%);"], ModalPopupKeyframes);

styled__default["default"](Button).withConfig({
  displayName: "ResetForm__ResetButton",
  componentId: "sc-bf5dkv-0"
})(["flex:0 0 96px;"]);

var Emoji = styled__default["default"].span.withConfig({
  displayName: "FormView__Emoji",
  componentId: "sc-1ux1lgt-0"
})(["font-size:40px;line-height:1;display:inline-block;"]);
var EmptyStateAnimation = styled.keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
styled__default["default"].div.withConfig({
  displayName: "FormView__EmptyState",
  componentId: "sc-1ux1lgt-1"
})(["position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:var(--tina-padding-big) var(--tina-padding-big) 64px var(--tina-padding-big);width:100%;height:100%;overflow-y:auto;animation-name:", ";animation-delay:300ms;animation-timing-function:ease-out;animation-iteration-count:1;animation-fill-mode:both;animation-duration:150ms;> *:first-child{margin:0 0 var(--tina-padding-big) 0;}> ", "{display:block;}h3{font-size:var(--tina-font-size-5);font-weight:normal;color:inherit;display:block;margin:0 0 var(--tina-padding-big) 0;", "{font-size:1em;}}p{display:block;margin:0 0 var(--tina-padding-big) 0;}"], EmptyStateAnimation, Emoji, Emoji);
styled__default["default"].a.withConfig({
  displayName: "FormView__LinkButton",
  componentId: "sc-1ux1lgt-2"
})(["text-align:center;border:0;border-radius:var(--tina-radius-big);border:1px solid var(--tina-color-grey-2);box-shadow:var(--tina-shadow-small);font-weight:var(--tina-font-weight-regular);cursor:pointer;font-size:var(--tina-font-size-0);transition:all var(--tina-timing-short) ease-out;background-color:white;color:var(--tina-color-grey-8);padding:var(--tina-padding-small) var(--tina-padding-big) var(--tina-padding-small) 56px;position:relative;text-decoration:none;display:inline-block;", "{font-size:24px;position:absolute;left:var(--tina-padding-big);top:50%;transform-origin:50% 50%;transform:translate3d(0,-50%,0);transition:all var(--tina-timing-short) ease-out;}&:hover{color:var(--tina-color-primary);", "{transform:translate3d(0,-50%,0);}}"], Emoji, Emoji);

var Wrapper = styled__default["default"].div.withConfig({
  displayName: "FormView__Wrapper",
  componentId: "sc-1ux1lgt-3"
})(["display:block;margin:0 auto;width:100%;"]);
styled__default["default"].div.withConfig({
  displayName: "FormView__FormBody",
  componentId: "sc-1ux1lgt-4"
})(["position:relative;flex:1 1 auto;display:flex;flex-direction:column;width:100%;overflow:auto;border-top:1px solid var(--tina-color-grey-2);background-color:white;", "{height:100%;}"], Wrapper);
styled__default["default"].div.withConfig({
  displayName: "FormView__FormFooter",
  componentId: "sc-1ux1lgt-5"
})(["position:relative;flex:0 0 auto;display:flex;align-items:center;width:100%;height:64px;background-color:white;border-top:1px solid var(--tina-color-grey-2);", "{flex:1 0 auto;display:flex;justify-content:space-between;align-items:center;padding:0 16px;}"], Wrapper); // @ts-ignore

styled__default["default"](Button).withConfig({
  displayName: "FormView__SaveButton",
  componentId: "sc-1ux1lgt-6"
})(["flex:1.5 0 auto;padding:12px 24px;"]);

var __jsx$b = React__namespace.createElement;

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GetTextColorForBackground = function GetTextColorForBackground(backgroundColor) {
  //fudgy rgb values found on the internets
  return !backgroundColor || backgroundColor.r * 0.299 + backgroundColor.g * 0.587 + backgroundColor.b * 0.114 > 186 ? "#000000" : "#ffffff";
};

var Swatch = styled__default["default"](function (_ref) {
  var colorRGBA = _ref.colorRGBA,
      colorFormat = _ref.colorFormat;
      _ref.unselectable;
      var props = index._objectWithoutProperties(_ref, ["colorRGBA", "colorFormat", "unselectable"]);

  return __jsx$b("div", props, __jsx$b("div", {
    className: "swatch-inner"
  }, !colorRGBA ? "Click to add color" : ColorFormatter[colorFormat].getLabel(colorRGBA)));
}).withConfig({
  displayName: "ColorPicker__Swatch",
  componentId: "sc-o45di8-0"
})(["background:var(--tina-color-grey-2);border-radius:var(--tina-radius-big);box-shadow:var(--tina-shadow-small);cursor:pointer;width:100%;margin:0;> div{display:flex;align-items:center;justify-content:center;font-size:var(--tina-font-size-1);font-weight:bold;width:100%;height:40px;border-radius:var(--tina-radius-big);box-shadow:inset 0 0 1px 1px rgba(0,0,0,0.075);background:", ";color:", ";transition:all var(--tina-timing-short) ease-out;}&:hover{> div{opacity:0.6;}}"], function (props) {
  return props.colorRGBA ? "rgba(".concat(props.colorRGBA.r, ", ").concat(props.colorRGBA.g, ", ").concat(props.colorRGBA.b, ", ").concat(props.colorRGBA.a, ")") : "#fff";
}, function (props) {
  return GetTextColorForBackground(props.colorRGBA);
});
var ColorPopupKeyframes = styled.keyframes(["0%{transform:translate3d(-50%,0,0) scale3d(0.5,0.5,1)}100%{transform:translate3d(-50%,8px,0) scale3d(1,1,1);}"]);
var ColorPopupOpenTopKeyframes = styled.keyframes(["0%{transform:translate3d(-50%,-100%,0) scale3d(0.5,0.5,1)}100%{transform:translate3d(-50%,calc(-100% - 8px),0) scale3d(1,1,1);}"]);
var Popover = styled__default["default"].div.withConfig({
  displayName: "ColorPicker__Popover",
  componentId: "sc-o45di8-1"
})(["position:fixed;top:", "px;left:", "px;transform:translate3d(-50%,8px,0) scale3d(1,1,1);transform-origin:50% 0;animation:", " 85ms ease-out both 1;z-index:var(--tina-z-index-5);&:before{content:\"\";position:absolute;top:0;left:50%;margin-top:1px;transform:translate3d(-50%,-100%,0);width:18px;height:14px;clip-path:polygon(50% 0%,0% 100%,100% 100%);background-color:var(--tina-color-grey-3);z-index:var(--tina-z-index-1);}&:after{content:\"\";position:absolute;top:0;left:50%;margin-top:2px;transform:translate3d(-50%,-100%,0);width:16px;height:13px;clip-path:polygon(50% 0%,0% 100%,100% 100%);background-color:white;z-index:var(--tina-z-index-2);}", ";"], function (props) {
  return props.triggerBoundingBox ? props.triggerBoundingBox.bottom : "0";
}, function (props) {
  return props.triggerBoundingBox ? props.triggerBoundingBox.left + props.triggerBoundingBox.width / 2 : "0";
}, ColorPopupKeyframes, function (props) {
  return props.openTop && styled.css(["top:", "px;transform:translate3d(-50%,calc(-100% - 8px),0) scale3d(1,1,1);animation:", " 85ms ease-out both 1;transform-origin:50% 100%;&:before,&:after{top:auto;bottom:0;transform:translate3d(-50%,100%,0);clip-path:polygon(0% 0%,100% 0%,50% 100%);}&:before{margin-top:0;margin-bottom:1px;}&:after{margin-top:0;margin-bottom:2px;}"], props.triggerBoundingBox ? props.triggerBoundingBox.top : "0", ColorPopupOpenTopKeyframes);
});
styled__default["default"].div.withConfig({
  displayName: "ColorPicker__Cover",
  componentId: "sc-o45di8-2"
})(["position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100vh;z-index:var(--tina-z-index-1);"]);
var ColorPickerWrapper = styled__default["default"].div.withConfig({
  displayName: "ColorPicker__ColorPickerWrapper",
  componentId: "sc-o45di8-3"
})(["position:relative;"]);
var nullColor = "transparent";
var presetColors = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"];

var SketchWidget = function SketchWidget(props) {
  return __jsx$b(SketchPicker, {
    presetColors: props.presetColors,
    color: props.color,
    onChange: props.onChange,
    disableAlpha: props.disableAlpha,
    width: props.width
  });
};

var BlockWidget = function BlockWidget(props) {
  return __jsx$b(BlockPicker, {
    colors: props.presetColors,
    color: props.color,
    onChange: props.onChange,
    width: props.width
  });
};

var WIDGETS = {
  sketch: SketchWidget,
  block: BlockWidget
};
var ColorPicker = function ColorPicker(_ref2) {
  var colorFormat = _ref2.colorFormat,
      _ref2$userColors = _ref2.userColors,
      userColors = _ref2$userColors === void 0 ? presetColors : _ref2$userColors,
      _ref2$widget = _ref2.widget,
      widget = _ref2$widget === void 0 ? "sketch" : _ref2$widget,
      input = _ref2.input;
  var FormPortal = useFormPortal();
  var triggerRef = React__namespace.useRef(null);

  var _useState = React.useState(null),
      triggerBoundingBox = _useState[0],
      setTriggerBoundingBox = _useState[1];

  var _useState2 = React.useState(false),
      openTop = _useState2[0],
      setOpenTop = _useState2[1];

  var updateTriggerBoundingBox = function updateTriggerBoundingBox() {
    if (triggerRef.current) {
      setTriggerBoundingBox(triggerRef.current.getBoundingClientRect());
    }
  };

  React__namespace.useEffect(function () {
    if (triggerBoundingBox) {
      var triggerOffsetTop = triggerBoundingBox.top + triggerBoundingBox.height / 2;
      var windowHeight = window.innerHeight;

      if (triggerOffsetTop > windowHeight / 2) {
        setOpenTop(true);
      } else {
        setOpenTop(false);
      }
    }
  }, [triggerBoundingBox]);
  React__namespace.useEffect(function () {
    var delay = 100;
    var timeout = false;
    setTimeout(function () {
      updateTriggerBoundingBox();
    }, delay);

    var handleResize = function handleResize() {
      clearTimeout(timeout);
      timeout = setTimeout(updateTriggerBoundingBox, delay);
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [triggerRef.current]);
  var Widget = WIDGETS[widget];
  if (!Widget) throw new Error("You must specify a widget type.");

  var _useState3 = React.useState(false),
      displayColorPicker = _useState3[0],
      setDisplayColorPicker = _useState3[1];

  var getColorFormat = (colorFormat || ColorFormat.Hex).toLowerCase();
  var getColorRGBA = input.value ? ColorFormatter[getColorFormat].parse(input.value) : null;

  var handleChange = function handleChange(pickerColor) {
    var color = pickerColor.hex === nullColor ? null : _objectSpread$7(_objectSpread$7({}, pickerColor.rgb), {}, {
      a: 1
    });
    input.onChange(color ? ColorFormatter[getColorFormat].getValue(color) : null);
  };

  var toggleColorPicker = function toggleColorPicker(event) {
    event.stopPropagation();
    var display = !displayColorPicker;
    setDisplayColorPicker(display);

    if (display) {
      updateTriggerBoundingBox();
    }
  };

  return __jsx$b(ColorPickerWrapper, {
    ref: triggerRef
  }, __jsx$b(Swatch, {
    onClick: toggleColorPicker,
    colorRGBA: getColorRGBA,
    colorFormat: getColorFormat
  }), displayColorPicker && __jsx$b(FormPortal, null, __jsx$b(Popover, {
    openTop: openTop,
    triggerBoundingBox: triggerBoundingBox
  }, __jsx$b(build.exports.Dismissible, {
    click: true,
    escape: true,
    disabled: !displayColorPicker,
    onDismiss: toggleColorPicker
  }, __jsx$b(Widget, {
    presetColors: [].concat(index._toConsumableArray(userColors), [nullColor]),
    color: getColorRGBA || {
      r: 0,
      g: 0,
      b: 0,
      a: 0
    },
    onChange: handleChange,
    disableAlpha: true,
    width: "240px"
  })))));
};

var __jsx$a = React__namespace.createElement;

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Toggle = function Toggle(_ref) {
  var input = _ref.input,
      field = _ref.field;
      _ref.name;
      var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var checked = !!(input.value || input.checked);

  var toggleProps = _objectSpread$6(_objectSpread$6({}, input), {}, {
    labels: null,
    name: field.name,
    disabled: disabled,
    value: checked,
    checked: checked
  });

  return __jsx$a(ToggleFieldWrapper, null, __jsx$a(index.SSToggle, toggleProps));
};
var ToggleFieldWrapper = styled__default["default"].div.withConfig({
  displayName: "Toggle__ToggleFieldWrapper",
  componentId: "sc-arbxdj-0"
})(["display:flex;justify-content:flex-end;"]);

var MIXED_VALUE = "__MIXED__";
var COMPONENTS_SUPPORTING_MIXED_VALUES = ["ss-block", "radio-group", "select", "token"];

function isMixedFieldValue(value) {
  return typeof value === "object" && value !== null && "__mixed__" in value && value.__mixed__;
}

var __jsx$9 = React__namespace.createElement;
var RadioGroup = function RadioGroup(_ref) {
  var input = _ref.input,
      field = _ref.field,
      options = _ref.options;
  var value = input.value;

  var _React$useState = React__namespace.useState(null),
      _React$useState2 = index._slicedToArray(_React$useState, 2);
      _React$useState2[0];
      var setActiveRadioRef = _React$useState2[1];

  var radioOptions = options || field.options;
  var radioRefs = {};
  var toggleButtonValue = isMixedFieldValue(value) ? undefined : value;
  React__namespace.useEffect(function () {
    if (toggleButtonValue) {
      setActiveRadioRef(radioRefs["radio_".concat(toggleButtonValue)]);
    }
  }, [toggleButtonValue]);

  var toProps = function toProps(option) {
    if (typeof option === "object") return option;
    return {
      value: option,
      label: option
    };
  };

  var radioOptionsMapped = radioOptions ? radioOptions.map(toProps) : [];
  return radioOptionsMapped && __jsx$9(index.SSSelectInline, index._extends({}, input, {
    value: toggleButtonValue
  }), radioOptionsMapped.map(function (option) {
    return __jsx$9(index.SSToggleButton, {
      key: option.value,
      icon: option.icon,
      value: option.value,
      hideLabel: option.hideLabel
    }, option.label);
  }));
};
styled__default["default"].span.withConfig({
  displayName: "RadioGroup__Label",
  componentId: "sc-1ovmjz5-0"
})(["", ""], function (p) {
  return p.variant === "button" ? "position: relative;" : "";
});
styled__default["default"].div.withConfig({
  displayName: "RadioGroup__ActiveRadioIndicator",
  componentId: "sc-1ovmjz5-1"
})(["position:absolute;", ";", ";", ";", " ", " transition:all 85ms ease-out;backface-visibility:hidden;background-color:var(--tina-color-primary);box-shadow:var(--tina-shadow-small);border-radius:var(--tina-radius-big);height:calc(40px - 6px);pointer-events:none;"], function (p) {
  return p.width ? "width: ".concat(p.width, "px;") : "";
}, function (p) {
  return p.height ? "height: ".concat(p.width, "px;") : "";
}, function (p) {
  return p.left ? "left: ".concat(p.left, "px;") : "";
}, function (p) {
  return p.top ? "top: ".concat(p.top, "px;") : "";
}, function (p) {
  return "transform: scale(".concat(p.hasValue ? "1" : "0", ");");
});
styled__default["default"].div.withConfig({
  displayName: "RadioGroup__RadioOptions",
  componentId: "sc-1ovmjz5-2"
})(["display:flex;padding-top:4px;", " ", ""], function (p) {
  return p.variant === "button" ? "\n    min-height: calc(40px + 2px);\n    background-color: var(--tina-color-grey-0);\n    border-radius: var(--tina-radius-big);\n    box-shadow: var(--tina-shadow-small);\n    background-color: var(--tina-color-grey-0);\n    border: 1px solid var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    padding: 3px;\n    box-shadow: 0 0 0 0 var(--tina-color-grey-3);\n    transition: all 85ms ease-out;\n    gap: 3px;\n    &:hover {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n    &:focus-within, &:active {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  " : "\n    gap: 12px;\n    flex-wrap: wrap;\n  ";
}, function (p) {
  return p.direction === "vertical" ? "flex-direction: column;" : "";
});
styled__default["default"].div.withConfig({
  displayName: "RadioGroup__RadioOptionWrap",
  componentId: "sc-1ovmjz5-3"
})(["", " & > input{position:absolute;opacity:0;cursor:pointer;height:0;width:0;}"], function (p) {
  return p.variant === "button" ? "\n      \n    flex: 1;\n    " : "";
});
styled__default["default"].label.withConfig({
  displayName: "RadioGroup__RadioOption",
  componentId: "sc-1ovmjz5-4"
})(["display:flex;align-items:center;font-size:var(--tina-font-size-1);", ""], function (p) {
  return p.variant === "button" ? "\n    flex: 1;\n    text-align: center;\n    border-radius: var(--tina-radius-big);\n    border: 1px solid var(--tina-color-grey-2);\n    color: var(--tina-color-primary);\n    font-weight: var(--tina-font-weight-regular);\n    cursor: pointer;\n    font-size: var(--tina-font-size-1);\n    height: calc(40px - 6px);\n    padding: 0 var(--tina-padding-small);\n    transition: all 85ms ease-out;\n    margin: 0;\n    border: none;\n    text-align: center;\n    justify-content: center;\n    input:checked + & {\n      color: var(--tina-color-grey-0);\n    }\n    &:hover {\n      background-color: var(--tina-color-grey-1);\n    }\n    &:active {\n      background-color: var(--tina-color-grey-2);\n    }\n  " : "\n  &:before {\n    content: '';\n    display: block;\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n    border-radius: var(--tina-radius-big);\n    background-color: var(--tina-color-primary);\n    border: 1px solid var(".concat(function (p) {
    return p.checked ? "--tina-color-primary" : "--tina-color-grey-2";
  }, ");\n    box-shadow: 0 0 0 0 var(--tina-color-grey-3), inset 0 0 0 8px white;\n    transition: all 85ms ease-out;\n  }\n  &:hover:before {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3), inset 0 0 0 8px white;\n  }\n  input:focus + &:before {\n    border: 1px solid var(--tina-color-grey-2);\n    box-shadow: 0 0 0 2px var(--tina-color-primary), inset 0 0 0 8px white;\n  }\n  input:checked + &:before {\n    border: 1px solid var(--tina-color-primary);\n    box-shadow: 0 0 0 0 var(--tina-color-primary), inset 0 0 0 4px white;\n  }\n  input:checked:focus + &:before {\n    border: 1px solid var(--tina-color-grey-2);\n    box-shadow: 0 0 0 2px var(--tina-color-primary), inset 0 0 0 4px white;\n  }\n  ");
});

var COMMON_MIME_TYPES = new Map([['avi', 'video/avi'], ['gif', 'image/gif'], ['ico', 'image/x-icon'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['mkv', 'video/x-matroska'], ['mov', 'video/quicktime'], ['mp4', 'video/mp4'], ['pdf', 'application/pdf'], ['png', 'image/png'], ['zip', 'application/zip'], ['doc', 'application/msword'], ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);

  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value: typeof path === 'string' ? path // If <input webkitdirectory> is set,
      // the File will have a {webkitRelativePath} property
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
      : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }

  return f;
}

function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;

  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);

    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }

  return file;
}

var FILES_TO_IGNORE = [// Thumbnail cache files for macOS and Windows
'.DS_Store', 'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */

function fromEvent(evt) {
  return tslib.__awaiter(this, void 0, void 0, function () {
    return tslib.__generator(this, function (_a) {
      return [2
      /*return*/
      , isDragEvt(evt) && evt.dataTransfer ? getDataTransferFiles(evt.dataTransfer, evt.type) : getInputFiles(evt)];
    });
  });
}

function isDragEvt(value) {
  return !!value.dataTransfer;
}

function getInputFiles(evt) {
  var files = isInput(evt.target) ? evt.target.files ? fromList(evt.target.files) : [] : [];
  return files.map(function (file) {
    return toFileWithPath(file);
  });
}

function isInput(value) {
  return value !== null;
}

function getDataTransferFiles(dt, type) {
  return tslib.__awaiter(this, void 0, void 0, function () {
    var items, files;
    return tslib.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items) return [3
          /*break*/
          , 2];
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          }); // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)

          if (type !== 'drop') {
            return [2
            /*return*/
            , items];
          }

          return [4
          /*yield*/
          , Promise.all(items.map(toFilePromises))];

        case 1:
          files = _a.sent();
          return [2
          /*return*/
          , noIgnoredFiles(flatten(files))];

        case 2:
          return [2
          /*return*/
          , noIgnoredFiles(fromList(dt.files).map(function (file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}

function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
} // IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList


function fromList(items) {
  var files = []; // tslint:disable: prefer-for-of

  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }

  return files;
} // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem


function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }

  var entry = item.webkitGetAsEntry(); // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file

  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }

  return fromDataTransferItem(item);
}

function flatten(items) {
  return items.reduce(function (acc, files) {
    return tslib.__spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}

function fromDataTransferItem(item) {
  var file = item.getAsFile();

  if (!file) {
    return Promise.reject(item + " is not a File");
  }

  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry


function fromEntry(entry) {
  return tslib.__awaiter(this, void 0, void 0, function () {
    return tslib.__generator(this, function (_a) {
      return [2
      /*return*/
      , entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry


function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];

    function readEntries() {
      var _this = this; // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries


      reader.readEntries(function (batch) {
        return tslib.__awaiter(_this, void 0, void 0, function () {
          var files, err_1, items;
          return tslib.__generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!!batch.length) return [3
                /*break*/
                , 5];
                _a.label = 1;

              case 1:
                _a.trys.push([1, 3,, 4]);

                return [4
                /*yield*/
                , Promise.all(entries)];

              case 2:
                files = _a.sent();
                resolve(files);
                return [3
                /*break*/
                , 4];

              case 3:
                err_1 = _a.sent();
                reject(err_1);
                return [3
                /*break*/
                , 4];

              case 4:
                return [3
                /*break*/
                , 6];

              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items); // Continue reading

                readEntries();
                _a.label = 6;

              case 6:
                return [2
                /*return*/
                ];
            }
          });
        });
      }, function (err) {
        reject(err);
      });
    }

    readEntries();
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry


function fromFileEntry(entry) {
  return tslib.__awaiter(this, void 0, void 0, function () {
    return tslib.__generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        entry.file(function (file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function (err) {
          reject(err);
        });
      })];
    });
  });
}

var dist = function (t) {
  function n(e) {
    if (r[e]) return r[e].exports;
    var o = r[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return t[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  var r = {};
  return n.m = t, n.c = r, n.d = function (t, r, e) {
    n.o(t, r) || Object.defineProperty(t, r, {
      configurable: !1,
      enumerable: !0,
      get: e
    });
  }, n.n = function (t) {
    var r = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n(n.s = 13);
}([function (t, n) {
  var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = r);
}, function (t, n) {
  t.exports = function (t) {
    return "object" == typeof t ? null !== t : "function" == typeof t;
  };
}, function (t, n) {
  var r = t.exports = {
    version: "2.5.0"
  };
  "number" == typeof __e && (__e = r);
}, function (t, n, r) {
  t.exports = !r(4)(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, n) {
  t.exports = function (t) {
    try {
      return !!t();
    } catch (t) {
      return !0;
    }
  };
}, function (t, n) {
  var r = {}.toString;

  t.exports = function (t) {
    return r.call(t).slice(8, -1);
  };
}, function (t, n, r) {
  var e = r(32)("wks"),
      o = r(9),
      i = r(0).Symbol,
      u = "function" == typeof i;
  (t.exports = function (t) {
    return e[t] || (e[t] = u && i[t] || (u ? i : o)("Symbol." + t));
  }).store = e;
}, function (t, n, r) {
  var e = r(0),
      o = r(2),
      i = r(8),
      u = r(22),
      c = r(10),
      f = function f(t, n, r) {
    var a,
        s,
        p,
        l,
        v = t & f.F,
        y = t & f.G,
        h = t & f.S,
        d = t & f.P,
        x = t & f.B,
        g = y ? e : h ? e[n] || (e[n] = {}) : (e[n] || {}).prototype,
        m = y ? o : o[n] || (o[n] = {}),
        b = m.prototype || (m.prototype = {});
    y && (r = n);

    for (a in r) {
      s = !v && g && void 0 !== g[a], p = (s ? g : r)[a], l = x && s ? c(p, e) : d && "function" == typeof p ? c(Function.call, p) : p, g && u(g, a, p, t & f.U), m[a] != p && i(m, a, l), d && b[a] != p && (b[a] = p);
    }
  };

  e.core = o, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, t.exports = f;
}, function (t, n, r) {
  var e = r(16),
      o = r(21);
  t.exports = r(3) ? function (t, n, r) {
    return e.f(t, n, o(1, r));
  } : function (t, n, r) {
    return t[n] = r, t;
  };
}, function (t, n) {
  var r = 0,
      e = Math.random();

  t.exports = function (t) {
    return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
  };
}, function (t, n, r) {
  var e = r(24);

  t.exports = function (t, n, r) {
    if (e(t), void 0 === n) return t;

    switch (r) {
      case 1:
        return function (r) {
          return t.call(n, r);
        };

      case 2:
        return function (r, e) {
          return t.call(n, r, e);
        };

      case 3:
        return function (r, e, o) {
          return t.call(n, r, e, o);
        };
    }

    return function () {
      return t.apply(n, arguments);
    };
  };
}, function (t, n) {
  t.exports = function (t) {
    if (void 0 == t) throw TypeError("Can't call method on  " + t);
    return t;
  };
}, function (t, n, r) {
  var e = r(28),
      o = Math.min;

  t.exports = function (t) {
    return t > 0 ? o(e(t), 9007199254740991) : 0;
  };
}, function (t, n, r) {

  n.__esModule = !0, n["default"] = function (t, n) {
    if (t && n) {
      var r = Array.isArray(n) ? n : n.split(","),
          e = t.name || "",
          o = t.type || "",
          i = o.replace(/\/.*$/, "");
      return r.some(function (t) {
        var n = t.trim();
        return "." === n.charAt(0) ? e.toLowerCase().endsWith(n.toLowerCase()) : n.endsWith("/*") ? i === n.replace(/\/.*$/, "") : o === n;
      });
    }

    return !0;
  }, r(14), r(34);
}, function (t, n, r) {
  r(15), t.exports = r(2).Array.some;
}, function (t, n, r) {

  var e = r(7),
      o = r(25)(3);
  e(e.P + e.F * !r(33)([].some, !0), "Array", {
    some: function some(t) {
      return o(this, t, arguments[1]);
    }
  });
}, function (t, n, r) {
  var e = r(17),
      o = r(18),
      i = r(20),
      u = Object.defineProperty;
  n.f = r(3) ? Object.defineProperty : function (t, n, r) {
    if (e(t), n = i(n, !0), e(r), o) try {
      return u(t, n, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
    return "value" in r && (t[n] = r.value), t;
  };
}, function (t, n, r) {
  var e = r(1);

  t.exports = function (t) {
    if (!e(t)) throw TypeError(t + " is not an object!");
    return t;
  };
}, function (t, n, r) {
  t.exports = !r(3) && !r(4)(function () {
    return 7 != Object.defineProperty(r(19)("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, n, r) {
  var e = r(1),
      o = r(0).document,
      i = e(o) && e(o.createElement);

  t.exports = function (t) {
    return i ? o.createElement(t) : {};
  };
}, function (t, n, r) {
  var e = r(1);

  t.exports = function (t, n) {
    if (!e(t)) return t;
    var r, o;
    if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
    if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    throw TypeError("Can't convert object to primitive value");
  };
}, function (t, n) {
  t.exports = function (t, n) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: n
    };
  };
}, function (t, n, r) {
  var e = r(0),
      o = r(8),
      i = r(23),
      u = r(9)("src"),
      c = Function.toString,
      f = ("" + c).split("toString");
  r(2).inspectSource = function (t) {
    return c.call(t);
  }, (t.exports = function (t, n, r, c) {
    var a = "function" == typeof r;
    a && (i(r, "name") || o(r, "name", n)), t[n] !== r && (a && (i(r, u) || o(r, u, t[n] ? "" + t[n] : f.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : o(t, n, r) : (delete t[n], o(t, n, r)));
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && this[u] || c.call(this);
  });
}, function (t, n) {
  var r = {}.hasOwnProperty;

  t.exports = function (t, n) {
    return r.call(t, n);
  };
}, function (t, n) {
  t.exports = function (t) {
    if ("function" != typeof t) throw TypeError(t + " is not a function!");
    return t;
  };
}, function (t, n, r) {
  var e = r(10),
      o = r(26),
      i = r(27),
      u = r(12),
      c = r(29);

  t.exports = function (t, n) {
    var r = 1 == t,
        f = 2 == t,
        a = 3 == t,
        s = 4 == t,
        p = 6 == t,
        l = 5 == t || p,
        v = n || c;
    return function (n, c, y) {
      for (var h, d, x = i(n), g = o(x), m = e(c, y, 3), b = u(g.length), _ = 0, w = r ? v(n, b) : f ? v(n, 0) : void 0; b > _; _++) {
        if ((l || _ in g) && (h = g[_], d = m(h, _, x), t)) if (r) w[_] = d;else if (d) switch (t) {
          case 3:
            return !0;

          case 5:
            return h;

          case 6:
            return _;

          case 2:
            w.push(h);
        } else if (s) return !1;
      }

      return p ? -1 : a || s ? s : w;
    };
  };
}, function (t, n, r) {
  var e = r(5);
  t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
    return "String" == e(t) ? t.split("") : Object(t);
  };
}, function (t, n, r) {
  var e = r(11);

  t.exports = function (t) {
    return Object(e(t));
  };
}, function (t, n) {
  var r = Math.ceil,
      e = Math.floor;

  t.exports = function (t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
  };
}, function (t, n, r) {
  var e = r(30);

  t.exports = function (t, n) {
    return new (e(t))(n);
  };
}, function (t, n, r) {
  var e = r(1),
      o = r(31),
      i = r(6)("species");

  t.exports = function (t) {
    var n;
    return o(t) && (n = t.constructor, "function" != typeof n || n !== Array && !o(n.prototype) || (n = void 0), e(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
  };
}, function (t, n, r) {
  var e = r(5);

  t.exports = Array.isArray || function (t) {
    return "Array" == e(t);
  };
}, function (t, n, r) {
  var e = r(0),
      o = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});

  t.exports = function (t) {
    return o[t] || (o[t] = {});
  };
}, function (t, n, r) {

  var e = r(4);

  t.exports = function (t, n) {
    return !!t && e(function () {
      n ? t.call(null, function () {}, 1) : t.call(null);
    });
  };
}, function (t, n, r) {
  r(35), t.exports = r(2).String.endsWith;
}, function (t, n, r) {

  var e = r(7),
      o = r(12),
      i = r(36),
      u = "".endsWith;
  e(e.P + e.F * r(38)("endsWith"), "String", {
    endsWith: function endsWith(t) {
      var n = i(this, t, "endsWith"),
          r = arguments.length > 1 ? arguments[1] : void 0,
          e = o(n.length),
          c = void 0 === r ? e : Math.min(o(r), e),
          f = String(t);
      return u ? u.call(n, f, c) : n.slice(c - f.length, c) === f;
    }
  });
}, function (t, n, r) {
  var e = r(37),
      o = r(11);

  t.exports = function (t, n, r) {
    if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
    return String(o(t));
  };
}, function (t, n, r) {
  var e = r(1),
      o = r(5),
      i = r(6)("match");

  t.exports = function (t) {
    var n;
    return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
  };
}, function (t, n, r) {
  var e = r(6)("match");

  t.exports = function (t) {
    var n = /./;

    try {
      "/./"[t](n);
    } catch (r) {
      try {
        return n[e] = !1, !"/./"[t](n);
      } catch (t) {}
    }

    return !0;
  };
}]);

// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || dist(file, accept);
}
function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}
function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  React.useEffect(function () {
    if (typeof ref === 'function') {
      ref({
        open: open
      });
    } else if (_typeof(ref) === 'object' && ref !== null) {
      ref.current = {
        open: open
      };
    }

    return function () {
      if (typeof ref === 'function') {
        ref(null);
      } else if (_typeof(ref) === 'object' && ref !== null) {
        ref.current = null;
      }
    };
  }, [ref]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, children(_objectSpread$5({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: index.PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.arrayOf(index.PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: index.PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: index.PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: index.PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: index.PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: index.PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: index.PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: index.PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: index.PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: index.PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: index.PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: index.PropTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: index.PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: index.PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: index.PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
  /**
   * A React hook that creates a drag 'n' drop area.
   *
   * ```jsx
   * function MyDropzone(props) {
   *   const {getRootProps, getInputProps} = useDropzone({
   *     onDrop: acceptedFiles => {
   *       // do something with the File objects, e.g. upload to some server
   *     }
   *   });
   *   return (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag and drop some files here, or click to select files</p>
   *     </div>
   *   )
   * }
   * ```
   *
   * @function useDropzone
   *
   * @param {object} props
   * @param {string|string[]} [props.accept] Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
   * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
   * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
   * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
   * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
   * @param {number} [props.minSize=0] Minimum file size (in bytes)
   * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
   * @param {boolean} [props.disabled=false] Enable/disable the dropzone
   * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
   * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
   * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
   * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
   * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
   * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   * @param {dropAcceptedCb} [props.onDropAccepted]
   * @param {dropRejectedCb} [props.onDropRejected]
   *
   * @returns {DropzoneState}
   */

};
function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useReducer = React.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = function openFileDialog() {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }; // Update file dialog active state when the window is focused on


  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  React.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = React.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = React.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      dragTargets = _useState2[0],
      setDragTargets = _useState2[1];

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    setDragTargets([]);
  };

  React.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargets.indexOf(event.target) === -1) {
      setDragTargets([].concat(_toConsumableArray(dragTargets), [event.target]));
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [dragTargets, getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = _toConsumableArray(dragTargets.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    }));

    setDragTargets(targets);

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, dragTargets, onDragLeave, noDragEventsBubbling]);
  var onDropCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    setDragTargets([]);
    dispatch({
      type: 'reset'
    });

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, maxSize, minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread$5(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React.useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$5({}, inputProps, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isMultipleAllowed = multiple || fileCount <= 1;
  var isDragAccept = fileCount > 0 && allFilesAccepted(draggedFiles, accept);
  var isDragReject = fileCount > 0 && (!isDragAccept || !isMultipleAllowed);
  return _objectSpread$5({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread$5({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread$5({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread$5({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread$5({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread$5({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread$5({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread$5({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: []
      });

    default:
      return state;
  }
}

var __jsx$8 = React__namespace.createElement;
var DropArea = styled__default["default"].div.withConfig({
  displayName: "ImageUpload__DropArea",
  componentId: "sc-13la4l7-0"
})(["border-radius:var(--tina-radius-small);flex:1;display:flex;flex-direction:column;outline:none;cursor:pointer;"]);
var ImgPlaceholder = styled__default["default"].div.withConfig({
  displayName: "ImageUpload__ImgPlaceholder",
  componentId: "sc-13la4l7-1"
})(["text-align:center;border-radius:var(--tina-radius-small);background-color:var(--tina-color-grey-2);color:var(--tina-color-grey-4);line-height:1.35;padding:12px 0;font-size:var(--tina-font-size-2);font-weight:var(--tina-font-weight-regular);transition:all 85ms ease-out;&:hover{opacity:0.6;}"]);
var StyledImage = styled__default["default"].img.withConfig({
  displayName: "ImageUpload__StyledImage",
  componentId: "sc-13la4l7-2"
})(["max-width:100%;min-height:100px;border-radius:var(--tina-radius-small);transition:opacity var(--tina-timing-short) ease-out;margin:0;display:block;background-color:#e1ddec;background-size:auto;background-position:center center;background-repeat:no-repeat;", ""], function (props) {
  return props.src && (props.src.includes("png") || props.src.includes("svg")) ? styled.css(["background-image:none;"]) : styled.css(["background-image:url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");"]);
}); // @ts-ignore circularly references itself

var DeleteButton = styled__default["default"](IconButton).withConfig({
  displayName: "ImageUpload__DeleteButton",
  componentId: "sc-13la4l7-3"
})(["top:8px;right:8px;position:absolute;&:not(:hover){fill:var(--tina-color-grey-0);background-color:transparent;border-color:transparent;}"]);
var StyledImageContainer = styled__default["default"].div.withConfig({
  displayName: "ImageUpload__StyledImageContainer",
  componentId: "sc-13la4l7-4"
})(["background-color:var(--tina-color-grey-4);position:relative;border-radius:var(--tina-radius-small);overflow:hidden;background-color:var(--tina-color-grey-8);&:hover{", "{opacity:0.6;}}"], StyledImage);
var ImageUpload = function ImageUpload(_ref) {
  var onDrop = _ref.onDrop,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      value = _ref.value,
      previewSrc = _ref.previewSrc,
      loading = _ref.loading;

  var _useDropzone = useDropzone({
    accept: "image/*",
    onDrop: onDrop,
    noClick: !!onClick
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  return __jsx$8(DropArea, index._extends({}, getRootProps(), {
    onClick: onClick
  }), __jsx$8("input", getInputProps()), value ? __jsx$8(StyledImageContainer, null, loading ? __jsx$8(ImageLoadingIndicator, null) : __jsx$8(React__namespace.Fragment, null, __jsx$8(StyledImage, {
    src: previewSrc
  }), onClear && __jsx$8(DeleteButton, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClear();
    }
  }, __jsx$8(TrashIcon, null)))) : __jsx$8(ImgPlaceholder, null, "Drag 'n' drop some files here,", __jsx$8("br", null), "or click to select files"));
};

var ImageLoadingIndicator = function ImageLoadingIndicator() {
  return __jsx$8(ImageLoaderWrapper, null, __jsx$8(LoadingDots, null));
};

var ImageLoaderWrapper = styled__default["default"].div.withConfig({
  displayName: "ImageUpload__ImageLoaderWrapper",
  componentId: "sc-13la4l7-5"
})(["padding:1rem;width:100%;min-height:6rem;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);

var __jsx$7 = React__default["default"].createElement;
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      rest = index._objectWithoutProperties(_ref, ["children", "style"]);

  return /*#__PURE__*/ReactDOM.createPortal(__jsx$7("div", index._extends({
    style: style,
    ref: ref
  }, rest), children), document.body);
});
var TooltipBody = styled__default["default"].div.withConfig({
  displayName: "Tooltip__TooltipBody",
  componentId: "sc-typ5dd-0"
})(["position:relative;top:6px;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:6px 4px;background:#333333;border-radius:2px;", " color:#fff;"], index.SSFonts.body);
var TooltipArrow = styled__default["default"].div.withConfig({
  displayName: "Tooltip__TooltipArrow",
  componentId: "sc-typ5dd-1"
})(["width:12px;height:6px;margin:0 auto;background:#333333;clip-path:polygon(50% 0%,0% 100%,100% 100%);"]);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function useTooltip() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick;

  var _useState = React.useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = React.useState(null),
      triggerElement = _useState2[0],
      setTriggerElement = _useState2[1];

  var _useState3 = React.useState(null),
      tooltipElement = _useState3[0],
      setTooltipElement = _useState3[1];

  var _useState4 = React.useState(null),
      arrowElement = _useState4[0],
      setArrowElement = _useState4[1];

  var _usePopper = reactPopper.usePopper(triggerElement, tooltipElement, {
    strategy: "absolute",
    placement: "bottom",
    modifiers: [{
      name: "arrow",
      options: {
        element: arrowElement,
        padding: 6
      }
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var tooltipTrigger = tooltip.useTooltipTrigger({
    isDisabled: isDisabled,
    delay: 0
  }, {
    isOpen: isOpen,
    open: function open() {
      setIsOpen(true);
    },
    close: function close() {
      setIsOpen(false);
    }
  }, {
    current: triggerElement
  });

  var triggerProps = _objectSpread$4(_objectSpread$4({
    ref: setTriggerElement
  }, tooltipTrigger.triggerProps), {}, {
    onClick: onClick === undefined ? tooltipTrigger.tooltipProps.onClick : function (event) {
      var _tooltipTrigger$toolt, _tooltipTrigger$toolt2;

      (_tooltipTrigger$toolt = (_tooltipTrigger$toolt2 = tooltipTrigger.tooltipProps).onClick) === null || _tooltipTrigger$toolt === void 0 ? void 0 : _tooltipTrigger$toolt.call(_tooltipTrigger$toolt2, event);
      onClick();
    }
  });

  var tooltipProps = _objectSpread$4(_objectSpread$4({
    ref: setTooltipElement,
    style: styles.popper
  }, attributes.popper), tooltipTrigger.tooltipProps);

  var arrowProps = {
    ref: setArrowElement,
    style: styles.arrow
  };
  return {
    isOpen: isOpen,
    triggerProps: triggerProps,
    tooltipProps: tooltipProps,
    arrowProps: arrowProps
  };
}

var __jsx$6 = React__namespace.createElement;
// Wraps the Field component in labels describing the field's meta state
// Add any other fields that the Field component should expect onto the ExtraFieldProps generic type
function FieldMetaWrapper(_ref) {
  var _renderLabel;

  var children = _ref.children,
      field = _ref.field,
      input = _ref.input,
      meta = _ref.meta,
      noWrap = _ref.noWrap,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "row" : _ref$layout,
      renderLabel = _ref.renderLabel,
      isLabelHidden = _ref.isLabelHidden;
  var editorContext = index.useEditorContext();
  var runChange = editorContext.actions.runChange,
      form = editorContext.form,
      resources = editorContext.resources;

  var _useTooltip = useTooltip({
    isDisabled: field.description === undefined
  }),
      isOpen = _useTooltip.isOpen,
      tooltipProps = _useTooltip.tooltipProps,
      triggerProps = _useTooltip.triggerProps,
      arrowProps = _useTooltip.arrowProps;

  var isMixedValueSupported = isMixedValueSupportedByComponent(isResponsiveField(field) ? field.subComponent : field.component);
  var isMixedValue = isMixedFieldValue(input.value);

  function handleButtonMixedClick() {
    runChange(function () {
      toArray(field.name).forEach(function (fieldName, _, names) {
        var firstFieldValue = dotNotationGet(form.values, names[0]);
        form.change(fieldName, firstFieldValue);
      });
    });
  }

  var content = __jsx$6(_StyledDiv$1, {
    $_css: layout === "row" ? "flex-end" : "flex-start"
  }, !isMixedValue || isMixedValue && isMixedValueSupported ? children : __jsx$6(TextButton, {
    component: "button",
    variant: "label",
    color: "black40",
    onClick: handleButtonMixedClick
  }, "Mixed"), meta.error && __jsx$6(FieldError, null, meta.error));

  if (noWrap) {
    return content;
  }

  var label = field.label || input.name;
  var schemaProp = field.schemaProp;
  var isResource = index.isResourceSchemaProp(schemaProp);
  var resolvedResource = isResource ? resources.find(index.resourceByIdentity(input.value.id, index.getResourceType(schemaProp, editorContext), input.value.info, index.getResourceFetchParams(schemaProp, editorContext))) : undefined;
  return __jsx$6(FieldWrapper, {
    margin: false,
    layout: layout
  }, !isLabelHidden && __jsx$6(FieldLabelWrapper, null, (_renderLabel = renderLabel === null || renderLabel === void 0 ? void 0 : renderLabel({
    label: label
  })) !== null && _renderLabel !== void 0 ? _renderLabel : __jsx$6(FieldLabel, index._extends({
    htmlFor: input.name,
    isError: resolvedResource !== undefined && resolvedResource.status === "error"
  }, triggerProps), label, isOpen && __jsx$6(Tooltip, tooltipProps, __jsx$6(TooltipArrow, arrowProps), __jsx$6(TooltipBody, null, field.description)))), __jsx$6(FieldInputWrapper, {
    layout: layout
  }, content));
}

function isResponsiveField(field) {
  return typeof field.component === "string" && field.component === "responsive2";
}

function isMixedValueSupportedByComponent(component) {
  if (typeof component === "string") {
    return COMPONENTS_SUPPORTING_MIXED_VALUES.includes(component);
  }

  return false;
}

var TextButton = styled__default["default"](index.Typography).withConfig({
  displayName: "wrapFieldWithMeta__TextButton",
  componentId: "sc-18u09ea-0"
})(["padding:0;margin:0;background:transparent;border:0;font-weight:500;&:hover{color:black;cursor:pointer;text-decoration:underline;}"]);
function wrapFieldsWithMeta(Field, extraProps) {
  return function (props) {
    return __jsx$6(FieldMetaWrapper, index._extends({}, props, extraProps), __jsx$6(Field, props));
  };
}
var FieldWrapper = styled__default["default"].div.withConfig({
  displayName: "wrapFieldWithMeta__FieldWrapper",
  componentId: "sc-18u09ea-1"
})(["display:flex;flex-direction:", ";gap:", ";justify-content:space-between;align-items:flex-start;position:relative;padding:4px 16px;"], function (_ref2) {
  var layout = _ref2.layout;
  return layout;
}, function (_ref3) {
  var layout = _ref3.layout;
  return layout === "row" ? "10px" : "4px";
});
var FieldLabelWrapper = styled__default["default"].div.withConfig({
  displayName: "wrapFieldWithMeta__FieldLabelWrapper",
  componentId: "sc-18u09ea-2"
})(["all:unset;position:relative;display:flex;flex-direction:row;align-items:center;min-height:28px;"]);
var FieldLabel = styled__default["default"].label.withConfig({
  displayName: "wrapFieldWithMeta__FieldLabel",
  componentId: "sc-18u09ea-3"
})(["all:unset;", ";display:block;color:", ";text-overflow:ellipsis;overflow:hidden;cursor:default;"], index.SSFonts.body, function (_ref4) {
  var isError = _ref4.isError;
  return isError ? "red" : "#000";
});
styled__default["default"].span.withConfig({
  displayName: "wrapFieldWithMeta__FieldDescription",
  componentId: "sc-18u09ea-4"
})(["all:unset;display:block;font-family:\"Inter\",sans-serif;font-size:var(--tina-font-size-0);font-style:italic;font-weight:lighter;color:var(--tina-color-grey-6);padding-top:4px;white-space:normal;margin:0;"]);
var FieldError = styled__default["default"].span.withConfig({
  displayName: "wrapFieldWithMeta__FieldError",
  componentId: "sc-18u09ea-5"
})(["display:block;color:red;font-size:var(--tina-font-size-1);margin-top:8px;font-weight:var(--tina-font-weight-regular);"]);
var FieldInputWrapper = styled__default["default"].div.withConfig({
  displayName: "wrapFieldWithMeta__FieldInputWrapper",
  componentId: "sc-18u09ea-6"
})(["display:flex;justify-content:flex-end;align-items:center;", ";min-height:28px;"], function (_ref5) {
  var layout = _ref5.layout;
  return layout === "row" ? styled.css(["flex-grow:1;"]) : styled.css(["width:100%;"]);
});

var _StyledDiv$1 = styled__default["default"]("div").withConfig({
  displayName: "wrapFieldWithMeta___StyledDiv",
  componentId: "sc-18u09ea-7"
})(["width:100%;display:flex;justify-content:", ";"], function (p) {
  return p.$_css;
});

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/
var parse = function parse(value) {
  return value || "";
};

var PanelBody = styled__default["default"].div.withConfig({
  displayName: "GroupFieldPlugin__PanelBody",
  componentId: "sc-13nltqr-0"
})(["background:white;position:relative;height:100%;overflow-y:auto;"]);
var GroupPanelKeyframes = styled.keyframes(["0%{transform:translate3d( 100%,0,0 );}100%{transform:translate3d( 0,0,0 );}"]);
var GroupPanel = styled__default["default"].div.withConfig({
  displayName: "GroupFieldPlugin__GroupPanel",
  componentId: "sc-13nltqr-1"
})(["position:absolute;width:100%;top:0;bottom:0;left:0;overflow:hidden;z-index:var(--tina-z-index-1);pointer-events:", ";> *{", ";", ";}"], function (p) {
  return p.isExpanded ? "all" : "none";
}, function (p) {
  return p.isExpanded && styled.css(["animation-name:", ";animation-duration:150ms;animation-delay:0ms;animation-iteration-count:1;animation-timing-function:ease-out;animation-fill-mode:backwards;"], GroupPanelKeyframes);
}, function (p) {
  return !p.isExpanded && styled.css(["transition:transform 150ms ease-out;transform:translate3d(100%,0,0);"]);
});

var __jsx$5 = React__namespace.createElement;

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTextValue(value, onChange, defaultPlaceholder, normalize) {
  var _useEditorContext = index.useEditorContext(),
      actions = _useEditorContext.actions,
      locale = _useEditorContext.contextParams.locale,
      locales = _useEditorContext.locales;

  var isExternal = typeof value === "object" && value !== null;
  var fallbackValue = isExternal ? getFallbackForLocale(value.value, locale, locales) : undefined;

  var valueFromProps = function () {
    if (isExternal) {
      var displayedValue = value.value[locale];

      if (typeof displayedValue !== "string") {
        displayedValue = fallbackValue !== null && fallbackValue !== void 0 ? fallbackValue : "";
      }

      return displayedValue;
    }

    return value !== null && value !== void 0 ? value : "";
  }();

  var previousValue = React.useRef(valueFromProps);

  var _React$useState = React__namespace.useState(valueFromProps),
      _React$useState2 = index._slicedToArray(_React$useState, 2),
      localInputValue = _React$useState2[0],
      setLocalInputValue = _React$useState2[1];

  function saveNewValue(newValue) {
    actions.runChange(function () {
      if (isExternal) {
        var newExternalValue = _objectSpread$3(_objectSpread$3({}, value), {}, {
          value: _objectSpread$3(_objectSpread$3({}, value.value), {}, index._defineProperty({}, locale, newValue))
        });

        onChange(newExternalValue);
      } else {
        onChange(newValue);
      }
    });
  }

  var onChangeDebounced = React__namespace.useCallback(debounce__default["default"](function (newValue) {
    // If normalization is on, we shouldn't save on change
    if (normalize) {
      return;
    }

    saveNewValue(newValue);
  }, 500), [isExternal]);

  function handleBlur() {
    onChangeDebounced.cancel();
    var newValue = localInputValue;

    if (normalize) {
      var normalized = normalize(newValue);

      if (normalized === null) {
        newValue = previousValue.current;
      } else {
        newValue = normalized;
        previousValue.current = localInputValue;
      }
    }

    setLocalInputValue(newValue);

    if (isExternal) {
      if (newValue.trim() === "") {
        saveNewValue(null);
        setLocalInputValue(fallbackValue !== null && fallbackValue !== void 0 ? fallbackValue : "");
      } else {
        saveNewValue(newValue);
      }
    } else {
      if (value !== newValue) {
        saveNewValue(newValue);
      }
    }
  }

  function handleChange(event) {
    setLocalInputValue(event.currentTarget.value);
    onChangeDebounced(event.currentTarget.value);
  } // Sync local value with value from the config if the field value has been
  // changed from outside


  React__namespace.useEffect(function () {
    setLocalInputValue(valueFromProps);
  }, [valueFromProps]);
  var style = {
    opacity: localInputValue === fallbackValue ? 0.5 : 1
  };
  return {
    onChange: handleChange,
    onBlur: handleBlur,
    value: index.cleanString(localInputValue),
    style: style,
    placeholder: defaultPlaceholder !== null && defaultPlaceholder !== void 0 ? defaultPlaceholder : "Enter text"
  };
}

var TextField = wrapFieldsWithMeta(function (_ref) {
  var input = _ref.input,
      field = _ref.field;

  var value = input.value,
      onChange = input.onChange,
      restInputProperties = index._objectWithoutProperties(input, ["value", "onChange"]);

  var inputProps = useTextValue(value, onChange, field.placeholder, field.normalize);
  return __jsx$5(index.SSInput, index._extends({}, restInputProperties, inputProps, {
    icon: field.icon,
    align: "right"
  }));
});
var TextFieldPlugin = {
  name: "text",
  Component: TextField,
  validate: function validate(value, values, meta, field) {
    if (field.required && !value) return "Required";
  },
  parse: parse
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function pathToCompiledPath(path, editorContext) {
  var pathInfo = parsePath(path, editorContext.form);

  if (pathInfo.parent) {
    var definition = index.findComponentDefinitionById(pathInfo.parent.templateId, editorContext);
    var schemaProp = definition.schema.find(function (schemaProp) {
      return schemaProp.prop === pathInfo.parent.fieldName;
    });
    var result = "".concat(pathToCompiledPath(pathInfo.parent.path, editorContext), ".").concat(getPropertyNameFromSchemaProp(schemaProp), ".").concat(pathInfo.parent.fieldName, ".").concat(pathInfo.index);

    if (result.startsWith(".")) {
      return result.substring(1);
    }

    return result;
  }

  return "";
}
function isFieldPortal(x) {
  return "portal" in x;
}
function buildTinaFields(path, editorContext) {
  return internalBuildTinaFields(path, editorContext);
}

function internalBuildTinaFields(path, editorContext, fieldsFilter) {
  var _compiledComponent$__, _compiledComponent$__2;

  var compiledPath = pathToCompiledPath(stripRichTextPartSelection(path), editorContext);
  var compiledComponent = dotNotationGet(editorContext.compiledComponentConfig, compiledPath);
  var allFields = [];
  ((_compiledComponent$__ = (_compiledComponent$__2 = compiledComponent.__editing) === null || _compiledComponent$__2 === void 0 ? void 0 : _compiledComponent$__2.fields) !== null && _compiledComponent$__ !== void 0 ? _compiledComponent$__ : []).filter(function (field) {
    return fieldsFilter ? fieldsFilter(field) : true;
  }).forEach(function (item) {
    if (isFieldPortal(item)) {
      var fields = [];

      if (item.portal === "component") {
        var _fields;

        var portalComponentFields = internalBuildTinaFields(item.source, editorContext);

        (_fields = fields).push.apply(_fields, index._toConsumableArray(portalComponentFields));

        if (!item.includeHeader) {
          fields = fields.filter(function (x) {
            return x.prop !== "$myself";
          });
        }

        var groups = item.groups;

        if (groups) {
          fields = fields.filter(function (x) {
            return x.prop === "$myself" || groups.includes(x.group || "___doesn't matter___");
          });
        }
      } else if (item.portal === "field") {
        if (item.hidden) {
          return;
        }

        var portalFieldFields = internalBuildTinaFields(item.source, editorContext, function (field) {
          return !isFieldPortal(field) && field.prop === item.fieldName;
        });

        var portalField = _objectSpread$2(_objectSpread$2({}, portalFieldFields[0]), item.overrides);

        fields.push(portalField);
      } else if (item.portal === "multi-field") {
        if (item.sources.length === 0) {
          if (item.hidden) {
            return;
          }

          throw new Error("Missing sources for multi field portal of component \"".concat(compiledComponent._template, "\" at path \"").concat(path, "\". Set \"hidden\" to \"true\" for this portal if sources are empty"));
        }

        var _portalFieldFields = item.sources.flatMap(function (source) {
          return internalBuildTinaFields(source, editorContext, function (field) {
            return !isFieldPortal(field) && field.prop === item.fieldName;
          });
        });

        var firstField = _portalFieldFields[0];

        var combinedField = _objectSpread$2(_objectSpread$2(_objectSpread$2({}, firstField), item.overrides), {}, {
          name: _portalFieldFields.flatMap(function (field) {
            return field.name;
          })
        });

        fields.push(combinedField);
      }

      allFields = [].concat(index._toConsumableArray(allFields), index._toConsumableArray(fields));
    } else {
      allFields.push(item);
    }
  }); // Analytics fields should always go to the bottom (later they'll be in separate tab)

  var nonAnalyticsFields = allFields.filter(function (x) {
    return x.group !== "Analytics";
  });
  var analyticsFields = allFields.filter(function (x) {
    return x.group === "Analytics";
  });
  return [].concat(index._toConsumableArray(nonAnalyticsFields), index._toConsumableArray(analyticsFields));
}

function getPropertyNameFromSchemaProp(schemaProp) {
  if (index.isSchemaPropAction(schemaProp)) {
    return "actions";
  }

  if (index.isSchemaPropTextModifier(schemaProp) || index.isSchemaPropActionTextModifier(schemaProp)) {
    return "textModifiers";
  }

  return "components";
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function mergeCommonFields(_ref) {
  var fields = _ref.fields;
  var mergedCommonFields = [];
  var fieldsGroupedByProperty = groupFieldsByPropertyName(fields.flat());

  for (var _i = 0, _Object$values = Object.values(fieldsGroupedByProperty); _i < _Object$values.length; _i++) {
    var currentFields = _Object$values[_i];

    if (currentFields.length < fields.length) {
      continue;
    }
    /**
     * Some fields can be hidden depending on the context of usage
     * ex. margin bottom is not applicable to the last element in stack
     */


    var visibleFields = currentFields.filter(function (field) {
      return !field.hidden;
    });

    if (visibleFields.length === 0) {
      continue;
    }

    var fieldDefinitionIds = visibleFields.map(function (field) {
      return getFieldSchemaWithDefinition(field).definition.id;
    });
    /**
     * All fields for given property have to be defined within the same schema, because ex.
     * field can have the same prop name in schema A, but different meaning in schema B
     */

    var uniqueDefinitionIds = getUniqueValues(fieldDefinitionIds); // It's common when interacting with $richText to pass fields of parent or ancestor down to $richTextPart.
    // Verify if the all unique ids aren't fields of $richText components.

    if (uniqueDefinitionIds.length > 1 && !uniqueDefinitionIds.every(function (id) {
      return id.startsWith("$richText");
    })) {
      continue;
    }

    var firstVisibleField = visibleFields[0];
    mergedCommonFields.push(_objectSpread$1(_objectSpread$1({}, firstVisibleField), {}, {
      name: visibleFields.length === 1 ? firstVisibleField.name : getUniqueValues(visibleFields.flatMap(function (field) {
        return field.name;
      }))
    }));
  }

  return mergedCommonFields;
}

function groupFieldsByPropertyName(fields) {
  return fields.reduce(function (repeatedFields, field) {
    var currentFieldPropertyName = getPropertyName(field.schemaProp.prop);
    var fields = repeatedFields[currentFieldPropertyName];
    repeatedFields[currentFieldPropertyName] = fields !== undefined ? [].concat(index._toConsumableArray(fields), [field]) : [field];
    return repeatedFields;
  }, {});
}

function getPropertyName(fieldName) {
  var fieldNameParts = fieldName.split(".");
  var lastPart = last(fieldNameParts); // If property name starts with `$` sign it's a special property of fake field.

  if (lastPart.startsWith("$")) {
    lastPart = lastPart.slice(1);
  }

  if (fieldNameParts[0] === "$previous") {
    return "".concat(fieldNameParts[0], ".").concat(lastPart);
  }

  return lastPart;
}

function getFieldSchemaWithDefinition(field) {
  return field.schemaProp;
}

var __jsx$4 = React__namespace.createElement;
var IdWrapper = styled__default["default"].div.withConfig({
  displayName: "SidebarFooter__IdWrapper",
  componentId: "sc-1tymhxv-0"
})(["display:block;padding:16px;", " color:", ";"], index.SSFonts.body, index.SSColors.black40);
function SidebarFooter(props) {
  var _useEditorContext = index.useEditorContext(),
      form = _useEditorContext.form,
      isMaster = _useEditorContext.isMaster,
      isAdminMode = _useEditorContext.isAdminMode;

  var value = props.paths.length === 1 ? dotNotationGet(form.values, stripRichTextPartSelection(props.paths[0])) : null;

  var _useState = React.useState(false),
      canClipboardCopy = _useState[0],
      setClipboardCopy = _useState[1];

  React.useEffect(function () {
    // @ts-ignore
    navigator.permissions.query({
      name: "clipboard-read",
      allowWithoutGesture: false
    }).then(function (_ref) {
      var state = _ref.state;

      if (state === "granted" || state === "prompt") {
        setClipboardCopy(true);
      }
    });
  }, []);

  if (!value) {
    return null;
  }

  return __jsx$4("div", null, __jsx$4(IdWrapper, null, __jsx$4("div", null, "Id: ", value._id), (isMaster || isAdminMode) && __jsx$4("div", {
    style: {
      paddingTop: 16
    }
  }, __jsx$4("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px"
    }
  }, __jsx$4(index.SSButtonPrimary, {
    onClick: function onClick() {
      console.log("The config:");
      console.log(value);
    }
  }, "Print to console"), canClipboardCopy && __jsx$4(index.SSButtonPrimary, {
    onClick: function onClick() {
      console.log("trying to copy config to clipboard");
      navigator.clipboard.writeText(JSON.stringify(value)).then(function () {
        console.log("copied successfully!");
      }, function (reason) {
        console.error("error while copying: ", reason);
      });
    }
  }, "Copy data")), value._master && __jsx$4("div", {
    style: {
      paddingTop: 16
    }
  }, "Master: ", value._master))));
}

var __jsx$3 = React__namespace.createElement;

var BlockField = function BlockField(_ref) {
  var field = _ref.field,
      input = _ref.input,
      isLabelHidden = _ref.isLabelHidden;

  var _React$useState = React__namespace.useState(false),
      _React$useState2 = index._slicedToArray(_React$useState, 2),
      isSubcomponentPanelExpanded = _React$useState2[0],
      setIsSubcomponentPanelExpanded = _React$useState2[1];

  var editorContext = index.useEditorContext();
  var actions = editorContext.actions,
      activeEditor = editorContext.activeEditor;
  var openComponentPicker = actions.openComponentPicker;
  var schemaProp = field.schemaProp;
  var isConfigRequired = schemaProp.type === "component-fixed" || schemaProp.required;
  var isMixed = isMixedFieldValue(input.value);

  var config = function () {
    if (isMixed) {
      return null;
    } // @ts-expect-error We can safely ignore the error since we know the value is not mixed


    return input.value[0] || null;
  }();

  var normalizedName = toArray(field.name); // Let's create paths

  var paths = normalizedName.map(function (x) {
    return "".concat(x, ".0");
  });
  var componentPickerPath = normalizedName[0];
  return __jsx$3(React__namespace.Fragment, null, !isLabelHidden && __jsx$3(_StyledDiv, null, __jsx$3(index.Typography, null, field.label || field.name)), __jsx$3(_StyledDiv2, null, config !== null && __jsx$3(React__namespace.Fragment, null, __jsx$3("div", {
    style: {
      flex: "1 1 auto",
      minWidth: 0
    }
  }, __jsx$3(SubComponentPanelButton, {
    paths: paths,
    isExpanded: isSubcomponentPanelExpanded,
    onExpand: function onExpand() {
      setIsSubcomponentPanelExpanded(true);
    },
    onCollapse: function onCollapse() {
      setIsSubcomponentPanelExpanded(false);
    }
  })), !isConfigRequired && __jsx$3("div", {
    style: {
      flex: "0 0 auto",
      minWidth: 0
    }
  }, __jsx$3(index.SSButtonGhost, {
    onClick: function onClick() {
      if (activeEditor) {
        input.onChange([]);
      } else {
        actions.removeItems(paths);
      }
    },
    icon: index.SSIcons.Remove,
    "aria-label": "Remove"
  }))), config === null && (isMixed ? __jsx$3(ThumbnailButton.ThumbnailButton, {
    label: "Mixed",
    disabled: true
  }) : __jsx$3(AddButton, {
    onAdd: function onAdd() {
      openComponentPicker({
        path: componentPickerPath
      }).then(function (newConfig) {
        if (newConfig) {
          if (activeEditor) {
            input.onChange([newConfig]);
          } else {
            actions.replaceItems(paths, newConfig);
          }

          setIsSubcomponentPanelExpanded(true);
        }
      });
    }
  }))));
};

function AddButton(_ref2) {
  var onAdd = _ref2.onAdd;
  return __jsx$3(_StyledSSButtonGhost, {
    onClick: onAdd,
    height: "32px"
  }, __jsx$3(_StyledDiv3, null, __jsx$3(_StyledDiv4, {
    $_css: index.SSColors.black20
  }, __jsx$3(index.SSIcons.Add, {
    size: 16
  })), "Add"));
}

var SubComponentPanelButton = function SubComponentPanelButton(_ref3) {
  var _ref4, _componentDefinition$, _componentDefinition$2;

  var paths = _ref3.paths,
      isExpanded = _ref3.isExpanded,
      onExpand = _ref3.onExpand,
      onCollapse = _ref3.onCollapse;
  var sidebarPanelsRoot = document.getElementById("sidebar-panels-root");
  var editorContext = index.useEditorContext();
  var config = dotNotationGet(editorContext.configAfterAuto, paths[0]);
  var componentDefinition = index.findComponentDefinition(config, editorContext);
  var label = (_ref4 = (_componentDefinition$ = componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.label) !== null && _componentDefinition$ !== void 0 ? _componentDefinition$ : componentDefinition === null || componentDefinition === void 0 ? void 0 : componentDefinition.id) !== null && _ref4 !== void 0 ? _ref4 : "Shopstory can\u2019t find custom component with id: ".concat(config._template, " in your project. Please contact your developers to resolve this issue.");
  var showError = componentDefinition === undefined;
  var sidebarPreview = componentDefinition === null || componentDefinition === void 0 ? void 0 : (_componentDefinition$2 = componentDefinition.getEditorSidebarPreview) === null || _componentDefinition$2 === void 0 ? void 0 : _componentDefinition$2.call(componentDefinition, config, editorContext);

  var thumbnail = function () {
    if (!sidebarPreview) {
      return;
    }

    if (sidebarPreview.type === "icon" && sidebarPreview.icon) {
      return {
        type: "icon",
        icon: sidebarPreview.icon
      };
    } else if (sidebarPreview.type === "image") {
      return {
        type: "image",
        src: sidebarPreview.url
      };
    } else if (sidebarPreview.type === "solid") {
      return {
        type: "color",
        color: sidebarPreview.color
      };
    }

    return;
  }();

  return showError ? __jsx$3(Error$1, null, label) : __jsx$3(React__namespace.Fragment, null, __jsx$3(ThumbnailButton.ThumbnailButton, {
    onClick: onExpand,
    label: label,
    description: sidebarPreview === null || sidebarPreview === void 0 ? void 0 : sidebarPreview.description,
    thumbnail: thumbnail
  }), sidebarPanelsRoot && /*#__PURE__*/ReactDOM__default["default"].createPortal(__jsx$3(Panel, {
    isExpanded: isExpanded,
    onCollapse: onCollapse,
    paths: paths
  }), sidebarPanelsRoot));
};

var Error$1 = styled__default["default"].div.withConfig({
  displayName: "BlockFieldPlugin__Error",
  componentId: "sc-151seuc-0"
})(["", " padding:7px 6px 7px;color:hsl(0deg 0% 50% / 0.8);white-space:normal;background:hsl(0deg 100% 50% / 0.2);margin-right:10px;border-radius:2px;"], index.SSFonts.body);
var PanelContext = /*#__PURE__*/React__namespace.createContext(undefined);

function Panel(_ref5) {
  var onCollapse = _ref5.onCollapse,
      isExpanded = _ref5.isExpanded,
      paths = _ref5.paths;
  var editorContext = index.useEditorContext();
  var fields = React__namespace.useMemo(function () {
    if (!isExpanded) {
      return [];
    }

    var fieldsPerName = toArray(paths).map(function (path) {
      return buildTinaFields(path, editorContext);
    });
    var mergedFields = mergeCommonFields({
      fields: fieldsPerName
    });
    return mergedFields;
  }, [isExpanded, paths]);
  return __jsx$3(PanelContext.Provider, {
    value: {
      onClose: onCollapse
    }
  }, __jsx$3(GroupPanel, {
    isExpanded: isExpanded
  }, __jsx$3(PanelBody, null, isExpanded ? __jsx$3("div", null, __jsx$3(FieldsBuilder, {
    form: editorContext.form,
    fields: fields
  }), __jsx$3(SidebarFooter, {
    paths: paths
  })) : null)));
}

var BlockFieldPlugin = {
  __type: "field",
  name: "ss-block",
  Component: BlockField
};

var _StyledDiv = styled__default["default"]("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv",
  componentId: "sc-151seuc-1"
})(["display:flex;align-items:center;padding:4px 16px;min-height:28px;"]);

var _StyledDiv2 = styled__default["default"]("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv2",
  componentId: "sc-151seuc-2"
})(["display:flex;justify-content:space-between;align-items:center;padding:4px 16px;margin-bottom:12px;"]);

var _StyledSSButtonGhost = styled__default["default"](index.SSButtonGhost).withConfig({
  displayName: "BlockFieldPlugin___StyledSSButtonGhost",
  componentId: "sc-151seuc-3"
})(["width:100%;padding-left:0;"]);

var _StyledDiv3 = styled__default["default"]("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv3",
  componentId: "sc-151seuc-4"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);

var _StyledDiv4 = styled__default["default"]("div").withConfig({
  displayName: "BlockFieldPlugin___StyledDiv4",
  componentId: "sc-151seuc-5"
})(["display:grid;place-items:center;width:32px;height:32px;margin-left:-1px;border:1px dashed ", ";border-radius:2px;"], function (p) {
  return p.$_css;
});

var __jsx$2 = React__namespace.createElement;
var VariantsList = styled__default["default"].ul.withConfig({
  displayName: "VariantsPlugin__VariantsList",
  componentId: "sc-84qzfz-0"
})(["display:flex;flex-direction:column;gap:0.25rem;list-style:none;padding:0;margin:1rem;"]);
var VariantListItem = styled__default["default"].li.withConfig({
  displayName: "VariantsPlugin__VariantListItem",
  componentId: "sc-84qzfz-1"
})(["padding:0.5rem;display:flex;justify-content:space-between;align-items:center;border-radius:0.25rem;border:1px solid ", ";"], function (props) {
  return props.isActive ? index.SSColors.blue50 : index.SSColors.black10;
});

var VariantItem = function VariantItem(_ref) {
  var id = _ref.id,
      index$1 = _ref.index,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      children = _ref.children;
  return __jsx$2(reactBeautifulDnd.Draggable, {
    draggableId: id,
    key: id,
    index: index$1
  }, function (draggableProvided) {
    return __jsx$2(VariantListItem, index._extends({
      isActive: isActive,
      onClick: onClick,
      ref: draggableProvided.innerRef
    }, draggableProvided.draggableProps, draggableProvided.dragHandleProps), children);
  });
};

var isVariant = function isVariant(config) {
  return config !== null || "_variantGroupId" in (config !== null && config !== void 0 ? config : {});
};

var VariantsComponent = function VariantsComponent(_ref2) {
  var field = _ref2.field,
      input = _ref2.input;

  var _useEditorContext = index.useEditorContext(),
      variantsManager = _useEditorContext.variantsManager;

  if (!variantsManager) {
    return null;
  }

  var getVariantsGroup = variantsManager.getVariantsGroup,
      reorderVariant = variantsManager.reorderVariant,
      selectVariant = variantsManager.selectVariant,
      removeVariant = variantsManager.removeVariant,
      openAddVariantModal = variantsManager.openAddVariantModal,
      openEditVariantModal = variantsManager.openEditVariantModal;

  var currentVariant = function () {
    if (field.schemaProp.type === "variants$$$") {
      return input.value || null;
    } else {
      // @ts-ignore it's safe
      return input.value[0] || null;
    }
  }();

  if (!isVariant(currentVariant)) {
    return null;
  }

  var variantGroupId = currentVariant._variantGroupId;
  var variants = getVariantsGroup(variantGroupId);
  var path = Array.isArray(field.name) ? field.name[0] : field.name;
  return __jsx$2(React__namespace.Fragment, null, variants.length > 0 && __jsx$2(reactBeautifulDnd.DragDropContext, {
    onDragEnd: function onDragEnd(result) {
      var _result$destination;

      reorderVariant(variantGroupId, result.source.index, result === null || result === void 0 ? void 0 : (_result$destination = result.destination) === null || _result$destination === void 0 ? void 0 : _result$destination.index);
    }
  }, __jsx$2(reactBeautifulDnd.Droppable, {
    droppableId: "variants"
  }, function (provided) {
    return __jsx$2(VariantsList, index._extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), variants.map(function (_ref3, index$1) {
      var variantId = _ref3.variantId,
          name = _ref3.name,
          description = _ref3.description;
      return __jsx$2(VariantItem, {
        key: variantId,
        id: variantId,
        index: index$1,
        isActive: currentVariant._id === variantId,
        onClick: function onClick() {
          selectVariant(variantId, path);
        }
      }, __jsx$2(VariantInfo, {
        title: "".concat(name, " - ").concat(description)
      }, __jsx$2(VariantName, null, name), description && __jsx$2(VariantDescription, null, description)), __jsx$2(VariantActions, null, __jsx$2(index.SSButtonGhostColor, {
        onClick: function onClick(e) {
          e.stopPropagation();
          openEditVariantModal(variantId, variantGroupId, path);
        }
      }, "Edit"), __jsx$2(index.SSButtonGhostColor, {
        onClick: function onClick(e) {
          e.stopPropagation();
          removeVariant(variantId, variantGroupId, path);
        }
      }, __jsx$2(TrashIcon, null))));
    }), provided.placeholder);
  })), __jsx$2(AddVariant, null, __jsx$2(index.SSButtonGhostColor, {
    onClick: function onClick() {
      openAddVariantModal(currentVariant, path);
    }
  }, __jsx$2(index.SSIcons.Add, null), " Add Variant")));
};

var VariantInfo = styled__default["default"].div.withConfig({
  displayName: "VariantsPlugin__VariantInfo",
  componentId: "sc-84qzfz-2"
})(["flex:1 1;display:flex;flex-direction:column;overflow:hidden;"]);
var VariantDescription = styled__default["default"].div.withConfig({
  displayName: "VariantsPlugin__VariantDescription",
  componentId: "sc-84qzfz-3"
})(["", " color:", ";text-overflow:ellipsis;overflow:hidden;"], index.SSFonts.body, index.SSColors.black40);
var VariantName = styled__default["default"].span.withConfig({
  displayName: "VariantsPlugin__VariantName",
  componentId: "sc-84qzfz-4"
})(["flex:1 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:all 85ms ease-out;text-align:left;", ";", ";"], index.SSFonts.label, function (props) {
  return props.error && styled.css(["color:var(--tina-color-error) !important;"]);
});
var VariantActions = styled__default["default"].div.withConfig({
  displayName: "VariantsPlugin__VariantActions",
  componentId: "sc-84qzfz-5"
})(["flex:0 0;display:flex;"]);
var AddVariant = styled__default["default"].div.withConfig({
  displayName: "VariantsPlugin__AddVariant",
  componentId: "sc-84qzfz-6"
})(["margin:1rem;"]);
var VariantsPlugin = {
  __type: "variant",
  name: "variant",
  Component: VariantsComponent
};

var __jsx$1 = React__default["default"].createElement;
function InlineTextarea(_ref) {
  var path = _ref.path,
      className = _ref.className,
      placeholder = _ref.placeholder;

  var _useEditorContext = index.useEditorContext();
      _useEditorContext.actions;
      var form = _useEditorContext.form;

  var isMountedRef = React.useRef(false);
  React.useEffect(function () {
    isMountedRef.current = true;
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  var valuePath = "".concat(path, ".value");
  var value = dotNotationGet(form.values, valuePath);
  var inputProps = useTextValue(value, function (val) {
    form.change(valuePath, val);
  }, placeholder);
  return __jsx$1(Textarea, index._extends({
    className: className,
    rows: 1
  }, inputProps));
}
var Textarea = styled__default["default"](TextareaAutosize__default["default"]).withConfig({
  displayName: "inline-textarea-field__Textarea",
  componentId: "sc-19t6lju-0"
})(["width:100%;word-wrap:break-word;display:block;font-size:inherit;font-family:inherit;font-weight:inherit;box-sizing:border-box;color:inherit;letter-spacing:inherit;line-height:inherit;margin:0 auto;max-width:inherit;text-transform:inherit;background-color:inherit;text-align:inherit;outline:none;resize:none;border:none;overflow:visible;position:relative;padding:0;-ms-overflow-style:none;::-webkit-scrollbar{display:none;}"]);

React__default["default"].createElement;
var textEditableComponent = {
  id: "$text",
  styles: $textStyles,
  tags: ["item", "notrace"],
  schema: [{
    prop: "value",
    type: "text"
  }, {
    prop: "color",
    label: "Color",
    type: "color"
  }, {
    prop: "font",
    label: "Font",
    type: "font"
  }, {
    prop: "accessibilityRole",
    type: "select",
    label: "Role",
    options: [{
      value: "p",
      label: "Paragraph"
    }].concat(index._toConsumableArray(range(1, 6).map(function (index) {
      return {
        value: "h".concat(index),
        label: "Heading ".concat(index)
      };
    }))),
    group: "Accessibility and SEO"
  }]
};
var $text = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
  var _props$__fromEditor = props.__fromEditor,
      Text = _props$__fromEditor.components.Text,
      path = _props$__fromEditor.path;
  return index.createElement(Text, {
    as: "div"
  }, index.createElement(InlineTextarea, {
    path: path,
    placeholder: "Here goes text content"
  }));
});

var takeNumbers = function takeNumbers(path) {
  return path.split(".").map(function (x) {
    return parseInt(x, 10);
  }).filter(function (x) {
    return !Number.isNaN(x);
  });
};

var preOrderPathComparator = function preOrderPathComparator() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ascending";
  return function (pathA, pathB) {
    var order = direction === "ascending" ? 1 : -1;
    var numbersA = takeNumbers(pathA);
    var numbersB = takeNumbers(pathB);
    var numberALength = numbersA.length;
    var numberBLength = numbersB.length;

    if (numberALength === 0 || numberBLength === 0) {
      throw new Error("Cannot compare paths '".concat(pathA, "' and '").concat(pathB, "'."));
    }

    var shorterLength = Math.min(numberALength, numberBLength);
    var index = 0;

    while (index < shorterLength) {
      var valueA = numbersA[index];
      var valueB = numbersB[index];

      if (valueA !== valueB) {
        return order * Math.sign(valueA - valueB);
      }

      index++;
    }

    return order * Math.sign(numberBLength - numberALength);
  };
};

var GLOBAL_SHORTCUTS_KEYS = ["Delete", "Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "l", "L"];
var DATA_TRANSFER_FORMAT = "text/x-shopstory";

function useEditorGlobalKeyboardShortcuts(editorContext) {
  React.useEffect(function () {
    var focusedFields = editorContext.focussedField,
        actions = editorContext.actions;

    function handleKeydown(event) {
      if (isTargetInputElement(event.target)) {
        return;
      }

      if (!isGlobalShortcut(event) || !isAnyFieldSelected(focusedFields)) {
        return;
      }

      if (event.key === "Delete" || event.key === "Backspace") {
        actions.removeItems(focusedFields);
      } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        actions.moveItems(focusedFields, "top");
      } else if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        actions.moveItems(focusedFields, "bottom");
      } else if (event.key.toUpperCase() === "L") {
        actions.logSelectedItems();
      }
    }

    function handleCopy(event) {
      var _event$clipboardData;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var configs = getConfigsToCopy(focusedFields, editorContext);
      event.preventDefault();
      (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.setData(DATA_TRANSFER_FORMAT, JSON.stringify(configs));
    }

    function handleCut(event) {
      var _event$clipboardData2;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var configs = getConfigsToCopy(focusedFields, editorContext);
      event.preventDefault();
      (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 ? void 0 : _event$clipboardData2.setData(DATA_TRANSFER_FORMAT, JSON.stringify(configs));
      actions.removeItems(focusedFields);
    }

    function handlePaste(event) {
      var _event$clipboardData3;

      if (!canHandleCopyPaste(focusedFields, event)) {
        return;
      }

      var rawData = (_event$clipboardData3 = event.clipboardData) === null || _event$clipboardData3 === void 0 ? void 0 : _event$clipboardData3.getData(DATA_TRANSFER_FORMAT);

      if (!rawData || rawData === "") {
        return;
      }

      try {
        var parsedData = JSON.parse(rawData);
        var data = Array.isArray(parsedData) ? parsedData : [parsedData];
        actions.pasteItems(data);
        event.preventDefault();
      } catch (e) {
        console.error(e);
        return;
      }
    }

    window.document.addEventListener("keydown", handleKeydown);
    window.document.addEventListener("copy", handleCopy);
    window.document.addEventListener("cut", handleCut);
    window.document.addEventListener("paste", handlePaste);
    return function () {
      window.document.removeEventListener("keydown", handleKeydown);
      window.document.removeEventListener("copy", handleCopy);
      window.document.removeEventListener("cut", handleCut);
      window.document.removeEventListener("paste", handlePaste);
    };
  });
}

function isTargetInputElement(target) {
  return isTargetHtmlElement(target) && (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) || target.tagName === "DIV" && target.getAttribute("role") === "textbox");
}

function isTargetHtmlElement(element) {
  return element !== null;
}

function getConfigsToCopy(paths, editorContext) {
  var sortedPaths = index._toConsumableArray(paths).sort(preOrderPathComparator("ascending"));

  return sortedPaths.map(function (path) {
    var config = dotNotationGet(editorContext.form.values, path);
    return duplicateConfig(config, editorContext);
  });
}

function canHandleCopyPaste(focusedFields, event) {
  var notInsideInputElement = !(isTargetInputElement(event.target) || isTargetInputElement(document.activeElement));
  var insideEditorIFrame = window.frameElement;
  var focusedFieldsSelected = isAnyFieldSelected(focusedFields);
  return notInsideInputElement && insideEditorIFrame && focusedFieldsSelected;
}

function isGlobalShortcut(event) {
  return GLOBAL_SHORTCUTS_KEYS.includes(event.key);
} // FIXME: This is my mistake, because I was lazy at the beginning and it was easier for me to introduce changes
// by assuming that non empty array with empty string means no fields selected.
// IMO this is stupid and can lead to confusion.


function isAnyFieldSelected(focusedFields) {
  return focusedFields.length > 0 && focusedFields[0] !== "";
}

function buildRichTextComponentConfig(_ref) {
  var accessibilityRole = _ref.accessibilityRole,
      compilationContext = _ref.compilationContext,
      elements = _ref.elements,
      isListStyleAuto = _ref.isListStyleAuto,
      mainColor = _ref.mainColor,
      mainFont = _ref.mainFont;
  return {
    _id: index.uniqueId(),
    _template: "$richText",
    accessibilityRole: accessibilityRole !== null && accessibilityRole !== void 0 ? accessibilityRole : "div",
    elements: index._defineProperty({}, compilationContext.contextParams.locale, elements),
    isListStyleAuto: isListStyleAuto !== null && isListStyleAuto !== void 0 ? isListStyleAuto : true,
    mainColor: mainColor,
    mainFont: mainFont
  };
}

function buildRichTextBlockElementComponentConfig(type, elements) {
  return {
    _template: "$richTextBlockElement",
    elements: elements,
    type: type,
    _id: index.uniqueId()
  };
}

function buildRichTextLineElementComponentConfig(_ref4) {
  var elements = _ref4.elements;
  return {
    _template: "$richTextLineElement",
    elements: elements,
    _id: index.uniqueId()
  };
}

function buildRichTextInlineWrapperElementComponentConfig(_ref5) {
  var id = _ref5.id,
      elements = _ref5.elements,
      action = _ref5.action,
      textModifier = _ref5.textModifier,
      actionTextModifier = _ref5.actionTextModifier;
  return {
    _id: id !== null && id !== void 0 ? id : index.uniqueId(),
    _template: "$richTextInlineWrapperElement",
    elements: elements,
    action: action !== null && action !== void 0 ? action : [],
    textModifier: textModifier !== null && textModifier !== void 0 ? textModifier : [],
    actionTextModifier: actionTextModifier !== null && actionTextModifier !== void 0 ? actionTextModifier : []
  };
}

function buildRichTextPartComponentConfig(_ref6) {
  var color = _ref6.color,
      font = _ref6.font,
      value = _ref6.value,
      id = _ref6.id;
  return {
    _id: id !== null && id !== void 0 ? id : index.uniqueId(),
    _template: "$richTextPart",
    color: color,
    font: font,
    value: value
  };
}

function convertEditorValueToRichTextElements(editorValue) {
  return editorValue.map(function (blockElement) {
    if (slate.Element.isElementType(blockElement, "bulleted-list")) {
      return convertEditorListElementToRichTextListBlockElement("bulleted-list", blockElement);
    }

    if (slate.Element.isElementType(blockElement, "numbered-list")) {
      return convertEditorListElementToRichTextListBlockElement("numbered-list", blockElement);
    }

    if (slate.Element.isElementType(blockElement, "paragraph")) {
      return convertEditorParagraphElementToRichTextParagraphBlockElement(blockElement);
    }

    throw new Error("Unknown block element");
  });
}

function convertEditorElementToRichTextLineElement(editorElement) {
  var lineElement = buildRichTextLineElementComponentConfig({
    elements: editorElement.children.map(function (child) {
      if (slate.Text.isText(child)) {
        return buildRichTextPartComponentConfig({
          value: index.cleanString(child.text),
          color: child.color,
          font: child.font,
          id: child.id
        });
      }

      return buildRichTextInlineWrapperElementComponentConfig({
        id: child.id,
        elements: child.children.map(function (child) {
          return buildRichTextPartComponentConfig({
            value: index.cleanString(child.text),
            color: child.color,
            font: child.font,
            id: child.id
          });
        }),
        action: child.action,
        textModifier: child.textModifier,
        actionTextModifier: child.actionTextModifier
      });
    })
  });
  lineElement._id = editorElement.id;
  return lineElement;
}

function convertEditorListElementToRichTextListBlockElement(type, editorElement) {
  var listBlockElement = buildRichTextBlockElementComponentConfig(type, editorElement.children.map(function (child) {
    return convertEditorElementToRichTextLineElement(child);
  }));
  listBlockElement._id = editorElement.id;
  return listBlockElement;
}

function convertEditorParagraphElementToRichTextParagraphBlockElement(editorElement) {
  var paragraphBlockElement = buildRichTextBlockElementComponentConfig("paragraph", editorElement.children.map(function (child) {
    return convertEditorElementToRichTextLineElement(child);
  }));
  paragraphBlockElement._id = editorElement.id;
  return paragraphBlockElement;
}

/**
 * `Object.keys` is badly typed for its reasons and this function just fixes it.
 * https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
 */
function keys(o) {
  return Object.keys(o);
}

function isElementInlineWrapperElement(node) {
  return slate.Element.isElementType(node, "inline-wrapper");
}

/**
 * Tracks which ids were used during current normalization run
 */
var USED_IDS = new Set();
/**
 * Keeps track what was the previous id before generating the unique id. This is needed because Slate rerenders before
 * our config updates and it wouldn't know which compiled component to render.
 */

var NORMALIZED_IDS_TO_IDS = new Map();

function isInline(node) {
  return node.type === "inline-wrapper";
}

function withShopstory(editor) {
  var insertText = editor.insertText,
      normalizeNode = editor.normalizeNode;

  editor.insertText = function (text) {
    // Verify if the current selection is placed at the end of an inline element. If yes, set the selection to start of
    // the next element before adding new text. This allows to break out from the inline element if it's placed at the end of line.
    if (editor.selection && slate.Range.isCollapsed(editor.selection)) {
      var selectedNodeParent = slate.Editor.parent(editor, editor.selection.focus.path);

      if (selectedNodeParent) {
        var _selectedNodeParent = index._slicedToArray(selectedNodeParent, 2),
            parentNode = _selectedNodeParent[0],
            parentNodePath = _selectedNodeParent[1];

        if (slate.Element.isElement(parentNode) && isInline(parentNode)) {
          var isCursorSetAtTheEnd = slate.Editor.isEnd(editor, editor.selection.focus, parentNodePath);
          var nodePointAfterInlineElement = slate.Editor.after(editor, parentNodePath);

          if (isCursorSetAtTheEnd && nodePointAfterInlineElement) {
            slate.Transforms.setSelection(editor, {
              anchor: nodePointAfterInlineElement,
              focus: nodePointAfterInlineElement
            });
          }
        }
      }
    }

    insertText(text);
  };

  editor.isInline = isInline;

  editor.normalizeNode = function (entry) {
    // When copying text content from content editable element, Slate wraps pasted content into top most element.
    // We need to unwrap each block element that is nested within another block element.
    if (unwrapBlockElementsNestedWithinBlockElement(editor, entry)) {
      return;
    } // Slate by default compares text elements and merges them, but to compare them it uses strict equality comparison algorithm.
    // We need to compare them using our own algorithm.


    if (mergeVisuallyTheSameOrEmptyTextNodes(editor, entry)) {
      return;
    }

    if (removeEmptyInlineWrappers(editor, entry)) {
      return;
    }

    if (normalizeEmptyTextNodesAfterInlineElements(editor, entry)) {
      return;
    } // Rich text and its elements contains collections. Each item of collection should have unique id.


    if (updateNonUniqueIds(editor, entry)) {
      return;
    } // Slate normalizes fields from deepest to lowest. The lowest element is editor element which has empty path.


    if (entry[1].length === 0) {
      USED_IDS.clear();
    }

    normalizeNode(entry);
  };

  return editor;
}

function unwrapBlockElementsNestedWithinBlockElement(editor, entry) {
  var _entry = index._slicedToArray(entry, 2),
      node = _entry[0],
      path = _entry[1];

  if (slate.Element.isElement(node) && // This cast is fine since `RichTextBlockElementType` overlaps with type of `node.type`.
  RICH_TEXT_BLOCK_ELEMENT_TYPES.includes(node.type)) {
    var nodeParent = slate.Node.parent(editor, path);

    if (slate.Element.isElement(nodeParent)) {
      if (nodeParent.type === node.type) {
        slate.Transforms.unwrapNodes(editor, {
          at: path
        });
        return true;
      } // For now there is only one case where block element can be nested within block element of different type,
      // it can happen while pasting content from one $richText to another. We want to keep the type of pasted content
      // so instead of unwrapping nodes, we lift them one level up.


      if (nodeParent.type !== node.type && RICH_TEXT_BLOCK_ELEMENT_TYPES.includes(nodeParent.type)) {
        slate.Transforms.liftNodes(editor, {
          at: path
        });
        return true;
      }
    }
  }

  return false;
}

function updateNonUniqueIds(editor, entry) {
  var _entry2 = index._slicedToArray(entry, 2),
      node = _entry2[0],
      path = _entry2[1];

  if (slate.Text.isText(node) || slate.Element.isElement(node)) {
    if (USED_IDS.has(node.id)) {
      var newId = index.uniqueId();
      NORMALIZED_IDS_TO_IDS.set(newId, node.id);
      slate.Transforms.setNodes(editor, {
        id: newId
      }, {
        at: path,
        match: function match(n) {
          return (slate.Text.isText(n) || slate.Element.isElement(n)) && n.id === node.id;
        }
      });
      return true;
    } else {
      USED_IDS.add(node.id);
    }
  }

  return false;
}

function mergeVisuallyTheSameOrEmptyTextNodes(editor, entry) {
  var _entry3 = index._slicedToArray(entry, 2),
      node = _entry3[0],
      path = _entry3[1];

  if (slate.Element.isElement(node) && (node.type === "text-line" || node.type === "list-item" || node.type === "inline-wrapper")) {
    var textLineChildren = Array.from(slate.Node.children(editor, path));

    if (textLineChildren.length > 1) {
      for (var childIndex = 0; childIndex < textLineChildren.length - 1; childIndex++) {
        var _textLineChildren$chi = index._slicedToArray(textLineChildren[childIndex], 2),
            currentChildNode = _textLineChildren$chi[0],
            currentChildPath = _textLineChildren$chi[1];

        var _textLineChildren = index._slicedToArray(textLineChildren[childIndex + 1], 2),
            nextChildNode = _textLineChildren[0],
            nextChildPath = _textLineChildren[1];

        if (slate.Text.isText(currentChildNode) && slate.Text.isText(nextChildNode)) {
          if (compareText(currentChildNode, nextChildNode) || nextChildNode.text.trim() === "" && childIndex + 1 < textLineChildren.length - 1) {
            slate.Transforms.mergeNodes(editor, {
              at: nextChildPath,
              match: function match(node) {
                return slate.Text.isText(node);
              }
            });
            return true;
          } // `Transforms.mergeNodes` always merges node/nodes at given position into PREVIOUS node.
          // In this case, we want to merge node at current position into next one.


          if (currentChildNode.text === "" && nextChildNode !== undefined) {
            slate.Transforms.setNodes(editor, {
              color: nextChildNode.color,
              font: nextChildNode.font
            }, {
              at: currentChildPath,
              match: function match(node) {
                return slate.Text.isText(node);
              }
            });
          }
        }
      }
    }
  }

  return false;
} // Slate normalization rules states that an inline element cannot be first or last child of block element.
// Slate during its own normalization will add empty Text nodes before or/and after inline element.
// Those Text nodes will be missing properties we add during constructing Slate value based on Shopstory config
// thus it will make compilation error because of missing schema prop values.


function normalizeEmptyTextNodesAfterInlineElements(editor, entry) {
  var _entry4 = index._slicedToArray(entry, 2),
      node = _entry4[0],
      path = _entry4[1];

  if (slate.Element.isElement(node) && (node.type === "text-line" || node.type === "list-item")) {
    for (var index$1 = 0; index$1 < node.children.length; index$1++) {
      var childNode = node.children[index$1];
      var previousNode = node.children[index$1 - 1];
      var nextNode = node.children[index$1 + 1];

      if (previousNode && nextNode && isElementInlineWrapperElement(previousNode) && isElementInlineWrapperElement(nextNode) && isInlineWrapperElementEqual(previousNode, nextNode)) {
        if (slate.Text.isText(childNode) && childNode.text === "") {
          slate.Transforms.removeNodes(editor, {
            at: [].concat(index._toConsumableArray(path), [index$1])
          });
          return true;
        }
      }

      if (childNode && nextNode && isElementInlineWrapperElement(childNode) && isElementInlineWrapperElement(nextNode) && isInlineWrapperElementEqual(childNode, nextNode)) {
        var nextNodePath = [].concat(index._toConsumableArray(path), [index$1 + 1]);
        slate.Transforms.mergeNodes(editor, {
          at: nextNodePath
        });
        return true;
      }

      if (isElementInlineWrapperElement(childNode)) {
        if (previousNode) {
          var firstWrapperChildTextNode = childNode.children[0];

          if (isEmptyPlainText(previousNode) || slate.Text.isText(previousNode) && previousNode.text === "" && !index.deepCompare(previousNode.font, firstWrapperChildTextNode.font)) {
            slate.Transforms.setNodes(editor, {
              id: index.uniqueId(),
              action: [],
              color: firstWrapperChildTextNode.color,
              font: firstWrapperChildTextNode.font
            }, {
              at: [].concat(index._toConsumableArray(path), [index$1 - 1]),
              match: function match(node) {
                return slate.Text.isText(node);
              }
            });
            return true;
          }
        }

        if (nextNode) {
          var lastWrapperChildTextNode = last(childNode.children);

          if (isEmptyPlainText(nextNode) || slate.Text.isText(nextNode) && nextNode.text === "" && !index.deepCompare(nextNode.font, lastWrapperChildTextNode.font)) {
            slate.Transforms.setNodes(editor, {
              id: index.uniqueId(),
              action: [],
              color: lastWrapperChildTextNode.color,
              font: lastWrapperChildTextNode.font
            }, {
              at: [].concat(index._toConsumableArray(path), [index$1 + 1]),
              match: function match(node) {
                return slate.Text.isText(node);
              }
            });
            return true;
          }
        }
      }
    }
  }

  return false;
}

function removeEmptyInlineWrappers(editor, entry) {
  var _entry5 = index._slicedToArray(entry, 2),
      node = _entry5[0],
      path = _entry5[1];

  if (isElementInlineWrapperElement(node) && node.children.length === 1 && node.children[0].text === "") {
    slate.Transforms.removeNodes(editor, {
      at: path,
      match: isElementInlineWrapperElement
    });
    return true;
  }
} // In Slate's terminology Text node is an object containing `text` string property.
// In our terminology Text node contains also other properties like color or font.


function isEmptyPlainText(node) {
  return slate.Text.isText(node) && node.color === undefined && node.font === undefined;
}

function filterNonComparableProperties(obj) {
  return keys(obj).filter(function (key) {
    return ["color", "font", "textModifier"].includes(key);
  }).reduce(function (filteredObject, currentKey) {
    filteredObject[currentKey] = obj[currentKey];
    return filteredObject;
  }, {});
}

function compareText(text1, text2) {
  var areEqual = true;
  var part1Keys = keys(filterNonComparableProperties(text1));
  var part2Keys = keys(filterNonComparableProperties(text2));

  if (part1Keys.length !== part2Keys.length) {
    return false;
  }

  for (var index$1 = 0; index$1 < part1Keys.length; index$1++) {
    var key = part1Keys[index$1];
    var part1Value = text1[key];
    var part2Value = text2[key];
    var areValuesEqual = index.deepCompare(part1Value, part2Value);

    if (!areValuesEqual) {
      areEqual = false;
      break;
    }
  }

  return areEqual;
}

var COMPARABLE_INLINE_WRAPPER_PROPERTIES = ["action", "actionTextModifier", "textModifier"];

function isInlineWrapperElementEqual(wrapper1, wrapper2) {
  return COMPARABLE_INLINE_WRAPPER_PROPERTIES.every(function (property) {
    var _wrapper1$property$, _wrapper2$property$;

    if ((property === "textModifier" || property === "actionTextModifier") && wrapper1[property][0] && wrapper2[property][0]) {
      return compareTextModifiers(wrapper1[property][0], wrapper2[property][0]);
    }

    if (property === "action" && wrapper1.action[0] && wrapper2.action[0]) {
      return compareActions(wrapper1.action[0], wrapper2.action[0]);
    }

    return ((_wrapper1$property$ = wrapper1[property][0]) === null || _wrapper1$property$ === void 0 ? void 0 : _wrapper1$property$._id) === ((_wrapper2$property$ = wrapper2[property][0]) === null || _wrapper2$property$ === void 0 ? void 0 : _wrapper2$property$._id);
  });
}

function compareTextModifiers(textModifier1, textModifier2) {
  textModifier1._id;
      var comparableTextModifier1 = index._objectWithoutProperties(textModifier1, ["_id"]);

  textModifier2._id;
      var comparableTextModifier2 = index._objectWithoutProperties(textModifier2, ["_id"]);

  return index.deepCompare(comparableTextModifier1, comparableTextModifier2);
}

function compareActions(action1, action2) {
  if (action1._template !== action2._template) {
    return false;
  }

  action1._id;
      var comparableAction1Properties = index._objectWithoutProperties(action1, ["_id"]);

  action1._id;
      var comparableAction2Properties = index._objectWithoutProperties(action1, ["_id"]);

  if (action1._template === "$StandardLink") {
    var url1 = comparableAction1Properties.url,
        restAction1Properties = index._objectWithoutProperties(comparableAction1Properties, ["url"]);

    var url2 = comparableAction2Properties.url,
        restAction2Properties = index._objectWithoutProperties(comparableAction2Properties, ["url"]);

    if (!index.deepCompare(restAction1Properties, restAction2Properties)) {
      return false;
    }

    if (!index.deepCompare(url1.value, url2.value)) {
      return false;
    }

    return true;
  }

  return index.deepCompare(comparableAction1Properties, comparableAction2Properties);
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { index._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// By creating temporary editor instance we can apply all transformations without
// touching original editor and read result from `temporaryEditor.children`

function createTemporaryEditor(editor) {
  var temporaryEditor = withShopstory(slateReact.withReact(slate.createEditor()));
  temporaryEditor.children = index._toConsumableArray(editor.children);
  temporaryEditor.selection = editor.selection ? _objectSpread({}, editor.selection) : null;
  return temporaryEditor;
}

function getAbsoluteRichTextPartPath(relativeRichTextPartPath, richTextPath, locale) {
  return "".concat(richTextPath, ".elements.").concat(locale, ".").concat(relativeRichTextPartPath);
}

function getFocusedRichTextPartsConfigPaths(editor) {
  if (editor.selection !== null) {
    var isBackward = slate.Range.isBackward(editor.selection);
    var anchorProperty = isBackward ? "focus" : "anchor";
    var focusProperty = isBackward ? "anchor" : "focus";
    var anchor = editor.selection[anchorProperty];
    var focus = editor.selection[focusProperty];
    var selectedTextNodes = Array.from(slate.Editor.nodes(editor, {
      match: slate.Text.isText
    }));

    if (selectedTextNodes.length === 1) {
      var range = {
        start: anchor.offset,
        end: focus.offset
      };

      var _selectedTextNodes$ = index._slicedToArray(selectedTextNodes[0], 2),
          textNode = _selectedTextNodes$[0],
          textPath = _selectedTextNodes$[1];

      return [buildFocusedRichTextPartConfigPath(textNode, textPath, range)];
    }

    var focusedRichTextPartsConfigPaths = selectedTextNodes.map(function (_ref, textEntryIndex) {
      var _ref2 = index._slicedToArray(_ref, 2),
          textNode = _ref2[0],
          textPath = _ref2[1];

      if (textNode.text === "") {
        return null;
      }

      var range = null;

      if (textEntryIndex === 0) {
        range = {
          start: anchor.offset,
          end: textNode.text.length
        };
      }

      if (textEntryIndex === selectedTextNodes.length - 1) {
        range = {
          start: 0,
          end: focus.offset
        };
      }

      return buildFocusedRichTextPartConfigPath(textNode, textPath, range);
    }).filter(function (configPath) {
      return configPath !== null;
    });
    return focusedRichTextPartsConfigPaths;
  }

  return [];
}

function buildFocusedRichTextPartConfigPath(textNode, path, range) {
  var focusedRichTextPartConfigPath = path.join(".elements.");

  if (range !== null && (isPartialSelection(range, textNode) || isCaretSelection(range))) {
    focusedRichTextPartConfigPath += ".{".concat(range.start, ",").concat(range.end, "}");
  }

  return focusedRichTextPartConfigPath;
}

function isPartialSelection(range, textNode) {
  return range.end - range.start !== textNode.text.length;
}

function isCaretSelection(range) {
  return range.end - range.start === 0;
}

var RICH_TEXT_PART_CONFIG_PATH_REGEXP = /\.elements\.[a-z(\-A-Z)?]+\.\d+(\.elements\.\d+){2,3}(\.\{\d+,\d+\})?$/;

function isConfigPathRichTextPart(configPath) {
  return RICH_TEXT_PART_CONFIG_PATH_REGEXP.test(configPath);
}

var __jsx = React__default["default"].createElement;
var EventDispatcherContext = /*#__PURE__*/React.createContext({
  dispatch: function dispatch() {}
});

function EventDispatcherProvider(_ref) {
  var children = _ref.children,
      target = _ref.target;
  return __jsx(EventDispatcherContext.Provider, {
    value: {
      dispatch: function dispatch(event) {
        target.postMessage(event);
      }
    }
  }, children);
}

function useEventDispatcher() {
  var _useContext = React.useContext(EventDispatcherContext),
      dispatch = _useContext.dispatch;

  return dispatch;
}

var createClient = function createClient(url, accessToken) {
  var HEADERS = {
    "content-type": "application/json",
    "x-shopstory-access-token": accessToken
  };
  return {
    call: function call(name, body) {
      return index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee() {
        var response, data;
        return index.regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(url, "/api/").concat(name), {
                  method: "POST",
                  headers: HEADERS,
                  body: body
                });

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                data = _context.sent;

                if (!("error" in data)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {
                  data: null,
                  error: data.error
                });

              case 9:
                return _context.abrupt("return", {
                  data: data,
                  error: null
                });

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  data: null,
                  error: _context.t0
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }))();
    }
  };
};

var _httpsShopstoryAp;
var configuration = {
  url: (_httpsShopstoryAp = "https://shopstory-api.vercel.app") !== null && _httpsShopstoryAp !== void 0 ? _httpsShopstoryAp : ""
};

function createApiStorage(_ref) {
  var _ref$accessToken = _ref.accessToken,
      accessToken = _ref$accessToken === void 0 ? "" : _ref$accessToken;
  var apiClient = createClient(configuration.url, accessToken);

  var getConfig = /*#__PURE__*/function () {
    var _ref2 = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee(input) {
      var _ref3;

      var body, _yield$apiClient$call, data, error;

      return index.regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(Array.isArray(input) && input.length === 0 || !input)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              body = JSON.stringify(input);
              _context.next = 5;
              return apiClient.call("get-config", body);

            case 5:
              _yield$apiClient$call = _context.sent;
              data = _yield$apiClient$call.data;
              error = _yield$apiClient$call.error;

              if (!error) {
                _context.next = 10;
                break;
              }

              throw new Error("[API -> getConfig] (configuration:".concat(JSON.stringify(configuration), ", body:").concat(body, ") : ").concat(error.message));

            case 10:
              if (!(data === null)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", null);

            case 12:
              return _context.abrupt("return", (_ref3 = data) !== null && _ref3 !== void 0 ? _ref3 : null);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getConfig(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getConfigForLocale = /*#__PURE__*/function () {
    var _ref4 = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee2(id, locale) {
      var _ref6;

      var body, _yield$apiClient$call2, data, error;

      return index.regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(Array.isArray(id) && id.length === 0 || !id)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", null);

            case 2:
              body = JSON.stringify({
                id: Array.isArray(id) ? id.map(function (_ref5) {
                  var id = _ref5.id;
                  return id;
                }) : [id.id],
                locale: locale
              });
              _context2.next = 5;
              return apiClient.call("get-config-localized", body);

            case 5:
              _yield$apiClient$call2 = _context2.sent;
              data = _yield$apiClient$call2.data;
              error = _yield$apiClient$call2.error;

              if (!error) {
                _context2.next = 10;
                break;
              }

              throw new Error("[API -> getConfig] (configuration:".concat(JSON.stringify(configuration), ", body:").concat(body, ") : ").concat(error.message));

            case 10:
              if (!(data === null)) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", null);

            case 12:
              return _context2.abrupt("return", (_ref6 = data) !== null && _ref6 !== void 0 ? _ref6 : null);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getConfigForLocale(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    getConfig: getConfig,
    getConfigForLocale: getConfigForLocale,
    saveConfig: function saveConfig(config) {
      return index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee3() {
        var _yield$apiClient$call3, data, error;

        return index.regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apiClient.call("save-config", JSON.stringify(config));

              case 2:
                _yield$apiClient$call3 = _context3.sent;
                data = _yield$apiClient$call3.data;
                error = _yield$apiClient$call3.error;

                if (!error) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("[API -> saveConfig]: ".concat(error.message));

              case 7:
                if (!(data === null)) {
                  _context3.next = 9;
                  break;
                }

                throw new Error("[API -> saveConfig]: Save config failed");

              case 9:
                return _context3.abrupt("return", {
                  id: data.id
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
}

exports.$text = $text;
exports.BlockFieldPlugin = BlockFieldPlugin;
exports.CMSContext = CMSContext;
exports.ColorPicker = ColorPicker;
exports.CompilationCache = CompilationCache;
exports.DATA_TRANSFER_FORMAT = DATA_TRANSFER_FORMAT;
exports.EventDispatcherProvider = EventDispatcherProvider;
exports.FieldBuilder = FieldBuilder;
exports.FieldMetaWrapper = FieldMetaWrapper;
exports.FieldsBuilder = FieldsBuilder;
exports.Form = Form;
exports.GlobalStyles = GlobalStyles;
exports.ICON_BUTTON_SIZE = ICON_BUTTON_SIZE;
exports.IconButton = IconButton;
exports.ImageUpload = ImageUpload;
exports.MIXED_VALUE = MIXED_VALUE;
exports.NORMALIZED_IDS_TO_IDS = NORMALIZED_IDS_TO_IDS;
exports.PanelContext = PanelContext;
exports.RICH_TEXT_PART_CONFIG_PATH_REGEXP = RICH_TEXT_PART_CONFIG_PATH_REGEXP;
exports.RadioGroup = RadioGroup;
exports.SidebarFooter = SidebarFooter;
exports.StyleReset = StyleReset;
exports.TextArea = TextArea;
exports.TextFieldPlugin = TextFieldPlugin;
exports.Theme = Theme;
exports.Toggle = Toggle;
exports.Tooltip = Tooltip;
exports.TooltipArrow = TooltipArrow;
exports.TooltipBody = TooltipBody;
exports.VariantsPlugin = VariantsPlugin;
exports._assertThisInitialized = _assertThisInitialized;
exports._classCallCheck = _classCallCheck$8;
exports._createClass = _createClass$8;
exports._getPrototypeOf = _getPrototypeOf;
exports._inherits = _inherits$8;
exports._possibleConstructorReturn = _possibleConstructorReturn$8;
exports._setPrototypeOf = _setPrototypeOf;
exports.box = box;
exports.buildFullTheme = buildFullTheme;
exports.buildRichTextBlockElementComponentConfig = buildRichTextBlockElementComponentConfig;
exports.buildRichTextComponentConfig = buildRichTextComponentConfig;
exports.buildRichTextLineElementComponentConfig = buildRichTextLineElementComponentConfig;
exports.buildRichTextPartComponentConfig = buildRichTextPartComponentConfig;
exports.buildTinaFields = buildTinaFields;
exports.buttonActionSchemaProp = buttonActionSchemaProp;
exports.buttonLabelSchemaProp = buttonLabelSchemaProp;
exports.buttonOptionalIconSchemaProp = buttonOptionalIconSchemaProp;
exports.buttonRequiredIconSchemaProp = buttonRequiredIconSchemaProp;
exports.compile = compile;
exports.configTraverse = configTraverse;
exports.convertEditorValueToRichTextElements = convertEditorValueToRichTextElements;
exports.convertInputConfigIntoRawContent = convertInputConfigIntoRawContent;
exports.createApiStorage = createApiStorage;
exports.createTemporaryEditor = createTemporaryEditor;
exports.dist = dist$2;
exports.dotNotationGet = dotNotationGet;
exports.dotNotationSet = dotNotationSet;
exports.duplicateConfig = duplicateConfig;
exports.getAbsoluteRichTextPartPath = getAbsoluteRichTextPartPath;
exports.getDefaultConfig = getDefaultConfig;
exports.getDefaultLocale = getDefaultLocale;
exports.getFallbackForLocale = getFallbackForLocale;
exports.getFocusedRichTextPartsConfigPaths = getFocusedRichTextPartsConfigPaths;
exports.getUniqueValues = getUniqueValues;
exports.isComponentConfig = isComponentConfig;
exports.isConfigPathRichTextPart = isConfigPathRichTextPart;
exports.isElementInlineWrapperElement = isElementInlineWrapperElement;
exports.isMixedFieldValue = isMixedFieldValue;
exports.last = last;
exports.mapAlignmentToFlexAlignment = mapAlignmentToFlexAlignment;
exports.mergeCommonFields = mergeCommonFields;
exports.nonNullable = nonNullable;
exports.normalize = normalize;
exports.normalizeCmsConfigInput = normalizeCmsConfigInput;
exports.optionalTextModifierSchemaProp = optionalTextModifierSchemaProp;
exports.parse = parse;
exports.parsePath = parsePath;
exports.parseSpacing = parseSpacing;
exports.pathToCompiledPath = pathToCompiledPath;
exports.preOrderPathComparator = preOrderPathComparator;
exports.range = range;
exports.responsiveValueFindDeviceWithDefinedValue = responsiveValueFindDeviceWithDefinedValue;
exports.responsiveValueFindHigherDeviceWithDefinedValue = responsiveValueFindHigherDeviceWithDefinedValue;
exports.responsiveValueFindLowerDeviceWithDefinedValue = responsiveValueFindLowerDeviceWithDefinedValue;
exports.responsiveValueGetDefinedValue = responsiveValueGetDefinedValue;
exports.responsiveValueGetFirstHigherValue = responsiveValueGetFirstHigherValue;
exports.responsiveValueGetFirstLowerValue = responsiveValueGetFirstLowerValue;
exports.richTextBlockElementEditableComponent = richTextBlockElementEditableComponent;
exports.richTextEditableComponent = richTextEditableComponent;
exports.richTextInlineWrapperActionSchemaProp = richTextInlineWrapperActionSchemaProp;
exports.richTextInlineWrapperElementEditableComponent = richTextInlineWrapperElementEditableComponent;
exports.richTextLineElementEditableComponent = richTextLineElementEditableComponent;
exports.richTextPartEditableComponent = richTextPartEditableComponent;
exports.spacingToPx = spacingToPx;
exports.stripRichTextPartSelection = stripRichTextPartSelection;
exports.textEditableComponent = textEditableComponent;
exports.toArray = toArray;
exports.useCMS = useCMS;
exports.useEditorGlobalKeyboardShortcuts = useEditorGlobalKeyboardShortcuts;
exports.useEventDispatcher = useEventDispatcher;
exports.useTooltip = useTooltip;
exports.withShopstory = withShopstory;
exports.wrapFieldsWithMeta = wrapFieldsWithMeta;
